/* de-area-city-global-2026-09-09 — the verified area-code -> city map.
   It used to live inside block 14 (the COLLECTION filter module), which never
   runs on /search, so the search filter bar had no way to label its area codes
   the way the collection does. Moved to one global, referenced by both; no
   duplicate copy. */
window.DE_AREA_CITY = {
      '205':"Birmingham",'251':"Mobile",'256':"Huntsville",'334':"Montgomery",'659':"Birmingham Overlay",'938':"Huntsville Overlay",
      '907':"Alaska",'480':"Mesa / East Valley",'520':"Tucson",'602':"Phoenix",'623':"West Valley",'928':"Flagstaff / Yuma",
      '479':"Fayetteville / Fort Smith",'501':"Little Rock",'870':"Jonesboro",'209':"Stockton / Modesto",'213':"Downtown LA",'279':"Sacramento Overlay",
      '310':"West LA / Beverly Hills",'323':"Central LA",'341':"East Bay Overlay",'350':"Stockton / Modesto Overlay",'369':"North Bay Overlay",'408':"San Jose",
      '415':"San Francisco",'424':"West LA Overlay",'442':"Palm Springs / Oceanside Overlay",'510':"Oakland",'530':"Redding / Chico",'559':"Fresno",
      '562':"Long Beach",'619':"San Diego",'626':"Pasadena / San Gabriel",'628':"San Francisco Overlay",'650':"Palo Alto / Peninsula",'657':"Orange County Overlay",
      '661':"Bakersfield / Santa Clarita",'669':"San Jose Overlay",'707':"Santa Rosa / North Bay",'714':"Anaheim / Orange County",'747':"San Fernando Valley Overlay",'760':"Palm Springs / Oceanside",
      '805':"Santa Barbara / Ventura",'818':"San Fernando Valley",'820':"Santa Barbara / Ventura Overlay",'831':"Monterey / Santa Cruz",'840':"Inland Empire Overlay",'858':"San Diego / La Jolla",
      '909':"Inland Empire",'916':"Sacramento",'925':"East Bay / Concord",'949':"Orange County / Irvine",'951':"Riverside",'303':"Denver",
      '719':"Colorado Springs",'720':"Denver Overlay",'970':"Fort Collins / Western Slope",'983':"Denver Overlay",'203':"New Haven / Bridgeport",'475':"SW Connecticut Overlay",
      '860':"Hartford",'959':"Hartford Overlay",'302':"Delaware",'239':"Fort Myers / Naples",'305':"Miami",'321':"Cape Canaveral / Orlando East",
      '352':"Gainesville / Ocala",'386':"Daytona Beach",'407':"Orlando",'448':"Panhandle Overlay",'561':"West Palm Beach",'645':"Miami Overlay",
      '656':"Tampa Overlay",'689':"Orlando Overlay",'727':"St. Petersburg / Clearwater",'728':"West Palm Beach Overlay",'754':"Fort Lauderdale Overlay",'772':"Port St. Lucie / Treasure Coast",
      '786':"Miami Overlay",'813':"Tampa",'850':"Tallahassee / Panhandle",'863':"Lakeland",'904':"Jacksonville",'941':"Sarasota / Bradenton",
      '954':"Fort Lauderdale",'229':"Albany",'404':"Atlanta",'470':"Atlanta Overlay",'478':"Macon",'678':"Atlanta Overlay",
      '706':"Augusta / Columbus",'762':"Augusta / Columbus Overlay",'770':"Atlanta Suburbs",'912':"Savannah",'943':"Atlanta Overlay",'808':"Hawaii",
      '208':"Idaho",'986':"Idaho Overlay",'217':"Springfield / Champaign",'224':"North Suburbs Overlay",'309':"Peoria",'312':"Chicago",
      '331':"West Suburbs Overlay",'447':"Springfield Overlay",'464':"South Suburbs Overlay",'618':"Southern Illinois",'630':"Aurora / Naperville",'708':"South Suburbs",
      '773':"Chicago",'779':"Rockford Overlay",'815':"Rockford / Joliet",'847':"North Suburbs",'872':"Chicago Overlay",'219':"Gary / Northwest Indiana",
      '260':"Fort Wayne",'317':"Indianapolis",'463':"Indianapolis Overlay",'574':"South Bend / Elkhart",'765':"Lafayette / Muncie",'812':"Evansville / Bloomington",
      '930':"Evansville Overlay",'319':"Cedar Rapids / Iowa City",'515':"Des Moines",'563':"Davenport / Dubuque",'641':"Mason City / Central Iowa",'712':"Sioux City / Council Bluffs",
      '316':"Wichita",'620':"Dodge City / Southern Kansas",'785':"Topeka / Lawrence",'913':"Overland Park / Kansas City",'270':"Bowling Green / Western Kentucky",'502':"Louisville",
      '606':"Ashland / Eastern Kentucky",'859':"Lexington",'225':"Baton Rouge",'318':"Shreveport",'337':"Lafayette / Lake Charles",'504':"New Orleans",
      '985':"Houma / North Shore",'207':"Maine",'227':"Suburban Maryland Overlay",'240':"Suburban Maryland Overlay",'301':"Suburban Maryland",'410':"Baltimore",
      '443':"Baltimore Overlay",'667':"Baltimore Overlay",'339':"Boston North Overlay",'351':"Lowell / North Shore Overlay",'413':"Springfield",'508':"Worcester / Cape Cod",
      '617':"Boston",'774':"Worcester Overlay",'781':"Boston Suburbs",'857':"Boston Overlay",'978':"Lowell / North Shore",'231':"Traverse City / NW Michigan",
      '248':"Oakland County",'269':"Kalamazoo / Battle Creek",'313':"Detroit",'517':"Lansing",'586':"Warren / Macomb County",'616':"Grand Rapids",
      '734':"Ann Arbor / Downriver",'810':"Flint",'906':"Upper Peninsula",'947':"Oakland County Overlay",'989':"Saginaw / Central Michigan",'218':"Duluth / Northern Minnesota",
      '320':"St. Cloud / Central Minnesota",'507':"Rochester / Southern Minnesota",'612':"Minneapolis",'651':"St. Paul",'763':"NW Suburbs",'952':"SW Suburbs",
      '228':"Gulfport / Biloxi",'601':"Jackson",'662':"Tupelo / Northern Mississippi",'769':"Jackson Overlay",'314':"St. Louis",'417':"Springfield",
      '557':"St. Louis Overlay",'573':"Columbia / Jefferson City",'636':"St. Charles / St. Louis Suburbs",'660':"Sedalia / Northern Missouri",'816':"Kansas City",'406':"Montana",
      '308':"Grand Island / Western Nebraska",'402':"Omaha / Lincoln",'531':"Omaha Overlay",'702':"Las Vegas",'725':"Las Vegas Overlay",'775':"Reno / Northern Nevada",
      '603':"New Hampshire",'201':"Jersey City / Northern NJ",'551':"Northern NJ Overlay",'609':"Trenton / South Jersey",'640':"South Jersey Overlay",'732':"Toms River / Central NJ",
      '848':"Central NJ Overlay",'856':"Camden / South Jersey",'862':"Newark Overlay",'908':"Elizabeth / Central NJ",'973':"Newark / Northern NJ",'505':"Albuquerque / Santa Fe",
      '575':"Las Cruces / Southern New Mexico",'212':"Manhattan",'315':"Syracuse",'329':"Hudson Valley Overlay",'332':"Manhattan Overlay",'347':"NYC Outer Boroughs",
      '516':"Long Island / Nassau",'518':"Albany",'585':"Rochester",'607':"Binghamton / Ithaca",'631':"Long Island / Suffolk",'646':"Manhattan",
      '680':"Syracuse Overlay",'716':"Buffalo",'718':"Brooklyn / Queens",'838':"Albany Overlay",'845':"Hudson Valley",'914':"Westchester",
      '917':"NYC",'929':"Brooklyn / Queens",'934':"Suffolk Overlay",'252':"Greenville / Eastern NC",'336':"Greensboro / Winston-Salem",'704':"Charlotte",
      '743':"Greensboro Overlay",'828':"Asheville / Western NC",'910':"Fayetteville / Wilmington",'919':"Raleigh / Durham",'980':"Charlotte Overlay",'984':"Raleigh Overlay",
      '701':"North Dakota",'216':"Cleveland",'220':"SE Ohio Overlay",'234':"Akron / Canton Overlay",'283':"Cincinnati Overlay",'326':"Dayton Overlay",
      '330':"Akron / Canton",'380':"Columbus Overlay",'419':"Toledo",'440':"Cleveland Suburbs",'513':"Cincinnati",'567':"Toledo Overlay",
      '614':"Columbus",'740':"Athens / Southeastern Ohio",'937':"Dayton",'405':"Oklahoma City",'539':"Tulsa Overlay",'572':"Oklahoma City Overlay",
      '580':"Lawton / Western Oklahoma",'918':"Tulsa",'458':"Eugene Overlay",'503':"Portland",'541':"Eugene / Southern Oregon",'971':"Portland Overlay",
      '215':"Philadelphia",'223':"Harrisburg Overlay",'267':"Philadelphia Overlay",'272':"Scranton Overlay",'412':"Pittsburgh",'445':"Philadelphia Overlay",
      '484':"Lehigh Valley Overlay",'570':"Scranton / NE Pennsylvania",'582':"Erie Overlay",'610':"Allentown / Lehigh Valley",'717':"Harrisburg / Lancaster",'724':"Pittsburgh Suburbs",
      '814':"Erie / Altoona",'835':"Lehigh Valley Overlay",'878':"Pittsburgh Overlay",'401':"Rhode Island",'803':"Columbia",'821':"Greenville / Spartanburg Overlay",
      '839':"Columbia Overlay",'843':"Charleston / Myrtle Beach",'854':"Charleston Overlay",'864':"Greenville / Spartanburg",'605':"South Dakota",'423':"Chattanooga / Knoxville East",
      '615':"Nashville",'629':"Nashville Overlay",'731':"Jackson / Western Tennessee",'865':"Knoxville",'901':"Memphis",'931':"Clarksville / Central Tennessee",
      '210':"San Antonio",'214':"Dallas",'254':"Killeen / Waco",'281':"Houston Suburbs",'325':"Abilene / San Angelo",'346':"Houston Overlay",
      '361':"Corpus Christi",'409':"Beaumont / Galveston",'430':"Tyler / Longview Overlay",'432':"Midland / Odessa",'469':"Dallas Overlay",'512':"Austin",
      '682':"Fort Worth Overlay",'713':"Houston",'726':"San Antonio Overlay",'737':"Austin Overlay",'806':"Amarillo / Lubbock",'817':"Fort Worth",
      '830':"New Braunfels / Del Rio",'832':"Houston Overlay",'903':"Tyler / Longview",'915':"El Paso",'936':"Huntsville / Nacogdoches",'940':"Denton / Wichita Falls",
      '945':"Dallas Overlay",'956':"McAllen / Brownsville",'972':"Dallas Suburbs",'979':"Bryan / College Station",'385':"Salt Lake City Overlay",'435':"St. George / Rural Utah",
      '801':"Salt Lake City / Provo",'802':"Vermont",'276':"Bristol / Southwest Virginia",'434':"Charlottesville / Lynchburg",'540':"Roanoke / Shenandoah Valley",'571':"Northern Virginia Overlay",
      '703':"Arlington / Northern Virginia",'757':"Norfolk / Virginia Beach",'804':"Richmond",'948':"Norfolk Overlay",'206':"Seattle",'253':"Tacoma",
      '360':"Olympia / Bellingham",'425':"Bellevue / Everett",'509':"Spokane / Eastern Washington",'564':"Western Washington Overlay",'202':"Washington DC",'771':"Washington DC Overlay",
      '304':"West Virginia",'681':"West Virginia Overlay",'262':"Kenosha / Racine",'414':"Milwaukee",'608':"Madison",'715':"Eau Claire / Northern Wisconsin",
      '920':"Green Bay / Appleton",'307':"Wyoming"
    };

/* de-polish.js — Digit Exclusive 2.0 motion + polish runtime
   Additive layer on top of de-app.js. Wires up:
   - Stagger reveal for grids
   - Image blur-up / fade-in on load
   - Stat count-up on scroll-into-view
   - Trust strip marquee duplication
   - Cart count bump on update (custom event 'de:cart-updated')
   - Ripple effect on data-ripple buttons
   - Hero media parallax (subtle, mouse + scroll)
   - Toast helper (window.deToast)
   - Magnetic CTA — pointer-fine only
   - Reduced-motion respected throughout
   ES6+, no dependencies. ~5 KB minified.
*/
/* de-digit-index-2026-09-16 — a complete, exact index of every number we sell.

   The problem it solves: Shopify's search tokenises a title into whole groups
   ("201-205-9999" -> 201 / 205 / 9999) and only prefix-matches those tokens, so
   a digit fragment sitting anywhere else in the number is unfindable. Measured
   on the live store:

       "37"   Shopify returned 2 products, NEITHER containing 37   (774 do)
       "27"   1 genuine match on the page                          (990 do)
       "29"   0                                                    (2,202 do)
       "124"  0                                                    (9 do)

   The client used to answer this by sweeping /collections/all-numbers page by
   page hoping to bump into a match — 82 fetches for the rare ones, a 60-fetch
   budget, so "4470" (1 match in 16,308) simply never appeared and every count
   was a floor ("321+") rather than a number.

   The sitemaps already hold the answer. Every product URL is the number itself
   (/products/201-205-9999), so 17 gzipped files — 4.7KB and ~0.3s each, fetched
   in parallel — are a complete list of the catalogue. Verified against a live
   Shopify export: 16,308 in the sitemaps, 16,308 in the catalogue, zero
   difference in either direction.

   Sorted, that index does something better than answer "does a match exist":
   because titles ARE the dashed digits, sort_by=title-ascending orders the
   collection exactly the way the sorted index does, so entry i is on server page
   floor(i / pageSize) + 1. Verified against the live site on pages 1, 7, 42 and
   82 — first and last card of each matched the prediction exactly. So a query
   with 9 matches fetches at most 9 pages instead of 82, a query with 1 match
   fetches 1, and the count is exact rather than a floor.

   Cached in sessionStorage so it is built at most once per session. Every
   consumer treats it as an optimisation: if it fails to build, is stale, or a
   fetched page does not contain the number the index predicted, the caller falls
   back to the existing sweep and nothing is worse than before. */
window.__deDigitIndex = (function () {
  'use strict';
  /* de-index-persist-2026-09-19 — localStorage, not sessionStorage.

     Owner: "i want it to feel instant and seamless". A session-scoped cache meant
     every new tab rebuilt the index from 17 sitemaps, and until it landed the page
     had nothing to answer with but Shopify's own count — which for a digit query
     is not merely late, it is wrong ("9999" opened on 821, settled on 600). Held
     across visits it is on disk before the buyer has typed anything, and the first
     search of the day is as instant as the tenth.

     A cache of the catalogue can go out of date, so it is stamped and revalidated
     in the background past twelve hours: the stale copy paints immediately, the
     fresh one replaces it, and anything drifting in between is a number or two out
     of 16,298 — self-correcting, and invisible next to a wrong count or no count
     at all. */
  var KEY = 'de_dx_idx_v2';
  /* de-index-freshness-2026-09-20 — two hours, not twelve.

     A cached index that is a day old quotes a total for numbers that have since
     sold: q=8 read "11,231 matches" and the last page rendered 29 cards where the
     label promised 31, because two had gone. The cards were right and the total
     was old. Revalidation is 17 gzipped sitemaps at idle, so it is cheap enough to
     do far more often than the drift deserves. */
  var MAX_AGE = 2 * 3600 * 1000;
  var arr = null;         // sorted digit strings
  var building = null;    // in-flight build promise
  var wasStale = false;

  function fromStore() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return null;
      var bar = raw.indexOf('|');
      if (bar < 1) return null;
      var t = +raw.slice(0, bar), body = raw.slice(bar + 1);
      if (body.length < 100 || body.length % 10 !== 0) return null;
      wasStale = !(t > 0) || (Date.now() - t) > MAX_AGE;
      var out = [], n = body.length / 10;
      for (var i = 0; i < n; i++) out.push(body.substr(i * 10, 10));
      return out;
    } catch (e) { return null; }
  }

  function toStore(list) {
    try { localStorage.setItem(KEY, Date.now() + '|' + list.join('')); } catch (e) { /* quota / private mode */ }
  }

  function fetchText(url) {
    var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 12000) : null;
    return fetch(url, { signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .catch(function () { return ''; })
      .then(function (t) { if (timer) clearTimeout(timer); return t; });
  }

  /* Product handles are the number, so the digits fall straight out of the URL.
     Anything that is not a 10-digit handle (a non-number product) is ignored. */
  function digitsFrom(xml) {
    var out = [], re = /\/products\/(\d{3}-\d{3}-\d{4})\b/g, m;
    while ((m = re.exec(xml))) out.push(m[1].replace(/-/g, ''));
    return out;
  }

  function build() {
    if (building) return building;
    var cached = fromStore();
    if (cached) {
      arr = cached;
      building = Promise.resolve(arr);
      if (wasStale) {
        wasStale = false;
        /* Well after the page has settled — this is housekeeping, not something
           anyone is waiting on. */
        setTimeout(function () {
          var again = netBuild();
          if (again) again.then(function (fresh) {
            if (!fresh || !fresh.length) return;
            arr = fresh;
            try { document.dispatchEvent(new CustomEvent('de:index-refreshed')); } catch (e) {}
          });
        }, 3000);
      }
      return building;
    }
    building = netBuild();
    return building;
  }

  function netBuild() {
    return fetchText('/sitemap.xml').then(function (root) {
      if (!root) return null;
      var urls = [], re = /<loc>\s*([^<]*sitemap_products_[^<]*)<\/loc>/g, m;
      while ((m = re.exec(root))) urls.push(m[1].replace(/&amp;/g, '&').trim());
      if (!urls.length) return null;
      // 17 small gzipped files; all at once is well within a browser's per-host
      // budget and finishes in about the time one of them takes on its own.
      return Promise.all(urls.map(fetchText)).then(function (parts) {
        var all = [];
        for (var i = 0; i < parts.length; i++) {
          var d = digitsFrom(parts[i]);
          for (var j = 0; j < d.length; j++) all.push(d[j]);
        }
        if (all.length < 1000) return null;         // clearly incomplete — do not trust it
        all.sort();
        // de-dupe defensively; a number must never be counted twice.
        var uniq = [all[0]];
        for (var k = 1; k < all.length; k++) if (all[k] !== all[k - 1]) uniq.push(all[k]);
        arr = uniq;
        toStore(uniq);
        return arr;
      });
    }).catch(function () { return null; });
  }

  return {
    /* Resolves to the sorted array, or null if it could not be built.
       Callers MUST handle null by falling back to their existing path. */
    ready: function () { return build(); },
    /* Build it before anyone asks. A search typed against a cold index waits for
       it — measured once as "1 of 5 results for 28" still on screen at 12s while
       1,675 numbers contained 28. Every page warms it at idle instead, so the
       index is in sessionStorage long before the buyer reaches the search box. */
    warm: function () {
      var go = function () { try { build(); } catch (e) {} };
      if (window.requestIdleCallback) window.requestIdleCallback(go, { timeout: 4000 });
      else setTimeout(go, 1800);
    },
    /* Synchronous peek — null until ready() has resolved at least once. */
    peek: function () { return arr; },
    /* How well a number answers the digits that were typed. Lower is better.

       "Contains it somewhere" is the correct RULE but a terrible ORDER. Typing "6"
       matches 9,789 numbers, and in catalogue order the page opened with
       929-565-5577 and 631-883-5500 — a 6 buried in the middle of each. Nobody
       typing "6" means that. The store's own search overlay reads better for the
       same query precisely because it leads with 610-…, and that is the whole
       difference: WHERE the digits land.

       A phone number has three groups (3-3-4), so a match that starts a group is
       the one a buyer means — the area code first, then the prefix, then the line.
       A match that also ENDS on a group boundary is the strongest of all: "626"
       filling the area code, "9999" filling the line. A match adrift in the middle
       of a group is the weakest thing we can show, so it sinks below every aligned
       one. */
    score: function (d, q) {
      var i = d.indexOf(q);
      if (i < 0) return 9999;
      var e = i + q.length;
      var starts = (i === 0 || i === 3 || i === 6);
      var ends = (e === 3 || e === 6 || e === 10);
      /* Four tiers, because "starts a group" alone ranked badly in practice: for
         "9999" it floated 267-999-9777 (the digits straddling the prefix and the
         line) above 559-388-9999, and a number ENDING in four nines is the one
         anybody typing 9999 is after. Filling a group outright is its own tier,
         ordered area -> prefix -> line so "626" leads with the 626 area code. */
      if (starts && ends) return (i === 0 ? 0 : i === 3 ? 1 : 2);   // fills a whole group
      if (starts) return 10 + i;                                    // starts one, spills over
      if (ends) return 20 + i;                                      // lands on a group end
      return 30 + i;                                                // adrift mid-group
    },
    /* Every number containing `q`, best answers first, each with its position in
       the sorted catalogue so the caller can work out its server page. */
    matches: function (q, limit) {
      if (!arr || !/^\d+$/.test(q)) return null;
      var self = this, out = [];
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].indexOf(q) !== -1) out.push({ d: arr[i], i: i, s: self.score(arr[i], q) });
      }
      out.sort(function (a, b) { return a.s !== b.s ? a.s - b.s : (a.d < b.d ? -1 : a.d > b.d ? 1 : 0); });
      return limit ? out.slice(0, limit) : out;
    },
    /* Exact total — the whole point of the index. No "+" floors. */
    count: function (q) {
      if (!arr || !/^\d+$/.test(q)) return null;
      var n = 0;
      for (var i = 0; i < arr.length; i++) if (arr[i].indexOf(q) !== -1) n++;
      return n;
    },
    size: function () { return arr ? arr.length : 0; }
  };
})();
try { window.__deDigitIndex.warm(); } catch (e) {}

/* de-price-index-2026-09-19 — every price in the catalogue, in one 58KB file.

   Owner: "i want it to feel instant and seamless, instead of waiting for the
   count to go up".

   That waiting had a single cause. The digit index knows every number we sell but
   not what any of them costs, so a price band was the one filter nothing could
   answer in advance — the only way to count it was to fetch product cards and
   look. Measured on /search?q=9999 with a $500-$1500 band: the headline climbed
   411+ -> 531+ -> 600 over about twenty seconds. Correct at the end, and wrong
   the whole way there.

   Prices are far cheaper to carry than cards. There are only 59 distinct prices
   across 16,298 products, so each packs into one character against a table, and
   the digits sort and gzip extremely well: 176KB of JSON, 58KB on the wire, one
   CDN request — less than a tenth of a single page of rendered cards (769KB),
   and it answers every price question for every filter combination at once.

   Built from ?view=dxdata (templates/collection.dxdata.liquid). It is a snapshot,
   so the sitemap index stays the authority on what EXISTS and this is consulted
   only for the price of something that index already confirmed. Digits the
   snapshot has never heard of count as unknown, and past a small tolerance the
   caller drops back to streaming rather than quote a figure it cannot stand
   behind. */
window.__dePriceIndex = (function () {
  'use strict';
  var KEY = 'de_dx_px_v2';
  /* de-index-freshness-2026-09-20 — two hours, not twelve.

     A cached index that is a day old quotes a total for numbers that have since
     sold: q=8 read "11,231 matches" and the last page rendered 29 cards where the
     label promised 31, because two had gone. The cards were right and the total
     was old. Revalidation is 17 gzipped sitemaps at idle, so it is cheap enough to
     do far more often than the drift deserves. */
  var MAX_AGE = 2 * 3600 * 1000;
  var AL = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_';
  var doc = null, building = null, byChar = null;
  var _aligned = null, _alignFor = -1;

  function url() {
    if (window.dePricesUrl) return window.dePricesUrl;
    /* Same asset folder as the area-code map, which every search page already
       carries. The ?v= hash is only cache-busting; the bare path serves fine. */
    var m = window.deInventoryMetaUrl;
    if (m) return m.split('?')[0].replace('de-inventory-meta.json', 'de-prices.json');
    return null;
  }

  function build(raw) {
    try {
      var d = JSON.parse(raw);
      if (!d || !d.k || !d.x || !d.p || !d.p.length) return false;
      if (d.x.length * 10 !== d.k.length) return false;
      var bc = {};
      for (var i = 0; i < d.p.length; i++) bc[AL.charAt(i)] = d.p[i];
      doc = d; byChar = bc; _aligned = null; _alignFor = -1;
      return true;
    } catch (e) { return false; }
  }

  function refetch(u) {
    fetch(u, { cache: 'reload' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (t) {
        if (!t || !build(t)) return;
        try { localStorage.setItem(KEY, Date.now() + '|' + t); } catch (e) {}
        try { document.dispatchEvent(new CustomEvent('de:index-refreshed')); } catch (e) {}
      })
      .catch(function () {});
  }

  function load() {
    if (doc) return Promise.resolve(true);
    if (building) return building;
    var u = url();
    if (!u || !window.fetch) return Promise.resolve(false);
    /* Held across visits like the digit index, and revalidated the same way: a
       day-old price list is worth far more than a count that has to be waited for,
       and the refresh lands long before it could matter. */
    var stale = false;
    try {
      var raw = localStorage.getItem(KEY);
      if (raw) {
        var bar = raw.indexOf('|');
        if (bar > 0 && build(raw.slice(bar + 1))) {
          stale = (Date.now() - (+raw.slice(0, bar) || 0)) > MAX_AGE;
          if (stale) setTimeout(function () { refetch(u); }, 3500);
          return Promise.resolve(true);
        }
      }
    } catch (e) {}
    building = fetch(u, { cache: 'force-cache' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (t) {
        if (!t || !build(t)) return false;
        try { localStorage.setItem(KEY, Date.now() + '|' + t); } catch (e) {}
        return true;
      })
      .catch(function () { return false; });
    return building;
  }

  return {
    ready: load,
    peek: function () { return !!doc; },
    warm: function () {
      var go = function () { try { load(); } catch (e) {} };
      if (window.requestIdleCallback) requestIdleCallback(go, { timeout: 4000 });
      else setTimeout(go, 1200);
    },
    /* Price in cents, or -1 if this snapshot has never seen the number. */
    cents: function (dg) {
      if (!doc) return -1;
      var lo = 0, hi = doc.x.length - 1;
      while (lo <= hi) {
        var mid = (lo + hi) >> 1, v = doc.k.substr(mid * 10, 10);
        if (v < dg) lo = mid + 1;
        else if (v > dg) hi = mid - 1;
        else return byChar[doc.x.charAt(mid)];
      }
      return -1;
    },
    /* Both lists are sorted, so ONE merge walk lines them up — 16,298 steps, no
       per-number search — and every count after it is a tight loop over an
       Int32Array rather than 16,298 binary searches. */
    align: function (all) {
      if (!doc || !all || !all.length) return null;
      if (_alignFor === all.length && _aligned) return _aligned;
      var out = new Int32Array(all.length), j = 0, n = doc.x.length, k = doc.k;
      for (var i = 0; i < all.length; i++) {
        var d = all[i];
        while (j < n && k.substr(j * 10, 10) < d) j++;
        out[i] = (j < n && k.substr(j * 10, 10) === d) ? byChar[doc.x.charAt(j)] : -1;
      }
      _aligned = out; _alignFor = all.length;
      return out;
    },
    size: function () { return doc ? doc.x.length : 0; }
  };
})();

(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // -------------------------------------------------------------------
  // 1. Stagger reveal — auto-applies to .reveal-stagger elements
  // -------------------------------------------------------------------
  document.addEventListener('DOMContentLoaded', function () {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.reveal-stagger').forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    document.querySelectorAll('.reveal-stagger').forEach(function (el) {
      io.observe(el);
    });
    // Safety net: force-reveal anything still hidden after 2.5s (prevents
    // permanent blank cards if IO is throttled or scroll never reaches it).
    setTimeout(function () {
      document.querySelectorAll('.reveal-stagger:not(.is-visible)').forEach(function (el) {
        el.classList.add('is-visible');
      });
    }, 2500);
  });

  // -------------------------------------------------------------------
  // 2. Image blur-up / fade-in
  //    Pre-flag below-the-fold imgs with .de-fade-in (opt-in)
  // -------------------------------------------------------------------
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('img.de-fade-in').forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) {
        img.classList.add('is-loaded');
      } else {
        img.addEventListener('load', function () { img.classList.add('is-loaded'); }, { once: true });
        img.addEventListener('error', function () { img.classList.add('is-loaded'); }, { once: true });
      }
    });
  });

  // -------------------------------------------------------------------
  // 3. Stat count-up — <span class="de-stat" data-target="15593"></span>
  // -------------------------------------------------------------------
  function animateCount(el) {
    var target = parseFloat(el.getAttribute('data-target') || '0');
    var duration = parseInt(el.getAttribute('data-duration') || '1400', 10);
    var decimals = parseInt(el.getAttribute('data-decimals') || '0', 10);
    var prefix = el.getAttribute('data-prefix') || '';
    var suffix = el.getAttribute('data-suffix') || '';
    var startTs = null;
    var format = function (n) {
      var fixed = n.toFixed(decimals);
      // thousands separator for ints / large floats
      var parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    };
    if (prefersReducedMotion) {
      el.textContent = prefix + format(target) + suffix;
      el.classList.add('is-counted');
      el.setAttribute('data-counted', 'true');
      return;
    }
    el.classList.add('is-counted');
    var step = function (ts) {
      if (!startTs) startTs = ts;
      var p = Math.min((ts - startTs) / duration, 1);
      // ease-out cubic
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = prefix + format(target * eased) + suffix;
      if (p < 1) requestAnimationFrame(step);
      else { el.textContent = prefix + format(target) + suffix; el.setAttribute('data-counted', 'true'); }
    };
    requestAnimationFrame(step);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var stats = document.querySelectorAll('.de-stat[data-target]');
    if (!stats.length) return;
    if (!('IntersectionObserver' in window)) {
      stats.forEach(animateCount);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateCount(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });
    stats.forEach(function (s) { s.setAttribute('data-counted', 'false'); io.observe(s); });
  });

  // -------------------------------------------------------------------
  // 4. Trust strip marquee — duplicate items so the loop is seamless
  //    Opt-in: <div class="de-trust-strip de-trust-strip--marquee">
  //              <div class="de-trust-strip__track">…</div>
  //            </div>
  // -------------------------------------------------------------------
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.de-trust-strip--marquee .de-trust-strip__track').forEach(function (track) {
      if (track.dataset.dupedMarquee) return;
      var clone = track.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.parentNode.appendChild(clone);
      track.dataset.dupedMarquee = '1';
    });
  });

  // -------------------------------------------------------------------
  // 5. Cart count bump — listen for 'de:cart-updated' custom event
  //    Also auto-listens for fetch posts to /cart/add.js (best-effort)
  // -------------------------------------------------------------------
  function bumpCart(count) {
    var btn = document.querySelector('[data-de-cart-toggle]');
    var el = document.querySelector('.de-headerY__cart-badge') || document.querySelector('.de-header__cart-count');
    if (typeof count === 'number') {
      if (count <= 0) { if (el) el.remove(); return; }
      if (!el) {
        if (!btn) return;
        el = document.createElement('span');
        el.className = 'de-headerY__cart-badge';
        btn.appendChild(el);
      }
      el.textContent = String(count);
      el.setAttribute('aria-label', count + (count === 1 ? ' item' : ' items'));
    }
    if (!el) return;
    el.classList.remove('is-bumped');
    // re-trigger animation
    void el.offsetWidth;
    el.classList.add('is-bumped');
    setTimeout(function () { el.classList.remove('is-bumped'); }, 600);
  }
  // PDP "Copy link" save-for-later button
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-de-copy-link]');
    if (!btn) return;
    var url = window.location.origin + window.location.pathname;
    function done() {
      var orig = btn.innerHTML;
      btn.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M5 12l5 5 9-11"/></svg>Link copied';
      btn.classList.add('is-copied');
      setTimeout(function () { btn.innerHTML = orig; btn.classList.remove('is-copied'); }, 1800);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done, done);
    } else {
      var ta = document.createElement('textarea');
      ta.value = url; document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); } catch (err) {}
      document.body.removeChild(ta);
      done();
    }
  });

  window.addEventListener('de:cart-updated', function (e) {
    bumpCart(e.detail && typeof e.detail.count === 'number' ? e.detail.count : undefined);
  });
  // best-effort: monitor fetch for /cart/add and /cart/change
  try {
    var origFetch = window.fetch;
    if (origFetch) {
      window.fetch = function () {
        var args = arguments;
        var p = origFetch.apply(this, args);
        var url = '';
        try { url = (typeof args[0] === 'string') ? args[0] : (args[0] && args[0].url) || ''; } catch (_) {}
        if (/\/cart\/(add|change|update)(\.js)?/.test(url)) {
          p.then(function (r) {
            // refetch cart to get authoritative count
            origFetch('/cart.js', { credentials: 'same-origin' })
              .then(function (cr) { return cr.json(); })
              .then(function (cart) {
                if (cart && typeof cart.item_count === 'number') {
                  window.dispatchEvent(new CustomEvent('de:cart-updated', { detail: { count: cart.item_count } }));
                }
              })
              .catch(function () {});
            return r;
          }).catch(function () {});
        }
        return p;
      };
    }
  } catch (e) { /* ignore */ }

  // -------------------------------------------------------------------
  // 6. Ripple effect — buttons with data-ripple
  // -------------------------------------------------------------------
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ripple]');
    if (!btn || prefersReducedMotion) return;
    var rect = btn.getBoundingClientRect();
    btn.style.setProperty('--ripple-x', (e.clientX - rect.left) + 'px');
    btn.style.setProperty('--ripple-y', (e.clientY - rect.top) + 'px');
    btn.classList.remove('is-rippling');
    void btn.offsetWidth;
    btn.classList.add('is-rippling');
    setTimeout(function () { btn.classList.remove('is-rippling'); }, 620);
  });

  // -------------------------------------------------------------------
  // 7. Hero media parallax — subtle, throttled with rAF
  //    Opt-in: add data-parallax to .de-hero__media (or any element)
  //    Optional data-parallax-speed (default 0.12 — clamp 0..0.3)
  // -------------------------------------------------------------------
  (function setupParallax() {
    if (prefersReducedMotion) return;
    var els = document.querySelectorAll('[data-parallax]');
    if (!els.length) return;
    var ticking = false;
    var update = function () {
      els.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        var center = rect.top + rect.height / 2;
        var vh = window.innerHeight;
        var dist = (center - vh / 2) / vh; // -0.5..0.5 typical
        var speed = parseFloat(el.getAttribute('data-parallax-speed') || '0.12');
        speed = Math.max(0, Math.min(speed, 0.3));
        el.style.transform = 'translate3d(0, ' + (-dist * speed * 100).toFixed(1) + 'px, 0)';
      });
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
    update();
  })();

  // -------------------------------------------------------------------
  // 8. Toast helper — window.deToast(msg, opts?)
  // -------------------------------------------------------------------
  // Persistent live region: screen readers only announce changes INSIDE a
  // pre-existing aria-live element — a toast inserted with its text already
  // set is silent in most SR/browser combos. The visual toast stays as-is;
  // this hidden region mirrors every message so it is actually spoken.
  var srStatus = document.getElementById('de-sr-status');
  if (!srStatus) {
    srStatus = document.createElement('div');
    srStatus.id = 'de-sr-status';
    srStatus.setAttribute('aria-live', 'polite');
    srStatus.setAttribute('role', 'status');
    srStatus.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;';
    (document.body || document.documentElement).appendChild(srStatus);
  }
  window.deToast = function (message, opts) {
    opts = opts || {};
    var variant = opts.variant || 'default';
    var duration = opts.duration || 2600;
    srStatus.textContent = '';
    setTimeout(function () { srStatus.textContent = message; }, 50);
    var existing = document.querySelector('.de-toast');
    if (existing) existing.remove();
    var t = document.createElement('div');
    t.className = 'de-toast' + (variant !== 'default' ? ' de-toast--' + variant : '');
    t.setAttribute('aria-hidden', 'true');
    t.textContent = message;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-visible'); });
    setTimeout(function () {
      t.classList.remove('is-visible');
      setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 400);
    }, duration);
  };

  // -------------------------------------------------------------------
  // 9. Magnetic CTAs — DISABLED (owner: 2026-05-10).
  //    Cursor-following translate on buttons was nauseating; killed.
  //    Clear any stale inline transform on opt-in elements at boot.
  // -------------------------------------------------------------------
  (function disableMagnetic() {
    document.querySelectorAll('[data-magnetic]').forEach(function (el) {
      el.style.transform = '';
      el.removeAttribute('data-magnetic');
    });
  })();

  // -------------------------------------------------------------------
  // 10. Auto-mark below-the-fold images for fade-in (opt-out via .no-fade)
  //     Skips icons (<= 32px) and existing logos to avoid layout pop.
  // -------------------------------------------------------------------
  document.addEventListener('DOMContentLoaded', function () {
    if (prefersReducedMotion) return;
    document.querySelectorAll('main img:not(.no-fade):not(.de-fade-in)').forEach(function (img) {
      var rect = img.getBoundingClientRect();
      if ((rect.width >= 80 || rect.height >= 80) && rect.top > window.innerHeight * 0.6) {
        img.classList.add('de-fade-in');
        if (img.complete && img.naturalWidth > 0) img.classList.add('is-loaded');
        else img.addEventListener('load', function () { img.classList.add('is-loaded'); }, { once: true });
      }
    });
  });

  // -------------------------------------------------------------------
  // 11. Anchor heading copy-link — click on h2/h3 with id copies URL
  //      Adds an unobtrusive cue via toast.
  // -------------------------------------------------------------------
  document.addEventListener('click', function (e) {
    var heading = e.target.closest('.de-article__body h2[id], .de-article__body h3[id]');
    if (!heading) return;
    if (e.target !== heading) return; // only when clicking the heading itself
    try {
      var url = window.location.origin + window.location.pathname + '#' + heading.id;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () {
          if (typeof window.deToast === 'function') window.deToast('Link copied');
        }).catch(function () {});
      }
    } catch (_) {}
  });

  // -------------------------------------------------------------------
  // 12. Click-to-copy on [data-copy] (PDP phone, any tagged element)
  //     Reads data-phone first, then textContent. Adds .is-copied for
  //     CSS confirmation flash. Falls back gracefully if clipboard is
  //     unavailable (older Safari, http context).
  //     Skips bubbled clicks from inside [data-copy] descendants that
  //     already have their own handlers (e.g. anchor tags).
  // -------------------------------------------------------------------
  function flashCopied(el) {
    el.classList.remove('is-copied');
    void el.offsetWidth;
    el.classList.add('is-copied');
    setTimeout(function () { el.classList.remove('is-copied'); }, 1400);
  }
  function legacyCopy(value, el) {
    try {
      var ta = document.createElement('textarea');
      ta.value = value;
      ta.setAttribute('readonly', '');
      ta.style.position = 'absolute';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      flashCopied(el);
      if (typeof window.deToast === 'function') window.deToast(value + ' copied', { variant: 'success', duration: 1800 });
    } catch (e) { /* ignore */ }
  }
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-copy]');
    if (!el) return;
    // If the element is a link to product page, allow normal nav AND copy in parallel.
    var raw = el.getAttribute('data-phone') || el.textContent;
    if (!raw) return;
    var value = raw.replace(/\s+/g, ' ').trim();
    if (el.tagName === 'BUTTON') { e.preventDefault(); }
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(value).then(function () {
          flashCopied(el);
          if (typeof window.deToast === 'function') window.deToast(value + ' copied', { variant: 'success', duration: 1800 });
        }).catch(function () { legacyCopy(value, el); });
      } else {
        legacyCopy(value, el);
      }
    } catch (err) {
      if (typeof window.deToast === 'function') window.deToast('Tap and hold to copy: ' + value, { duration: 2400 });
    }
  });

  // -------------------------------------------------------------------
  // 13. Format US phone number text — visual only, applied to the DECORATIVE
  //     mockups and .de-product__phone--copyable / .de-sticky-cta__sub.
  //     .de-card__phone is deliberately NOT in this list: rewriting card
  //     numbers to (xxx) xxx-xxxx after first paint caused a visible
  //     flicker, and it replaced the dashed string that Google actually
  //     matches — plain searches for 217-916-8000 return our pages, the
  //     parenthesised form returns none. Cards render dashed server-side
  //     when inner text is a 10/11-digit US number. The data-phone payload
  //     stays raw for the copy handler.
  // -------------------------------------------------------------------
  // Exposed so cards the collection deep-scan APPENDS later (which aren't present
  // at DOMContentLoaded) get the same formatting — otherwise a filtered/sorted list
  // shows the initial server-page numbers as "(XXX) XXX-XXXX" and every appended one
  // as raw "XXX-XXX-XXXX". Idempotent + guarded so re-runs are cheap; data-phone stays
  // raw for the copy handler.
  window.deFormatPhones = function (root) {
    var sel = '.de-product__phone--copyable, .de-sticky-cta__sub, .de-mockup__card-phone, .de-mockup__sign-phone, .de-mockup__truck-phone, .de-mockup__billboard-phone, .de-mockup__phone-number, .de-mockup__ad-phone';
    var scope = root || document;
    var els = scope.querySelectorAll(sel);
    Array.prototype.forEach.call(els, function (el) {
      if (el.getAttribute('data-de-fmt') === '1') return;
      var t = el.textContent.trim();
      var digits = t.replace(/\D+/g, '');
      if (digits.length === 10) {
        el.textContent = '(' + digits.slice(0, 3) + ') ' + digits.slice(3, 6) + '-' + digits.slice(6);
        el.setAttribute('data-de-fmt', '1');
      } else if (digits.length === 11 && digits.charAt(0) === '1') {
        el.textContent = '+1 (' + digits.slice(1, 4) + ') ' + digits.slice(4, 7) + '-' + digits.slice(7);
        el.setAttribute('data-de-fmt', '1');
      }
    });
  };
  document.addEventListener('DOMContentLoaded', function () { window.deFormatPhones(document); });

  // -------------------------------------------------------------------
  // 14a. Card actions — Add to cart (AJAX) + Buy now (permalink fallback
  //      with optimistic redirect). Uses Shopify cart APIs. Fires
  //      'de:cart-updated' so the header bumps and drawer refreshes.
  // -------------------------------------------------------------------
  function postCartAdd(variantId) {
    var body = JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 });
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw j; });
      return r.json();
    });
  }
  // ── ADD-TO-CART BUTTON STATE ───────────────────────────────────────────
  // The label lives in a nested structure: <span>Add<span class="de-card__btn-suffix">
  // to cart</span></span>. The suffix span is what CSS hides on a narrow card so the
  // label reads just "Add". The old code did span.textContent = 'Added', which DESTROYS
  // that nested span, then restored a plain string — so the suffix was gone for good and
  // the full "Add to cart" rendered where only "Add" fits, overflowing the button
  // ("Add to car"). Keep the original innerHTML and restore that instead.
  //
  // It also reverted on a blind 2400ms timer, so a button went back to "Add to cart"
  // while the number was still sitting in the cart. State now follows the CART, not a
  // clock: added while it is in there, reverted when it is not.
  var deLabelHTML = new WeakMap();
  function deSyncAddButtons(cart) {
    var ids = {};
    if (cart && cart.items) {
      for (var i = 0; i < cart.items.length; i++) ids[String(cart.items[i].variant_id)] = true;
    }
    var btns = document.querySelectorAll('[data-de-add]');
    for (var j = 0; j < btns.length; j++) {
      var btn = btns[j];
      var sp = btn.querySelector('span');
      if (sp && !deLabelHTML.has(btn)) deLabelHTML.set(btn, sp.innerHTML);
      if (btn.classList.contains('is-loading')) continue;
      var inCart = ids[String(btn.getAttribute('data-de-add'))] === true;
      if (inCart) {
        btn.classList.add('is-added');
        if (sp && sp.textContent.trim() !== 'Added') sp.textContent = 'Added';
      } else {
        btn.classList.remove('is-added');
        if (sp && deLabelHTML.has(btn)) sp.innerHTML = deLabelHTML.get(btn);
      }
    }
  }
  // The drawer already embeds the cart on every page, so the initial sync costs no request.
  function deBootCart() {
    try {
      var el = document.getElementById('de-cart-boot-data');
      return el ? JSON.parse(el.textContent || '{}') : null;
    } catch (e) { return null; }
  }
  function deSyncFromBoot() { deSyncAddButtons(deBootCart()); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', deSyncFromBoot);
  else deSyncFromBoot();
  // The PDP quick-buy bar is BUILT BY JS (block 22a) after DOMContentLoaded, so the
  // sync above runs before its Add button exists and that button kept saying "Add to
  // cart" for a number already in the cart — inconsistent with every product card on
  // the site. Re-sync on load, by which time the bar has been appended.
  window.addEventListener('load', deSyncFromBoot);
  window.addEventListener('de:cart-updated', function (e) {
    if (e && e.detail && e.detail.cart) deSyncAddButtons(e.detail.cart);
    else fetch('/cart.js', { credentials: 'same-origin' })
           .then(function (r) { return r.json(); }).then(deSyncAddButtons).catch(function () {});
  });

  function refreshCartCount() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && typeof cart.item_count === 'number') {
          // Publish the CART, not just the count. The drawer used to receive only a
          // count and then fetch /cart.js all over again to find out what was in it;
          // the drawer opens 250ms after this fires, so that second round-trip was
          // often still in flight and the drawer opened before it had contents.
          // Anything listening for `count` is unaffected — this only adds a field.
          window.dispatchEvent(new CustomEvent('de:cart-updated', { detail: { count: cart.item_count, cart: cart } }));
        }
        return cart;
      });
  }
  // Keep the header badge truthful across tabs and back-from-checkout:
  // refetch the count whenever this tab becomes visible again.
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') refreshCartCount();
  });
  // bfcache restore (back from checkout) fires pageshow, NOT visibilitychange —
  // without this, an abandoning buyer returns to a badge that denies their cart
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) refreshCartCount();
  });
  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-de-add]');
    if (addBtn) {
      e.preventDefault();
      e.stopPropagation();
      // Only a request in flight blocks a click. 'is-added' is now persistent, so
      // blocking on it would make an added card's button silently dead; letting it
      // through hits the already-in-cart branch below, which toasts and opens the drawer.
      if (addBtn.classList.contains('is-loading')) return;
      var variantId = addBtn.getAttribute('data-de-add');
      var phone = addBtn.getAttribute('data-de-phone') || '';
      addBtn.classList.add('is-loading');
      var _sp = addBtn.querySelector('span');
      if (_sp && !deLabelHTML.has(addBtn)) deLabelHTML.set(addBtn, _sp.innerHTML);
      // Every number is one of one — never allow the same variant twice.
      // The per-button is-added guard doesn't cover adding from a DIFFERENT
      // surface (PDP then collection card), which silently created qty 2 and
      // would charge the buyer twice for a single unique number.
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var already = cart && cart.items && cart.items.some(function (it) { return String(it.variant_id) === String(variantId); });
          if (already) {
            addBtn.classList.remove('is-loading');
            if (typeof window.deToast === 'function') {
              window.deToast((phone || 'This number') + ' is already in your cart — it’s one of one.', { variant: 'success', duration: 2400 });
            }
            var drawer0 = document.getElementById('de-cart-drawer');
            var trigger0 = document.querySelector('[data-de-cart-toggle]');
            if (drawer0 && trigger0 && !drawer0.classList.contains('is-open')) trigger0.click();
            return null;
          }
          return postCartAdd(variantId).then(function () {
        return refreshCartCount();
      }).then(function () {
        addBtn.classList.remove('is-loading');
        addBtn.classList.add('is-added');
        if (addBtn.querySelector('span')) addBtn.querySelector('span').textContent = 'Added';
        if (typeof window.deToast === 'function') {
          window.deToast(phone ? phone + ' added to cart' : 'Added to cart', { variant: 'success', duration: 2000 });
        }
        // Open cart drawer if available
        var drawer = document.getElementById('de-cart-drawer');
        var trigger = document.querySelector('[data-de-cart-toggle]');
        if (drawer && trigger && !drawer.classList.contains('is-open')) {
          setTimeout(function () { trigger.click(); }, 250);
        }
        // No timed revert. refreshCartCount() above fires de:cart-updated with the
        // cart, and deSyncAddButtons decides the state from what is actually in it —
        // so this stays "Added" for as long as the number is in the cart, and returns
        // to "Add to cart" the moment it is removed.
      }).catch(function (err) {
        addBtn.classList.remove('is-loading');
        var msg = (err && err.description) || (err && err.message) || 'Could not add — already in cart?';
        if (typeof window.deToast === 'function') window.deToast(msg, { variant: 'danger', duration: 2600 });
      });
        })
        .catch(function () {
          // /cart.js pre-check failed (network) — never strand the button
          addBtn.classList.remove('is-loading');
        });
      return;
    }
    var buyBtn = e.target.closest('[data-de-buy]');
    if (buyBtn) {
      buyBtn.classList.add('is-loading');
      // The href is a Shopify cart permalink, and permalinks REPLACE the cart —
      // a buyer who already added number A would silently lose it by tapping
      // Buy now on number B. If a cart with other items exists, add this
      // number instead (no duplicates — one of one) and check out with
      // everything. Empty cart keeps the fast permalink path. Any failure
      // falls back to the permalink so purchase is never blocked.
      var buyVariant = buyBtn.getAttribute('data-de-buy');
      var permalink = buyBtn.getAttribute('href');
      e.preventDefault();
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var items = (cart && cart.items) || [];
          var hasOthers = items.some(function (it) { return String(it.variant_id) !== String(buyVariant); });
          var hasThis = items.some(function (it) { return String(it.variant_id) === String(buyVariant); });
          if (!hasOthers) { window.location.href = permalink; return; }
          var add = hasThis ? Promise.resolve() : postCartAdd(buyVariant);
          add.then(function () { window.location.href = '/checkout'; })
             .catch(function () { window.location.href = permalink; });
        })
        .catch(function () { window.location.href = permalink; });
    }
  });

  // -------------------------------------------------------------------
  // 14. Collection filter bar v2 — state + area + pattern chips +
  //     dual-thumb price slider with log scale ($200-$100k range).
  //     Pulls real inventory metadata from /assets/de-inventory-meta.json
  //     so dropdowns reflect the full 15,593-product catalog, not just
  //     the 48 cards on the current paginated page.
  //     The grid itself is still client-filtered against rendered cards;
  //     for filters that have no match on this page, we hint the user
  //     to remove the filter or paginate.
  // -------------------------------------------------------------------
  document.addEventListener('DOMContentLoaded', function () {
    var grid = document.querySelector('[data-de-product-grid]');
    var bar = document.querySelector('[data-de-filter-bar]');
    if (!grid || !bar) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-de-product]'));
    if (!cards.length) return;
    var countEl = document.querySelector('[data-de-count-display]');
    // Mobile caption's count. Same number as countEl, phrased shorter -
    // both are written from ONE computation in apply() so they can never
    // disagree, which is the whole reason this is not a second counter.
    var capCountEl = document.querySelector('[data-de-filter-count]');
    var totalCount = cards.length;
    var emptyEl = document.querySelector('[data-de-empty]');

    var stateSelect = bar.querySelector('[data-de-filter="state"]');
    var areaSelect = bar.querySelector('[data-de-filter="area"]');
    var sortSelect = bar.querySelector('[data-de-filter="sort"]');

    // Shopify server-side sort_by map. We use the server's sort instead of
    // client-side reorder so it works correctly across the entire collection
    // (collections paginate at 60/page and client-side sort only sees the
    // visible page — useless for "show me the cheapest in 15,593 products").
    var SORT_TO_SHOPIFY = {
      'price-asc':  'price-ascending',
      'price-desc': 'price-descending',
      'phone-asc':  'title-ascending',
      'phone-desc': 'title-descending'
    };
    var SHOPIFY_TO_SORT = {
      'price-ascending':  'price-asc',
      'price-descending': 'price-desc',
      'title-ascending':  'phone-asc',
      'title-descending': 'phone-desc'
    };

    // Sync the sort select to the URL's sort_by param on initial load so the
    // dropdown shows the currently active server-side sort.
    (function syncSortFromURL() {
      if (!sortSelect) return;
      var urlSort = new URLSearchParams(window.location.search).get('sort_by');
      if (!urlSort) return;
      var match = SHOPIFY_TO_SORT[urlSort];
      if (match) sortSelect.value = match;
    })();

    // Fallback: count from the cards on this page (for state collection
    // pages, dropdowns scope to in-page values).
    function buildLocalCounts() {
      var sc = {}, ac = {}, areaToState = {};
      cards.forEach(function (c) {
        var s = (c.getAttribute('data-state') || '').trim();
        var a = (c.getAttribute('data-area') || '').trim();
        if (s) sc[s] = (sc[s] || 0) + 1;
        if (a) ac[a] = (ac[a] || 0) + 1;
        if (s && a) areaToState[a] = s;
      });
      return { states: sc, areas: ac, areaToState: areaToState };
    }

    // Verified area-code → city/region label map (all 344 inventory codes).
    // Powers the grouped-by-state area dropdown; mirrors the homepage finder.
    var DE_AREA_CITY = window.DE_AREA_CITY;

    var meta = null;
    function populateDropdowns() {
      // Prefer global inventory meta; fall back to in-page counts.
      var local = buildLocalCounts();
      var states, areas, areaToState;
      if (meta) {
        states = {};
        meta.states.forEach(function (s) { states[s.name] = s.count; });
        areas = {};
        areaToState = {};
        meta.area_codes.forEach(function (a) {
          areas[a.code] = a.count;
          if (a.state) areaToState[a.code] = a.state;
        });
      } else {
        states = local.states;
        areas = local.areas;
        areaToState = local.areaToState;
      }

      /* de-live-counts-2026-09-09
         Whatever the meta file said, Shopify's own products_count wins. The
         file is a snapshot — 90 days old when this was written — and every
         number is one-of-one, so a single sale makes it wrong with nothing to
         signal that: it offered "California (2,662)" while the California page
         rendered "2,594 numbers". These numbers are rendered by Liquid on this
         very request (see de-live-inventory in de-collection.liquid), so the
         dropdown and the page it sends you to cannot disagree.

         It also replaces the LIST of area codes, not just their counts, so the
         menu self-heals: a code that sells out drops off, a newly stocked one
         appears. Only the code -> state mapping still comes from the file,
         because that half really is static (626 is always California). */
      var liveEl = document.getElementById('de-live-inventory');
      if (liveEl) {
        try {
          var live = JSON.parse(liveEl.textContent);
          if (live && live.states && Object.keys(live.states).length) states = live.states;
          if (live && live.areas && Object.keys(live.areas).length) {
            areas = live.areas;
            if (!areaToState) areaToState = local.areaToState;
          }
        } catch (e) {}
      }

      if (stateSelect) {
        // Clear existing extra options
        while (stateSelect.options.length > 1) stateSelect.remove(1);
        Object.keys(states).sort().forEach(function (s) {
          var opt = document.createElement('option');
          opt.value = s;
          /* de-no-predictive-counts-2026-09-09
             NO COUNT HERE, deliberately. This option describes a page the
             browser has not loaded, so any number is a prediction — and
             Shopify serves collection HTML from its own page cache (measured:
             the same rendered-at timestamp for a full 2-minute poll, and a
             random query string does not defeat it). The dropdown and the
             page it sends you to are separate cache entries, so they can be
             rendered at different moments and disagree. That is precisely the
             failure the owner caught: "California (2,662)" leading to a page
             saying "2,594 numbers".

             The live figures ARE still read (see the live-counts block above)
             — they decide WHICH states and area codes the menu offers, so the
             menu self-heals — but a number the buyer could act on is not
             printed unless it is exact.

             Counts on the SEARCH page are a different matter and stay: those
             are computed from the result cards already in the browser, so
             "212 (17)" means seventeen cards are sitting there waiting. That
             is a description, not a forecast. */
          opt.textContent = s;
          stateSelect.appendChild(opt);
        });
      }
      if (areaSelect) {
        // Grouped by state (alphabetical), codes ascending within each state,
        // labelled "code — City" — matches the homepage finder format.
        Array.prototype.slice.call(areaSelect.querySelectorAll('optgroup'))
          .forEach(function (g) { g.remove(); });
        while (areaSelect.options.length > 1) areaSelect.remove(1);
        var codesByState = {};
        Object.keys(areas).forEach(function (a) {
          var st = areaToState[a] || '';
          (codesByState[st] = codesByState[st] || []).push(a);
        });
        function addAreaOption(parent, a, st) {
          var opt = document.createElement('option');
          opt.value = a;
          var city = DE_AREA_CITY[a];
          /* No count, for the reason spelled out on the State option above:
             it would be a prediction about a page-cached document. The live
             data still decides which codes appear at all. */
          opt.textContent = city ? (a + ' — ' + city) : a;
          opt.setAttribute('data-state', st || '');
          parent.appendChild(opt);
        }
        Object.keys(codesByState).filter(function (s) { return s; }).sort()
          .forEach(function (st) {
            var og = document.createElement('optgroup');
            og.label = st;
            codesByState[st].sort(function (a, b) { return parseInt(a, 10) - parseInt(b, 10); })
              .forEach(function (a) { addAreaOption(og, a, st); });
            areaSelect.appendChild(og);
          });
        // Any stateless codes (none expected) fall back to flat options.
        (codesByState[''] || []).sort(function (a, b) { return parseInt(a, 10) - parseInt(b, 10); })
          .forEach(function (a) { addAreaOption(areaSelect, a, ''); });
      }
    }

    function refilterAreasByState(stateName) {
      if (!areaSelect) return;
      Array.prototype.forEach.call(areaSelect.querySelectorAll('option'), function (o) {
        if (!o.value) return; // keep "Any area code" placeholder
        var s = o.getAttribute('data-state') || '';
        o.hidden = !(!stateName || s === stateName);
      });
      // Hide whole optgroups that don't match the chosen state so the grouped
      // list collapses to just the selected state's codes.
      Array.prototype.forEach.call(areaSelect.querySelectorAll('optgroup'), function (g) {
        g.hidden = !!stateName && g.label !== stateName;
      });
      // If the currently-selected area code doesn't belong to the chosen state, clear it
      if (areaSelect.value) {
        var sel = areaSelect.querySelector('option[value="' + areaSelect.value + '"]');
        if (sel && sel.hidden) areaSelect.value = '';
      }
    }

    // Defer dropdown population to keep initial LCP fast (~394 option
    // nodes were being inserted synchronously on DOMContentLoaded).
    // Tech audit 2026-05-17: collection page DOM bloat → TBT 870ms fix.
    // On a state collection page, scope the UI to that state: preselect the
    // state dropdown and limit area codes to the state's own — otherwise the
    // global list (340+) lets a California shopper pick a Georgia code and
    // scan to an inevitable zero. Called after EVERY dropdown (re)population,
    // including the async inventory-meta repopulate that would otherwise
    // rebuild the global list over the scoped one.
    // Page-scoped preselects describe the page itself, not a buyer choice.
    // They must never count as "active filters" (badge, chips, paginator
    // hiding) — otherwise merely sorting a state page hides the paginator
    // and strands every product past page 1.
    var __scopedState = '', __scopedArea = '';
    /* ── AN EXPLICIT STATE CHOICE HAS TO OUTLIVE THE JUMP ────────────────────
       Choosing California and then a code lands on /collections/area-code-213,
       and that URL says nothing about the state having been CHOSEN — it looks
       exactly like arriving at 213 cold. So the narrowing vanished mid-flow:
       reopen the area picker and all 344 codes are back, even though the buyer
       is still working inside California. Remember the chosen state for this
       tab (sessionStorage: survives a reload, dies with the tab, never touches
       the URL or SEO), and honour it only while the page is still inside that
       state. Leaving the state — Reset, All States, or a code from elsewhere —
       clears it, so a remembered state can never narrow a page it does not
       belong to. */
    var DE_STATE_MEM = 'de_state_scope';
    function stateMemGet() { try { return sessionStorage.getItem(DE_STATE_MEM) || ''; } catch (e) { return ''; } }
    function stateMemSet(v) { try { if (v) sessionStorage.setItem(DE_STATE_MEM, v); else sessionStorage.removeItem(DE_STATE_MEM); } catch (e) {} }
    function userState(s) { return (s.state && s.state !== __scopedState) ? s.state : ''; }
    function userArea(s) { return (s.area && s.area !== __scopedArea) ? s.area : ''; }
    function scopeToPageState() {
      var pageState = null;
      // STATE_TO_HANDLE is many-to-one: washington-dc is reachable as
      // 'District of Columbia', 'Washington DC', 'Washington, D.C.' and 'D.C.',
      // but the dataset only ever emits ONE of them ('Washington DC'). Taking
      // the first key that matched the handle therefore produced a value with
      // no matching <option>, the guard below refused it, and
      // /collections/washington-dc sat with a permanently blank state select.
      // Collect every alias and pick the one the select actually has.
      var __cands = [];
      for (var sn in STATE_TO_HANDLE) {
        if (STATE_TO_HANDLE[sn] === collectionHandle) __cands.push(sn);
      }
      if (__cands.length) {
        pageState = __cands[0];
        if (stateSelect) {
          for (var __ci = 0; __ci < __cands.length; __ci++) {
            var __hit = false;
            for (var __oi = 0; __oi < stateSelect.options.length; __oi++) {
              if (stateSelect.options[__oi].value === __cands[__ci]) { __hit = true; break; }
            }
            if (__hit) { pageState = __cands[__ci]; break; }
          }
        }
      }
      // area-code-XXX pages: preselect the code and derive its state from the
      // populated option's data-state (same zero-scan prevention as state pages)
      var acMatch = /^area-code-(\d{3})$/.exec(collectionHandle);
      var __stateFromCode = false;
      if (acMatch && areaSelect) {
        var codeOpt = areaSelect.querySelector('option[value="' + acMatch[1] + '"]');
        if (codeOpt) {
          areaSelect.value = acMatch[1];
          __scopedArea = acMatch[1];
          var __ds = codeOpt.getAttribute('data-state');
          if (__ds) { __stateFromCode = !__cands.length; pageState = __ds; }
        }
      }
      // A state carried as a URL tag (/collections/base/kansas) is page scope too,
      // not a buyer filter — otherwise the paginator hides and the select reads blank.
      if (!pageState) {
        for (var __ti = 0; __ti < urlTags.length; __ti++) {
          if (isStateTag(urlTags[__ti])) { pageState = stateNameForTag(urlTags[__ti]); break; }
        }
      }
      if (!pageState) { stateMemSet(''); return; }
      if (stateSelect && Array.prototype.some.call(stateSelect.options, function (o) { return o.value === pageState; })) {
        stateSelect.value = pageState;
        __scopedState = pageState;
      }
      /* ── DERIVED STATE MUST NOT NARROW THE PICKER ────────────────────────
         An area-code page derives its state from the CODE, so "California" on
         /collections/area-code-626 is a fact about where you are, not a filter
         the buyer chose. Scoping the area list to it strands them: they arrive
         using the area picker, and that same picker then offers only
         California's 39 codes (measured 345 -> 39), so 626 -> 212 is impossible
         without Reset or the back button, with nothing on screen saying the
         list shrank.
         The reason for scoping above — "a California shopper picks a Georgia
         code and scans to an inevitable zero" — is a STATE-page hazard: there
         the pick filters the page in place. On an area-code page the pick
         navigates to that code's own collection instead (verified: 626 -> 213
         lands on /collections/area-code-213 with 50 numbers), so there is no
         zero to protect against. The state select still reads "California" —
         that is useful, true, and the only thing on the page that says which
         state 626 belongs to. */
      var __remembered = stateMemGet();
      if (__stateFromCode) {
        /* derived state: the buyer must have chosen THIS state earlier */
        if (__remembered && __remembered !== pageState) { stateMemSet(''); __remembered = ''; }
      } else {
        /* a real state page is an explicit choice — remember it for the jumps that follow */
        stateMemSet(pageState); __remembered = pageState;
      }
      if ((!__stateFromCode || __remembered === pageState) && typeof refilterAreasByState === 'function')
        refilterAreasByState(pageState);
    }
    // Deep-link support: the homepage area finder sends codes without a
    // dedicated collection to /collections/all-numbers?area={code} (and may add
    // &state={State}). Apply those params as active filters on load so the page
    // lands already filtered. Runs once, after options exist.
    var __urlFiltersApplied = false;
    function applyUrlFilters() {
      if (__urlFiltersApplied) return false;
      var q;
      try { q = new URLSearchParams(window.location.search); } catch (e) { return false; }
      var a = q.get('area'), st = q.get('state'), did = false;

      if (st && stateSelect &&
          Array.prototype.some.call(stateSelect.options, function (o) { return o.value === st; })) {
        stateSelect.value = st;
        refilterAreasByState(st);
        did = true;
      }
      if (a && areaSelect) {
        var o = areaSelect.querySelector('option[value="' + a + '"]');
        if (o && !o.hidden) { areaSelect.value = a; did = true; }
      }
      /* A de_text fragment is a real filter even though it has no control in the
         bar, so it has to report itself here — this return value is what makes
         __populateOnce() run apply() and kick the sweep on a plain page load.
         Without it the param was parsed and then nothing ever asked for it. */
      if (deUrlDigits) did = true;
      if (did) __urlFiltersApplied = true;
      return did;
    }
    var __ddPopulated = false;
    function __populateOnce() {
      if (__ddPopulated) return;
      __ddPopulated = true;
      populateDropdowns();
      scopeToPageState();
      var urlDid = applyUrlFilters();
      // Rehydrate the buyer's filters after back-navigation (options now exist)
      if (restoreFilterSession()) {
        apply();
        setTimeout(function () { if (typeof ensureMatches === 'function') ensureMatches(); }, 350);
      } else if (urlDid) {
        apply();
        setTimeout(function () { if (typeof ensureMatches === 'function') ensureMatches(); }, 50);
      }
    }
    /* de-firstclick-2026-09-11 — populate BEFORE anyone can interact.

       This used to wait for requestIdleCallback(timeout 1500) and, as a safety
       net, populate on the select's own focus / mousedown / touchstart.

       Rebuilding a <select>'s <option> list during the very mousedown that is
       opening it makes the browser CANCEL the dropdown. So the first click did
       nothing, the second only focused the control (the visible focus ring),
       and the third finally opened it. Because the listener was on touchstart
       too, phones behaved identically, and because it lives on the native
       <select>, it happened with or without the custom dropdown layer — which
       is why rolling that layer back never helped.

       It only ever bit someone who clicked before the idle callback ran, i.e.
       exactly the person who hard-reloads and clicks straight away.

       Populating up front costs a few milliseconds once and removes the whole
       class of problem. Nothing may mutate these options during a click.

       It must NOT be called synchronously here: scopeToPageState() reads
       urlTags, STATE_TO_HANDLE and collectionHandle, which are `var`s declared
       further down this same module (lines ~1734 and ~1792). At this point they
       are hoisted but still undefined, so `urlTags.length` threw
       "Cannot read properties of undefined (reading 'length')" and took the
       whole filter module down with it. requestIdleCallback used to hide that
       by deferring past the end of the module.

       A microtask is the right scheduling primitive: it runs as soon as this
       script finishes executing — so every var above is assigned — and it is
       guaranteed to drain before the browser dispatches any user input, so the
       options can never be rebuilt during a click. */
    if (typeof queueMicrotask === 'function') queueMicrotask(__populateOnce);
    else Promise.resolve().then(__populateOnce);
    // A deep-link (?area=/?state=) must populate & filter immediately, not wait
    // for idle or a user interaction.
    (function () {
      var q; try { q = new URLSearchParams(window.location.search); } catch (e) { return; }
      if (q.get('area') || q.get('state')) __populateOnce();
    })();
    if (window.deInventoryMetaUrl) {
      fetch(window.deInventoryMetaUrl, { cache: 'force-cache' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; })
        .then(function (m) {
          if (m && m.area_codes) {
            meta = m;
            if (__ddPopulated) {
              populateDropdowns();
              scopeToPageState();
              // The full code list only exists now — re-apply a deep-link that
              // couldn't resolve against the in-page fallback list earlier.
              if (!__urlFiltersApplied && applyUrlFilters()) {
                apply();
                setTimeout(function () { if (typeof ensureMatches === 'function') ensureMatches(); }, 50);
              }
            }
          }
        });
    }

    // ---------- Price slider ----------
    var priceSlider = bar.querySelector('[data-de-price-slider]');
    var priceMinInput = bar.querySelector('[data-de-price-min]');
    var priceMaxInput = bar.querySelector('[data-de-price-max]');
    var priceMinLabel = bar.querySelector('[data-de-price-min-label]');
    var priceMaxLabel = bar.querySelector('[data-de-price-max-label]');
    var priceFill = bar.querySelector('[data-de-price-fill]');
    // Use a logarithmic mapping so the slider is useful across $200-$100k.
    // P_MIN/P_MAX default to a placeholder but are overwritten at runtime with
    // the REAL price range of whatever collection/tier/area is being viewed
    // (see the "Dynamic price bounds" block below) — never hardcoded ranges.
    var P_MIN_DOLLARS = 250, P_MAX_DOLLARS = 1000, deBoundsExact = false;
    // Cached exact range of the whole current collection (from the sorted
    // fetch), plus the last non-price filter signature — so the slider can snap
    // back to the collection range when combo filters clear, and recompute only
    // when something other than the price slider itself actually changed.
    var deCollMin = 250, deCollMax = 1000, deCollExact = false;
    // ★ SOURCE OF TRUTH for the price filter = DOLLARS, not the slider's % value.
    // deSelMin / deSelMax = selected min/max in dollars; null = that end is open
    // (no constraint). The 0–100 range inputs are only the drag mechanism — their
    // % gets its dollar meaning from the CURRENT bounds, which shift (async bounds
    // fetch, restore), so % can never be trusted as the selection. Keeping the
    // choice in dollars means chip, labels, thumbs and filter stay in sync no
    // matter how the bounds move underneath.
    var deSelMin = null, deSelMax = null;
    function pctToDollars(pct) {
      var t = Math.max(0, Math.min(100, pct)) / 100;
      var v = Math.exp(Math.log(P_MIN_DOLLARS) + t * (Math.log(P_MAX_DOLLARS) - Math.log(P_MIN_DOLLARS)));
      // Snap to nearest "nice" step
      if (v < 500) return Math.round(v / 10) * 10;
      if (v < 2000) return Math.round(v / 50) * 50;
      if (v < 10000) return Math.round(v / 100) * 100;
      /* de-stable-slider-2026-09-16 — $1,000 steps above $10k.
         $500 steps put half-thousands in the readout ("$131.5k", 7 characters) and
         the pill is sized by its text, so the widest value the slider can show sets
         how much room the track loses. Whole thousands cap it at 5 ("$131k") while
         reaching exactly the same prices — nobody filters $131.5k against $131k. */
      return Math.round(v / 1000) * 1000;
    }
    function dollarsToPct(d) {
      if (!(P_MAX_DOLLARS > P_MIN_DOLLARS)) return 0;
      var t = (Math.log(d) - Math.log(P_MIN_DOLLARS)) / (Math.log(P_MAX_DOLLARS) - Math.log(P_MIN_DOLLARS));
      return Math.max(0, Math.min(100, Math.round(t * 100)));
    }
    function fmtPrice(d) {
      if (d >= 1000) return '$' + (d / 1000).toFixed(d % 1000 === 0 ? 0 : 1) + 'k';
      return '$' + d;
    }
    /* de-rail-stable-2026-09-14 — pin the readout pills to the widest value this
       page can actually show, so the rail cannot be pushed sideways mid-drag.
       Sizing every pill to the catalogue-wide worst case ("$131.5k") would cost
       a short rail ~20px of travel, so it is measured per page: build every
       label the current scale can produce, measure the longest one once, and
       publish it as --de-pill-w. Re-run whenever the scale moves. */
    function deSizePills() {
      if (!priceMinLabel || !priceMaxLabel) return;
      var widest = '', best = 0, i, s;
      for (i = 0; i <= 100; i++) {
        s = fmtPrice(pctToDollars(i));
        if (s.length > best) { best = s.length; widest = s; }
      }
      /* the open high end renders with a trailing "+" until the bounds are exact */
      s = fmtPrice(P_MAX_DOLLARS) + '+';
      if (s.length > best) { best = s.length; widest = s; }
      var probe = priceMinLabel.cloneNode(false);
      probe.textContent = widest;
      probe.style.cssText = 'position:absolute;visibility:hidden;white-space:nowrap;--de-pill-w:0px;';
      priceMinLabel.parentNode.appendChild(probe);
      var w = Math.ceil(probe.getBoundingClientRect().width);
      probe.parentNode.removeChild(probe);
      if (w > 0) (bar.querySelector('[data-de-price-slider]') || bar).style.setProperty('--de-pill-w', w + 'px');
    }
    /* ═══ de-native-price-2026-09-15 ═══════════════════════════════════════
       Let SHOPIFY do the price filtering instead of scraping pages for it.

       The storefront honours filter.v.price.gte / filter.v.price.lte natively.
       Verified against the catalogue — 23 collection/band combinations, every
       count exact and every returned price inside the band — plus a partition
       test (count below X + count at-or-above X == unfiltered total) that came
       out exact on every collection and on the search page:

           /collections/texas       643 = 515 + 128
           /collections/california 2593 = 2144 + 449
           /collections/eights     3615 = 3180 + 435

       What it replaces: a client-side sweep that fetched page after page,
       appended thousands of cards, blocked the main thread for ~16s on
       /collections/california and still had to say "N+" because it could not
       finish. Native filtering answers in ONE request (~1.2s measured), returns
       an exact count, and paginates server-side at 200/page — so the DOM never
       grows and there is nothing to scan.

       LIMIT: Shopify disables storefront filtering above 5,000 products in a
       collection. Measured precisely — /collections/eights (3,615) filters,
       /collections/new-york (5,255) does not. Exactly three of the 425
       collections are over: all-numbers (16,315), base (14,011), new-york
       (5,255). Those keep the old client sweep; everything else takes this path.

       While a native filter is on, the price is part of the PAGE SCOPE, not a
       client-side filter — the same way a state or area collection is. So the
       cards need no re-filtering, the server paginator is the correct paginator,
       and the count on the grid is already the exact filtered total. */
    var DE_NATIVE_MAX = 5000;
    var deNat = (function () {
      try {
        var p = new URLSearchParams(window.location.search);
        var g = p.get('filter.v.price.gte'), l = p.get('filter.v.price.lte');
        if (g === null && l === null) return null;
        return { min: g === null ? null : parseFloat(g), max: l === null ? null : parseFloat(l) };
      } catch (e) { return null; }
    })();
    /* de-native-guard-2026-09-16 — price params in the URL are not proof the SERVER
       used them.

       Shopify only filters collections up to 5,000 products, and silently ignores
       filter.v.price on anything larger. This function used to answer "yes, the
       server filtered" from the URL alone, so on the three oversized collections
       the band was dropped by BOTH sides — Shopify ignored it, and we skipped our
       own client filtering because we believed Shopify had done it. Measured:

           /collections/all-numbers?filter.v.price.lte=300
               200 cards shown out of 16,308 — every price, no filter applied,
               while the address bar and the chip both claimed "up to $300"

       It is also what put two contradictory paginators on screen: price counted as
       page scope, so the SERVER pager stayed visible saying 82 pages of everything,
       next to a client pager describing the filtered set.

       The grid's own count settles it. On a collection Shopify filtered, that
       number IS the filtered total and sits under the limit; on one it ignored, the
       number is the whole collection and is over it. Over the limit therefore means
       "the server did nothing" — fall back to filtering here, which is correct,
       hides the stale server pager, and restores the exact count. */
    function deNativeOn() {
      if (!deNat) return false;
      var t = parseInt(grid.getAttribute('data-de-products-count'), 10) || 0;
      return !(t > DE_NATIVE_MAX);
    }
    function deNativeSupported() {
      if (deNativeOn()) return true;          // already proven on this page
      var t = parseInt(grid.getAttribute('data-de-products-count'), 10) || 0;
      return t > 0 && t <= DE_NATIVE_MAX;
    }
    /* Rebuild the current URL with the chosen band. Everything else on the URL
       (sort_by, tag scope) is preserved untouched; `page` is dropped because a
       different result set has different pages. */
    function deNativeNavigate(minD, maxD) {
      var url = new URL(window.location.href);
      url.searchParams.delete('filter.v.price.gte');
      url.searchParams.delete('filter.v.price.lte');
      if (minD !== null && minD !== undefined) url.searchParams.set('filter.v.price.gte', String(minD));
      if (maxD !== null && maxD !== undefined) url.searchParams.set('filter.v.price.lte', String(maxD));
      url.searchParams.delete('page');
      /* A navigation to the URL we are already on is a reload loop. Any init path
         that echoes the restored band back through the change handler would spin
         forever, so the guard lives here rather than at each call site. */
      var next = url.toString();
      if (next === window.location.href) return;
      window.location.href = next;
    }
    /* Put the URL's band back on the thumbs. This has to be callable again AFTER
       the real collection bounds arrive: at init the track is still the default
       $250-$1,000, so deApplyBounds() treats any max above $1,000 as "no maximum"
       and nulls it. Measured before this existed — /collections/texas with
       filter.v.price.lte=2500 displayed "$250 - $1k+" while actually showing
       $750-$2,175, i.e. the readout disagreed with the page. */
    function deSeedFromNative() {
      if (!deNat) return;
      deSelMin = (deNat.min === null || isNaN(deNat.min)) ? null : deNat.min;
      deSelMax = (deNat.max === null || isNaN(deNat.max)) ? null : deNat.max;
      if (deSelMin !== null && deSelMin <= P_MIN_DOLLARS) deSelMin = null;
      if (deSelMax !== null && deSelMax >= P_MAX_DOLLARS) deSelMax = null;
      if (typeof paintSlider === 'function') paintSlider(true);
    }
    /* de-band-carry-2026-09-15 — a price band must survive every navigation.

       Measured before this: from /collections/texas?filter.v.price.gte=1000&
       filter.v.price.lte=5000, picking California in the state dropdown landed on
       a bare /collections/california and the band was gone; the tier chips pointed
       at /collections/special/texas, also bare. The buyer sets a budget, picks a
       state or a tier, and silently gets everything again — the exact friction we
       are trying to remove. Sorting, paging and the view toggle already carried it
       because they rebuild the CURRENT url; these two build a NEW path, so they
       have to be told. */
    function deCarryBand(href) {
      /* Carry whatever band is CURRENTLY selected, regardless of which side is
         enforcing it. This used to require deNativeOn(), i.e. "Shopify applied it",
         which silently dropped the band on the one handoff that matters most:
         from /collections/all-numbers — too large for Shopify to filter, so the
         band was ours — to a state collection, which lands as a bare
         /collections/alabama with the buyer's budget thrown away.

         The receiving page decides how to honour it: small enough and Shopify
         filters it natively, too large and deNativeOn() sees the oversized count
         and we filter it here. Either way the band survives the trip. */
      var lo = (typeof deSelMin === 'undefined') ? null : deSelMin;
      var hi = (typeof deSelMax === 'undefined') ? null : deSelMax;
      if (lo === null && hi === null) return href;
      try {
        var u = new URL(href, window.location.origin);
        u.searchParams.delete('filter.v.price.gte');
        u.searchParams.delete('filter.v.price.lte');
        if (lo !== null && !isNaN(lo)) u.searchParams.set('filter.v.price.gte', String(Math.round(lo)));
        if (hi !== null && !isNaN(hi)) u.searchParams.set('filter.v.price.lte', String(Math.round(hi)));
        return u.pathname + (u.search || '');
      } catch (e) { return href; }
    }
    /* ═══ de-native-swap-2026-09-15 ════════════════════════════════════════
       Apply the band WITHOUT reloading the page.

       Handing the band to Shopify fixed the accuracy and the scan, but it did it
       by navigating — and a navigation tears the document down and rebuilds it.
       Measured on /collections/california at 4x CPU throttle, moving one slider:

           full navigation   5,284ms to load · 3,595ms of blocked main thread
                             across 17 long tasks (worst 996ms) · 19/397 frames
                             dropped · blank until first paint at 1.5s

       That is the choppiness. Shopify's Section Rendering API returns just this
       section's HTML, so the same band can be fetched and swapped in instead:

           fetch + swap      1,209ms total · 287ms blocked across 2 long tasks
                             (worst 178ms) · 2/95 frames dropped · no blank

       4x faster and 12x less main-thread blocking, because nothing is torn down:
       the 356KB bundle stays loaded, the header/footer never re-render, and only
       the grid, its paginator and the count are replaced.

       The grid NODE is kept and its children swapped, rather than replacing the
       element. Every listener in this file closes over `grid`, so replacing it
       would leave them pointing at a detached node. Same reason `cards` is
       re-read afterwards. Any failure falls back to the plain navigation. */
    var deSwapBusy = false;
    function deSwapSupported() {
      return !!(document.querySelector('[id^="shopify-section-"][id$="__main"]') &&
                window.fetch && window.DOMParser && window.history && history.pushState);
    }
    function deNativeApply(minD, maxD) {
      var sec = document.querySelector('[id^="shopify-section-"][id$="__main"]');
      if (!sec || !window.fetch || !window.DOMParser || !(window.history && history.pushState)) {
        deNativeNavigate(minD, maxD); return;
      }
      if (deSwapBusy) return;
      var target = new URL(window.location.href);
      target.searchParams.delete('filter.v.price.gte');
      target.searchParams.delete('filter.v.price.lte');
      if (minD !== null && minD !== undefined) target.searchParams.set('filter.v.price.gte', String(minD));
      if (maxD !== null && maxD !== undefined) target.searchParams.set('filter.v.price.lte', String(maxD));
      target.searchParams.delete('page');
      if (target.toString() === window.location.href) return;
      var fetchUrl = new URL(target.toString());
      fetchUrl.searchParams.set('section_id', sec.id.replace('shopify-section-', ''));
      deSwapBusy = true;
      grid.setAttribute('data-de-swapping', '1');
      fetch(fetchUrl.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var ng = doc.querySelector('[data-de-product-grid]');
          if (!ng) throw new Error('no grid in section response');
          grid.innerHTML = ng.innerHTML;
          // Only the SERVER's facts move across. data-de-view / data-de-cols /
          // data-de-filtered belong to this session and must survive the swap.
          ['data-de-products-count', 'data-de-server-page', 'data-de-server-pages', 'data-de-server-page-size']
            .forEach(function (a) {
              var v = ng.getAttribute(a);
              if (v !== null) grid.setAttribute(a, v); else grid.removeAttribute(a);
            });
          var op = document.querySelector('.de-collection__pagination');
          var np = doc.querySelector('.de-collection__pagination');
          if (op && np) op.replaceWith(np);
          else if (op) op.remove();
          else if (np && grid.parentNode) grid.parentNode.insertBefore(np, grid.nextSibling);
          var oc = document.querySelector('.de-collection__count');
          var nc = doc.querySelector('.de-collection__count');
          if (oc && nc) oc.textContent = nc.textContent;
          cards = Array.prototype.slice.call(grid.querySelectorAll('[data-de-product]'));
          totalCount = cards.length;
          deInvalidateTally();
          /* catalogTotal was read once at init and is what the heading renders,
             so without this the header kept quoting the UNFILTERED size: a band
             returning 2,332 still read "2,593 numbers". Shopify's own figure for
             the filtered set is on the swapped-in grid. */
          catalogTotal = parseInt(grid.getAttribute('data-de-products-count'), 10) || 0;
          serverPagesTotal = parseInt(grid.getAttribute('data-de-server-pages'), 10) || 1;
          pagesPrefetched = parseInt(grid.getAttribute('data-de-server-page'), 10) || 1;
          deNat = (minD === null || minD === undefined) && (maxD === null || maxD === undefined)
            ? null : { min: (minD === undefined ? null : minD), max: (maxD === undefined ? null : maxD) };
          try { history.pushState({ deBand: 1 }, '', target.pathname + target.search); } catch (e) {}
          deSeedFromNative();
          apply();
          try { document.dispatchEvent(new CustomEvent('de:filterschanged')); } catch (e) {}
          deScheduleWarm();
        })
        .catch(function () { deNativeNavigate(minD, maxD); })
        .then(function () { deSwapBusy = false; grid.removeAttribute('data-de-swapping'); });
    }
    /* Back/forward across swapped bands: the document was never replaced, so the
       browser restores the URL without restoring the grid. A reload is the honest,
       always-correct answer and it only happens on an actual Back press. */
    window.addEventListener('popstate', function () {
      if (deNativeOn() || /filter\.v\.price/.test(window.location.search)) window.location.reload();
    });
    /* Running count of cards currently matching, and the signature it belongs to.
       null forces the next apply() to do a real pass. */
    var deVisibleTally = null, deFullPassSig = null;
    function deInvalidateTally() { deVisibleTally = null; deFullPassSig = null; }
    /* ═══ de-warm-sort-2026-09-16 ══════════════════════════════════════════
       Have the other sort order ready before it is asked for.

       Flipping between "price: low to high" and "price: high to low" cannot reuse
       what is on screen unless the whole result set is here — page 1 ascending is
       a different 200 from page 1 descending. So it has to be fetched. But it does
       not have to be fetched WHEN THE BUYER CLICKS: the page sits idle after the
       results settle, and the answer is one request away.

       So warm it during that idle time into the same cache the swap reads from
       (deFetchHTML, 60s). A flip that hits the cache costs no round trip at all.
       Deliberately: one URL only, fired on idle, never during a scan, and only
       when the buyer has actually filtered — a plain unfiltered collection page
       does not get speculative traffic. */
    var deWarmed = {};
    function deWarmOtherSort() {
      try {
        if (!deSwapSupported() || deSwapBusy || prefetching) return;
        if (!priceIsActive() && !deNativeOn()) return;      // only after a real narrowing
        var sec = document.querySelector('[id^="shopify-section-"][id$="__main"]');
        if (!sec) return;
        var cur = sortSelect ? sortSelect.value : 'default';
        var other = cur === 'price-desc' ? 'price-asc' : 'price-desc';
        var u = new URL(window.location.href);
        if (SORT_TO_SHOPIFY[other]) u.searchParams.set('sort_by', SORT_TO_SHOPIFY[other]);
        u.searchParams.delete('page');
        u.searchParams.set('section_id', sec.id.replace('shopify-section-', ''));
        var key = u.toString();
        if (deWarmed[key]) return;
        deWarmed[key] = 1;
        deFetchHTML(key).catch(function () { delete deWarmed[key]; });
      } catch (e) {}
    }
    function deScheduleWarm() {
      if (window.requestIdleCallback) requestIdleCallback(deWarmOtherSort, { timeout: 4000 });
      else setTimeout(deWarmOtherSort, 1500);
    }
    /* ═══ de-url-digits-2026-09-16 ══════════════════════════════════════════
       "Numbers containing 29" — the query Shopify structurally cannot answer.

       Its index matches whole title tokens, so a fragment that only ever appears
       mid-number returns nothing. Swept exhaustively: of the 100 two-digit
       queries, 44 come back empty while the catalogue holds matches, and 13 of
       those map to no area code and no repeating digit, so there was nothing
       honest to offer at all — "29" returns 0 results while 2,202 numbers contain
       it. Same at three digits: "016" returns 0, 113 numbers contain it.

       This collection bar used to have an in-page text filter that did exactly the
       right thing, but its box now redirects to /search, so the capability was
       stranded with no way to reach it. `?de_text=29` drives it directly from the
       URL instead: no input required, the existing deep scan pulls the matches in,
       and the count is exact. Search links to it for any digit fragment, so no
       digit query can dead-end.

       Digits only — this is deliberately not a free-text search. */
    var deUrlDigits = (function () {
      try {
        var v = (new URLSearchParams(window.location.search).get('de_text') || '').replace(/\D+/g, '');
        return v || '';
      } catch (e) { return ''; }
    })();
    /* de-degenerate-band-2026-09-17 — REVERTED, deliberately.

       The owner's "Price: $250 – $250" chip is real, but gating priceIsActive() on
       a collapsed scale was the wrong lever: it feeds `anyFilter`, which decides
       the whole page's vocabulary and paging. Measured cost — 59 regressions across
       the collection suite, every native band page dropping from "1,628 matching
       numbers" to "1,628 numbers" and its pager to 0 pages. A cosmetic edge case is
       not worth that; if the chip needs fixing it has to be fixed in the chip. */
    function priceIsActive() { return deSelMin !== null || deSelMax !== null; }

    function priceFilterMin() { return deSelMin === null ? 0 : deSelMin; }
    function priceFilterMax() { return deSelMax === null ? Infinity : deSelMax; }
    // Both end labels come from ONE place (dollars) so the readout and the chip
    // can never disagree; open ends show the current collection bounds.
    function priceLabels() {
      var loTxt = fmtPrice(deSelMin === null ? P_MIN_DOLLARS : deSelMin);
      var hiTxt = deSelMax === null
        ? (fmtPrice(P_MAX_DOLLARS) + (deBoundsExact ? '' : '+'))
        : fmtPrice(deSelMax);
      return { lo: loTxt, hi: hiTxt };
    }
    // On drag, derive the DOLLAR selection from the current thumb %positions.
    function syncSelFromThumbs() {
      if (!priceMinInput || !priceMaxInput) return;
      var loPct = parseInt(priceMinInput.value, 10);
      var hiPct = parseInt(priceMaxInput.value, 10);
      deSelMin = loPct <= 0 ? null : pctToDollars(loPct);
      deSelMax = hiPct >= 100 ? null : pctToDollars(hiPct);
    }
    // reposition=true  -> move thumbs to match the DOLLAR selection (bounds
    //   change / restore / reset) so shifting bounds re-place the thumbs without
    //   ever altering what's selected.
    // reposition=false -> leave thumbs where the user is dragging; just repaint
    //   fill + labels from the freshly-synced selection.
    function paintSlider(reposition) {
      if (!priceMinInput || !priceMaxInput) return;
      if (reposition) {
        priceMinInput.value = deSelMin === null ? 0 : dollarsToPct(deSelMin);
        priceMaxInput.value = deSelMax === null ? 100 : dollarsToPct(deSelMax);
      }
      var lo = parseInt(priceMinInput.value, 10);
      var hi = parseInt(priceMaxInput.value, 10);
      if (lo > hi - 1) { lo = Math.max(0, hi - 1); priceMinInput.value = lo; }
      if (priceFill) {
        priceFill.style.left = lo + '%';
        priceFill.style.right = (100 - hi) + '%';
      }
      var L = priceLabels();
      if (priceMinLabel) priceMinLabel.textContent = L.lo;
      if (priceMaxLabel) priceMaxLabel.textContent = L.hi;
      /* de-pill-guard-2026-09-16 — the reservation must never be out-grown.
         sizePills() measures the widest label from the range KNOWN AT THE TIME, but
         the range moves (the deep scan widens it, a band re-seeds it), so a later
         value can be wider than what was reserved and the track shifts again —
         measured at 4.8-6.9px on search, about one character. After painting, if a
         label's own content is wider than the box reserved for it, raise the
         reservation. Self-correcting, settles in one step, only ever grows. */
      try {
        var _host = bar.querySelector('[data-de-price-slider]') || bar;
        var _cur = parseFloat(_host.style.getPropertyValue('--de-pill-w') || '0') || 0;
        var _need = Math.ceil(Math.max(priceMinLabel ? priceMinLabel.scrollWidth : 0, priceMaxLabel ? priceMaxLabel.scrollWidth : 0));
        if (_need > _cur) _host.style.setProperty('--de-pill-w', _need + 'px');
      } catch (e) {}
      if (lo > 50) {
        priceMinInput.style.zIndex = '5';
        priceMaxInput.style.zIndex = '4';
      } else {
        priceMinInput.style.zIndex = '4';
        priceMaxInput.style.zIndex = '5';
      }
    }
    /* de-drag-quiet-2026-09-15 — at most one repaint per frame while dragging.
       A pointer can emit several 'input' events inside a single frame, and each
       repaint rewrites the two $ readouts. Those pills size to their text on the
       collection bar (deliberately left that way), so every rewrite reflows the
       filter row. The screen cannot show more than one paint per frame, so the
       extra ones were pure cost. Identical visually, measurably less work. */
    var dePaintRaf = 0;
    function paintSliderSoon() {
      if (dePaintRaf) return;
      dePaintRaf = requestAnimationFrame(function () { dePaintRaf = 0; paintSlider(false); });
    }
    if (priceMinInput && priceMaxInput) {
      ['input', 'change'].forEach(function (ev) {
        priceMinInput.addEventListener(ev, function () {
          if (parseInt(priceMinInput.value, 10) > parseInt(priceMaxInput.value, 10) - 1) {
            priceMinInput.value = parseInt(priceMaxInput.value, 10) - 1;
          }
          syncSelFromThumbs();
          if (ev === 'input') { paintSliderSoon(); return; }
          paintSlider(false);
        });
        priceMaxInput.addEventListener(ev, function () {
          if (parseInt(priceMaxInput.value, 10) < parseInt(priceMinInput.value, 10) + 1) {
            priceMaxInput.value = parseInt(priceMinInput.value, 10) + 1;
          }
          syncSelFromThumbs();
          if (ev === 'input') { paintSliderSoon(); return; }
          paintSlider(false);
        });
      });
      // Click on the track itself jumps the nearest thumb to that position.
      var sliderTrack = bar.querySelector('.de-price-slider__track');
      if (sliderTrack) {
        sliderTrack.addEventListener('mousedown', function (e) {
          if (e.target.tagName === 'INPUT') return; // dragging a thumb already
          var rect = sliderTrack.getBoundingClientRect();
          var pct = Math.max(0, Math.min(100, ((e.clientX - rect.left) / rect.width) * 100));
          var lo = parseInt(priceMinInput.value, 10);
          var hi = parseInt(priceMaxInput.value, 10);
          // Move whichever thumb is closer
          if (Math.abs(pct - lo) <= Math.abs(pct - hi)) {
            priceMinInput.value = Math.round(Math.min(pct, hi - 1));
          } else {
            priceMaxInput.value = Math.round(Math.max(pct, lo + 1));
          }
          syncSelFromThumbs();
          paintSlider(false);
          // Trigger filter apply via change event
          priceMinInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
      // Endpoints track the REAL catalog range — see deInitPriceBounds() and the
      // combo-aware recompute in apply() (both at function scope so they're
      // reachable under 'use strict'). Never a hardcoded $250–$1k again.
      deInitPriceBounds();
      /* de-native-price-2026-09-15 — show the band the SERVER applied.
         The cards arrived already filtered, so the thumbs and the "Price: $x – $y"
         chip have to be seeded from the URL or the bar would claim no price filter
         while the page is plainly narrowed. deApplyBounds() releases an endpoint
         that sits at/outside the collection's true range back to "open", so a band
         that spans everything reads as no filter, which is correct. */
      if (deNat) {
        deSeedFromNative();
        /* Render the bar once so the "Price: $x – $y" chip appears. Without this
           the band was live on the page with no chip and therefore no way to
           clear it except Reset — apply() does not otherwise run on a plain load
           with no client-side filters. */
        setTimeout(function () { try { apply(); } catch (e) {} }, 0);
      }
      paintSlider(true);
    }

    // ---------- Pattern chips ----------
    // Chips are anchor tags that navigate to their dedicated collection page
    // (All patterns / Special / Premium / Exclusive / 0s..9s / AABB / ABAB /
    // Ascending). In-place filter glitched the visible grid against the
    // chip's logical scope, so we let the browser navigate normally. The
    // server-side `is-active` class (Liquid via collection.handle) handles
    // the highlight. Safety-net: capture-phase listener that forces nav if
    // any other handler tries to preventDefault on the click.
    var chipsWrap = bar.querySelector('[data-de-pattern-chips]');
    var activePattern = '';
    // Multi-filter rule: a chip clicked while OTHER filters are active (or on
    // a scoped collection like a state page) becomes a CLIENT-side toggle so
    // combinations compose (price + Premium + California). A chip clicked as
    // the first/only pick keeps its navigation to the dedicated collection.
    function setActiveChip(p) {
      if (!chipsWrap) return;
      Array.prototype.forEach.call(chipsWrap.querySelectorAll('.de-pattern-chip'), function (b) {
        var bp = b.getAttribute('data-de-pattern') || '';
        b.classList.toggle('is-active', p ? bp === p : b.classList.contains('de-pattern-chip--all'));
      });
    }
    /* de-band-carry-2026-09-15 — the tier / pattern chips are plain server-rendered
       <a> tags, so the band has to be written onto them. Done once at wiring time
       (they do not change) and only while a band is active, so a normal page keeps
       exactly the hrefs the template produced. "All" is deliberately included: it
       clears the PATTERN, not the price. */
    if (chipsWrap && (deNativeOn() || deSelMin !== null || deSelMax !== null)) {
      Array.prototype.forEach.call(chipsWrap.querySelectorAll('a.de-pattern-chip'), function (a) {
        var h = a.getAttribute('href');
        if (h) a.setAttribute('href', deCarryBand(h));
      });
    }
    var chipPageInitial = !!(chipsWrap && chipsWrap.querySelector('.de-pattern-chip.is-active:not(.de-pattern-chip--all)'));
    /* de-scoped-pattern-2026-09-15 — a tier/pattern COLLECTION lights its own chip
       on load. That is page scope, not something the buyer picked, and treating it
       as a user filter cost /collections/base its exact count: the label read
       "1,400+ matching numbers" where the true figure is 13,782. Remember the
       page's own pattern so userPattern() can tell the two apart — exactly how
       userState()/userArea() already treat a scoped state or area code. */
    var __scopedPattern = (function () {
      if (!chipsWrap) return '';
      var a = chipsWrap.querySelector('.de-pattern-chip.is-active:not(.de-pattern-chip--all)');
      return a ? (a.getAttribute('data-de-pattern') || '') : '';
    })();
    function userPattern(s) {
      var p = s && s.pattern ? s.pattern : '';
      return (p && p !== __scopedPattern) ? p : '';
    }
    if (chipsWrap) {
      chipsWrap.addEventListener('click', function (e) {
        var chip = e.target.closest('a.de-pattern-chip');
        if (!chip) return;
        var pat = chip.getAttribute('data-de-pattern') || '';
        // Tier chips (Special/Premium/Exclusive) are tag-based collections —
        // default-navigate to them.
        if (pat.slice(0, 5) === 'tier-') return;
        var href = chip.getAttribute('href');
        if (!href) return;
        var targetPath = href.replace(/[#?].*$/, '').replace(/^https?:\/\/[^/]+/, '');
        // Already on this pattern's own collection -> nothing to do.
        if (targetPath === window.location.pathname) { e.preventDefault(); e.stopPropagation(); return; }
        // Patterns ALWAYS navigate to their dedicated collection so the count +
        // results are SERVER-rendered — exact for every combo, no client-side
        // undercount, and picking a different pattern SWITCHES (never a stray 0).
        // Carry the buyer's price/state/area/text so the combo survives the hop.
        e.preventDefault();
        e.stopPropagation();
        try {
          var s = getFilterState();
          // Carry state/area/text (collection-relative & valid on the target),
          // but NOT price — a $ range from one collection can be invalid on the
          // next (e.g. $2.3k+ on a collection that tops out at $1.4k = a broken
          // "$2.3k–$1.4k"). Price is re-applied fresh on the target if wanted.
          var carry = {
            text: (s.text || '').trim(), state: userState(s), area: userArea(s), pattern: '',
            pmin: '', pmax: ''
          };
          if (carry.text || carry.state || carry.area) {
            sessionStorage.setItem('deFilters:' + targetPath, JSON.stringify(carry));
          } else {
            sessionStorage.removeItem('deFilters:' + targetPath);
          }
        } catch (err) {}
        window.location.href = href;
      }, true);
    }

    // ---------- Filter logic ----------
    var inputs = bar.querySelectorAll('[data-de-filter]');
    var resets = document.querySelectorAll('[data-de-filter-reset]');

    function patternMatches(digits, p, priceCents) {
      if (!p) return true;
      var last4 = digits.slice(-4);
      // Specific repeating-digit shortcuts ("All 7s" etc.) — match last 4 chars
      var m = /^repeating-(\d)$/.exec(p);
      if (m) {
        var d = m[1];
        return last4 === d + d + d + d;
      }
      switch (p) {
        case 'tier-special':   return priceCents >= 30000 && priceCents < 50000;
        case 'tier-premium':   return priceCents >= 50000 && priceCents < 100000;
        case 'tier-exclusive': return priceCents >= 100000;
        case 'repeating': return /(\d)\1{3,}/.test(digits);
        case 'triple': return /(\d)\1{2}$/.test(digits);
        case 'aabb': return /^(\d)\1(\d)\2$/.test(last4);
        case 'abab': return /^(\d)(\d)\1\2$/.test(last4) && last4.charAt(0) !== last4.charAt(1);
        case 'ascending': return /(?:0123|1234|2345|3456|4567|5678|6789)/.test(digits);
        case 'zeros': return /0{3,}/.test(digits) || (digits.match(/0/g) || []).length >= 4;
        case 'palindrome': return last4 === last4.split('').reverse().join('');
        default: return true;
      }
    }

    function priceMatchesSlider(cents) {
      // de-native-price-2026-09-15: when Shopify filtered the page, every card on
      // it is in band by construction. Re-testing here would be harmless but it
      // would also make the slider a CLIENT filter again, which is what forces the
      // paginator client-side and the count onto the loaded subset.
      if (deNativeOn()) return true;
      // Filters against the DOLLAR selection (source of truth), never the % thumbs.
      if (deSelMin === null && deSelMax === null) return true;
      var d = cents / 100;
      if (deSelMin !== null && d < deSelMin) return false;
      if (deSelMax !== null && d > deSelMax) return false;
      return true;
    }

    // Back-button friction fix: the browser BACK from a PDP re-renders the
    // collection fresh, wiping the buyer's filter work (query, selects, price).
    // Persist per-collection in sessionStorage and rehydrate on load.
    var FILTER_SESSION_KEY = 'deFilters:' + window.location.pathname;
    function saveFilterSession(state) {
      try {
        var payload = {
          text: state.text || '',
          state: state.state || '',
          area: state.area || '',
          pattern: state.pattern || '',
          /* persist the DOLLAR selection ('' = open end), never the % thumbs.
             de-band-owner-2026-09-15: where Shopify can filter, the band lives in
             the URL and ONLY in the URL. Writing it here too meant a later visit
             to the clean collection URL re-applied it client-side — measured on
             /collections/california: 2,593 cards dragged into the DOM, a "2,332+"
             estimate instead of the exact 2,332, and 22.5s to settle where the
             native path takes 1.9s. Back/Forward still restores the band because
             it is in the address bar. */
          pmin: (deSelMin === null || deNativeSupported()) ? '' : String(deSelMin),
          pmax: (deSelMax === null || deNativeSupported()) ? '' : String(deSelMax)
        };
        if (!payload.text && !payload.state && !payload.area && !payload.pattern && !payload.pmin && !payload.pmax) {
          sessionStorage.removeItem(FILTER_SESSION_KEY);
        } else {
          sessionStorage.setItem(FILTER_SESSION_KEY, JSON.stringify(payload));
        }
      } catch (e) {}
    }
    function restoreFilterSession() {
      var raw = null;
      try { raw = sessionStorage.getItem(FILTER_SESSION_KEY); } catch (e) {}
      if (!raw) return false;
      var p;
      try { p = JSON.parse(raw); } catch (e) { return false; }
      var textEl = bar.querySelector('[data-de-filter="text"]');
      if (textEl && p.text) textEl.value = p.text;
      // state/area selects navigate on change; only restore values that exist as options
      var stEl = bar.querySelector('[data-de-filter="state"]');
      if (stEl && p.state && [...stEl.options].some(function (o) { return o.value === p.state; })) stEl.value = p.state;
      var arEl = bar.querySelector('[data-de-filter="area"]');
      if (arEl && p.area && [...arEl.options].some(function (o) { return o.value === p.area; })) arEl.value = p.area;
      // restore the DOLLAR selection; thumbs get positioned by paintSlider(true)
      // once bounds are known, so shifting bounds can never corrupt it.
      // On a natively-filtered page the URL is the authority — a band left over
      // in sessionStorage from an earlier view would re-filter the server's
      // result set client-side and hide rows that legitimately match.
      if (!deNativeSupported()) {
        deSelMin = p.pmin ? parseFloat(p.pmin) : null;
        deSelMax = p.pmax ? parseFloat(p.pmax) : null;
      }
      // Tier patterns are navigation now (chips link to the tier collection), not
      // in-page filters — never rehydrate a stale 'tier-*' pattern. The old in-page
      // tier filter used price bands that surfaced $300 Base numbers under a
      // "Special tier" filter; skipping it keeps Base (and every collection) clean.
      if (p.pattern && p.pattern.slice(0, 5) !== 'tier-') { activePattern = p.pattern; if (typeof setActiveChip === 'function') setActiveChip(p.pattern); }
      if (typeof paintSlider === 'function') paintSlider();
      // Restored text + fresh typing must REPLACE, not append — select-all on
      // the first focus after a restore (typing junk like '58588888' otherwise)
      if (textEl && p.text) {
        textEl.addEventListener('focus', function selOnce() {
          textEl.select();
          textEl.removeEventListener('focus', selOnce);
        });
      }
      if (typeof paintSlider === 'function') paintSlider(true);
      return !!(p.text || p.state || p.area || p.pattern || p.pmin || p.pmax);
    }

    function getFilterState() {
      var s = {};
      inputs.forEach(function (el) {
        var k = el.getAttribute('data-de-filter');
        s[k] = (el.value || '').trim();
      });
      s.pattern = activePattern;
      return s;
    }

    function sortGrid(mode) {
      /* de-digit-relevance-2026-09-16 — "default" is RELEVANCE, and for a digit
         browse that has to mean something.

         A number contains the digits in one of two very different ways: filling a
         group ("626" as the area code, "9999" as the line) or buried mid-group.
         Only the first is what anyone means. Catalogue order ignores the
         difference, so /collections/all-numbers?de_text=73 — where a digit search
         lands when Shopify has nothing — opened on 206-737-3388 while 95 numbers
         in the 73x area code sat further down. Same rule the search page uses, so
         a query ranks identically wherever it is answered. */
      if ((!mode || mode === 'default') && deUrlDigits && window.__deDigitIndex &&
          window.__deDigitIndex.peek()) {
        var idxD = window.__deDigitIndex, qD = deUrlDigits;
        var visD = cards.filter(function (c) { return !c.hasAttribute('hidden'); });
        if (visD.length < 2) return;
        var sOf = function (c) { return idxD.score(c.getAttribute('data-digits') || '', qD); };
        var okD = true;
        for (var i0 = 1; i0 < visD.length; i0++) if (sOf(visD[i0 - 1]) > sOf(visD[i0])) { okD = false; break; }
        if (okD) return;
        var keyD = visD.map(function (c, n) { return { c: c, s: sOf(c), n: n }; });
        keyD.sort(function (a, b) { return a.s !== b.s ? a.s - b.s : a.n - b.n; });
        var fragD = document.createDocumentFragment();
        for (var i1 = 0; i1 < keyD.length; i1++) fragD.appendChild(keyD[i1].c);
        grid.appendChild(fragD);
        return;
      }
      if (!mode || mode === 'default') return;
      var visibleCards = cards.filter(function (c) { return !c.hasAttribute('hidden'); });
      visibleCards.sort(function (a, b) {
        if (mode === 'price-asc') return parseInt(a.getAttribute('data-price-cents'), 10) - parseInt(b.getAttribute('data-price-cents'), 10);
        if (mode === 'price-desc') return parseInt(b.getAttribute('data-price-cents'), 10) - parseInt(a.getAttribute('data-price-cents'), 10);
        if (mode === 'phone-asc') return (a.getAttribute('data-digits') || '').localeCompare(b.getAttribute('data-digits') || '');
        if (mode === 'phone-desc') return (b.getAttribute('data-digits') || '').localeCompare(a.getAttribute('data-digits') || '');
        return 0;
      });
      visibleCards.forEach(function (c) { grid.appendChild(c); });
    }

    function renderActiveChips(s) {
      var host = bar.querySelector('[data-de-active-filters]');
      if (!host) return;
      var chips = [];
      if (deUrlDigits) chips.push({ key: 'urldigits', label: 'Contains: ' + deUrlDigits });
      if (s.text) chips.push({ key: 'text', label: 'Search: "' + s.text + '"' });
      if (userState(s)) chips.push({ key: 'state', label: 'State: ' + s.state });
      if (userArea(s)) chips.push({ key: 'area', label: 'Area code: ' + s.area });
      if (s.pattern) {
        var patLabels = { 'tier-special': 'Special tier', 'tier-premium': 'Premium tier', 'tier-exclusive': 'Exclusive tier' };
        var pl = patLabels[s.pattern] || (/^repeating-(\d)$/.test(s.pattern) ? s.pattern.slice(-1) + s.pattern.slice(-1) + s.pattern.slice(-1) + s.pattern.slice(-1) + ' endings' : s.pattern);
        chips.push({ key: 'pattern', label: 'Pattern: ' + pl });
      }
      if (priceMinInput && priceMaxInput && priceIsActive()) {
        var pL = priceLabels();
        chips.push({ key: 'price', label: 'Price: ' + pL.lo + ' – ' + pL.hi });
      }
      if (s.sort && s.sort !== 'default') {
        var sortMap = {
          'price-asc': 'Sort: low to high',
          'price-desc': 'Sort: high to low',
          'phone-asc': 'Sort: phone asc',
          'phone-desc': 'Sort: phone desc'
        };
        chips.push({ key: 'sort', label: sortMap[s.sort] || ('Sort: ' + s.sort) });
      }
      if (chips.length === 0) {
        host.innerHTML = '';
        host.setAttribute('hidden', '');
        return;
      }
      host.removeAttribute('hidden');
      var chipsHtml = chips.map(function (c) {
        return '<button type="button" class="de-active-filter" data-de-clear="' + c.key + '">' +
               '<span>' + c.label + '</span>' +
               '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><line x1="2" y1="2" x2="10" y2="10"/><line x1="10" y1="2" x2="2" y2="10"/></svg>' +
               '</button>';
      }).join('') + '<button type="button" class="de-active-filter de-active-filter--clear-all" data-de-clear="all">Clear all</button>';
      // Skip identical re-renders: apply() now runs per prefetched page, and
      // rewriting innerHTML every time makes chip clicks land on a node that
      // was just swapped out (intermittent dead "Clear all" clicks).
      if (host.getAttribute('data-de-chips-state') === chipsHtml) return;
      host.setAttribute('data-de-chips-state', chipsHtml);
      host.innerHTML = chipsHtml;
    }

    function clearOne(key) {
      if (key === 'all') {
        var resetBtn = document.querySelector('[data-de-filter-reset]');
        if (resetBtn) resetBtn.click();
        return;
      }
      if (key === 'urldigits') {
        var u9 = new URL(window.location.href);
        u9.searchParams.delete('de_text'); u9.searchParams.delete('page');
        window.location.href = u9.pathname + (u9.search || '');
        return;
      }
      if (key === 'pattern') {
        activePattern = '';
        if (typeof setActiveChip === 'function') setActiveChip('');
        apply();
        return;
      }
      if (key === 'price' && priceMinInput && priceMaxInput) {
        deSelMin = null; deSelMax = null;
        // de-native-price-2026-09-15: blanking the thumbs cannot undo a filter the
        // SERVER applied — the params have to come off the URL.
        if (deNativeOn()) { deNativeApply(null, null); return; }
        paintSlider(true);
        apply();
        return;
      }
      var input = bar.querySelector('[data-de-filter="' + key + '"]');
      if (input) {
        input.value = '';
        if (input.tagName === 'SELECT') {
          var def = input.querySelector('option[selected]') || input.options[0];
          input.value = def ? def.value : '';
        }
        apply();
      }
    }

    bar.addEventListener('click', function (e) {
      var clear = e.target.closest('[data-de-clear]');
      if (!clear) return;
      e.preventDefault();
      clearOne(clear.getAttribute('data-de-clear'));
    });

    // Mobile "Filter & sort" disclosure + active-filter count badge
    // No mobile disclosure any more - the filter panel is always open, so
    // there is no toggle to bind and no open/closed state to persist. Both
    // lookups stay null-safe: filterCountBadge is absent with the button it
    // lived on, and updateFilterCountBadge() below already returns early.
    var filterCountBadge = bar.querySelector('[data-de-filter-active-count]');
    function updateFilterCountBadge(s) {
      if (!filterCountBadge) return;
      var n = 0;
      if ((s.text || '').trim()) n++;
      if (userState(s)) n++;
      if (userArea(s)) n++;
      if (s.pattern) n++;
      if (priceIsActive()) n++;
      if (n > 0) { filterCountBadge.textContent = String(n); filterCountBadge.removeAttribute('hidden'); }
      else filterCountBadge.setAttribute('hidden', '');
    }

    // One predicate for apply() AND every deep-scan: a card "matches" only if
    // it passes EVERY active filter, so combined filters fill correctly. Split
    // so the price-slider bounds can be derived from the set matching every
    // OTHER filter (price bounds are collection-level, set on load).
    function cardMatchesNonPrice(c, s, lower) {
      var digits = c.getAttribute('data-digits') || '';
      if (deUrlDigits && digits.indexOf(deUrlDigits) === -1) return false;
      var price = parseInt(c.getAttribute('data-price-cents') || '0', 10);
      if (lower) {
        var lowerDigits = lower.replace(/\D+/g, '');
        if (lowerDigits) { if (digits.indexOf(lowerDigits) === -1) return false; }
        else {
          var title = c.getAttribute('data-title') || '';
          var st = (c.getAttribute('data-state') || '').toLowerCase();
          if (title.indexOf(lower) === -1 && st.indexOf(lower) === -1) return false;
        }
      }
      if (s.state && c.getAttribute('data-state') !== s.state) return false;
      if (s.area && (c.getAttribute('data-area') || '') !== s.area) return false;
      if (s.pattern && !patternMatches(digits, s.pattern, price)) return false;
      return true;
    }
    function cardMatchesAll(c, s, lower) {
      if (!cardMatchesNonPrice(c, s, lower)) return false;
      return priceMatchesSlider(parseInt(c.getAttribute('data-price-cents') || '0', 10));
    }

    // ================= Dynamic price-slider bounds =================
    // The slider endpoints must reflect the REAL cheapest + most expensive
    // number in whatever the buyer is looking at — the collection, a tier, an
    // area code, a state, OR any in-page mix-and-match of those (area code +
    // pattern, state + tier) — never a hardcoded $250–$1k. Otherwise sliding
    // into a price the current view doesn't carry shows nothing, and views that
    // live entirely above $1k (Exclusive, Premium) can't be filtered at all.
    // Derived live, so it also self-heals if a price floor is ever changed.
    function deRoundBound(d, dir) {
      // Widen to a clean step so the true min/max sit comfortably INSIDE the
      // track and are never clipped off the reachable ends.
      var step = d < 500 ? 10 : d < 2000 ? 50 : d < 10000 ? 100 : 500;
      return dir === 'floor' ? Math.max(1, Math.floor(d / step) * step)
                             : Math.ceil(d / step) * step;
    }
    function deApplyBounds(minD, maxD, exact) {
      if (!priceMinInput || !priceMaxInput) return;
      if (!(minD > 0) || !(maxD > 0) || maxD < minD) return;
      var nMin = deRoundBound(minD, 'floor');
      var nMax = deRoundBound(maxD, 'ceil');
      // A view where every number costs the same ($300 in "626" + area 678) has a
      // real range of $300-$300. Bumping it to $300-$301 invented a spread that does
      // not exist; log scaling and every consumer already handle min === max.
      if (nMax < nMin) nMax = nMin;
      // Idempotent: skip redundant repaints (e.g. during a pure price drag).
      if (nMin === P_MIN_DOLLARS && nMax === P_MAX_DOLLARS && deBoundsExact === !!exact) return;
      P_MIN_DOLLARS = nMin; P_MAX_DOLLARS = nMax; deBoundsExact = !!exact;
      // Clamp the DOLLAR selection into the new range. A min at/below the floor
      // or a max at/above the ceiling is treated as "open" (null) — so a $250 min
      // on a $250-floor collection reads as no-min, not a stuck value.
      if (deSelMin !== null && deSelMin <= P_MIN_DOLLARS) deSelMin = null;
      else if (deSelMin !== null && deSelMin > P_MAX_DOLLARS) deSelMin = P_MAX_DOLLARS;
      if (deSelMax !== null && deSelMax >= P_MAX_DOLLARS) deSelMax = null;
      else if (deSelMax !== null && deSelMax < P_MIN_DOLLARS) deSelMax = P_MIN_DOLLARS;
      // Bounds moved, selection unchanged (in $) -> reposition thumbs to match.
      deSizePills();
      paintSlider(true);
    }
    function deScanCardBounds() {
      // Immediate, approximate bounds from cards already in the DOM (every card
      // on a tier/area page is in-band, so this is close before the fetch lands).
      var nodes = document.querySelectorAll('[data-de-product][data-price-cents]');
      var lo = Infinity, hi = 0;
      Array.prototype.forEach.call(nodes, function (c) {
        var cents = parseInt(c.getAttribute('data-price-cents') || '0', 10);
        if (!cents) return;
        var d = cents / 100;
        if (d < lo) lo = d;
        if (d > hi) hi = d;
      });
      return (isFinite(lo) && hi > 0) ? { min: lo, max: hi } : null;
    }
    function deFetchExactBounds() {
      // Two cheap sorted fetches of the CURRENT collection path give the exact
      // cheapest + most expensive without loading every page. State / area-code
      // pages are their own collections, so those get exact bounds here too;
      // in-page mixes keep this collection-level scale (no per-combo re-scale).
      var base = window.location.pathname;
      function firstPrice(html) {
        var m = html && html.match(/data-price-cents="(\d+)"/);
        return m ? parseInt(m[1], 10) / 100 : null;
      }
      function grab(sort) {
        return fetch(base + '?sort_by=' + sort, { headers: { 'X-Requested-With': 'fetch' } })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(firstPrice)
          .catch(function () { return null; });
      }
      Promise.all([grab('price-ascending'), grab('price-descending')]).then(function (res) {
        var lo = res[0], hi = res[1];
        if (lo == null || hi == null || hi < lo) return;
        deCollMin = lo; deCollMax = hi; deCollExact = true;
        // The track is only now the right size, so re-place the URL's band on it.
        if (deNat) { setTimeout(function () { try { deSeedFromNative(); apply(); } catch (e) {} }, 0); }
        // This lands hundreds of ms late. If the buyer has narrowed in the
        // meantime, applying it would overwrite their view's range with the
        // whole collection's; deRescaleBounds() picks it up on the next apply().
        if (userFiltersActive('price')) return;
        // Safe to apply anytime: the DOLLAR selection is preserved; only the
        // thumb positions/labels re-scale to the true collection range.
        deApplyBounds(lo, hi, true);
      });
    }
    // NOTE: the scale now tracks the CURRENT view, not the whole collection —
    // see deRescaleBounds(). The old worry (re-scaling silently moves a price the
    // buyer set) is handled two ways: the selection is held in DOLLARS so thumbs
    // re-place around it, and price is excluded from its own bounds.
    // de-price-bounds-filtered-2026-09-14
    // The scale used to be the whole COLLECTION's range and stayed frozen while
    // you filtered. That was right back when every narrowing navigated to its own
    // scoped collection - but search narrows IN PLACE now, so the scale kept
    // describing a set the buyer had already left. Measured, and checked against
    // the catalogue rather than assumed:
    //
    //     search "626"              352 numbers, truly $250-$2,175   slider $250-$2.2k  OK
    //     search "626" + area 678     2 numbers, truly   $300-$300   slider $250-$2.2k  WRONG
    //
    // Two of the two results cost $300 and the track still offered $250-$2,200, so
    // ~97% of it pointed at nothing and any drag returned "no matches".
    //
    // Bounds are computed over the cards matching every filter EXCEPT price, which
    // is what keeps the old trapping bug from coming back: narrowing to $300-$400
    // can never shrink the track to $300-$400 and strand the buyer inside it,
    // because the price selection is not an input to its own scale. With no other
    // filter active the collection's own (exact, fetched) range stays authoritative
    // rather than the subset that happens to be loaded.
    function deRescaleBounds(s, lower) {
      if (!priceMinInput || !priceMaxInput) return;
      var narrowed = !!((s.text || '').trim() || userState(s) || userArea(s) || s.pattern);
      if (!narrowed) {
        if (deCollMin > 0 && deCollMax >= deCollMin) deApplyBounds(deCollMin, deCollMax, deCollExact);
        return;
      }
      var lo = Infinity, hi = 0;
      cards.forEach(function (c) {
        if (!cardMatchesNonPrice(c, s, lower)) return;
        var cents = parseInt(c.getAttribute('data-price-cents') || '0', 10);
        if (!cents) return;
        var d = cents / 100;
        if (d < lo) lo = d;
        if (d > hi) hi = d;
      });
      // Nothing matches the non-price filters: leave the scale where it is rather
      // than collapsing it, so clearing the filter does not have to rebuild it.
      if (!isFinite(lo) || !(hi > 0)) return;
      // Same honesty rule the count label uses: while the prefetch is still behind
      // the server's page total these are a floor, so the high end keeps its "+".
      var allLoaded = (typeof pagesPrefetched === 'number' && typeof serverPagesTotal === 'number')
        ? (pagesPrefetched >= serverPagesTotal) : true;
      deApplyBounds(lo, hi, allLoaded);
    }
    /* de-stable-slider-2026-09-16 — the track must not move while you drag.

       Owner: "no matter what when I'm moving either circle slowly, left or right,
       it is so fucking janky, especially when moving the maximum/right circle...
       the size/horizontal length of the overall slider just keeps glitching and
       changing." Measured on /collections/all-numbers with a slow real drag of the
       right thumb:

           right pill  38.3px -> 65.4px   ($140k vs $131.5k)
           TRACK       86.6px -> 113.7px  — it swings 27px, a THIRD of its length

       The pills sit in the same flex row as the track and size to their text, so
       every value change re-lays-out the row under the cursor. Reserving the widest
       width this page can produce makes the geometry constant.

       An earlier attempt at this was reverted because it reserved the CATALOGUE
       worst case (7 characters) and left the track at 69px. With the shorter labels
       above, the reservation lands near the track's former mid-point instead of its
       minimum — stable AND no shorter than it sits at rest today. */
    function deSizePills() {
      if (!priceMinLabel || !priceMaxLabel) return;
      var widest = '', best = 0, i, s;
      for (i = 0; i <= 100; i++) { s = fmtPrice(pctToDollars(i)); if (s.length > best) { best = s.length; widest = s; } }
      s = fmtPrice(P_MAX_DOLLARS) + '+';          // the open high end renders with a trailing +
      if (s.length > best) { best = s.length; widest = s; }
      /* Measure with a NEUTRAL span, not a clone of the label. A clone still matches
         `[data-de-price-max-label] { min-width: var(--de-pill-w) !important }`, so it
         measured the reservation instead of the text and the value ratcheted upward
         each time — 62px reserved for a 5-character label that needs ~54px, costing
         the track 20px it did not have to lose. */
      var cs = window.getComputedStyle(priceMaxLabel);
      var probe = document.createElement('span');
      probe.textContent = widest;
      probe.style.cssText = 'position:absolute;left:-9999px;top:0;visibility:hidden;white-space:nowrap;' +
        'font:' + cs.font + ';font-size:' + cs.fontSize + ';font-weight:' + cs.fontWeight +
        ';font-family:' + cs.fontFamily + ';letter-spacing:' + cs.letterSpacing +
        ';font-variant-numeric:' + (cs.fontVariantNumeric || 'normal') + ';';
      document.body.appendChild(probe);
      var textW = probe.getBoundingClientRect().width;
      probe.parentNode.removeChild(probe);
      var padL = parseFloat(cs.paddingLeft) || 0, padR = parseFloat(cs.paddingRight) || 0;
      var bw = (parseFloat(cs.borderLeftWidth) || 0) + (parseFloat(cs.borderRightWidth) || 0);
      var w = Math.ceil(textW + padL + padR + bw);
      if (w > 0) (bar.querySelector('[data-de-price-slider]') || bar).style.setProperty('--de-pill-w', w + 'px');
    }
    function deInitPriceBounds() {
      // de-native-price-2026-09-15 — on a natively-filtered page the cards in the
      // DOM are only the in-band ones, so seeding from them would shrink the track
      // to the band and trap the buyer inside it (they could never widen back out).
      // deFetchExactBounds() asks for location.pathname with NO query string, so it
      // returns the whole collection's true range; wait for that instead.
      if (!deNativeOn()) {
        var b = deScanCardBounds();
        if (b) { deCollMin = b.min; deCollMax = b.max; deCollExact = false; deApplyBounds(b.min, b.max, false); }
      }
      deFetchExactBounds();
    }
    function combinedMatchCount() {
      var s = getFilterState();
      var lower = (s.text || '').toLowerCase().replace(/\s+/g, '');
      var n = 0;
      cards.forEach(function (c) { if (cardMatchesAll(c, s, lower)) n++; });
      return n;
    }
    // Is any filter OTHER than `except` active? Page scope counts as a primary
    // dimension: on any scoped collection (state/area/tier page), cross-
    // dimension picks must stay client-side or the scope would be lost.
    function userFiltersActive(except) {
      var s = getFilterState();
      if (except !== 'text' && (s.text || '').trim()) return true;
      if (except !== 'state' && userState(s)) return true;
      if (except !== 'area' && userArea(s)) return true;
      if (except !== 'pattern' && s.pattern) return true;
      if (except !== 'price' && priceIsActive()) return true;
      return false;
    }
    function comboContext(except) {
      if (collectionHandle && collectionHandle !== 'all-numbers') return true;
      return userFiltersActive(except);
    }

    function apply() {
      var s = getFilterState();
      saveFilterSession(s);
      renderActiveChips(s);
      updateFilterCountBadge(s);
      var lower = (s.text || '').toLowerCase().replace(/\s+/g, '');
      // Re-scale BEFORE the visibility pass: deRescaleBounds() can release a
      // selection that has fallen outside the new range, and the pass below has to
      // test against the released value, not the stale one.
      deRescaleBounds(s, lower);
      var visible = 0;
      cards.forEach(function (c) {
        if (cardMatchesAll(c, s, lower)) { c.removeAttribute('hidden'); visible++; }
        else { c.setAttribute('hidden', ''); }
      });
      // de-native-price-2026-09-15: a natively-filtered price is part of the page
      // scope (like a state or tier collection), so it must NOT count as a client
      // filter — otherwise the server paginator gets hidden and the count falls
      // back to the loaded subset, both of which the server has already done right.
      var anyFilter = !!((s.text || '').trim() || userState(s) || userArea(s) || s.pattern ||
                         deUrlDigits || (priceIsActive() && !deNativeOn()));
      // ---- result count: computed ONCE, rendered in two places ----
      // The header count under the H1 and the "Filter & sort" caption count on
      // mobile must never show different numbers. These four values used to be
      // scoped inside `if (countEl)`; they are hoisted so both consumers read
      // exactly the same figures.
      //
      // "of totalCount" would read as the whole catalog when it's only the
      // loaded cards — show plain match count under filters, true catalog
      // size otherwise.
      var totalN = catalogTotal || totalCount;
      // A price band cut off by the fetch budget only knows a FLOOR on the
      // count — show "N+" so a big range never claims a precise total it
      // couldn't finish verifying.
      // Prefer the EXACT boundary-count for a pure-price range (the sweep may
      // only have loaded a page of it); else the loaded-match count, with "N+"
      // if a band was budget-truncated.
      var _exact = (deCountCache.sig === filterSig() && deCountCache.value != null) ? deCountCache.value : null;
      var _bandTrunc = _exact == null && deBandScan && deBandScan.truncated && deBandScan.sig === filterSig();
      // A client-side filter can only test the cards fetched so far. While the
      // prefetch is still behind the server's page total, the match count is a
      // FLOOR, not a total - so it gets the same "+" the truncated price band
      // uses. Measured case that forced this: a text search for "777" on
      // /collections/all-numbers settled on "19 matching" while the catalogue
      // actually holds 1,285 - the number was a sixty-fold undercount stated as
      // an exact figure. The count is still a floor; it now says so.
      // typeof-guarded because apply() can run before these are initialised, in
      // which case there is nothing loaded to be behind on.
      var _allLoaded = (typeof pagesPrefetched === 'number' && typeof serverPagesTotal === 'number')
        ? (pagesPrefetched >= serverPagesTotal) : true;
      var _floor = _bandTrunc || (_exact == null && anyFilter && !_allLoaded);
      var _shown = _exact != null ? _exact : visible;
      if (countEl) {
        countEl.textContent = anyFilter
          ? (_shown.toLocaleString() + (_floor ? '+' : '') + ' matching number' + (_shown === 1 ? '' : 's'))
          : (totalN.toLocaleString() + ' number' + (totalN === 1 ? '' : 's'));
      }
      if (capCountEl) {
        // Shorter wording because it sits in a 11px caption on a 390px screen:
        // "412 matching" not "412 matching numbers". The "+" is carried over
        // verbatim — a truncated band must stay honest in both places.
        capCountEl.textContent = anyFilter
          ? (_shown === 0
              ? 'No matches'
              : _shown.toLocaleString() + (_floor ? '+' : '') + ' matching')
          : (totalN.toLocaleString() + ' number' + (totalN === 1 ? '' : 's'));
      }

      if (emptyEl) {
        if (visible === 0) {
          emptyEl.removeAttribute('hidden');
          /* de-empty-loading-2026-09-15 — never say "No numbers match those
             filters." while more of the collection is still on its way.

             The scan already refuses to show that copy until it CONCLUDES (see
             the `!rescan` guard where it clears data-de-loading), but apply()
             runs FIRST and un-hid the panel with the full copy before any scan
             had started. Measured on the live site: sort "Price: high to low"
             on /collections/california, then drag the price max down —

                 0.06s–3.0s   "No numbers match those filters."  ON SCREEN
                              while the heading read "2,332 matching numbers"
                 22–25s       2,332 actually shown

             Two contradictory statements at once, and the first one is false:
             the server returns the 200 dearest numbers under that sort, none of
             them fall in the band, and the rest have not been fetched yet.

             So when a filter is active and the page still holds fewer cards than
             the collection has, open the panel in its LOADING state instead
             ("Searching every number in this range…" + spinner, already built).
             The scan clears the flag when it finishes, which is the only moment
             the "no match" copy is actually true. */
          var _ct = parseInt(grid.getAttribute('data-de-products-count'), 10) || 0;
          if (anyFilter && _ct > 0 && cards.length < _ct) {
            emptyEl.setAttribute('data-de-loading', '1');
          }
        } else {
          emptyEl.setAttribute('hidden', '');
          emptyEl.removeAttribute('data-de-loading');
        }
      }
      // Flag zero results on the grid so CSS can drop BOTH paginators. Paging
      // controls over an empty set contradict themselves - the buyer is told
      // nothing matched and simultaneously offered "1 2 ... 4  Next".
      if (visible === 0) grid.setAttribute('data-de-noresults', '1');
      else grid.removeAttribute('data-de-noresults');
      updateSearchScopeHint(s, visible);
      // Server pagination + client filtering don't compose: page 2 is a
      // different 60 cards where the buyer's matches may all be hidden.
      // The deep-scan + full-catalog hint already cover reach — hide the
      // paginator while any filter is active.
      /* de-one-pager-2026-09-16 — exactly one paginator, on every combination.

         Owner's screenshot: "1-200 of 535 · Previous 1 2 3 Next · Page 1 of 3"
         sitting directly above "Previous 1 2 3 … 82 Next". Two pagers, two
         different page counts, one of them describing a set the buyer is not
         looking at. A matrix over collection x columns x view x sort x paging
         reproduced it 133 times.

         The rule is simply: whoever is actually narrowing owns the pager.
           client narrowing (text / state / area / pattern / a price band Shopify
             could not apply) -> the client pager owns it; the server pager still
             describes the whole collection and must go.
           nothing client-side (plain browsing, or a native band the SERVER
             applied) -> the server pager is the accurate one and the client pager
             stands down.
         List view and phone widths are exempt: there the client pager always owns
         the page, which is what the Show 25/50/100/200 control means. */
      var pag = document.querySelector('.de-collection__pagination');
      var lstPag = document.querySelector('.de-list-paginator');
      var isListView = grid.getAttribute('data-de-view') === 'list';
      var narrowScreen = false;
      try { narrowScreen = window.matchMedia('(max-width: 640px)').matches; } catch (e) {}
      var clientOwnsPager = anyFilter || isListView || narrowScreen;
      if (pag) pag.style.display = clientOwnsPager ? 'none' : '';
      if (lstPag && !isListView && !narrowScreen) lstPag.style.display = anyFilter ? '' : 'none';
      // The custom list-view paginator lives in a separate module. Signal it via a
      // grid attribute + one-shot event ONLY when the filtered state flips, so it
      // hides while a real filter is active (its server-page math is meaningless over
      // a client-filtered subset) and re-paginates cleanly when filters clear. Sort
      // alone is NOT a filter here (anyFilter excludes it) — the server re-paginates
      // in sort order, so paging must keep working while only sorting.
      var wasFiltered = grid.getAttribute('data-de-filtered') === '1';
      if (anyFilter !== wasFiltered) {
        if (anyFilter) grid.setAttribute('data-de-filtered', '1');
        else grid.removeAttribute('data-de-filtered');
        try { document.dispatchEvent(new CustomEvent('de:filterschanged')); } catch (e) {}
      }
      sortGrid(s.sort);
      // Stamp the effective filter signature (INCLUDING sort) so the list paginator
      // can tell a genuine filter/sort change (→ jump back to page 1) apart from a
      // pure deep-scan append (→ hold the user's current page). filterSig() omits
      // sort, so prepend it.
      grid.setAttribute('data-de-filter-sig', (s.sort || 'default') + '~' + filterSig());
      // Deterministic re-slice signal for the list paginator: fires on EVERY apply()
      // (incl. each deep-scan append + the final settle) AFTER sortGrid, so the pager
      // always re-slices the fully-loaded, fully-sorted match set. More reliable than
      // a MutationObserver, which can miss the settle when no [hidden] actually changes.
      if (anyFilter) { try { document.dispatchEvent(new CustomEvent('de:applied')); } catch (e) {} }
    }

    // When a text query is active we are only matching against the cards loaded
    // so far — never let the buyer believe that's the whole catalog. Offer the
    // full-catalog /search path (validated buyer conversion path) prominently.
    var scopeHintEl = null;
    var catalogTotal = parseInt(grid.getAttribute('data-de-products-count'), 10) || 0;
    function updateSearchScopeHint(s, visible) {
      var q = (s.text || '').trim();
      var loadedAll = pagesPrefetched >= serverPagesTotal;
      if (!q || (loadedAll && visible > 0)) {
        if (scopeHintEl) { scopeHintEl.setAttribute('hidden', ''); }
        return;
      }
      if (!scopeHintEl) {
        scopeHintEl = document.createElement('div');
        scopeHintEl.className = 'de-search-scope-hint';
        scopeHintEl.setAttribute('role', 'status');
        bar.appendChild(scopeHintEl);
      }
      scopeHintEl.removeAttribute('hidden');
      // The link targets GLOBAL search — only promise the collection's count
      // when this collection IS the full catalog; on scoped collections
      // (states, area codes, tiers) say what the link actually delivers.
      // Shopify search is token/prefix-based: 3+ digit queries return strong
      // results (matching area-code or last-4 tokens) but 1-2 digit queries
      // return almost nothing (22 hits for "66" vs thousands of true substring
      // matches) — routing those buyers to /search lands them somewhere WORSE
      // than the page they're on. Coach a longer query instead.
      var qDigits = q.replace(/\D+/g, '');
      var head = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3" stroke-linecap="round"/></svg>' +
        '<span>' + visible.toLocaleString() + ' match' + (visible === 1 ? '' : 'es') + ' loaded here so far.</span> ';
      if (qDigits.length === 1 || qDigits.length === 2) {
        scopeHintEl.innerHTML = head +
          '<span>Add another digit to search every number we have.</span>';
        return;
      }
      var searchLabel = (collectionHandle === 'all-numbers' && catalogTotal)
        ? 'Search all ' + catalogTotal.toLocaleString() + ' numbers'
        : 'Search our full catalog';
      scopeHintEl.innerHTML = head +
        '<a href="/search?q=' + encodeURIComponent(q) + '">' + searchLabel + ' for “' + q.replace(/[<>&"]/g, '') + '” →</a>';
    }

    var debounce;
    function scheduleApply() {
      clearTimeout(debounce);
      debounce = setTimeout(apply, 80);
    }

    // Map state names (display) → collection handle for redirect
    var STATE_TO_HANDLE = {
      'Alabama':'alabama','Alaska':'alaska','Arizona':'arizona','Arkansas':'arkansas',
      'California':'california','Colorado':'colorado','Connecticut':'connecticut',
      'Delaware':'delaware','Florida':'florida','Georgia':'georgia','Hawaii':'hawaii',
      'Idaho':'idaho','Illinois':'illinois','Indiana':'indiana','Iowa':'iowa',
      'Kansas':'kansas','Kentucky':'kentucky','Louisiana':'louisiana','Maine':'maine',
      'Maryland':'maryland','Massachusetts':'massachusetts','Michigan':'michigan',
      'Minnesota':'minnesota','Mississippi':'mississippi','Missouri':'missouri',
      'Montana':'montana','Nebraska':'nebraska','Nevada':'nevada',
      'New Hampshire':'new-hampshire','New Jersey':'new-jersey','New Mexico':'new-mexico',
      'New York':'new-york','North Carolina':'north-carolina','North Dakota':'north-dakota',
      'Ohio':'ohio','Oklahoma':'oklahoma','Oregon':'oregon','Pennsylvania':'pennsylvania',
      'Rhode Island':'rhode-island','South Carolina':'south-carolina',
      'South Dakota':'south-dakota','Tennessee':'tennessee','Texas':'texas',
      'Utah':'utah','Vermont':'vermont','Virginia':'virginia','Washington':'washington',
      'West Virginia':'west-virginia','Wisconsin':'wisconsin','Wyoming':'wyoming',
      'District of Columbia':'washington-dc','Washington DC':'washington-dc','Washington, D.C.':'washington-dc','D.C.':'washington-dc'
    };

    // Area codes that have dedicated collections — picking one navigates to /collections/area-code-XXX
    // Codes NOT in this set fall back to client-side filtering (rare codes with few products)
    // Every inventory area code now has a dedicated /collections/area-code-XXX
    // collection (original 52 + 292 created 2026-07-11). So an area pick always
    // navigates to the code's own server-paginated collection page.
    var AREA_CODES_WITH_COLLECTIONS = {
      '201':1,'202':1,'203':1,'205':1,'206':1,'207':1,'208':1,'209':1,'210':1,'212':1,'213':1,'214':1,'215':1,
      '216':1,'217':1,'218':1,'219':1,'220':1,'223':1,'224':1,'225':1,'227':1,'228':1,'229':1,'231':1,'234':1,
      '239':1,'240':1,'248':1,'251':1,'252':1,'253':1,'254':1,'256':1,'260':1,'262':1,'267':1,'269':1,'270':1,
      '272':1,'276':1,'279':1,'281':1,'283':1,'301':1,'302':1,'303':1,'304':1,'305':1,'307':1,'308':1,'309':1,
      '310':1,'312':1,'313':1,'314':1,'315':1,'316':1,'317':1,'318':1,'319':1,'320':1,'321':1,'323':1,'325':1,
      '326':1,'329':1,'330':1,'331':1,'332':1,'334':1,'336':1,'337':1,'339':1,'341':1,'346':1,'347':1,'350':1,
      '351':1,'352':1,'360':1,'361':1,'369':1,'380':1,'385':1,'386':1,'401':1,'402':1,'404':1,'405':1,'406':1,
      '407':1,'408':1,'409':1,'410':1,'412':1,'413':1,'414':1,'415':1,'417':1,'419':1,'423':1,'424':1,'425':1,
      '430':1,'432':1,'434':1,'435':1,'440':1,'442':1,'443':1,'445':1,'447':1,'448':1,'458':1,'463':1,'464':1,
      '469':1,'470':1,'475':1,'478':1,'479':1,'480':1,'484':1,'501':1,'502':1,'503':1,'504':1,'505':1,'507':1,
      '508':1,'509':1,'510':1,'512':1,'513':1,'515':1,'516':1,'517':1,'518':1,'520':1,'530':1,'531':1,'539':1,
      '540':1,'541':1,'551':1,'557':1,'559':1,'561':1,'562':1,'563':1,'564':1,'567':1,'570':1,'571':1,'572':1,
      '573':1,'574':1,'575':1,'580':1,'582':1,'585':1,'586':1,'601':1,'602':1,'603':1,'605':1,'606':1,'607':1,
      '608':1,'609':1,'610':1,'612':1,'614':1,'615':1,'616':1,'617':1,'618':1,'619':1,'620':1,'623':1,'626':1,
      '628':1,'629':1,'630':1,'631':1,'636':1,'640':1,'641':1,'645':1,'646':1,'650':1,'651':1,'656':1,'657':1,
      '659':1,'660':1,'661':1,'662':1,'667':1,'669':1,'678':1,'680':1,'681':1,'682':1,'689':1,'701':1,'702':1,
      '703':1,'704':1,'706':1,'707':1,'708':1,'712':1,'713':1,'714':1,'715':1,'716':1,'717':1,'718':1,'719':1,
      '720':1,'724':1,'725':1,'726':1,'727':1,'728':1,'731':1,'732':1,'734':1,'737':1,'740':1,'743':1,'747':1,
      '754':1,'757':1,'760':1,'762':1,'763':1,'765':1,'769':1,'770':1,'771':1,'772':1,'773':1,'774':1,'775':1,
      '779':1,'781':1,'785':1,'786':1,'801':1,'802':1,'803':1,'804':1,'805':1,'806':1,'808':1,'810':1,'812':1,
      '813':1,'814':1,'815':1,'816':1,'817':1,'818':1,'820':1,'821':1,'828':1,'830':1,'831':1,'832':1,'835':1,
      '838':1,'839':1,'840':1,'843':1,'845':1,'847':1,'848':1,'850':1,'854':1,'856':1,'857':1,'858':1,'859':1,
      '860':1,'862':1,'863':1,'864':1,'865':1,'870':1,'872':1,'878':1,'901':1,'903':1,'904':1,'906':1,'907':1,
      '908':1,'909':1,'910':1,'912':1,'913':1,'914':1,'915':1,'916':1,'917':1,'918':1,'919':1,'920':1,'925':1,
      '928':1,'929':1,'930':1,'931':1,'934':1,'936':1,'937':1,'938':1,'940':1,'941':1,'943':1,'945':1,'947':1,
      '948':1,'949':1,'951':1,'952':1,'954':1,'956':1,'959':1,'970':1,'971':1,'972':1,'973':1,'978':1,'979':1,
      '980':1,'983':1,'984':1,'985':1,'986':1,'989':1
    };

    // True when we're on /collections/all-numbers (or any collection where redirects to
    // a more specific filtered collection are the right UX). For a state pillar like
    // /collections/california, picking area code "415" should still redirect to
    // /collections/area-code-415 (better UX than client-filtering 2,319 cards).
    var collectionHandle = (function () {
      var m = window.location.pathname.match(/\/collections\/([^/?#]+)/);
      return m ? m[1] : '';
    })();
    // ── SHOPIFY TAG FILTERING (2026-08-28) ───────────────────────────────────
    // Every product carries its tier, state and pattern as TAGS
    // (e.g. ['888','Base','Kansas']), and Shopify serves /collections/<handle>/<tag>
    // as a real, server-paginated collection. So a tier+state combination has an
    // exact server-side URL — /collections/base/kansas returns precisely the 53
    // Base numbers in Kansas — instead of the client lazy-fetching page after page
    // to approximate it, which is what produced "N+ matching numbers", the long
    // wait while cards trickled in, and numbers that never showed up at all.
    // The state TAG handle is identical to the state COLLECTION handle, so
    // STATE_TO_HANDLE doubles as the tag map.
    var urlTags = (function () {
      var m = window.location.pathname.match(/\/collections\/[^/?#]+\/([^/?#]+)/);
      return m ? m[1].split('+').filter(Boolean) : [];
    })();
    function isStateTag(tag) {
      for (var s in STATE_TO_HANDLE) { if (STATE_TO_HANDLE[s] === tag) return true; }
      return false;
    }
    function stateNameForTag(tag) {
      var hit = null;
      for (var s in STATE_TO_HANDLE) {
        if (STATE_TO_HANDLE[s] !== tag) continue;
        if (hit === null) hit = s;
        // prefer the alias that actually exists as an option (see scopeToPageState)
        if (stateSelect) {
          for (var i = 0; i < stateSelect.options.length; i++) {
            if (stateSelect.options[i].value === s) return s;
          }
        }
      }
      return hit;
    }
    // Rebuild /collections/<base>/<tags> with the state tag swapped or removed.
    function tagUrl(baseHandle, tags) {
      var u = '/collections/' + baseHandle;
      if (tags && tags.length) u += '/' + tags.join('+');
      try {
        var sb = new URL(window.location.href).searchParams.get('sort_by');
        if (sb) u += '?sort_by=' + encodeURIComponent(sb);
      } catch (e) {}
      /* de-band-carry-2026-09-15 — every state navigation is built here, and this
         used to keep ONLY sort_by. So a buyer on texas with a $1k-$5k band who
         picked California landed on a bare /collections/california with the band
         gone. Carrying it here fixes all four state paths at once (catalog->state,
         state->state, tag-scope intersections, and clearing the state tag). */
      return deCarryBand(u);
    }
    function tagsWithoutState() {
      return urlTags.filter(function (t) { return !isStateTag(t); });
    }
    // Don't redirect when the user is on an area-code page picking the SAME code
    function isCurrentAreaCode(code) { return collectionHandle === 'area-code-' + code; }
    function isCurrentStateHandle(handle) { return collectionHandle === handle; }

    // ── SCOPE RESET (2026-08-28) ─────────────────────────────────────────────
    // Picking a state or an area code NAVIGATES to that collection (see the two
    // handlers below). Clearing the same select therefore cannot be a client
    // reset: the page being stood on is server-side narrowed, so apply() has
    // nothing wider to reveal. The old code called apply() anyway, which left
    // the bar reading "All states" above an Alabama-only grid — the control
    // lying about what is on screen. Clearing has to walk back out to the
    // catalog instead.
    var CATALOG_PATH = '/collections/all-numbers';
    function isStatePage() {
      for (var sn in STATE_TO_HANDLE) {
        if (STATE_TO_HANDLE[sn] === collectionHandle) return true;
      }
      return false;
    }
    function isAreaPage() { return /^area-code-\d{3}$/.test(collectionHandle); }
    // The session key is namespaced per pathname, so a bare navigation would
    // silently drop every OTHER filter the buyer set. Write the DESTINATION's
    // key first and their text/pattern/price survive the scope change.
    // `drop` names the filter being cleared; 'all' is the Reset button.
    function resetScopeToCatalog(drop) {
      try {
        var s = (typeof getFilterState === 'function' ? (getFilterState() || {}) : {});
        var all = (drop === 'all');
        var payload = {
          text:    (all || drop === 'text')  ? '' : (s.text || ''),
          state:   (all || drop === 'state') ? '' : (s.state || ''),
          area:    (all || drop === 'area')  ? '' : (s.area || ''),
          pattern: all ? '' : (s.pattern || ''),
          pmin: (all || typeof deSelMin === 'undefined' || deSelMin === null) ? '' : String(deSelMin),
          pmax: (all || typeof deSelMax === 'undefined' || deSelMax === null) ? '' : String(deSelMax)
        };
        var key = 'deFilters:' + CATALOG_PATH;
        if (payload.text || payload.state || payload.area || payload.pattern || payload.pmin || payload.pmax) {
          sessionStorage.setItem(key, JSON.stringify(payload));
        } else {
          sessionStorage.removeItem(key);
        }
        // Drop THIS page's session too, or a back-navigation re-narrows us.
        sessionStorage.removeItem('deFilters:' + window.location.pathname);
      } catch (e) {}
      var dest = CATALOG_PATH;
      try {
        var sb = new URL(window.location.href).searchParams.get('sort_by');
        if (sb) dest += '?sort_by=' + encodeURIComponent(sb);
      } catch (e) {}
      // Dropping ONE dimension (state / area / text) must not silently drop the
      // price too; only a full Reset ('all') clears the band.
      if (!all) dest = deCarryBand(dest);
      window.location.href = dest;
    }

    // WCAG 3.2.2 guard: Windows fires change per arrow-keypress on closed
    // selects — defer keyboard-driven redirects to Enter/blur (mouse = instant)
    function kbSafeChange(sel, onCommit) {
      var kb = false;
      sel.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Home' || e.key === 'End') kb = true;
        if (e.key === 'Enter') { kb = false; onCommit(); }
      });
      sel.addEventListener('blur', function () { if (kb) { kb = false; onCommit(); } });
      sel.addEventListener('change', function () { if (!kb) onCommit(); });
    }
    if (stateSelect) {
      kbSafeChange(stateSelect, function () {
        var v = stateSelect.value;
        // No selection → leave the narrowed scope, or reset client filters
        if (!v) {
          // State expressed as a URL tag (/collections/base/kansas): drop just that
          // tag and stay in the tier/pattern/area scope the buyer chose.
          if (urlTags.some(isStateTag)) {
            window.location.href = tagUrl(collectionHandle, tagsWithoutState());
            return;
          }
          if (isStatePage()) { resetScopeToCatalog('state'); return; }
          refilterAreasByState(''); apply(); return;
        }
        var __h = STATE_TO_HANDLE[v];
        if (__h) {
          // From the plain catalog, prefer the dedicated state collection: it is a
          // richer, indexable page than a tag URL.
          if (collectionHandle === 'all-numbers' && !urlTags.length) {
            if (!isCurrentStateHandle(__h)) { window.location.href = tagUrl(__h, []); }
            return;
          }
          // Already on a state collection → swap to the other state, keeping any
          // non-state tags (so /collections/alabama/base becomes /collections/texas/base).
          if (isStatePage()) {
            if (!isCurrentStateHandle(__h)) { window.location.href = tagUrl(__h, tagsWithoutState()); }
            return;
          }
          // Any other scope (tier, pattern, area code): ask Shopify for the exact
          // intersection. This replaces the old client-side lazy-fetch, which only
          // ever produced an approximate "N+ matching" count, took seconds to
          // trickle cards in, and could miss numbers beyond the pages it scanned.
          var __next = tagsWithoutState();
          __next.push(__h);
          window.location.href = tagUrl(collectionHandle, __next);
          return;
        }
        var handle = STATE_TO_HANDLE[v];
        // Navigate to the dedicated state page ONLY as a first/only pick from
        // the catalog or as a state->state switch from another state page.
        // With other filters active (or on a tier/area/pattern collection),
        // stay here and client-filter so combinations compose.
        var stateCombo = (userFiltersActive('state') ||
          (collectionHandle !== 'all-numbers')) && !isCurrentStateHandle(handle);
        var onAnotherStatePage = (function () {
          for (var sn in STATE_TO_HANDLE) { if (STATE_TO_HANDLE[sn] === collectionHandle) return true; }
          return false;
        })();
        if (handle && !isCurrentStateHandle(handle) && (!stateCombo || onAnotherStatePage)) {
          window.location.href = deCarryBand('/collections/' + handle);
          return;
        }
        if (handle && !isCurrentStateHandle(handle)) {
          // combo: client-filter this state within the current scope
          refilterAreasByState(v);
          apply();
          ensureMatches();
          return;
        }
        // Already on the target state page — client-filter within it
        refilterAreasByState(v);
        apply();
      });
    }

    // Area code: when a dedicated area-code collection exists, navigate to it
    // (server-paginated view of ALL numbers in that code). Otherwise fall back to
    // the lazy-fetch client filter for codes without dedicated collections.
    var pagesPrefetched = parseInt(grid.getAttribute('data-de-server-page'), 10) || 1;
    var serverPagesTotal = parseInt(grid.getAttribute('data-de-server-pages'), 10) || 1;
    var prefetching = false;
    // first/last price summaries per fetched scan page — survives the
    // abort→rescan cycles a slider drag produces, so restarts skip probes
    var scanCache = { path: null, pages: {} };

    async function loadMorePagesUntilArea(targetArea) {
      if (prefetching) return;
      prefetching = true;
      if (emptyEl) {
        emptyEl.removeAttribute('hidden');
        emptyEl.setAttribute('data-de-loading', '1');
      }
      try {
        for (var p = pagesPrefetched + 1; p <= serverPagesTotal; p++) {
          var url = window.location.pathname + '?page=' + p;
          var resp = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
          var html = await resp.text();
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newCards = doc.querySelectorAll('.de-collection__grid > .de-card.de-card--number');
          newCards.forEach(function (c) {
            grid.appendChild(c);
            if (window.deFormatPhones) window.deFormatPhones(c); // consistent (XXX) XXX-XXXX format
            cards.push(c);
          });
          pagesPrefetched = p;
          totalCount = cards.length;
          apply(); // keep newly appended cards filtered while the scan continues
          if (Array.prototype.some.call(newCards, function (c) {
            return (c.getAttribute('data-area') || '') === targetArea;
          })) break;
        }
      } finally {
        prefetching = false;
        if (emptyEl) emptyEl.removeAttribute('data-de-loading');
      }
    }

    // Targeted area-code load via the TITLE-ASCENDING stream. Product titles
    // start with "{code}-", so title-ascending order places every number for a
    // code on contiguous pages — binary-search straight to them. The default
    // order scatters codes, so the sequential budget scan misses rare codes
    // (e.g. a code with 3 numbers among 16k). Reliable for EVERY code, including
    // the ~292 without a dedicated collection. Loads the code's FULL inventory,
    // so any secondary filter (price/pattern/text) then applies exactly.
    /* de-digits-index-2026-09-16 — see the call site in ensureMatches. */
    var deIdxScan = { sig: null };
    async function loadDigitsByIndex(q, idx, all) {
      var exact = idx.count(q);
      if (exact == null) return;
      var seen = {};
      cards.forEach(function (c) { seen[c.getAttribute('data-digits') || ''] = 1; });
      var want = idx.matches(q) || [];
      var missing = [];
      for (var i = 0; i < want.length; i++) if (!seen[want[i].d]) missing.push(want[i]);

      // The exact total is known the moment the index answers, whether or not a
      // single card still needs fetching. No more "321+".
      deCountCache = { sig: filterSig(), value: exact };
      if (!missing.length) return;

      var deIdxSid = null;                    // learned from page 1, see deContainsFetch
      async function grab(pg) {
        var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
        var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 15000) : null;
        try {
          var sidQ = deIdxSid ? '&section_id=' + encodeURIComponent(deIdxSid) : '';
          var r = await fetch(window.location.pathname + '?sort_by=title-ascending&page=' + pg + sidQ,
            { headers: { 'X-Requested-With': 'XMLHttpRequest' }, signal: ctrl ? ctrl.signal : undefined });
          if (!r.ok) return null;
          return await r.text();
        } catch (e) { return null; } finally { if (timer) clearTimeout(timer); }
      }

      var html1 = await grab(1);
      if (!html1) return;
      var doc1 = new DOMParser().parseFromString(html1, 'text/html');
      var g1 = doc1.querySelector('[data-de-product-grid]');
      if (!g1) return;
      var size = parseInt(g1.getAttribute('data-de-server-page-size'), 10) ||
                 g1.querySelectorAll(':scope > .de-card.de-card--number').length;
      if (!(size > 0)) return;
      var declared = parseInt(g1.getAttribute('data-de-products-count'), 10) || 0;
      // Same tolerance as the search path — an exact match is too strict when a
      // single sale can separate the sitemap from the collection count.
      if (declared && Math.abs(declared - all.length) > 50) return;
      var secC = doc1.querySelector('[id^="shopify-section-template--"]');
      if (secC) deIdxSid = secC.id.replace('shopify-section-', '');

      /* Dense fragments ("29", 2,202 matches) put ~27 matches on every page, so a
         screenful costs a handful of fetches. Sparse ones are the opposite: "016"
         has 113 matches scattered over ~100 pages, and a flat 26-page budget
         showed 64 of them under a heading that said 113. When the whole answer is
         small enough to hold, buy every page it needs; only a genuinely broad
         fragment falls back to filling the first screen. */
      var TARGET = Math.max(200, deSweepTarget);
      var BUDGET = (missing.length <= 400) ? 80 : 26;
      var pages = [], seenPg = { 1: true }, covered = 0;
      for (var k = 0; k < missing.length && covered < TARGET; k++) {
        var pg = Math.floor(missing[k].i / size) + 1;
        covered++;
        if (seenPg[pg]) continue;
        seenPg[pg] = true;
        pages.push(pg);
        if (pages.length >= BUDGET) break;
      }

      var added = false;
      function harvest(doc) {
        var got = doc.querySelectorAll('[data-de-product-grid] > .de-card.de-card--number');
        var any = false;
        for (var n = 0; n < got.length; n++) {
          var dg = got[n].getAttribute('data-digits') || '';
          if (dg.indexOf(q) === -1 || !dg || seen[dg]) continue;   // pages carry neighbours too
          // Live check too: an extend/sweep may have appended this number since.
          if (grid.querySelector('.de-card--number[data-digits="' + dg + '"]')) { seen[dg] = 1; continue; }
          seen[dg] = 1;
          var node = document.importNode(got[n], true);
          node.setAttribute('data-de-appended', '1');
          grid.appendChild(node);
          if (window.deFormatPhones) window.deFormatPhones(node);
          cards.push(node);
          any = true; added = true;
        }
        return any;
      }
      harvest(doc1);
      // Paint each chunk as it lands — a sparse fragment can need dozens of pages
      // and there is no reason to stare at a spinner while they arrive.
      for (var s = 0; s < pages.length; s += 6) {
        var htmls = await Promise.all(pages.slice(s, s + 6).map(grab));
        var any = false;
        for (var h = 0; h < htmls.length; h++) {
          if (htmls[h]) any = harvest(new DOMParser().parseFromString(htmls[h], 'text/html')) || any;
        }
        if (any) { totalCount = cards.length; deCountCache = { sig: filterSig(), value: exact }; apply(); }
      }
      if (added) { totalCount = cards.length; deCountCache = { sig: filterSig(), value: exact }; }
    }

    async function loadAreaByTitle(target) {
      var t = parseInt(target, 10);
      if (!t) return;
      var totalPages = serverPagesTotal > 1 ? serverPagesTotal : 999;
      var pageCache = {}, fetched = 0, BUDGET = 16;
      var seen = {};
      cards.forEach(function (c) {
        var a = c.querySelector('a[href*="/products/"]');
        if (a) seen[a.getAttribute('href').split('?')[0]] = 1;
      });
      function areaOf(node) { return (node.getAttribute('data-area') || '').trim(); }
      async function getPage(pg) {
        if (pageCache[pg]) return pageCache[pg];
        if (fetched >= BUDGET) return null;
        fetched++;
        var url = window.location.pathname + '?sort_by=title-ascending&page=' + pg;
        var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
        var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 7000) : null;
        var resp, html;
        try {
          resp = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' },
            signal: ctrl ? ctrl.signal : undefined });
          if (!resp.ok) return null;
          html = await resp.text();
        } catch (e) { return null; } finally { if (timer) clearTimeout(timer); }
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fg = doc.querySelector('[data-de-product-grid]');
        var fp = fg ? parseInt(fg.getAttribute('data-de-server-pages'), 10) : 0;
        if (fp > 0) totalPages = fp;
        var nodes = Array.prototype.slice.call(
          doc.querySelectorAll('.de-collection__grid > .de-card.de-card--number'));
        var codes = nodes.map(areaOf).filter(Boolean);
        var rec = { nodes: nodes, empty: !nodes.length,
          first: codes.length ? parseInt(codes[0], 10) : 0,
          last: codes.length ? parseInt(codes[codes.length - 1], 10) : 0 };
        pageCache[pg] = rec;
        return rec;
      }
      function appendTargets(rec) {
        if (!rec) return;
        var added = false;
        rec.nodes.forEach(function (c) {
          if (areaOf(c) !== target) return;
          var a = c.querySelector('a[href*="/products/"]');
          var key = a ? a.getAttribute('href').split('?')[0] : null;
          if (key && seen[key]) return;
          if (key) seen[key] = 1;
          grid.appendChild(c);
          if (window.deFormatPhones) window.deFormatPhones(c); // consistent (XXX) XXX-XXXX format
          cards.push(c);
          added = true;
        });
        if (added) { totalCount = cards.length; apply(); }
      }
      // Binary-search for a page whose [first,last] area-code span brackets t.
      var lo = 1, hi = totalPages, found = null;
      while (lo <= hi && fetched < BUDGET) {
        var mid = (lo + hi) >> 1;
        var rec = await getPage(mid);
        if (!rec) break;
        if (rec.empty) { hi = mid - 1; continue; }
        if (rec.last < t) lo = mid + 1;
        else if (rec.first > t) hi = mid - 1;
        else { found = mid; break; }
      }
      if (found === null) { apply(); return; }
      appendTargets(pageCache[found]);
      // Expand to neighbouring pages while they still contain the target code.
      for (var lp = found - 1; lp >= 1 && fetched < BUDGET; lp--) {
        var rl = await getPage(lp);
        if (!rl || rl.empty || !(rl.first <= t && rl.last >= t)) break;
        appendTargets(rl);
        if (rl.first < t) break; // target begins on this page — nothing lower
      }
      for (var rp = found + 1; rp <= totalPages && fetched < BUDGET; rp++) {
        var rr = await getPage(rp);
        if (!rr || rr.empty || !(rr.first <= t && rr.last >= t)) break;
        appendTargets(rr);
        if (rr.last > t) break; // target ends on this page — nothing higher
      }
      apply();
    }

    // Price filter across the WHOLE collection: when a non-default price range is set,
    // prefetch additional server pages (reusing the area-code prefetch pattern) so the
    // slider matches against every number in the collection, not just the loaded page.
    // UNIFIED combined-filter deep-scan. Counts matches with the FULL filter
    // predicate (so price+state+tier combos fill correctly, not just one
    // dimension). Stream choice: if an effective price band is active (slider
    // and/or tier chip) scan a price-ASCENDING stream and GALLOP to the band
    // (the default order serves ~59 pages of floor-priced numbers first);
    // otherwise read the default stream sequentially.
    function effectivePriceBounds() {
      var minC = priceFilterMin() * 100;
      var maxC = priceFilterMax() === Infinity ? Infinity : priceFilterMax() * 100;
      var p = activePattern || '';
      if (p === 'tier-special')   { minC = Math.max(minC, 30000); maxC = Math.min(maxC, 49999); }
      if (p === 'tier-premium')   { minC = Math.max(minC, 50000); maxC = Math.min(maxC, 99999); }
      if (p === 'tier-exclusive') { minC = Math.max(minC, 100000); }
      return { minC: minC, maxC: maxC, banded: minC > 0 || maxC !== Infinity };
    }
    function filterSig() {
      var s2 = getFilterState();
      return [deUrlDigits, s2.text || '', s2.state || '', s2.area || '', s2.pattern || '',
              deSelMin === null ? '' : String(deSelMin),
              deSelMax === null ? '' : String(deSelMax)].join('|');
    }
    // Tracks whether the FULL price band for a given filter signature has been
    // swept (count is EXACT) vs. cut off by the fetch budget (count is a floor →
    // show "N+"). Lets a re-apply skip re-scanning an already-complete band, and
    // lets apply() label a truncated count honestly.
    var deBandScan = { sig: null, complete: false, truncated: false };
    // ★ EXACT price count via binary-search on the price-sorted stream. The
    // client-side sweep can only count cards it LOADS, so any range covering the
    // huge $250 mass (e.g. "$250–$1.6k") stalls at ~60 loaded and shows a wildly
    // low count. Counting = itemsAtOrBelowMax − itemsBelowMin, each found with
    // ~8 page probes (no need to load the results). Exact for ANY pure-price
    // range; the sweep still loads cards for DISPLAY.
    var deCountCache = { sig: null, value: null };
    /* de-scan-dedup-2026-09-15 — one fetch per page, not three.

       Narrowing the price band starts TWO independent loaders:
         deComputeExactCount()  binary-searches the price-ascending stream for the
                                exact count, with its own private `cache`
         ensureMatches()        sweeps the same price-ascending stream for cards,
                                with its own private `scanCache`
       Neither could see the other's work, so the same URL was requested up to
       three times. Measured on the live site, narrowing after a high-to-low sort:

           /collections/california   25 fetches / 21.3s   page=7,10,11,12 each x3
           /collections/texas        13 fetches /  2.6s   page=2,3,4      each x3

       One cache in front of both. Concurrent callers share the in-flight promise
       (so a duplicate costs nothing rather than a second round trip), and a
       completed page is reused for 60s — long enough to cover a scan and the
       drag that follows, short enough that nothing goes stale in a session. The
       cache is dropped whenever the collection path changes. */
    var deHtmlCache = { key: null, map: {} };
    function deFetchHTML(url) {
      var k = window.location.pathname;
      if (deHtmlCache.key !== k) { deHtmlCache.key = k; deHtmlCache.map = {}; }
      var e = deHtmlCache.map[url];
      if (e) {
        if (e.promise) return e.promise;                       // already in flight — join it
        if (Date.now() - e.t < 60000) return Promise.resolve(e.html);
      }
      var p = fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.text(); })
        .then(function (h) { deHtmlCache.map[url] = { t: Date.now(), html: h, promise: null }; return h; })
        .catch(function (err) { delete deHtmlCache.map[url]; throw err; });
      deHtmlCache.map[url] = { t: Date.now(), html: null, promise: p };
      return p;
    }

    /* de-count-converge-2026-09-15 — keep asking until the exact count is in.

       deComputeExactCount() abandons itself the moment the filter signature moves
       (the async bounds fetch re-clamps the selection while it is binary-searching,
       so this happens often), and a single fire-and-forget call simply lost the
       count when that raced. Measured over 3 runs each: all-numbers 0/3 exact,
       base 2/3 — which is precisely the "it feels like an estimate" complaint.

       This retries against the CURRENT signature until a value is cached for it,
       bounded so a genuinely uncountable filter cannot spin. Every attempt is
       cheap: the page fetches it needs are already in deHtmlCache. */
    var deCountRetryT = 0;
    function deEnsureExactCount(depth) {
      depth = depth || 0;
      clearTimeout(deCountRetryT);
      var want = filterSig();
      Promise.resolve(deComputeExactCount()).catch(function () {}).then(function () {
        var now = filterSig();
        if (deCountCache && deCountCache.sig === now && deCountCache.value != null) { apply(); return; }
        if (depth >= 5) return;
        // If the buyer moved on, restart from the new signature rather than
        // chasing one that no longer describes the page.
        deCountRetryT = setTimeout(function () { deEnsureExactCount(now === want ? depth + 1 : 0); }, 500);
      });
    }
    async function deComputeExactCount() {
      // Same reason as ensureMatches: on a natively-filtered page the count is
      // already exact on the grid, and this would binary-search the UNFILTERED
      // stream and overwrite it with a figure for a different set.
      if (deNativeOn()) return;
      var mySig = filterSig();
      var s = getFilterState();
      // Pure price only — a non-price facet needs the combined (loaded) count.
      // "Pure" is judged against what the BUYER chose: a tier collection's own
      // chip, and a state page's own state, are page scope and already baked into
      // the path this binary search walks.
      if (deUrlDigits || (s.text || '').trim() || userState(s) || userArea(s) || userPattern(s)) return;
      var eb = effectivePriceBounds();
      if (!eb.banded) return; // no price constraint -> full collection count already shown
      var minC = eb.minC, maxC = eb.maxC;
      // Items per server page — read live (theme paginates by 50 now, was 60). A wrong
      // constant here would offset every price-boundary count by a page's worth.
      var pageSz = parseInt(grid.getAttribute('data-de-server-page-size'), 10) || 50;
      var totalPages = serverPagesTotal, N = catalogTotal || (totalPages * pageSz);
      var base = window.location.pathname, cache = {};
      async function pp(pg) {
        if (cache[pg]) return cache[pg];
        try {
          var h = await deFetchHTML(base + '?sort_by=price-ascending&page=' + pg);
          var m = h.match(/data-price-cents="(\d+)"/g) || [];
          var a = m.map(function (x) { return parseInt(x.match(/\d+/)[0], 10); });
          cache[pg] = a; return a;
        } catch (e) { return null; }
      }
      async function firstReaching(thr) {
        var lo = 1, hi = totalPages, ans = totalPages + 1;
        while (lo <= hi) {
          if (filterSig() !== mySig) return -1;   // filter changed -> abandon
          var mid = (lo + hi) >> 1;
          var p = await pp(mid);
          if (p === null) return -2;              // fetch failed -> leave sweep's count
          if (!p.length) { hi = mid - 1; continue; }
          if (p[p.length - 1] >= thr) { ans = mid; hi = mid - 1; } else { lo = mid + 1; }
        }
        return ans;
      }
      var below = 0;
      if (minC > 0) {
        var bp = await firstReaching(minC);
        if (bp === -1 || bp === -2) return;
        if (bp > totalPages) below = N;
        else { var pB = await pp(bp); if (!pB) return; below = (bp - 1) * pageSz + pB.filter(function (x) { return x < minC; }).length; }
      }
      var atMax = N;
      if (maxC !== Infinity) {
        var mp = await firstReaching(maxC + 1);
        if (mp === -1 || mp === -2) return;
        if (mp <= totalPages) { var pM = await pp(mp); if (!pM) return; atMax = (mp - 1) * pageSz + pM.filter(function (x) { return x <= maxC; }).length; }
      }
      if (filterSig() !== mySig) return;
      deCountCache = { sig: mySig, value: Math.max(0, atMax - below) };
      apply();
    }
    /* How many MATCHES the sweep should aim for right now. Starts at a few pages
       and grows when the buyer actually pages towards the end of the loaded set,
       so reachability is never reduced — only deferred. */
    var deSweepTarget = 400;
    var deExtending = false;
    function deExtendSweep() {
      if (deExtending || deNativeOn()) return;
      if (!priceIsActive() && !(getFilterState().text || '').trim()) return;
      deExtending = true;
      deSweepTarget += 400;
      Promise.resolve(ensureMatches()).catch(function () {}).then(function () { deExtending = false; });
    }
    /* The paginator writes the page it moved to onto the grid. When that page is
       within one of the last loaded page, fetch the next block. */
    try {
      new MutationObserver(function () {
        var per = parseInt(grid.getAttribute('data-de-list-limit'), 10) || 200;
        var pg = parseInt(grid.getAttribute('data-de-list-page'), 10) || 1;
        var matches = grid.querySelectorAll('[data-de-product]:not([hidden])').length;
        var pagesLoaded = Math.max(1, Math.ceil(matches / per));
        /* Only when the buyer is actually ON the last loaded page. `>= pagesLoaded - 1`
           was true the instant two pages existed and page 1 was showing, so every
           filter immediately fetched another block nobody had asked for — which is
           why 400 kept growing to 800 and beyond. */
        if (pg >= pagesLoaded) deExtendSweep();
      }).observe(grid, { attributes: true, attributeFilter: ['data-de-list-page'] });
    } catch (e) {}

    async function ensureMatches() {
      /* de-native-price-2026-09-15 — the server already produced the exact set.
         The sweep fetches window.location.pathname WITHOUT the filter params, so
         letting it run appended UNFILTERED pages on top of a filtered page: the
         stress run showed /collections/special?gte=1000 rendering all 726 cards
         spanning $500-$8,000 instead of the 9 in band. Nothing to load here. */
      if (deNativeOn()) { if (emptyEl) emptyEl.removeAttribute('data-de-loading'); return; }
      if (prefetching) return;
      var sig = filterSig();
      var s2 = getFilterState();
      var hasAny = (s2.text || '').trim() || s2.state || s2.area || s2.pattern ||
        deUrlDigits || priceIsActive();
      if (!hasAny) { if (emptyEl) emptyEl.removeAttribute('data-de-loading'); return; }
      /* de-url-digits-2026-09-16 — "enough" is 18 when the grid is only proving a
         filter has results, but a de_text fragment IS the whole browse (the buyer
         came here from search to see numbers containing those digits), so stopping
         at 18 of 2,202 reads as a broken page. Fill the page instead; the paginator
         then extends on demand exactly as it does for a price band. */
      var ENOUGH = deUrlDigits ? 200 : 18, FETCH_BUDGET = 60;
      // Full band sweeps load EVERY matching card so the list paginator can page
      // through all of them (not just the first server window). The cap scales to the
      // collection size: a normal collection (pattern/state/area — all a few thousand
      // at most) loads EVERY match so its pager is complete and asc/desc agree; only a
      // giant catalog (all-numbers, 16k) caps, so a floor-touching or broad-text filter
      // there can't dump tens of thousands of cards into the DOM. The exact COUNT still
      // reflects the true total (deComputeExactCount for pure price); only the loaded/
      // paginated set stops at the cap on that one oversized collection.
      var _collTotal = parseInt(grid.getAttribute('data-de-products-count'), 10) || 0;
      /* de-lazy-sweep-2026-09-15 — load what the buyer can SEE, then extend.

         The sweep used to pull every matching card before showing anything, so a
         filter on a collection Shopify cannot filter natively paid for the whole
         set up front. Measured, time until results settle:

             /collections/new-york (5,255)   30.9s   — all 5,255 dragged in
             /collections/all-numbers        9.4s
             /collections/base               9.2s

         Only 200 are on screen. The exact COUNT does not come from the loaded
         set either — it comes from the binary search in deComputeExactCount — so
         loading everything bought nothing except a page or two of the paginator.

         So sweep a few pages' worth first, and extend by the same amount whenever
         the buyer pages near the end of what is loaded (deExtendTarget below).
         Nothing becomes unreachable; it just arrives when it is needed. */
      /* de-small-sweep-2026-09-15 — appending is the single most expensive thing
         on this page. Profiled during "band + sort high to low" while scrolling:

             appendChild ............ 5,437ms   (1,456 cards, ~36,000 DOM nodes)
             Shopify web pixel ...... ~2,190ms  (it observes DOM mutations)
             DOMParser .............. 548ms

         Only 200 are ever displayed and the count comes from the binary search, so
         most of that work was for cards nobody had asked to see yet. Two pages'
         worth is enough to fill the view and let the buyer page once; deExtendSweep()
         fetches the next block the moment they approach the end. */
      var SWEEP_BLOCK = 400;
      var SWEEP_CAP = Math.max(SWEEP_BLOCK, deSweepTarget);
      if (_collTotal > 0 && _collTotal <= 6000) SWEEP_CAP = Math.min(SWEEP_CAP, _collTotal + 200);
      else SWEEP_CAP = Math.min(SWEEP_CAP, 2500);
      // Hard ceiling on TOTAL cards appended during a sweep. SWEEP_CAP bounds MATCHES,
      // but the descending sweep appends whole pages (incl. out-of-band cards) while
      // reading down toward the floor, so a sparse band on the giant catalog can pile
      // up thousands of hidden non-matches. This bounds the DOM regardless of how
      // sparse the matches are. Generous enough that normal collections (which load
      // every match well under it) are never trimmed. Skipped on small collections so
      // they always sweep to completion.
      /* de-dom-cap-2026-09-15 — the descending sweep appends WHOLE pages while it
         reads down towards the band floor, so out-of-band cards ride along and the
         DOM grew to ~2,000 on /collections/all-numbers under a band + high-to-low
         sort. That is the one case still stuttering while scrolling: 60/597 frames
         dropped, worst 2,260ms, with the sampler catching 600 cards laid out at
         once instead of the 200 a page shows.

         Only 200 are ever displayed and the count comes from the binary search, so
         a smaller ceiling costs nothing visible — and deExtendSweep() raises the
         target and fetches more the moment the buyer pages towards the end. */
      var DOM_HARD = (_collTotal > 6000) ? 1400 : (_collTotal > 3000 ? 1800 : Infinity);
      function numCardCount() { return grid.querySelectorAll(':scope > .de-card.de-card--number').length; }
      // Only skip re-scanning when there's no price BAND to fully sweep, or this
      // exact filter's band is already proven complete — otherwise a slider nudge
      // that widens the band would keep a stale, too-small result set + count.
      var _eb0 = effectivePriceBounds();
      // A high-to-low sort over ANY band (even one touching the $250 floor) needs
      // the descending window loaded — otherwise the already-loaded page shows
      // only its handful of in-band cards. Treat it like a band that must sweep.
      // A band worth fully sweeping is one with a real bound: a floor above $250
      // (minC>25000), a real upper cap (maxC finite — even one that touches the
      // $250 floor, e.g. "$250–$500"), or a high-to-low sort. The ONLY case left
      // to the light window is "floor and up, no cap" (minC≤25000 & maxC=∞) which
      // is the whole collection — nothing to filter, so browse handles it.
      var _bandPath = _eb0.banded &&
        (_eb0.minC > 25000 || _eb0.maxC !== Infinity || s2.sort === 'price-desc');
      if (combinedMatchCount() >= ENOUGH &&
          (!_bandPath || (deBandScan.sig === sig && deBandScan.complete))) {
        if (emptyEl) emptyEl.removeAttribute('data-de-loading'); return;
      }
      /* de-digits-index-2026-09-16 — answer a digit browse from the index.

         A de_text browse ("show me numbers containing 124") used to be answered by
         sweeping pages of this collection in catalogue order until either enough
         matches turned up or a 60-fetch budget ran out. For common fragments that
         worked; for rare ones it did not, and it could not say so:

             "4470"   1 number contains it       swept 60 pages, found nothing
             "124"    9 numbers contain it       found 4, or 0, run to run
             every count was a floor — "321+", never a number

         The index knows the exact answer and, because titles are the dashed digits,
         it also knows which title-ascending page each match sits on. So fetch those
         pages and nothing else: one fetch for "4470", at most nine for "124".

         Bails out to the sweep below on anything unexpected — no index, a catalogue
         size that disagrees with it, or a page that does not contain the number it
         was predicted to. */
      if (deUrlDigits && /^[0-9]+$/.test(deUrlDigits) && window.__deDigitIndex &&
          deIdxScan.sig !== sig) {
        var _idx = window.__deDigitIndex;
        var _all = _idx.peek();
        /* AWAIT the index rather than kicking it off and carrying on. The first
           cut did the latter: peek() is null on a cold load, so it fell straight
           through to the sweep below, which set `prefetching` — and every later
           pass returned at the `if (prefetching)` guard before reaching here. The
           index path never ran once. Building it is ~1s of parallel fetches and
           it is cached for the session, so waiting is cheaper than the sweep it
           replaces; if it fails we fall through exactly as before. */
        if (_all == null) {
          if (emptyEl) { emptyEl.removeAttribute('hidden'); emptyEl.setAttribute('data-de-loading', '1'); }
          try { _all = await _idx.ready(); } catch (e) { _all = null; }
        }
        if (_all && _all.length && _all.length === (catalogTotal || _all.length)) {
          deIdxScan.sig = sig;
          prefetching = true;
          if (emptyEl) { emptyEl.removeAttribute('hidden'); emptyEl.setAttribute('data-de-loading', '1'); }
          try { await loadDigitsByIndex(deUrlDigits, _idx, _all); }
          catch (e) { deIdxScan.sig = null; }
          finally {
            prefetching = false;
            var rescanI = filterSig() !== sig;
            apply();
            if (emptyEl && !rescanI) emptyEl.removeAttribute('data-de-loading');
            if (rescanI) setTimeout(ensureMatches, 120);
          }
          return;
        }
      }

      // Area code with no dedicated collection: title-ascending binary search
      // loads the code's full block reliably (the default-order budget scan
      // misses scattered rare codes). Then apply() handles any secondary filter.
      // Codes WITH a dedicated collection fall through to the foreign-stream path.
      if (s2.area && !AREA_CODES_WITH_COLLECTIONS[s2.area]) {
        prefetching = true;
        if (emptyEl) { emptyEl.removeAttribute('hidden'); emptyEl.setAttribute('data-de-loading', '1'); }
        try { await loadAreaByTitle(s2.area); }
        finally {
          prefetching = false;
          var rescanA = filterSig() !== sig;
          apply();
          if (emptyEl && !rescanA) emptyEl.removeAttribute('data-de-loading');
          if (rescanA) setTimeout(ensureMatches, 120);
        }
        return;
      }
      var bounds = effectivePriceBounds();
      // Stream choice: on the catalog-wide page a state/area pick concentrates
      // matches ~50x in the dedicated collection — stream THAT instead of
      // burning the budget on 270+ pages of floor-priced numbers. Only safe
      // from all-numbers (no implicit page scope to violate); area/state
      // collections are strict subsets of the filter they serve.
      var scanPath = window.location.pathname;
      var foreign = false;
      if (collectionHandle === 'all-numbers') {
        if (s2.area && AREA_CODES_WITH_COLLECTIONS[s2.area]) {
          scanPath = '/collections/area-code-' + s2.area; foreign = true;
        } else if (s2.state && STATE_TO_HANDLE[s2.state]) {
          scanPath = '/collections/' + STATE_TO_HANDLE[s2.state]; foreign = true;
        }
      }
      var scanTotal = foreign ? Infinity : serverPagesTotal;
      if (scanCache.path !== scanPath) { scanCache.path = scanPath; scanCache.pages = {}; }
      prefetching = true;
      if (emptyEl) { emptyEl.removeAttribute('hidden'); emptyEl.setAttribute('data-de-loading', '1'); }
      var fetches = 0;
      var seen = {};
      cards.forEach(function (c) {
        var a = c.querySelector('a[href*="/products/"]');
        if (a) seen[a.getAttribute('href').split('?')[0]] = 1;
      });
      function moved() { return filterSig() !== sig; }
      var probeInfo = {}; // pg -> full result (incl. nodes) for THIS run's sorted stream
      var probeFailed = false; // any fetch failed/timed out this run
      async function fetchPage(pg, stream) {
        // stream: 'asc' (price-ascending) | 'desc' (price-descending) | '' (default order)
        fetches++;
        var sortParam = stream === 'asc' ? 'sort_by=price-ascending&'
                      : stream === 'desc' ? 'sort_by=price-descending&' : '';
        var url = scanPath + '?' + sortParam + 'page=' + pg;
        // Shared with deComputeExactCount via deFetchHTML (de-scan-dedup-2026-09-15).
        // The 7s give-up is now a RACE rather than an abort: aborting would cancel
        // the shared request for every other caller waiting on it, so this one
        // stops waiting while the fetch itself is left to finish for them. A
        // throttled/error response rejects and is treated as a failed probe — it
        // must never be parsed as an "empty page", which would fake the end of
        // the collection.
        var html;
        try {
          html = await Promise.race([
            deFetchHTML(url),
            new Promise(function (_r, rej) { setTimeout(function () { rej(new Error('timeout')); }, 7000); })
          ]);
        } catch (e2) { probeFailed = true; return null; }
        if (typeof html !== 'string') { probeFailed = true; return null; }
        var doc = new DOMParser().parseFromString(html, 'text/html');
        if (foreign && scanTotal === Infinity) {
          var fg = doc.querySelector('[data-de-product-grid]');
          var fp = fg ? parseInt(fg.getAttribute('data-de-server-pages'), 10) : 0;
          if (fp > 0) scanTotal = fp;
        }
        var nodes = Array.prototype.slice.call(doc.querySelectorAll('.de-collection__grid > .de-card.de-card--number'));
        var prices = nodes.map(function (n) { return parseInt(n.getAttribute('data-price-cents') || '0', 10); });
        var rec = { nodes: nodes, empty: !nodes.length,
          firstC: prices.length ? prices[0] : 0, lastC: prices.length ? prices[prices.length - 1] : 0 };
        // summary cache survives drag-abort rescans, so restarted scans skip
        // every probe they already paid for (nodes stay per-run only — memory)
        var ck = (stream === 'asc' ? 's' : stream === 'desc' ? 'z' : 'd') + pg;
        scanCache.pages[ck] = { firstC: rec.firstC, lastC: rec.lastC, empty: rec.empty };
        if (stream) probeInfo[pg] = rec;
        return rec;
      }
      function probeOf(pg) { return probeInfo[pg] || scanCache.pages['s' + pg] || null; }
      // parallel probe wave (sorted stream), chunked to stay polite to Shopify;
      // individual failures resolve to null so one stall can't sink the wave
      async function fetchWave(pages2) {
        var need = [];
        pages2.forEach(function (p2) {
          if (p2 >= 1 && need.indexOf(p2) === -1 && !probeOf(p2)) need.push(p2);
        });
        for (var i2 = 0; i2 < need.length; i2 += 12) {
          if (moved() || fetches >= FETCH_BUDGET) return;
          await Promise.all(need.slice(i2, i2 + 12).map(function (p3) {
            return fetchPage(p3, 'asc').catch(function () { probeFailed = true; return null; });
          }));
        }
      }
      /* de-append-cheap-2026-09-15 — appending a page must cost the NEW cards only.

         Owner: "when I am scrolling up or down while listings are loading in and
         increasing, my frames start to drop and it gets very laggy until all the
         listings are done loading".

         Reproduced by scrolling naturally during the sweep. The median frame was
         fine (8.4ms) but every appended page produced a spike — 131ms to 392ms —
         and a spike per page is exactly what reads as stutter:

             all-numbers, band + sort high->low   worst 392ms, 12 frames dropped

         Two causes, both here. Each page was inserted VISIBLE and then hidden a
         moment later by the paginator, so the browser laid out hundreds of cards
         it was about to throw away; and apply() re-tested EVERY card loaded so far,
         so the cost grew with each page.

         Now: decide each new card's state before it is in the document, insert the
         whole page in one fragment, and skip the full pass. The cards are appended
         past the page being viewed by definition, so they go in already marked for
         the paginator — no layout, no flash. The sweep's `finally` still runs a
         real apply(), so the settled state is produced by exactly the same code. */
      var deApplyT = 0, deApplyLast = 0;
      function deApplySoon() {
        if (deApplyT) return;
        var since = Date.now() - deApplyLast;
        var wait = since >= 320 ? 0 : (320 - since);
        deApplyT = setTimeout(function () {
          deApplyT = 0; deApplyLast = Date.now();
          try { apply(); } catch (e) {}
        }, wait);
      }
      function appendNodes(nodes) {
        var s2 = getFilterState();
        var lower2 = (s2.text || '').toLowerCase().replace(/\s+/g, '');
        var frag = document.createDocumentFragment();
        var added = 0;
        /* de-fill-first-2026-09-15 — fill the visible page, then insert the rest
           already paged out.

           Sampling every frame during "price band, then sort high to low" showed
           each fetched page briefly laying out EVERY match before the paginator
           sliced back to 200, 150-400ms later:

               3433ms laid 367 -> 3596ms laid 200
               4252ms laid 600 -> 4403ms laid 200
               5028ms laid 400 -> 5467ms laid 200

           Hundreds of cards laid out and thrown away, per page, while the buyer
           scrolls — that is the stutter. Marking them all paginator-hidden on the
           way in was tried first and left the grid EMPTY when nothing was showing
           yet, so the count of what is ALREADY visible decides: cards fill the page
           up to the limit, and only the overflow goes in hidden. The grid can
           therefore never be empty, and nothing is laid out to be discarded. */
        var per = parseInt(grid.getAttribute('data-de-list-limit'), 10) ||
                  parseInt(grid.getAttribute('data-de-server-page-size'), 10) || 200;
        var onPage = grid.querySelectorAll(
          '[data-de-product]:not([hidden]):not(.de-card--hidden-by-paginator)').length;
        nodes.forEach(function (c) {
          var a = c.querySelector('a[href*="/products/"]');
          var key = a ? a.getAttribute('href').split('?')[0] : null;
          if (key && seen[key]) return;
          /* de-skip-oob-2026-09-15 — do not put cards in the document that this
             filter excludes. The descending sweep reads whole pages while walking
             down to the band floor, so most of what it carries is ABOVE the band:
             invisible, uncounted (the count comes from the binary search), and yet
             still laid out and style-recalculated on every pass. That is what made
             "price band, then sort high to low" the last stuttering case —
             28/557 frames dropped, worst 631ms, on an otherwise 8.4ms scroll.

             `seen` is deliberately marked only for cards we KEEP: a later, wider
             filter re-runs the scan, and marking a skipped card as seen would stop
             it ever being added. */
          if (!cardMatchesAll(c, s2, lower2)) return;
          if (key) seen[key] = 1;
          if (onPage >= per) c.classList.add('de-card--hidden-by-paginator');
          else onPage++;
          // Tag deep-scan appends so the list paginator can page ONLY the original
          // server-page cards when the buyer later clears filters and browses.
          c.setAttribute('data-de-appended', '1');
          /* Reverted 2026-09-15: these used to be inserted pre-marked for the
             paginator, which saved a little layout but left the grid EMPTY in one
             real case — /collections/all-numbers with a $4.3k band sorted high to
             low showed 0 of 1,600 cards. Nothing on screen is far worse than a
             dropped frame, so the cards go in plain and apply() decides, exactly
             as before. The fragment and the throttle below keep most of the win. */
          frag.appendChild(c);
          if (window.deFormatPhones) window.deFormatPhones(c); // match the initial cards' (XXX) XXX-XXXX format
          cards.push(c);
          added++;
        });
        if (added) grid.appendChild(frag);
        totalCount = cards.length;
        /* The cards went in pre-marked for the paginator, so SOMETHING has to
           re-slice or the grid can end up showing nothing at all — measured once
           with the full pass removed: "peak laid out 0 of 1,200", an empty grid
           for the whole scroll. So a real apply() still runs, just throttled to
           ~3/second instead of once per fetched page. The eye cannot use more
           than that, the paginator stays correct, and the sweep's `finally`
           produces the settled state exactly as before. */
        deApplySoon();
      }
      // ---- price-descending display window (for "price: high to low" sort) ----
      // The ascending/default scans load the CHEAP end of a band, so under a
      // high-to-low sort the grid wrongly shows $250 first. Load the EXPENSIVE
      // end from the price-descending stream so the top of the sort is the
      // priciest in-band number. The COUNT stays exact via deComputeExactCount
      // (pure price) or the loaded set (combos) — this only fixes what's shown.
      // Returns true if the band was swept to its floor (loaded set complete for
      // combo counting), false if it stopped on the display target/budget.
      async function loadDescWindow(minC, maxC, target, pureprice) {
        var maxPage = function () { return scanTotal === Infinity ? 256 : scanTotal; };
        var startPg = 1;
        if (maxC !== Infinity) {
          // binary-search the first descending page whose lowest price (lastC)
          // dips at/below maxC — i.e. the first page that enters the band.
          var lo = 1, hi = maxPage(), found = null;
          while (lo <= hi && fetches < FETCH_BUDGET && !moved()) {
            var mid = (lo + hi) >> 1;
            var pr = await fetchPage(mid, 'desc');
            if (!pr) return false;               // fetch failed — leave display as-is
            if (pr.empty) { hi = mid - 1; continue; }
            if (pr.lastC <= maxC) { found = mid; hi = mid - 1; }
            else lo = mid + 1;
          }
          startPg = (found !== null) ? found : lo;
        }
        /* de-scan-pipeline-2026-09-15 — overlap the next fetch with this page's work.
           The sweep was strictly serial: fetch a page, append it (which runs a full
           apply() over every loaded card), then fetch the next. Measured on
           /collections/california narrowed after a high-to-low sort, the descending
           walk was 13 pages x ~1.4s = the bulk of a 19s wait, with the network idle
           the whole time apply() was running and vice versa.

           So start page N+1 before appending page N. Strictly one page of
           look-ahead, so a sweep that stops early over-fetches at most ONE page,
           and the append order (which IS the display order under a high-to-low
           sort) is unchanged because pages are still consumed in sequence. */
        var pg = startPg, swept = false, ahead = null, aheadPg = 0;
        while (pg <= maxPage() && fetches < FETCH_BUDGET && !moved()) {
          if (numCardCount() >= DOM_HARD) break; // DOM ceiling: stop appending out-of-band pages
          var rec = probeInfo[pg] ||
                    (aheadPg === pg && ahead ? await ahead : await fetchPage(pg, 'desc'));
          ahead = null; aheadPg = 0;
          if (!rec) break;                       // fetch failed → count is a floor
          if (rec.empty) { swept = true; break; }
          // queue the next page now; it downloads while appendNodes() + apply() run
          if (pg + 1 <= maxPage() && fetches < FETCH_BUDGET && !probeInfo[pg + 1]) {
            aheadPg = pg + 1;
            ahead = fetchPage(aheadPg, 'desc').catch(function () { return null; });
          }
          appendNodes(rec.nodes);                // out-of-band cards get hidden by apply()
          if (rec.firstC < minC) { swept = true; break; } // page's priciest is below the floor → past band
          // Stop at the cap on ANY filter (pure price OR combo). On a normal collection
          // the cap is collTotal+200 so this never trips → full sweep, exact combo count.
          // On the giant all-numbers it caps the DOM even for a broad-text high-to-low
          // (which would otherwise sweep thousands of cards); pure-price counts stay
          // exact via deComputeExactCount, combo counts show an honest "N+".
          if (combinedMatchCount() >= target) break;
          pg++;
        }
        if (pg > maxPage()) swept = true;
        return swept;
      }
      try {
        if (bounds.banded && s2.sort === 'price-desc') {
          // High-to-low sort: show the EXPENSIVE end of the band first.
          var ppDesc = !((s2.text || '').trim() || s2.state || s2.area || s2.pattern);
          // Display window: small/mid bands load fully (parity with the ascending
          // path); a giant floor-inclusive band caps at SWEEP_CAP expensive cards so
          // the DOM stays light and the list paginator pages the SAME set the
          // ascending sweep does — the exact count still reflects the whole band.
          var sweptDesc = await loadDescWindow(bounds.minC, bounds.maxC, SWEEP_CAP, ppDesc);
          // complete=true → the display window is loaded, don't re-scan this sig on
          // a plain re-apply. truncated flags a count floor (matters only for
          // combos; pure price shows the exact count from deComputeExactCount).
          if (!moved()) deBandScan = { sig: sig, complete: true, truncated: !sweptDesc };
        } else if (bounds.banded && (bounds.minC > 25000 || bounds.maxC !== Infinity)) {
          // Real-bounded band (floor above $250, OR a finite upper cap even if it
          // touches the $250 floor). Locate the window start (first sorted page
          // with lastC >= minC) — for a floor-touching band the bracket naturally
          // resolves to page 1 — then sweep the whole band. With
          // PARALLEL probe waves instead of a serial gallop: one factor-4
          // ladder wave brackets it, then <=5-point waves narrow the bracket.
          // Wall-clock ~4-5 round-trips for any range over a 280-page catalog.
          function appendOverlaps() {
            for (var pk in probeInfo) {
              var pr = probeInfo[pk];
              if (!pr.empty && !pr.appended &&
                  pr.firstC <= bounds.maxC && pr.lastC >= bounds.minC) {
                pr.appended = true;
                appendNodes(pr.nodes);
              }
            }
          }
          var ladder = [];
          for (var lp = 1; lp <= Math.min(scanTotal === Infinity ? 256 : scanTotal, 256); lp *= 4) ladder.push(lp);
          if (scanTotal !== Infinity && ladder.indexOf(scanTotal) === -1) ladder.push(scanTotal);
          await fetchWave(ladder);
          appendOverlaps();
          // bracket: loB = last page proven entirely below the window,
          // hiB = first page proven to reach it (or past the collection end).
          // Missing probes (timeout/503/budget) are SKIPPED — a transient
          // failure must coarsen the bracket, never fake an empty catalog.
          var loB = 0, hiB = null;
          ladder.sort(function (a, b) { return a - b; });
          for (var li = 0; li < ladder.length; li++) {
            var lpr = probeOf(ladder[li]);
            if (!lpr) continue;
            if (!lpr.empty && lpr.lastC < bounds.minC) loB = ladder[li];
            else { hiB = ladder[li]; break; }
          }
          var lastSpan = Infinity;
          while (hiB !== null && hiB - loB > 1 && fetches < FETCH_BUDGET && !moved()) {
            var span = hiB - loB;
            if (span >= lastSpan) break; // no progress (failed probes) — stop narrowing
            lastSpan = span;
            var mids = [];
            var mc = Math.min(5, span - 1);
            for (var mi2 = 1; mi2 <= mc; mi2++) {
              var cand = loB + Math.round(span * mi2 / (mc + 1));
              if (cand > loB && cand < hiB && mids.indexOf(cand) === -1) mids.push(cand);
            }
            if (!mids.length) break;
            await fetchWave(mids);
            appendOverlaps();
            for (var mi3 = 0; mi3 < mids.length; mi3++) {
              var mpr = probeOf(mids[mi3]);
              if (!mpr) continue;
              if (!mpr.empty && mpr.lastC < bounds.minC) loB = Math.max(loB, mids[mi3]);
              else { hiB = Math.min(hiB, mids[mi3]); break; }
            }
          }
          // read forward from the window start until enough combined matches.
          // If probes failed and we never proved a start page, fall back to a
          // sequential read from the last proven-below page — slower, correct.
          var startPg = (hiB !== null) ? hiB : (probeFailed ? loB + 1 : null);
          // Assume truncated for this filter; flip to complete only if we sweep
          // every page that could hold a match (natural band end or EOF).
          deBandScan = { sig: sig, complete: false, truncated: true };
          if (startPg !== null) {
            var pg = startPg;
            var bandEnded = false, cappedOut = false;
            // Sweep the ENTIRE band (not just until ENOUGH matches) so the COUNT
            // is exact — the old early-stop is exactly what let a WIDER range show
            // FEWER results than a narrower one. Bounded by the fetch budget AND a
            // hard match cap so a floor-touching band on a 16k collection can't
            // append tens of thousands of cards (the count stays exact regardless).
            while (pg <= scanTotal && fetches < FETCH_BUDGET && !moved()) {
              if (combinedMatchCount() >= SWEEP_CAP || numCardCount() >= DOM_HARD) { cappedOut = true; break; }
              var nx = probeInfo[pg] || await fetchPage(pg, 'asc');
              if (!nx) break; // fetch failed — count stays a floor ("N+")
              if (nx.empty) { bandEnded = true; break; }
              if (!nx.appended) { nx.appended = true; appendNodes(nx.nodes); }
              if (nx.firstC > bounds.maxC) { bandEnded = true; break; } // past top of range
              pg++;
            }
            if (pg > scanTotal) bandEnded = true; // reached the end of the stream
            // complete=true → don't re-sweep this sig on a plain re-apply. When we
            // stopped on the cap the loaded set is truncated (only matters for combo
            // counts; pure-price still shows the exact deComputeExactCount total).
            if ((bandEnded || cappedOut) && !moved())
              deBandScan = { sig: sig, complete: true, truncated: !bandEnded };
          } else if (!probeFailed) {
            // Bracket proved no page reaches the band → zero matches, and that's exact.
            deBandScan = { sig: sig, complete: true, truncated: false };
          }
        } else {
          // no meaningful price band: sequential default-order scan
          // (foreign stream starts at page 1 — pagesPrefetched tracks only
          // the current collection's own stream)
          for (var dp = foreign ? 1 : pagesPrefetched + 1;
               dp <= scanTotal && fetches < FETCH_BUDGET &&
               combinedMatchCount() < ENOUGH && !moved(); dp++) {
            var di = await fetchPage(dp, '');
            if (!di || di.empty) break;
            appendNodes(di.nodes);
            if (!foreign) pagesPrefetched = dp;
          }
        }
      } finally {
        prefetching = false;
        if (deApplyT) { clearTimeout(deApplyT); deApplyT = 0; }
        var rescan = filterSig() !== sig;
        apply();
        /* de-count-converge-2026-09-15 — make the exact count arrive, always.

           deComputeExactCount() is fired once, in parallel, and it abandons itself
           if the filter signature moves while it is binary-searching (the async
           bounds fetch re-clamps the selection early on, which is exactly when it
           is running). Before the sweep was made lazy that did not show, because
           the sweep took 9-30s and the count had time to be retried by the next
           apply(); now the sweep finishes in ~2s and a lost count simply stayed
           lost. Measured over 3 runs each: all-numbers 0/3 exact, base 2/3.

           The sweep has just finished on a settled signature, so this is the right
           moment to ask again — and only if nothing authoritative is cached. */
        try {
          if (!rescan && (!deCountCache || deCountCache.sig !== filterSig() || deCountCache.value == null)) {
            deEnsureExactCount();
          }
        } catch (e) {}
        /* Warm the other sort order now the sweep has stopped. The idle callback
           fired earlier refuses to run while `prefetching` is true, which is why
           the big client-path collections were the only ones still paying a round
           trip on a flip (144ms cached elsewhere, 269ms + a request here). */
        if (!rescan) deScheduleWarm();
        // Keep the "Searching…" state up through abort→rescan handoffs:
        // the full "No numbers match" copy may only render once a scan
        // CONCLUDES on the filters the buyer actually settled on.
        if (emptyEl && !rescan) emptyEl.removeAttribute('data-de-loading');
        if (rescan) setTimeout(ensureMatches, 120);
      }
    }
    // legacy names — all call sites funnel into the unified (reliable) scan
    async function loadMorePagesForPrice() {
      deEnsureExactCount();    // exact count (async, pure-price only) — retries until it lands
      return ensureMatches();  // load cards for display
    }

    // Text search across the WHOLE collection: same progressive prefetch as the
    // price slider, so typing "8888" scans deeper pages instead of only the 60
    // cards on the current page. Capped to keep bandwidth sane; the scope hint
    // below always offers full-catalog /search as the definitive fallback.
    var textInput = bar.querySelector('[data-de-filter="text"]');
    function loadMorePagesForText() { return ensureMatches(); }

    var textPrefetchDebounce;
    if (textInput) {
      textInput.addEventListener('input', function () {
        clearTimeout(textPrefetchDebounce);
        textPrefetchDebounce = setTimeout(loadMorePagesForText, 450);
      });
    }

    if (areaSelect) {
      kbSafeChange(areaSelect, async function () {
        var v = areaSelect.value;
        if (!v) {
          if (isAreaPage()) { resetScopeToCatalog('area'); return; }
          apply(); return;
        }
        // Redirect to the dedicated area-code collection ONLY as a first/only
        // pick — with other filters active, stay and client-filter the combo.
        var onAreaPage = /^area-code-\d{3}$/.test(collectionHandle);
        var areaCombo = userFiltersActive('area') ||
          (collectionHandle !== 'all-numbers' && !onAreaPage);
        if (AREA_CODES_WITH_COLLECTIONS[v] && !isCurrentAreaCode(v) && !areaCombo) {
          window.location.href = deCarryBand('/collections/area-code-' + v);
          return;
        }
        // No dedicated collection (rare area code) — lazy-load + client filter
        var anyInPage = cards.some(function (c) {
          return (c.getAttribute('data-area') || '') === v;
        });
        apply();
        ensureMatches();
      });
    }

    // Sort: route through Shopify server-side ?sort_by= so the entire
    // collection re-sorts and re-paginates. Client-side sort is broken for
    // multi-page collections (only sees the 60 cards on the current page).
    if (sortSelect) {
      /* ═══ de-local-sort-2026-09-16 ═══════════════════════════════════════
         If every matching number is already here, flipping the sort is a reorder,
         not a round trip.

         Owner: "if we already loaded one or the other, when it switches, it should
         already have it... why is there the wait to reload it".

         Exactly right whenever the result set is COMPLETE in the page. It is not
         right otherwise, and that distinction is the whole of this function: with
         2,332 California results the page holds only the first 200, and page 1
         ascending is a different 200 from page 1 descending — reversing what is
         here would invent an answer. So it is gated on having the whole set,
         judged against the authoritative count (the binary-search figure when a
         client filter is active, Shopify's own count when it is not).

         When the gate passes the flip is instant and nothing is fetched. When it
         does not, the old navigation runs unchanged. */
      function deHaveWholeSet() {
        var sig = filterSig();
        var authoritative = null;
        if (deCountCache && deCountCache.sig === sig && deCountCache.value != null) {
          authoritative = deCountCache.value;
        } else {
          var st = getFilterState();
          var clientNarrow = !!((st.text || '').trim() || userState(st) || userArea(st) ||
                                userPattern(st) || (priceIsActive() && !deNativeOn()));
          var t = parseInt(grid.getAttribute('data-de-products-count'), 10) || 0;
          if (!clientNarrow && t) authoritative = t;      // server total describes the page
        }
        if (authoritative === null || authoritative <= 0) return false;
        var have = 0;
        for (var i = 0; i < cards.length; i++) if (!cards[i].hasAttribute('hidden')) have++;
        return have >= authoritative;
      }
      function deSortLocally(mode) {
        var vis = [];
        for (var i = 0; i < cards.length; i++) if (!cards[i].hasAttribute('hidden')) vis.push(cards[i]);
        var cents = function (c) { return parseInt(c.getAttribute('data-price-cents'), 10) || 0; };
        var dig = function (c) { return c.getAttribute('data-digits') || ''; };
        vis.sort(function (a, b) {
          if (mode === 'price-asc') return cents(a) - cents(b);
          if (mode === 'price-desc') return cents(b) - cents(a);
          if (mode === 'phone-asc') return dig(a) < dig(b) ? -1 : (dig(a) > dig(b) ? 1 : 0);
          if (mode === 'phone-desc') return dig(a) > dig(b) ? -1 : (dig(a) < dig(b) ? 1 : 0);
          return 0;
        });
        // One reflow, not one per card: moving nodes into a fragment detaches them,
        // and the single append puts the whole run back in order.
        var frag = document.createDocumentFragment();
        for (var j = 0; j < vis.length; j++) frag.appendChild(vis[j]);
        grid.appendChild(frag);
        cards = Array.prototype.slice.call(grid.querySelectorAll('[data-de-product]'));
        apply();
        // back to page 1 of the new order, same signal a real filter change sends
        try { document.dispatchEvent(new CustomEvent('de:filterschanged')); } catch (e) {}
      }
      sortSelect.addEventListener('change', function () {
        var v = sortSelect.value;
        var url = new URL(window.location.href);
        if (v === 'default' || !v) {
          url.searchParams.delete('sort_by');
        } else if (SORT_TO_SHOPIFY[v]) {
          url.searchParams.set('sort_by', SORT_TO_SHOPIFY[v]);
        }
        url.searchParams.delete('page'); // start from page 1 after re-sort
        if (v && v !== 'default' && deHaveWholeSet()) {
          deSortLocally(v);
          try { history.pushState({ deSort: 1 }, '', url.pathname + url.search); } catch (e) {}
          return;
        }
        /* de-sort-swap-2026-09-16 — a sort that genuinely needs the server still
           does NOT need the whole document rebuilt. Page 1 descending is a
           different 200 from page 1 ascending, so it must be fetched; but the same
           Section Rendering swap the price slider uses brings it back without
           tearing the page down (measured on the slider: 5,284ms reload versus
           1,209ms swap, and 3,595ms of blocked main thread versus 287ms). */
        if (deSwapSupported() && !deSwapBusy) {
          var sec2 = document.querySelector('[id^="shopify-section-"][id$="__main"]');
          var f2 = new URL(url.toString());
          f2.searchParams.set('section_id', sec2.id.replace('shopify-section-', ''));
          deSwapBusy = true;
          grid.setAttribute('data-de-swapping', '1');
          deFetchHTML(f2.toString())
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var ng = doc.querySelector('[data-de-product-grid]');
              if (!ng) throw new Error('no grid');
              grid.innerHTML = ng.innerHTML;
              ['data-de-products-count', 'data-de-server-page', 'data-de-server-pages', 'data-de-server-page-size']
                .forEach(function (a2) { var val = ng.getAttribute(a2);
                  if (val !== null) grid.setAttribute(a2, val); else grid.removeAttribute(a2); });
              var op = document.querySelector('.de-collection__pagination');
              var np = doc.querySelector('.de-collection__pagination');
              if (op && np) op.replaceWith(np); else if (op) op.remove();
              else if (np && grid.parentNode) grid.parentNode.insertBefore(np, grid.nextSibling);
              var oc = document.querySelector('.de-collection__count');
              var nc = doc.querySelector('.de-collection__count');
              if (oc && nc) oc.textContent = nc.textContent;
              cards = Array.prototype.slice.call(grid.querySelectorAll('[data-de-product]'));
              totalCount = cards.length;
              catalogTotal = parseInt(grid.getAttribute('data-de-products-count'), 10) || 0;
              serverPagesTotal = parseInt(grid.getAttribute('data-de-server-pages'), 10) || 1;
              pagesPrefetched = parseInt(grid.getAttribute('data-de-server-page'), 10) || 1;
              deInvalidateTally();
              deSweepTarget = 400;                       // a new order starts a fresh budget
              try { history.pushState({ deSort: 1 }, '', url.pathname + url.search); } catch (e) {}
              apply();
              try { document.dispatchEvent(new CustomEvent('de:filterschanged')); } catch (e) {}
              if (!deNativeOn()) { deEnsureExactCount(); ensureMatches(); }
              deScheduleWarm();
            })
            .catch(function () { window.location.href = url.toString(); })
            .then(function () { deSwapBusy = false; grid.removeAttribute('data-de-swapping'); });
          return;
        }
        window.location.href = url.toString();
      });
    }

    inputs.forEach(function (el) {
      if (el === stateSelect || el === areaSelect || el === sortSelect) return; // wired separately
      el.addEventListener('input', scheduleApply);
      el.addEventListener('change', apply);
    });
    function onPriceChange() {
      /* 'change' is the real commit (pointer-up). Cancel the safety-net debounce
         first: once both fired, the scan was started twice and the second call
         hit `prefetching` and returned, leaving the first one cut short — base
         dropped from an exact 13,782 back to "1,200+". One commit, one scan. */
      clearTimeout(priceDebounce);
      // de-native-price-2026-09-15 — hand the band to Shopify when it can take it.
      if (deNativeSupported()) { deNativeApply(deSelMin, deSelMax); return; }
      apply(); loadMorePagesForPrice();
    }
    // 'change' can be missed on real drags (the dual thumbs swap z-index on
    // input, so pointer-up may land on the sibling) — also trigger from a
    // debounced 'input'; the scan's sliderMoved abort makes mid-drag churn safe.
    var priceDebounce;
    /* de-drag-quiet-2026-09-15 — do no filtering work WHILE the thumb is moving.

       This was the actual choppiness. Attributed on /collections/california at 4x
       CPU throttle, with the three phases measured separately:

           idle, no interaction .............     0ms blocked
           DRAGGING the thumb ............... 7,416ms blocked, 48 long tasks
           release -> fetch + swap .......... 1,155ms blocked,  5 long tasks

       Every 'input' event ran a full apply(): re-testing every card, re-rendering
       the active-filter chips, recomputing counts and repainting the paginator —
       around 48 times over one drag, for a result that is thrown away on the next
       mouse move. On a collection Shopify can filter, NONE of it is needed: the
       band is applied server-side on release.

       The slider's own 'input' handler (syncSelFromThumbs + paintSlider) is a
       separate listener and still runs, so the thumbs, the fill and the $ readout
       track the cursor exactly as before. Only the invisible work is skipped.

       Where Shopify cannot filter (all-numbers / base / new-york) the grid really
       is filtered client-side, so apply() still runs — but coalesced to one per
       animation frame instead of one per event, which is all the screen can show. */
    function onPriceInput() {
      clearTimeout(priceDebounce);
      if (deNativeSupported()) return;          // server applies it on release
      /* Client path (all-numbers / base / new-york — the three collections over
         Shopify's 5,000-product filter limit). apply() here walks every loaded
         card, and those grids hold thousands, so running it per frame was still
         far too heavy. Measured mid-drag on /collections/all-numbers:

             1x CPU   33/124 frames dropped, worst 143ms, median 17.6ms
             4x CPU  116/163 frames dropped, worst 4,533ms, median 369.5ms

         Nothing is filtered until the buyer settles anyway, so wait for them to
         stop moving. 'change' alone is not enough — the two thumbs swap z-index
         on input, so pointer-up can land on the sibling and the event is missed
         (that is why this debounce existed at all). 220ms after the last input
         covers that case without doing any work during the drag itself. */
      priceDebounce = setTimeout(function () { apply(); loadMorePagesForPrice(); }, 220);
    }
    if (priceMinInput) {
      priceMinInput.addEventListener('change', onPriceChange);
      priceMinInput.addEventListener('input', onPriceInput);
    }
    if (priceMaxInput) {
      priceMaxInput.addEventListener('change', onPriceChange);
      priceMaxInput.addEventListener('input', onPriceInput);
    }

    resets.forEach(function (r) {
      r.addEventListener('click', function () {
        inputs.forEach(function (i) {
          if (i.tagName === 'SELECT') {
            var def = i.querySelector('option[selected]') || i.options[0];
            i.value = def ? def.value : '';
          } else {
            i.value = '';
          }
        });
        deSelMin = null; deSelMax = null;
        // de-native-price-2026-09-15: same reason as the price chip above.
        if (deNativeOn()) { deNativeNavigate(null, null); return; }
        paintSlider(true);
        activePattern = '';
        if (chipsWrap) {
          Array.prototype.forEach.call(chipsWrap.querySelectorAll('.de-pattern-chip'), function (b) {
            b.classList.toggle('is-active', (b.getAttribute('data-de-pattern') || '') === '');
          });
        }
        if (areaSelect) refilterAreasByState('');
        // Same reason as the clears above: on a server-narrowed collection
        // page, blanking the controls leaves the grid narrowed and the bar lying.
        if (isStatePage() || isAreaPage()) { resetScopeToCatalog('all'); return; }
        apply();
      });
    });
  });

})();

/* =====================================================================
   15. PREDICTIVE SEARCH OVERLAY
   Hits /search/suggest.json for live results. 80ms debounce.
   Numeric-aware: digits-only queries are passed verbatim (the SKU/handle
   already encodes the area code so digit search routes naturally).
   ===================================================================== */
(function () {
  var overlay = document.getElementById('deSearchOverlay');
  if (!overlay) return;
  var input = overlay.querySelector('#deSearchInput');
  var resultsHost = overlay.querySelector('#deSearchResults');
  var emptyState = overlay.querySelector('[data-de-search-empty]');
  var products = overlay.querySelector('[data-de-search-products]');
  var articles = overlay.querySelector('[data-de-search-articles]');
  var noneState = overlay.querySelector('[data-de-search-none]');
  var viewAll = overlay.querySelector('[data-de-search-viewall]');
  var countEl = overlay.querySelector('[data-de-search-count]');
  var lastFocus = null;
  var inflight = null;
  var debounce = null;

  function open() {
    lastFocus = document.activeElement;
    overlay.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function () { input.focus(); }, 60);
  }
  function close() {
    overlay.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    input.value = '';
    showEmpty();
  }
  function showEmpty() {
    emptyState.hidden = false;
    products.hidden = true; products.innerHTML = '';
    articles.hidden = true; articles.innerHTML = '';
    noneState.hidden = true;
    viewAll.hidden = true;
  }
  function escapeHtml(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' })[c]; }); }
  function moneyUSD(value) {
    if (value == null) return '';
    var n = (typeof value === 'number') ? value : parseFloat(String(value));
    if (isNaN(n)) return '';
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: n % 1 === 0 ? 0 : 2, maximumFractionDigits: 2 });
  }

  function render(q, data) {
    emptyState.hidden = true;
    var ps = (data && data.resources && data.resources.results && data.resources.results.products) || [];
    var as = (data && data.resources && data.resources.results && data.resources.results.articles) || [];
    if (!ps.length && !as.length) {
      products.hidden = true; articles.hidden = true; viewAll.hidden = true;
      noneState.hidden = false; return;
    }
    noneState.hidden = true;
    if (ps.length) {
      var html = '<div class="de-search-overlay__group-label">Numbers</div>';
      ps.forEach(function (p) {
        var parts = (p.title || '').split(' · ');
        var phone = (parts[0] || '').trim();
        var meta = parts.slice(1).join(' · ').trim();
        html += '<a class="de-search-overlay__row" href="' + escapeHtml(p.url) + '">' +
          '<span class="de-search-overlay__row-phone">' + escapeHtml(phone) + '</span>' +
          '<span class="de-search-overlay__row-meta">' + escapeHtml(meta || 'One-of-one') + '</span>' +
          '<span class="de-search-overlay__row-price">' + escapeHtml(moneyUSD(p.price)) + '</span>' +
        '</a>';
      });
      products.innerHTML = html;
      products.hidden = false;
    } else { products.hidden = true; products.innerHTML = ''; }
    if (as.length) {
      var ahtml = '<div class="de-search-overlay__group-label">Guides</div>';
      as.forEach(function (a) {
        ahtml += '<a class="de-search-overlay__article-row" href="' + escapeHtml(a.url) + '">' +
          '<span class="de-search-overlay__article-tag">Guide</span>' +
          '<span>' + escapeHtml(a.title) + '</span>' +
        '</a>';
      });
      articles.innerHTML = ahtml;
      articles.hidden = false;
    } else { articles.hidden = true; articles.innerHTML = ''; }
    var total = ps.length + as.length;
    if (total >= 4) {
      /* de-search-is-the-destination-2026-09-17 — always the search page.

         Short digit queries used to be diverted to /collections/all-numbers with
         a text filter pre-seeded, because Shopify's token search returned almost
         nothing for them (22 hits for "66"). The digit index removed that reason:
         /search now answers "66" with every one of the numbers that contain it.

         Owner: "rn it doesnt even take me to a search results page when using the
         search, not only for the search in the filter system, but the main search
         button". This was that — the main search button landed on a collection. */
      viewAll.href = '/search?q=' + encodeURIComponent(q);
      viewAll.removeAttribute('data-de-seed-text');
      countEl.textContent = '';
      viewAll.hidden = false;
    } else { viewAll.hidden = true; }
  }

  function seedCatalogTextFilter(q) {
    try {
      sessionStorage.setItem('deFilters:/collections/all-numbers', JSON.stringify({
        text: q, state: '', area: '', pmin: '0', pmax: '100'
      }));
    } catch (e) {}
  }

  function fetchSuggest(q) {
    if (inflight && inflight.abort) { try { inflight.abort(); } catch (e) {} }
    var ctrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
    inflight = ctrl;
    var url = '/search/suggest.json' +
      '?q=' + encodeURIComponent(q) +
      '&resources[type]=product,article' +
      '&resources[limit]=8' +
      '&resources[options][unavailable_products]=last';
    var opts = { credentials: 'same-origin' };
    if (ctrl) opts.signal = ctrl.signal;
    return fetch(url, opts).then(function (r) { return r.json(); });
  }

  input.addEventListener('input', function () {
    var q = input.value.trim();
    clearTimeout(debounce);
    if (!q) { showEmpty(); return; }
    debounce = setTimeout(function () {
      fetchSuggest(q).then(function (data) { render(q, data); }).catch(function () {});
    }, 80);
  });

  // The view-all link for short digit queries carries data-de-seed-text —
  // seed the catalog filter session just before navigation.
  overlay.addEventListener('click', function (e) {
    var va = e.target.closest('[data-de-search-viewall]');
    if (va && va.getAttribute('data-de-seed-text')) {
      seedCatalogTextFilter(va.getAttribute('data-de-seed-text'));
    }
  });
  /* The form posts to /search, which is now the right destination for every
     query including a bare "6" — so nothing to intercept. The submit handler that
     used to divert 1-2 digit queries to the catalogue has been removed with the
     reason for it (see de-search-is-the-destination-2026-09-17 above). */

  overlay.addEventListener('click', function (e) {
    if (e.target.closest('[data-de-search-close]')) { e.preventDefault(); close(); }
  });
  // Keyboard: Esc/⌘K/slash + Arrow up/down + Enter to navigate result rows
  var activeIdx = -1;
  function clearActive() {
    overlay.querySelectorAll('.de-search-overlay__row.is-active, .de-search-overlay__article-row.is-active')
      .forEach(function (r) { r.classList.remove('is-active'); });
  }
  function setActive(idx) {
    var rows = overlay.querySelectorAll('.de-search-overlay__row, .de-search-overlay__article-row');
    if (!rows.length) { activeIdx = -1; return; }
    activeIdx = ((idx % rows.length) + rows.length) % rows.length;
    clearActive();
    rows[activeIdx].classList.add('is-active');
    rows[activeIdx].scrollIntoView({ block: 'nearest' });
  }
  document.addEventListener('keydown', function (e) {
    var open_ = overlay.getAttribute('aria-hidden') === 'false';
    if (e.key === 'Escape' && open_) close();
    if ((e.key === 'k' || e.key === 'K') && (e.metaKey || e.ctrlKey)) {
      e.preventDefault();
      if (overlay.getAttribute('aria-hidden') === 'true') open(); else close();
    }
    if (e.key === '/' && document.activeElement && document.activeElement.tagName !== 'INPUT' && document.activeElement.tagName !== 'TEXTAREA') {
      e.preventDefault(); open();
    }
    if (open_ && document.activeElement === input) {
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(activeIdx + 1); }
      if (e.key === 'ArrowUp')   { e.preventDefault(); setActive(activeIdx - 1); }
      if (e.key === 'Enter') {
        var rows = overlay.querySelectorAll('.de-search-overlay__row, .de-search-overlay__article-row');
        if (activeIdx >= 0 && rows[activeIdx]) {
          e.preventDefault();
          window.location.href = rows[activeIdx].getAttribute('href');
        }
      }
    }
  });
  // Reset active row whenever input changes
  input.addEventListener('input', function () { activeIdx = -1; clearActive(); });
  document.querySelectorAll('[data-de-search-toggle]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault(); open();
    });
  });

  showEmpty();
})();

/* =====================================================================
   16. SCROLL PROGRESS BAR — slim line at top, hides on hero, shows on scroll
   ===================================================================== */
(function () {
  if (document.querySelector('.de-scroll-progress')) return;
  var bar = document.createElement('div');
  bar.className = 'de-scroll-progress';
  bar.setAttribute('aria-hidden', 'true');
  document.body.appendChild(bar);
  var ticking = false;
  /* de-scroll-metrics-2026-09-15 — do not re-measure the page on every frame.

     `doc.scrollHeight` is a forced synchronous layout. Reading it once per scroll
     frame is cheap on a short page (0.2ms for 20 reads on 200 cards) but ruinous
     while the deep scan is appending: layout is dirty, so each read flushes a full
     re-layout of a 1,400-card grid, 60 times a second, exactly while the buyer is
     scrolling. It showed up in the CPU profile as getBoundingClientRect 520ms and
     `update` 341ms — our own code, not the browser's.

     The value only changes when the document resizes, so measure it then: a
     ResizeObserver on <body> catches every appended page, with a 400ms staleness
     fallback where ResizeObserver is missing. The bar itself still updates every
     frame — it just no longer asks the browser to re-lay-out the page to do it. */
  var deMax = 0, deMeasured = 0, deMeasureQueued = 0;
  function deMeasureNow() {
    var d = document.documentElement;
    deMax = d.scrollHeight - d.clientHeight;
    deMeasured = Date.now();
    deMeasureQueued = 0;
  }
  /* The observer fires once per appended page, and each measurement is a forced
     layout — 296ms of them in the profile. One per frame is the most that can
     matter, so coalesce. */
  function deMeasure() {
    if (deMeasureQueued) return;
    deMeasureQueued = requestAnimationFrame(deMeasureNow);
  }
  deMeasureNow();
  try {
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () { deMeasure(); });
      ro.observe(document.body);
    }
  } catch (e) {}
  window.addEventListener('resize', deMeasure, { passive: true });
  function update() {
    if (!window.ResizeObserver && Date.now() - deMeasured > 400) deMeasureNow();
    var max = deMax;
    var pct = max > 0 ? (window.scrollY / max) * 100 : 0;
    bar.style.width = pct + '%';
    bar.style.opacity = window.scrollY > 80 ? '1' : '0';
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }, { passive: true });
  update();
})();

/* =====================================================================
   17. READING PROGRESS — only on article pages
   ===================================================================== */
(function () {
  var article = document.querySelector('.de-articleX__body');
  if (!article) return;
  // hide global scroll progress on articles since reading progress takes over
  var existing = document.querySelector('.de-scroll-progress');
  if (existing) existing.style.display = 'none';
  var bar = document.createElement('div');
  bar.className = 'de-readingX';
  bar.setAttribute('aria-hidden', 'true');
  document.body.appendChild(bar);
  /* Same forced-layout problem as the scroll-progress bar above: getBoundingClientRect
     plus offsetHeight, per frame, on a page the deep scan is still growing. The
     article's geometry only moves when the document does. */
  var deTop = 0, deTotal = 1, deSeen = 0;
  function deMeasureArticle() {
    var r = article.getBoundingClientRect();
    deTop = r.top + (window.scrollY || window.pageYOffset || 0);
    deTotal = article.offsetHeight - window.innerHeight;
    deSeen = Date.now();
  }
  deMeasureArticle();
  try {
    if (window.ResizeObserver) { var roA = new ResizeObserver(function () { deMeasureArticle(); }); roA.observe(article); }
  } catch (e) {}
  window.addEventListener('resize', deMeasureArticle, { passive: true });
  function tick() {
    if (!window.ResizeObserver && Date.now() - deSeen > 400) deMeasureArticle();
    var total = deTotal;
    var scrolled = (window.scrollY || window.pageYOffset || 0) - deTop;
    var pct = Math.max(0, Math.min(1, scrolled / total));
    bar.style.width = (pct * 100) + '%';
    bar.style.opacity = scrolled > 0 ? '1' : '0';
  }
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(function () { tick(); ticking = false; });
      ticking = true;
    }
  }, { passive: true });
  tick();
})();

/* =====================================================================
   18. HEADER SCROLL STATE — adds .is-scrolled past 12px
   ===================================================================== */
(function () {
  var header = document.querySelector('.de-header');
  if (!header) return;
  function update() {
    if (window.scrollY > 12) header.classList.add('is-scrolled');
    else header.classList.remove('is-scrolled');
  }
  window.addEventListener('scroll', update, { passive: true });
  update();
})();

/* =====================================================================
   19. HERO HEADING WORD SPLIT — wrap each word in span for stagger
   ===================================================================== */
/* Hero heading word-split DISABLED — heading renders as plain static text. */

/* =====================================================================
   20. LIVE ACTIVITY TICKER — DISABLED.
   Was a synthetic "just sold to a buyer in [city]" toast generated on a
   timer with manufactured phone numbers + locations. On a small store
   savvy buyers detect the pattern (same N every reload, no real cadence
   variance with traffic, etc.) and trust collapses. We sell on TRUTHFUL
   one-of-one scarcity instead — handled by the de-pdp__activity scarcity
   block. Keeping the function body for reversibility but short-circuiting
   at the top so nothing ever renders.
   ===================================================================== */
(function () {
  return; // hard-off: no synthetic activity toast
  try {
    var dismissedAt = parseInt(localStorage.getItem('deActivityDismissedAt') || '0', 10);
    if (dismissedAt && (Date.now() - dismissedAt) < 4 * 60 * 60 * 1000) return;
  } catch (e) { /* ignore */ }
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  // skip checkout / cart / account pages
  if (/\/cart|\/checkout|\/account/.test(location.pathname)) return;
  // skip product pages (PDP has its own sticky CTA — ticker would conflict on mobile)
  if (/\/products\//.test(location.pathname)) return;

  // Real US cities — broad coverage across all 50 states. The ticker masks
  // the area code as (***); these locations are where the BUYER lives, so
  // we can include any believable US city without tying it to inventory.
  var areaCodes = [
    // California
    { city: 'Los Angeles', state: 'CA' }, { city: 'Beverly Hills', state: 'CA' },
    { city: 'San Francisco', state: 'CA' }, { city: 'San Diego', state: 'CA' },
    { city: 'San Jose', state: 'CA' }, { city: 'Oakland', state: 'CA' },
    { city: 'Sacramento', state: 'CA' }, { city: 'Long Beach', state: 'CA' },
    { city: 'Anaheim', state: 'CA' }, { city: 'Santa Monica', state: 'CA' },
    { city: 'Pasadena', state: 'CA' }, { city: 'Fresno', state: 'CA' },
    { city: 'Bakersfield', state: 'CA' }, { city: 'Riverside', state: 'CA' },
    { city: 'Irvine', state: 'CA' }, { city: 'Palo Alto', state: 'CA' },
    // New York
    { city: 'New York', state: 'NY' }, { city: 'Brooklyn', state: 'NY' },
    { city: 'Manhattan', state: 'NY' }, { city: 'Queens', state: 'NY' },
    { city: 'Buffalo', state: 'NY' }, { city: 'Rochester', state: 'NY' },
    { city: 'Albany', state: 'NY' }, { city: 'Syracuse', state: 'NY' },
    { city: 'Yonkers', state: 'NY' }, { city: 'White Plains', state: 'NY' },
    // Texas
    { city: 'Houston', state: 'TX' }, { city: 'Dallas', state: 'TX' },
    { city: 'Austin', state: 'TX' }, { city: 'San Antonio', state: 'TX' },
    { city: 'Fort Worth', state: 'TX' }, { city: 'El Paso', state: 'TX' },
    { city: 'Plano', state: 'TX' }, { city: 'Frisco', state: 'TX' },
    { city: 'Arlington', state: 'TX' }, { city: 'Corpus Christi', state: 'TX' },
    { city: 'Lubbock', state: 'TX' }, { city: 'McKinney', state: 'TX' },
    { city: 'Waco', state: 'TX' }, { city: 'Sugar Land', state: 'TX' },
    // Florida
    { city: 'Miami', state: 'FL' }, { city: 'Orlando', state: 'FL' },
    { city: 'Tampa', state: 'FL' }, { city: 'Jacksonville', state: 'FL' },
    { city: 'Fort Lauderdale', state: 'FL' }, { city: 'St. Petersburg', state: 'FL' },
    { city: 'Tallahassee', state: 'FL' }, { city: 'Hialeah', state: 'FL' },
    { city: 'Naples', state: 'FL' }, { city: 'Sarasota', state: 'FL' },
    { city: 'Boca Raton', state: 'FL' }, { city: 'Coral Gables', state: 'FL' },
    // Illinois
    { city: 'Chicago', state: 'IL' }, { city: 'Naperville', state: 'IL' },
    { city: 'Aurora', state: 'IL' }, { city: 'Rockford', state: 'IL' },
    { city: 'Evanston', state: 'IL' }, { city: 'Springfield', state: 'IL' },
    // Pennsylvania
    { city: 'Philadelphia', state: 'PA' }, { city: 'Pittsburgh', state: 'PA' },
    { city: 'Allentown', state: 'PA' }, { city: 'Erie', state: 'PA' },
    { city: 'Reading', state: 'PA' }, { city: 'Scranton', state: 'PA' },
    // Ohio
    { city: 'Columbus', state: 'OH' }, { city: 'Cleveland', state: 'OH' },
    { city: 'Cincinnati', state: 'OH' }, { city: 'Toledo', state: 'OH' },
    { city: 'Akron', state: 'OH' }, { city: 'Dayton', state: 'OH' },
    // Georgia
    { city: 'Atlanta', state: 'GA' }, { city: 'Savannah', state: 'GA' },
    { city: 'Augusta', state: 'GA' }, { city: 'Macon', state: 'GA' },
    { city: 'Marietta', state: 'GA' }, { city: 'Athens', state: 'GA' },
    // North Carolina
    { city: 'Charlotte', state: 'NC' }, { city: 'Raleigh', state: 'NC' },
    { city: 'Greensboro', state: 'NC' }, { city: 'Durham', state: 'NC' },
    { city: 'Asheville', state: 'NC' }, { city: 'Cary', state: 'NC' },
    // Michigan
    { city: 'Detroit', state: 'MI' }, { city: 'Grand Rapids', state: 'MI' },
    { city: 'Ann Arbor', state: 'MI' }, { city: 'Lansing', state: 'MI' },
    { city: 'Warren', state: 'MI' },
    // New Jersey
    { city: 'Newark', state: 'NJ' }, { city: 'Jersey City', state: 'NJ' },
    { city: 'Paterson', state: 'NJ' }, { city: 'Edison', state: 'NJ' },
    { city: 'Hoboken', state: 'NJ' }, { city: 'Princeton', state: 'NJ' },
    // Virginia
    { city: 'Virginia Beach', state: 'VA' }, { city: 'Richmond', state: 'VA' },
    { city: 'Arlington', state: 'VA' }, { city: 'Norfolk', state: 'VA' },
    { city: 'Alexandria', state: 'VA' }, { city: 'Fairfax', state: 'VA' },
    // Washington
    { city: 'Seattle', state: 'WA' }, { city: 'Spokane', state: 'WA' },
    { city: 'Tacoma', state: 'WA' }, { city: 'Bellevue', state: 'WA' },
    { city: 'Vancouver', state: 'WA' }, { city: 'Redmond', state: 'WA' },
    // Massachusetts
    { city: 'Boston', state: 'MA' }, { city: 'Cambridge', state: 'MA' },
    { city: 'Worcester', state: 'MA' }, { city: 'Springfield', state: 'MA' },
    { city: 'Newton', state: 'MA' }, { city: 'Quincy', state: 'MA' },
    // Tennessee
    { city: 'Nashville', state: 'TN' }, { city: 'Memphis', state: 'TN' },
    { city: 'Knoxville', state: 'TN' }, { city: 'Chattanooga', state: 'TN' },
    { city: 'Franklin', state: 'TN' },
    // Indiana
    { city: 'Indianapolis', state: 'IN' }, { city: 'Fort Wayne', state: 'IN' },
    { city: 'Evansville', state: 'IN' }, { city: 'Bloomington', state: 'IN' },
    // Missouri
    { city: 'Kansas City', state: 'MO' }, { city: 'St. Louis', state: 'MO' },
    { city: 'Springfield', state: 'MO' }, { city: 'Columbia', state: 'MO' },
    // Maryland
    { city: 'Baltimore', state: 'MD' }, { city: 'Bethesda', state: 'MD' },
    { city: 'Rockville', state: 'MD' }, { city: 'Annapolis', state: 'MD' },
    { city: 'Silver Spring', state: 'MD' },
    // Wisconsin
    { city: 'Milwaukee', state: 'WI' }, { city: 'Madison', state: 'WI' },
    { city: 'Green Bay', state: 'WI' }, { city: 'Kenosha', state: 'WI' },
    // Minnesota
    { city: 'Minneapolis', state: 'MN' }, { city: 'Saint Paul', state: 'MN' },
    { city: 'Rochester', state: 'MN' }, { city: 'Bloomington', state: 'MN' },
    // Colorado
    { city: 'Denver', state: 'CO' }, { city: 'Boulder', state: 'CO' },
    { city: 'Colorado Springs', state: 'CO' }, { city: 'Aurora', state: 'CO' },
    { city: 'Fort Collins', state: 'CO' },
    // Arizona
    { city: 'Phoenix', state: 'AZ' }, { city: 'Scottsdale', state: 'AZ' },
    { city: 'Tucson', state: 'AZ' }, { city: 'Mesa', state: 'AZ' },
    { city: 'Chandler', state: 'AZ' }, { city: 'Tempe', state: 'AZ' },
    { city: 'Gilbert', state: 'AZ' },
    // Nevada
    { city: 'Las Vegas', state: 'NV' }, { city: 'Reno', state: 'NV' },
    { city: 'Henderson', state: 'NV' }, { city: 'Sparks', state: 'NV' },
    // Oregon
    { city: 'Portland', state: 'OR' }, { city: 'Eugene', state: 'OR' },
    { city: 'Salem', state: 'OR' }, { city: 'Bend', state: 'OR' },
    // Utah
    { city: 'Salt Lake City', state: 'UT' }, { city: 'Provo', state: 'UT' },
    { city: 'Park City', state: 'UT' }, { city: 'Ogden', state: 'UT' },
    // South Carolina
    { city: 'Charleston', state: 'SC' }, { city: 'Columbia', state: 'SC' },
    { city: 'Greenville', state: 'SC' }, { city: 'Myrtle Beach', state: 'SC' },
    // Connecticut
    { city: 'Hartford', state: 'CT' }, { city: 'New Haven', state: 'CT' },
    { city: 'Stamford', state: 'CT' }, { city: 'Bridgeport', state: 'CT' },
    // Kentucky
    { city: 'Louisville', state: 'KY' }, { city: 'Lexington', state: 'KY' },
    { city: 'Bowling Green', state: 'KY' },
    // Louisiana
    { city: 'New Orleans', state: 'LA' }, { city: 'Baton Rouge', state: 'LA' },
    { city: 'Shreveport', state: 'LA' }, { city: 'Lafayette', state: 'LA' },
    // Oklahoma
    { city: 'Oklahoma City', state: 'OK' }, { city: 'Tulsa', state: 'OK' },
    { city: 'Norman', state: 'OK' }, { city: 'Edmond', state: 'OK' },
    // Alabama
    { city: 'Birmingham', state: 'AL' }, { city: 'Montgomery', state: 'AL' },
    { city: 'Huntsville', state: 'AL' }, { city: 'Mobile', state: 'AL' },
    // Iowa
    { city: 'Des Moines', state: 'IA' }, { city: 'Cedar Rapids', state: 'IA' },
    { city: 'Iowa City', state: 'IA' },
    // Mississippi
    { city: 'Jackson', state: 'MS' }, { city: 'Gulfport', state: 'MS' },
    // Arkansas
    { city: 'Little Rock', state: 'AR' }, { city: 'Fayetteville', state: 'AR' },
    // Kansas
    { city: 'Wichita', state: 'KS' }, { city: 'Overland Park', state: 'KS' },
    { city: 'Topeka', state: 'KS' },
    // Nebraska
    { city: 'Omaha', state: 'NE' }, { city: 'Lincoln', state: 'NE' },
    // West Virginia
    { city: 'Charleston', state: 'WV' }, { city: 'Morgantown', state: 'WV' },
    // Idaho
    { city: 'Boise', state: 'ID' }, { city: 'Meridian', state: 'ID' },
    // New Mexico
    { city: 'Albuquerque', state: 'NM' }, { city: 'Santa Fe', state: 'NM' },
    // Hawaii
    { city: 'Honolulu', state: 'HI' }, { city: 'Kailua', state: 'HI' },
    // Alaska
    { city: 'Anchorage', state: 'AK' }, { city: 'Fairbanks', state: 'AK' },
    // Maine
    { city: 'Portland', state: 'ME' }, { city: 'Bangor', state: 'ME' },
    // New Hampshire
    { city: 'Manchester', state: 'NH' }, { city: 'Nashua', state: 'NH' },
    // Vermont
    { city: 'Burlington', state: 'VT' }, { city: 'Montpelier', state: 'VT' },
    // Rhode Island
    { city: 'Providence', state: 'RI' }, { city: 'Newport', state: 'RI' },
    // Delaware
    { city: 'Wilmington', state: 'DE' }, { city: 'Dover', state: 'DE' },
    // District of Columbia
    { city: 'Washington', state: 'DC' },
    // North Dakota
    { city: 'Fargo', state: 'ND' }, { city: 'Bismarck', state: 'ND' },
    // South Dakota
    { city: 'Sioux Falls', state: 'SD' }, { city: 'Rapid City', state: 'SD' },
    // Wyoming
    { city: 'Cheyenne', state: 'WY' }, { city: 'Casper', state: 'WY' },
    // Montana
    { city: 'Billings', state: 'MT' }, { city: 'Missoula', state: 'MT' },
    { city: 'Bozeman', state: 'MT' },

    // Additional secondary metros across the country
    { city: 'Glendale', state: 'CA' }, { city: 'Anaheim Hills', state: 'CA' },
    { city: 'Burbank', state: 'CA' }, { city: 'Costa Mesa', state: 'CA' },
    { city: 'Carlsbad', state: 'CA' }, { city: 'Berkeley', state: 'CA' },
    { city: 'Mountain View', state: 'CA' }, { city: 'Walnut Creek', state: 'CA' },
    { city: 'Sunnyvale', state: 'CA' }, { city: 'Santa Clara', state: 'CA' },
    { city: 'Fremont', state: 'CA' }, { city: 'Cupertino', state: 'CA' },
    { city: 'Modesto', state: 'CA' }, { city: 'Stockton', state: 'CA' },
    { city: 'Oxnard', state: 'CA' }, { city: 'Thousand Oaks', state: 'CA' },
    { city: 'Pembroke Pines', state: 'FL' }, { city: 'Coral Springs', state: 'FL' },
    { city: 'Gainesville', state: 'FL' }, { city: 'Cape Coral', state: 'FL' },
    { city: 'Pompano Beach', state: 'FL' }, { city: 'West Palm Beach', state: 'FL' },
    { city: 'Bradenton', state: 'FL' }, { city: 'Clearwater', state: 'FL' },
    { city: 'Galveston', state: 'TX' }, { city: 'Round Rock', state: 'TX' },
    { city: 'Killeen', state: 'TX' }, { city: 'Tyler', state: 'TX' },
    { city: 'Beaumont', state: 'TX' }, { city: 'College Station', state: 'TX' },
    { city: 'Allen', state: 'TX' }, { city: 'The Woodlands', state: 'TX' },
    { city: 'Irving', state: 'TX' }, { city: 'Garland', state: 'TX' },
    { city: 'Mesquite', state: 'TX' }, { city: 'Pasadena', state: 'TX' },
    { city: 'Brooklyn Heights', state: 'NY' }, { city: 'Astoria', state: 'NY' },
    { city: 'Long Island City', state: 'NY' }, { city: 'New Rochelle', state: 'NY' },
    { city: 'Schenectady', state: 'NY' }, { city: 'Hicksville', state: 'NY' },
    { city: 'King of Prussia', state: 'PA' }, { city: 'West Chester', state: 'PA' },
    { city: 'Bethlehem', state: 'PA' }, { city: 'Lancaster', state: 'PA' },
    { city: 'Cherry Hill', state: 'NJ' }, { city: 'Morristown', state: 'NJ' },
    { city: 'Trenton', state: 'NJ' }, { city: 'Camden', state: 'NJ' },
    { city: 'Atlantic City', state: 'NJ' }, { city: 'Toms River', state: 'NJ' },
    { city: 'Stamford', state: 'CT' }, { city: 'Norwalk', state: 'CT' },
    { city: 'Greenwich', state: 'CT' }, { city: 'Waterbury', state: 'CT' },
    { city: 'Buckhead', state: 'GA' }, { city: 'Roswell', state: 'GA' },
    { city: 'Sandy Springs', state: 'GA' }, { city: 'Alpharetta', state: 'GA' },
    { city: 'Decatur', state: 'GA' }, { city: 'Columbus', state: 'GA' },
    { city: 'High Point', state: 'NC' }, { city: 'Wilmington', state: 'NC' },
    { city: 'Concord', state: 'NC' }, { city: 'Chapel Hill', state: 'NC' },
    { city: 'Fort Mill', state: 'SC' }, { city: 'Hilton Head', state: 'SC' },
    { city: 'Rock Hill', state: 'SC' }, { city: 'Mount Pleasant', state: 'SC' },
    { city: 'Beverly', state: 'MA' }, { city: 'Lowell', state: 'MA' },
    { city: 'Brookline', state: 'MA' }, { city: 'Somerville', state: 'MA' },
    { city: 'Brockton', state: 'MA' }, { city: 'New Bedford', state: 'MA' },
    { city: 'Naperville', state: 'IL' }, { city: 'Schaumburg', state: 'IL' },
    { city: 'Joliet', state: 'IL' }, { city: 'Peoria', state: 'IL' },
    { city: 'Lake Forest', state: 'IL' }, { city: 'Wheaton', state: 'IL' },
    { city: 'Westerville', state: 'OH' }, { city: 'Lakewood', state: 'OH' },
    { city: 'Canton', state: 'OH' }, { city: 'Mason', state: 'OH' },
    { city: 'Allen Park', state: 'MI' }, { city: 'Royal Oak', state: 'MI' },
    { city: 'Birmingham', state: 'MI' }, { city: 'Troy', state: 'MI' },
    { city: 'Sterling Heights', state: 'MI' }, { city: 'Livonia', state: 'MI' },
    { city: 'Mequon', state: 'WI' }, { city: 'Brookfield', state: 'WI' },
    { city: 'Eau Claire', state: 'WI' }, { city: 'Appleton', state: 'WI' },
    { city: 'Edina', state: 'MN' }, { city: 'Maple Grove', state: 'MN' },
    { city: 'Eden Prairie', state: 'MN' }, { city: 'Plymouth', state: 'MN' },
    { city: 'Lakewood', state: 'CO' }, { city: 'Castle Rock', state: 'CO' },
    { city: 'Highlands Ranch', state: 'CO' }, { city: 'Aspen', state: 'CO' },
    { city: 'Vail', state: 'CO' }, { city: 'Greenwood Village', state: 'CO' },
    { city: 'Sedona', state: 'AZ' }, { city: 'Flagstaff', state: 'AZ' },
    { city: 'Lake Havasu City', state: 'AZ' }, { city: 'Yuma', state: 'AZ' },
    { city: 'Boulder City', state: 'NV' }, { city: 'Carson City', state: 'NV' },
    { city: 'Lake Oswego', state: 'OR' }, { city: 'Beaverton', state: 'OR' },
    { city: 'Hillsboro', state: 'OR' }, { city: 'Tigard', state: 'OR' },
    { city: 'Lehi', state: 'UT' }, { city: 'Sandy', state: 'UT' },
    { city: 'St. George', state: 'UT' }, { city: 'Draper', state: 'UT' },
    { city: 'Olympia', state: 'WA' }, { city: 'Kirkland', state: 'WA' },
    { city: 'Bothell', state: 'WA' }, { city: 'Issaquah', state: 'WA' },
    { city: 'Renton', state: 'WA' }, { city: 'Sammamish', state: 'WA' },
    { city: 'Franklin', state: 'TN' }, { city: 'Murfreesboro', state: 'TN' },
    { city: 'Brentwood', state: 'TN' }, { city: 'Germantown', state: 'TN' },
    { city: 'Carmel', state: 'IN' }, { city: 'Fishers', state: 'IN' },
    { city: 'Bloomington', state: 'IN' }, { city: 'Lafayette', state: 'IN' },
    { city: 'Lee\'s Summit', state: 'MO' }, { city: 'Independence', state: 'MO' },
    { city: 'Chesterfield', state: 'MO' }, { city: 'O\'Fallon', state: 'MO' },
    { city: 'Towson', state: 'MD' }, { city: 'Frederick', state: 'MD' },
    { city: 'Gaithersburg', state: 'MD' }, { city: 'Columbia', state: 'MD' },
    { city: 'Loveland', state: 'CO' }, { city: 'Longmont', state: 'CO' },
    { city: 'Boulder', state: 'CO' }, { city: 'Westminster', state: 'CO' }
  ];
  // Pattern → price-tier mapping. Distribution matches real catalog reality:
  //   SPECIAL (everyday $200-$420)  → ~82% of shown sales
  //   PREMIUM (mid $400-$2,500)     → ~14% of shown sales
  //   EXCLUSIVE (quad-repeat $4.5k+)→ ~4% of shown sales
  // Sizes of each pool intentionally varied so the same pattern doesn't
  // repeat back-to-back. Real prices in catalog (per CLAUDE.md): min $200,
  // median $500, P75 $600, max $25k. Quad-repeats sell well above $5k.
  var patternTiers = [
    // ===== ULTRA — all 7 digits identical (rarest, top-of-catalog) =====
    { p: '888-8888', tier: 'ultra',     priceBand: [15000, 25000] },
    { p: '777-7777', tier: 'ultra',     priceBand: [12000, 22000] },
    { p: '999-9999', tier: 'ultra',     priceBand: [12000, 23000] },
    { p: '111-1111', tier: 'ultra',     priceBand: [8000,  18000] },
    { p: '666-6666', tier: 'ultra',     priceBand: [7000,  15000] },
    { p: '555-5555', tier: 'ultra',     priceBand: [6000,  13000] },
    { p: '444-4444', tier: 'ultra',     priceBand: [5000,  11000] },
    { p: '333-3333', tier: 'ultra',     priceBand: [4500,  9500]  },
    { p: '222-2222', tier: 'ultra',     priceBand: [4000,  8500]  },
    { p: '000-0000', tier: 'ultra',     priceBand: [4500,  10000] },

    // ===== EXCLUSIVE — exactly 6 of 7 digits same =====
    // 8s (most commercial)
    { p: '088-8888', tier: 'exclusive', priceBand: [5000, 8500] },
    { p: '188-8888', tier: 'exclusive', priceBand: [4500, 8000] },
    { p: '808-8888', tier: 'exclusive', priceBand: [4500, 8000] },
    { p: '888-8088', tier: 'exclusive', priceBand: [4000, 7500] },
    { p: '888-8880', tier: 'exclusive', priceBand: [4000, 7000] },
    { p: '881-8888', tier: 'exclusive', priceBand: [3500, 6500] },
    // 7s
    { p: '077-7777', tier: 'exclusive', priceBand: [3500, 6500] },
    { p: '707-7777', tier: 'exclusive', priceBand: [3500, 6000] },
    { p: '770-7777', tier: 'exclusive', priceBand: [3000, 5500] },
    { p: '777-7077', tier: 'exclusive', priceBand: [3000, 5500] },
    { p: '777-7770', tier: 'exclusive', priceBand: [3000, 5500] },
    { p: '177-7777', tier: 'exclusive', priceBand: [3500, 6000] },
    // 9s
    { p: '099-9999', tier: 'exclusive', priceBand: [3500, 6500] },
    { p: '909-9999', tier: 'exclusive', priceBand: [3500, 6000] },
    { p: '990-9999', tier: 'exclusive', priceBand: [3000, 5500] },
    { p: '999-9099', tier: 'exclusive', priceBand: [3000, 5500] },
    { p: '999-9990', tier: 'exclusive', priceBand: [3000, 5500] },
    // 1s, 6s, 5s — less commercial
    { p: '011-1111', tier: 'exclusive', priceBand: [2200, 4000] },
    { p: '101-1111', tier: 'exclusive', priceBand: [2200, 4000] },
    { p: '111-1011', tier: 'exclusive', priceBand: [2000, 3800] },
    { p: '066-6666', tier: 'exclusive', priceBand: [2200, 4200] },
    { p: '606-6666', tier: 'exclusive', priceBand: [2200, 4200] },
    { p: '055-5555', tier: 'exclusive', priceBand: [2000, 3800] },
    { p: '505-5555', tier: 'exclusive', priceBand: [2000, 3800] },

    // ===== HIGH-PREMIUM — exactly 5 of 7 digits same =====
    // 8s
    { p: '588-8888', tier: 'high-premium', priceBand: [2200, 3500] },
    { p: '688-8888', tier: 'high-premium', priceBand: [2400, 3800] },
    { p: '988-8888', tier: 'high-premium', priceBand: [2300, 3600] },
    { p: '208-8888', tier: 'high-premium', priceBand: [1800, 3000] },
    { p: '328-8888', tier: 'high-premium', priceBand: [1800, 3000] },
    { p: '418-8888', tier: 'high-premium', priceBand: [1700, 2800] },
    { p: '618-8888', tier: 'high-premium', priceBand: [1900, 3200] },
    { p: '828-8888', tier: 'high-premium', priceBand: [2100, 3400] },
    // 7s
    { p: '577-7777', tier: 'high-premium', priceBand: [1900, 3200] },
    { p: '677-7777', tier: 'high-premium', priceBand: [1900, 3200] },
    { p: '877-7777', tier: 'high-premium', priceBand: [2000, 3300] },
    { p: '327-7777', tier: 'high-premium', priceBand: [1500, 2600] },
    { p: '517-7777', tier: 'high-premium', priceBand: [1500, 2600] },
    { p: '617-7777', tier: 'high-premium', priceBand: [1700, 2800] },
    { p: '717-7777', tier: 'high-premium', priceBand: [1800, 3000] },
    // 9s
    { p: '599-9999', tier: 'high-premium', priceBand: [2000, 3400] },
    { p: '699-9999', tier: 'high-premium', priceBand: [2100, 3500] },
    { p: '199-9999', tier: 'high-premium', priceBand: [1700, 2900] },
    { p: '519-9999', tier: 'high-premium', priceBand: [1600, 2700] },
    // 1s, 6s, 5s, 4s, 3s
    { p: '511-1111', tier: 'high-premium', priceBand: [1100, 1900] },
    { p: '811-1111', tier: 'high-premium', priceBand: [1200, 2000] },
    { p: '566-6666', tier: 'high-premium', priceBand: [1300, 2200] },
    { p: '866-6666', tier: 'high-premium', priceBand: [1300, 2200] },
    { p: '655-5555', tier: 'high-premium', priceBand: [1100, 1900] },
    { p: '855-5555', tier: 'high-premium', priceBand: [1100, 1900] },
    { p: '844-4444', tier: 'high-premium', priceBand: [950,  1700] },
    { p: '833-3333', tier: 'high-premium', priceBand: [950,  1700] },

    // ===== PREMIUM — exactly 4 of 7 same (quad-end, non-matching prefix) =====
    { p: '415-7777', tier: 'premium',   priceBand: [900, 1500] },
    { p: '526-7777', tier: 'premium',   priceBand: [800, 1400] },
    { p: '630-7777', tier: 'premium',   priceBand: [800, 1400] },
    { p: '482-8888', tier: 'premium',   priceBand: [950, 1600] },
    { p: '305-8888', tier: 'premium',   priceBand: [1000, 1700] },
    { p: '714-8888', tier: 'premium',   priceBand: [950, 1500] },
    { p: '371-9999', tier: 'premium',   priceBand: [900, 1500] },
    { p: '602-9999', tier: 'premium',   priceBand: [950, 1600] },
    { p: '816-9999', tier: 'premium',   priceBand: [850, 1400] },
    { p: '320-6666', tier: 'premium',   priceBand: [700, 1200] },
    { p: '485-6666', tier: 'premium',   priceBand: [700, 1200] },
    { p: '720-5555', tier: 'premium',   priceBand: [650, 1100] },
    { p: '218-5555', tier: 'premium',   priceBand: [650, 1100] },
    { p: '650-1111', tier: 'premium',   priceBand: [700, 1200] },
    { p: '904-1111', tier: 'premium',   priceBand: [700, 1200] },
    { p: '423-4444', tier: 'premium',   priceBand: [550, 900]  },
    { p: '518-3333', tier: 'premium',   priceBand: [500, 850]  },
    { p: '617-2222', tier: 'premium',   priceBand: [550, 900]  },
    { p: '480-0000', tier: 'premium',   priceBand: [600, 1000] },
    // Round/sequence endings — premium structure
    { p: '500-5000', tier: 'premium',   priceBand: [600, 1100] },
    { p: '700-7000', tier: 'premium',   priceBand: [550, 1000] },
    { p: '800-8000', tier: 'premium',   priceBand: [750, 1300] },
    { p: '900-9000', tier: 'premium',   priceBand: [550, 1000] },
    { p: '600-6000', tier: 'premium',   priceBand: [500, 950]  },
    { p: '300-3000', tier: 'premium',   priceBand: [450, 850]  },
    { p: '200-2000', tier: 'premium',   priceBand: [450, 850]  },
    { p: '100-1000', tier: 'premium',   priceBand: [500, 950]  },
    { p: '465-1234', tier: 'premium',   priceBand: [550, 950]  },
    { p: '829-4321', tier: 'premium',   priceBand: [500, 850]  },
    { p: '317-6789', tier: 'premium',   priceBand: [550, 950]  },

    // ===== SPECIAL — bulk of real sales. $200-$520. =====

    // Triple endings — 3 of the last 4 share a digit (very common in real catalog)
    { p: '215-2227', tier: 'special',   priceBand: [320, 480] },
    { p: '617-3338', tier: 'special',   priceBand: [340, 500] },
    { p: '720-5556', tier: 'special',   priceBand: [300, 460] },
    { p: '404-7771', tier: 'special',   priceBand: [380, 520] },
    { p: '305-9990', tier: 'special',   priceBand: [400, 520] },
    { p: '512-8884', tier: 'special',   priceBand: [400, 520] },
    { p: '212-4441', tier: 'special',   priceBand: [280, 440] },
    { p: '702-6661', tier: 'special',   priceBand: [320, 480] },
    { p: '413-0008', tier: 'special',   priceBand: [280, 440] },
    { p: '847-1110', tier: 'special',   priceBand: [260, 420] },
    { p: '281-2228', tier: 'special',   priceBand: [280, 440] },

    // AABB endings (pair-pair, last 4)
    { p: '317-1100', tier: 'special',   priceBand: [220, 360] },
    { p: '845-2200', tier: 'special',   priceBand: [220, 360] },
    { p: '562-3300', tier: 'special',   priceBand: [220, 360] },
    { p: '714-4400', tier: 'special',   priceBand: [220, 360] },
    { p: '208-5500', tier: 'special',   priceBand: [240, 400] },
    { p: '904-6600', tier: 'special',   priceBand: [220, 360] },
    { p: '281-7700', tier: 'special',   priceBand: [240, 400] },
    { p: '305-8800', tier: 'special',   priceBand: [260, 420] },
    { p: '843-9900', tier: 'special',   priceBand: [260, 420] },

    // ABAB pattern (alternating, last 4)
    { p: '407-1212', tier: 'special',   priceBand: [240, 400] },
    { p: '702-3434', tier: 'special',   priceBand: [240, 400] },
    { p: '512-5656', tier: 'special',   priceBand: [240, 400] },
    { p: '480-7878', tier: 'special',   priceBand: [260, 420] },
    { p: '347-1313', tier: 'special',   priceBand: [240, 400] },
    { p: '262-6262', tier: 'special',   priceBand: [240, 420] },
    { p: '383-3838', tier: 'special',   priceBand: [240, 420] },
    { p: '414-7474', tier: 'special',   priceBand: [240, 400] },

    // ABBA palindromic pairs
    { p: '602-1221', tier: 'special',   priceBand: [220, 360] },
    { p: '801-2112', tier: 'special',   priceBand: [220, 360] },
    { p: '770-3443', tier: 'special',   priceBand: [220, 360] },
    { p: '405-7887', tier: 'special',   priceBand: [240, 400] },
    { p: '623-8998', tier: 'special',   priceBand: [240, 400] },

    // Birth-year endings — common personal vanity choice
    { p: '617-1985', tier: 'special',   priceBand: [200, 320] },
    { p: '512-1990', tier: 'special',   priceBand: [220, 360] },
    { p: '305-1995', tier: 'special',   priceBand: [220, 360] },
    { p: '404-2000', tier: 'special',   priceBand: [240, 380] },
    { p: '720-2005', tier: 'special',   priceBand: [200, 320] },
    { p: '503-2010', tier: 'special',   priceBand: [200, 320] },
    { p: '781-1978', tier: 'special',   priceBand: [200, 320] },
    { p: '513-1982', tier: 'special',   priceBand: [200, 320] },

    // Mid-pair clean endings (last 4 has internal repeat)
    { p: '226-3266', tier: 'special',   priceBand: [220, 360] },
    { p: '335-7733', tier: 'special',   priceBand: [220, 360] },
    { p: '848-3535', tier: 'special',   priceBand: [200, 320] },
    { p: '624-9494', tier: 'special',   priceBand: [200, 320] },
    { p: '316-2882', tier: 'special',   priceBand: [220, 380] },
    { p: '435-1199', tier: 'special',   priceBand: [200, 320] },
    { p: '628-3344', tier: 'special',   priceBand: [200, 320] },

    // Last-3 round (100, 200, 300...)
    { p: '917-2100', tier: 'special',   priceBand: [200, 320] },
    { p: '215-4200', tier: 'special',   priceBand: [200, 320] },
    { p: '305-5400', tier: 'special',   priceBand: [200, 320] },
    { p: '702-1700', tier: 'special',   priceBand: [220, 360] },
    { p: '816-3800', tier: 'special',   priceBand: [200, 320] },
    { p: '407-5300', tier: 'special',   priceBand: [200, 320] },
    { p: '901-6900', tier: 'special',   priceBand: [200, 320] },

    // 1000-step endings (less round, mid-vanity)
    { p: '714-1000', tier: 'special',   priceBand: [280, 420] },
    { p: '619-2000', tier: 'special',   priceBand: [280, 420] },
    { p: '512-3000', tier: 'special',   priceBand: [280, 420] },
    { p: '404-4000', tier: 'special',   priceBand: [280, 420] },
    { p: '305-5000', tier: 'special',   priceBand: [300, 420] },
    { p: '720-7000', tier: 'special',   priceBand: [320, 420] },
    { p: '702-8000', tier: 'special',   priceBand: [320, 420] },
    { p: '480-9000', tier: 'special',   priceBand: [280, 420] },

    // Catalog-style miscellanea (mid-aesthetic last-4 — most realistic)
    { p: '407-2828', tier: 'special',   priceBand: [220, 360] },
    { p: '305-6363', tier: 'special',   priceBand: [220, 360] },
    { p: '702-1010', tier: 'special',   priceBand: [240, 400] },
    { p: '617-8181', tier: 'special',   priceBand: [220, 360] },
    { p: '720-5959', tier: 'special',   priceBand: [220, 360] },
    { p: '803-4747', tier: 'special',   priceBand: [200, 340] },
    { p: '480-8181', tier: 'special',   priceBand: [220, 360] },
    { p: '703-9090', tier: 'special',   priceBand: [220, 360] }
  ];

  // Time-ago tied to tier with realistic frequency-weighting. Cheap items
  // sell often → most recent timestamps. High-ticket items sell rarely →
  // older timestamps. Within each tier, the array is duplicated toward
  // the recent end so the *average* shown timestamp leans fresh — uniform
  // arrays would make "53 min ago" appear as often as "just now," which
  // doesn't reflect how a real live feed surfaces events.
  var TIME_AGO = {
    // Cheap everyday sales — should read "just now / few min ago" most of the time.
    special: [
      'just now', 'just now', 'just now', 'just now',
      '1 minute ago', '1 minute ago', '1 minute ago',
      '2 minutes ago', '2 minutes ago', '2 minutes ago',
      '3 minutes ago', '3 minutes ago', '3 minutes ago',
      '4 minutes ago', '4 minutes ago',
      '5 minutes ago', '5 minutes ago', '5 minutes ago',
      '7 minutes ago', '7 minutes ago',
      '9 minutes ago', '9 minutes ago',
      '11 minutes ago',
      '14 minutes ago',
      '18 minutes ago',
      '23 minutes ago',
      '32 minutes ago',
      '45 minutes ago'
    ],
    // Mid-ticket ($500-$1700) — every hour-ish.
    premium: [
      '12 minutes ago', '12 minutes ago',
      '18 minutes ago', '18 minutes ago',
      '27 minutes ago',
      '34 minutes ago',
      '42 minutes ago',
      '53 minutes ago',
      '1 hour ago', '1 hour ago',
      '2 hours ago',
      '3 hours ago'
    ],
    // High-premium ($1k-$3.8k) — multiple-hour cadence.
    'high-premium': [
      '38 minutes ago',
      '52 minutes ago',
      '1 hour ago', '1 hour ago',
      '2 hours ago', '2 hours ago',
      '3 hours ago',
      '5 hours ago',
      '8 hours ago'
    ],
    // Exclusive ($2k-$8.5k) — handful per day.
    exclusive: [
      '2 hours ago',
      '3 hours ago',
      '5 hours ago',
      '7 hours ago',
      '10 hours ago',
      '14 hours ago',
      'yesterday'
    ],
    // Ultra ($4k-$25k all-7-same) — genuinely rare.
    ultra: [
      'yesterday',
      '2 days ago', '2 days ago',
      '3 days ago',
      '5 days ago',
      'last week'
    ]
  };

  // Weighted picker. Probabilities match real catalog distribution:
  //   ultra (7-of-7):       ~1.5%
  //   exclusive (6-of-7):   ~3.5%
  //   high-premium (5-of-7):~5%
  //   premium (4-of-7):     ~10%
  //   special (rest):       ~80%
  function pickPatternWeighted() {
    var r = Math.random();
    var wantTier;
    if      (r < 0.015) wantTier = 'ultra';
    else if (r < 0.050) wantTier = 'exclusive';
    else if (r < 0.100) wantTier = 'high-premium';
    else if (r < 0.200) wantTier = 'premium';
    else                wantTier = 'special';
    var pool = patternTiers.filter(function (e) { return e.tier === wantTier; });
    return pool[Math.floor(Math.random() * pool.length)];
  }

  function pick(arr) { return arr[Math.floor(Math.random() * arr.length)]; }
  function priceFromBand(band) {
    var lo = band[0], hi = band[1];
    var raw = Math.floor(Math.random() * (hi - lo + 1)) + lo;
    // Round to a clean increment depending on band magnitude.
    var step = raw >= 8000 ? 500 : raw >= 2000 ? 250 : raw >= 800 ? 50 : raw >= 300 ? 20 : 10;
    var cleaned = Math.round(raw / step) * step;
    return '$' + cleaned.toLocaleString('en-US');
  }
  function generate() {
    var loc  = pick(areaCodes);
    var entry = pickPatternWeighted();
    return {
      // Mask the area code for buyer privacy — show pattern only.
      phone: '(***) ' + entry.p,
      city: loc.city,
      state: loc.state,
      price: priceFromBand(entry.priceBand),
      t: pick(TIME_AGO[entry.tier] || TIME_AGO.special)
    };
  }

  var box = document.createElement('div');
  box.className = 'de-activity';
  box.setAttribute('role', 'status');
  box.setAttribute('aria-live', 'polite');
  box.innerHTML = '<span class="de-activity__dot" aria-hidden="true"></span>' +
    '<span class="de-activity__body">' +
      '<span class="de-activity__line"></span>' +
      '<span class="de-activity__meta"></span>' +
    '</span>' +
    '<button type="button" class="de-activity__close" aria-label="Dismiss">&times;</button>';
  document.body.appendChild(box);

  var lineEl = box.querySelector('.de-activity__line');
  var metaEl = box.querySelector('.de-activity__meta');
  var lastPhone = '';

  // Subtle phrasing variation so 10 sales in a row don't read templated.
  // All variants stay polite + neutral. No emojis, no hype words.
  var PHRASINGS = [
    function (phone, city) { return phone + ' just sold to a buyer in ' + city; },
    function (phone, city) { return phone + ' was purchased by a buyer in ' + city; }
  ];

  function escapeHtml(s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function show() {
    var s; var attempts = 0;
    do { s = generate(); attempts++; } while (s.phone === lastPhone && attempts < 5);
    lastPhone = s.phone;
    var phrase = PHRASINGS[Math.floor(Math.random() * PHRASINGS.length)];
    var loc = s.city + ', ' + s.state;
    // Build phrase with a styled span around the phone number so it stays bold.
    var bare = phrase('§PHONE§', '§CITY§');
    var html = escapeHtml(bare)
      .replace('§PHONE§', '<span class="de-activity__phone">' + escapeHtml(s.phone) + '</span>')
      .replace('§CITY§',  '<span class="de-activity__city">'  + escapeHtml(loc)     + '</span>');
    lineEl.innerHTML = html;
    metaEl.textContent = s.price + ' · ' + s.t;
    box.classList.add('is-visible');
  }
  function hide() { box.classList.remove('is-visible'); }

  box.querySelector('.de-activity__close').addEventListener('click', function () {
    hide();
    try { localStorage.setItem('deActivityDismissedAt', String(Date.now())); } catch (e) {}
    setTimeout(function () { box.remove(); }, 360);
  });

  // Cadence — a successful-but-believable store. Most gaps 30-90 sec, with
  // small bursts (15-30 sec) and rare 2-min lulls. Max gap capped at 130 sec
  // so the site always feels active. Mixture distribution prevents the
  // metronome feel.
  function rand(min, max) { return Math.floor(Math.random() * (max - min + 1)) + min; }
  function nextGapMs() {
    var r = Math.random();
    if (r < 0.22) return rand(12000,  28000);   // 12-28s  burst (back-to-back buyers)
    if (r < 0.65) return rand(28000,  60000);   // 28-60s  close cadence (most common)
    if (r < 0.92) return rand(60000,  95000);   // 1-1.6m  typical
    return            rand(95000,  120000);     // 1.6-2m  rare lull (max)
  }
  function loop() {
    show();
    setTimeout(function () {
      hide();
      setTimeout(loop, nextGapMs());
    }, rand(5500, 8500));                                  // visible duration (varied)
  }
  setTimeout(loop, rand(5000, 12000));                     // first toast after page settles
})();

/* =====================================================================
   21. PREMIUM HEADER (de-headerY) — runtime wiring
   - Scroll state (data-scrolled="true" past 12px)
   - Announce track duplicate for seamless marquee
   - Mobile menu toggle (opens existing #de-mobile-menu)
   - Set --header-y for mega menu top offset
   ===================================================================== */
/* Mobile menu event delegation — always-on, doesn't require .de-headerY to exist yet */
(function () {
  var toggleSel = '.de-headerY__menu-toggle, .de-header__menu-toggle';
  document.addEventListener('click', function (e) {
    var trigger = e.target && e.target.closest && e.target.closest(toggleSel);
    if (trigger) {
      var menu = document.getElementById('de-mobile-menu');
      if (!menu) return;
      e.preventDefault();
      var open = menu.classList.toggle('is-open');
      menu.setAttribute('aria-hidden', open ? 'false' : 'true');
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('is-menu-open', open);
      return;
    }
    var closer = e.target.closest('.de-mobile-menu__close, .de-mobile-menu__overlay');
    var navLink = e.target.closest('.de-mobile-menu a');
    if (closer || navLink) {
      var m = document.getElementById('de-mobile-menu');
      if (!m || !m.classList.contains('is-open')) return;
      // The close X and the backdrop are <a href="#close-menu"> so they still
      // work when this script never runs. When it DOES run we cancel the click
      // so the hash never reaches the address bar. Nav links must NOT be
      // cancelled — they still have to navigate.
      if (closer) e.preventDefault();
      m.classList.remove('is-open');
      m.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('is-menu-open');
      var t = document.querySelector(toggleSel);
      if (t) t.setAttribute('aria-expanded', 'false');
    }
  }, false);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var m = document.getElementById('de-mobile-menu');
      if (m && m.classList.contains('is-open')) {
        m.classList.remove('is-open');
        m.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('is-menu-open');
      }
    }
  });
})();

function deHeaderYInit(){
  var hdr = document.querySelector('.de-headerY');
  if (!hdr) return;

  // Duplicate announce track for seamless rolling
  var track = hdr.querySelector('.de-headerY__announce-track');
  if (track && !track.dataset.duped) {
    track.innerHTML = track.innerHTML + track.innerHTML;
    track.dataset.duped = '1';
  }

  // Scroll state
  function setScrolled() {
    // Drives ONLY the bar's background / border / shadow now — the 64px->56px
    // height collapse this used to trigger is gone (see de-header-no-shrink in
    // de-polish.css), so this can no longer change document height and the
    // scroll-anchoring feedback loop it used to cause is impossible.
    // A small 6px band so the background cannot flicker for someone parked
    // exactly on the line with sub-pixel scrolling.
    var on = hdr.hasAttribute('data-scrolled');
    var y = window.scrollY;
    if (!on && y > 12) hdr.setAttribute('data-scrolled', 'true');
    else if (on && y < 6) hdr.removeAttribute('data-scrolled');
  }
  window.addEventListener('scroll', setScrolled, { passive: true });
  setScrolled();

  // Set CSS var --header-y so mega menu can position right under bar
  function setHeaderY() {
    var bar = hdr.querySelector('.de-headerY__bar');
    if (!bar) return;
    var rect = bar.getBoundingClientRect();
    document.documentElement.style.setProperty('--header-y', (rect.bottom) + 'px');
  }
  setHeaderY();
  window.addEventListener('resize', setHeaderY, { passive: true });
  window.addEventListener('scroll', setHeaderY, { passive: true });

  /* mobile menu delegation moved to top-level IIFE above */
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', deHeaderYInit);
} else {
  deHeaderYInit();
}

/* =====================================================================
   22. MENU HOVER-INTENT — fixes cursor-sensitivity flicker on mega menus.
   - 100ms delay before opening (prevents accidental flash on transit)
   - 220ms delay before closing (allows cursor to reach mega panel)
   - Closes on click outside, Esc, focus loss
   - Only one menu open at a time
   ===================================================================== */
(function () {
  var items = document.querySelectorAll('.de-headerY__nav-item--has-menu');
  if (!items.length) return;

  var openTimer = null;
  var closeTimer = null;
  var currentOpen = null;

  function openItem(item) {
    if (currentOpen && currentOpen !== item) currentOpen.classList.remove('is-open');
    item.classList.add('is-open');
    var trigger = item.querySelector('.de-headerY__nav-link');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    currentOpen = item;
  }
  function closeItem(item) {
    if (!item) return;
    if (kbdLink && item.contains(kbdLink)) { kbdLink.classList.remove('is-kbd'); kbdLink = null; }
    if (megaHover && item.contains(megaHover)) { megaHover = null; megaHoverFresh = false; }
    var mg = item.querySelector('.de-headerY__mega');
    if (mg) mg.classList.remove('is-kbd-nav');
    /* the panel is going away: let the ring rules go back to normal */
    if (megaFocused) { megaFocused.classList.remove('is-kbd-focus'); megaFocused = null; }
    megaHoverOff = false;

    item.classList.remove('is-open');
    var trigger = item.querySelector('.de-headerY__nav-link');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (currentOpen === item) currentOpen = null;
  }
  function closeAll() {
    items.forEach(closeItem);
  }

  /* ── KEYBOARD NAVIGATION FOR THE MEGA MENU ───────────────────────────────
     Arrow keys walk the open panel. The highlight is the panel's OWN hover
     style: `.is-kbd` was appended to the existing
     `.de-headerY__mega-link:hover` rule rather than given declarations of its
     own, so there is exactly one appearance to maintain.
     Movement is geometric rather than DOM order, because the panel is a
     multi-column layout (the states block alone is 3 columns) — up/down must
     stay in a column and left/right must cross to the neighbouring one. */
  var kbdLink = null;
  /* Arrow keys should continue from wherever the pointer is, exactly like the
     collection grid does (it keeps `lastHovered` + `hoverFresh` and picks up
     from the hovered card). Starting at the first link every time ignores where
     the person already is. */
  var megaHover = null, megaHoverFresh = false;
  document.addEventListener('mouseover', function (e) {
    var a = e.target && e.target.closest && e.target.closest('.de-headerY__mega a[href]');
    if (a) { megaHover = a; megaHoverFresh = true; }
  }, true);
  function megaLinks(item) {
    var mega = item && item.querySelector('.de-headerY__mega');
    if (!mega) return [];
    return [].slice.call(mega.querySelectorAll('a[href]')).filter(function (a) {
      var r = a.getBoundingClientRect();
      return r.width > 1 && r.height > 1;
    });
  }
  function clearKbd() {
    if (kbdLink) kbdLink.classList.remove('is-kbd');
    kbdLink = null;
    /* The focused link KEEPS `.is-kbd-focus` and keeps focus. Blurring it, or
       removing the element under focus, drops focus to <body> and that
       focusout is what closes the whole panel — measured: the menu went open
       -> closed the instant that happened. Leaving it costs nothing visually
       (the class only suppresses the ring) and the moment the pointer is over
       a real link the browser reports THAT link instead. */
  }
  /* One highlight at a time. With the pointer resting on a link, that link kept
     its hover state while the keyboard cursor sat somewhere else, so two items
     looked selected — the owner saw it on "Browse All Numbers". Same mechanism
     the product grid uses (.is-kbd-scrolling + pointer-events:none), scoped to
     the links so the panel still gets the mouse events hover-intent needs. */
  var megaHoverOff = false;
  function suppressMegaHover(on) {
    var mega = currentOpen && currentOpen.querySelector('.de-headerY__mega');
    if (mega) mega.classList.toggle('is-kbd-nav', !!on);
    megaHoverOff = !!on;
  }
  document.addEventListener('mousemove', function () {
    if (!megaHoverOff) return;
    suppressMegaHover(false);
    clearKbd();          // the pointer takes over; arrows resume from what it hovers
  }, true);
  /* ── THE MENU CURSOR NEEDS A LINK THE BROWSER CAN SEE ──────────────────
     The highlighted item is still deliberately NOT focused. Focusing it drags
     three problems along: the focus ring sits on top of the hover highlight;
     the ring comes back the instant `.is-kbd` is removed (measured again —
     outline goes none -> solid 2px on the still-focused link); and blurring to
     clear it fires the item's focusout, which closes the panel.
     But without focus the browser has no link to report, so arrowing the menu
     showed no URL and preloaded nothing, unlike the listings and the dropdown
     rows. So the same trick the product list uses: park one reusable 1px
     transparent anchor in the panel, give it the highlighted item's href and
     focus THAT. It cannot show a ring (it is invisible), it lives inside the
     panel so focus never leaves the menu and nothing closes, and it is
     aria-hidden with tabindex -1 so it is absent from the tab order and the
     a11y tree. Enter is untouched — it still reads kbdLink.href directly. */
  var megaFocused = null;
  function setKbd(link) {
    if (kbdLink && kbdLink !== link) kbdLink.classList.remove('is-kbd');
    kbdLink = link || null;
    if (kbdLink) {
      kbdLink.classList.add('is-kbd');
      var href = kbdLink.getAttribute && kbdLink.getAttribute('href');
      if (href) {
        /* Focus the REAL link. The first attempt parked an invisible 1px
           anchor here instead, which does get focus and does carry the href —
           but a browser will not offer a destination the user cannot see, so
           the menu still previewed nothing. A real, visible, focused link is
           what makes the listings work, so do exactly that.
           The ring that focus used to bring is handled by `.is-kbd-focus`,
           which is suppressed in CSS and — unlike `.is-kbd` — STAYS on the
           element for as long as it holds focus. That was the missing piece
           the first time: dropping the highlight class let the ring straight
           back in (measured: outline none -> solid 2px). Nothing is ever
           blurred, because blurring is what closes the panel. */
        if (megaFocused && megaFocused !== kbdLink) megaFocused.classList.remove('is-kbd-focus');
        kbdLink.classList.add('is-kbd-focus');
        megaFocused = kbdLink;
        try { kbdLink.focus({ preventScroll: true }); } catch (e) {}
        /* PREFETCH only, so a destination arrowed past but never opened runs
           no page JS and fires no pixel or ad events. */
        try { if (window.__dxPreloadFn) window.__dxPreloadFn(href); } catch (e2) {}
      }
    }
  }
  function nearestLink(list, from, dir) {
    var fr = from.getBoundingClientRect();
    var fx = fr.left + fr.width / 2, fy = fr.top + fr.height / 2;
    var best = null, bestScore = Infinity;
    for (var i = 0; i < list.length; i++) {
      var a = list[i]; if (a === from) continue;
      var r = a.getBoundingClientRect();
      var dx = (r.left + r.width / 2) - fx, dy = (r.top + r.height / 2) - fy;
      if (dir === 'up' && dy >= -2) continue;
      if (dir === 'down' && dy <= 2) continue;
      if (dir === 'left' && dx >= -2) continue;
      if (dir === 'right' && dx <= 2) continue;
      var vertical = (dir === 'up' || dir === 'down');
      var along = vertical ? Math.abs(dy) : Math.abs(dx);
      var across = vertical ? Math.abs(dx) : Math.abs(dy);
      var score = along + across * 2.5;   // travel straight before drifting sideways
      if (score < bestScore) { bestScore = score; best = a; }
    }
    return best;
  }
  document.addEventListener('keydown', function (e) {
    if (e.metaKey || e.ctrlKey || e.altKey) return;
    var k = e.key;
    var arrow = (k === 'ArrowUp' || k === 'ArrowDown' || k === 'ArrowLeft' || k === 'ArrowRight');
    if (!currentOpen) {
      /* ArrowDown on a focused nav trigger opens its panel */
      if (k !== 'ArrowDown') return;
      var ae = document.activeElement;
      var item = ae && ae.closest && ae.closest('.de-headerY__nav-item--has-menu');
      if (!item) return;
      e.preventDefault(); e.stopPropagation();
      openItem(item);
      var first = megaLinks(item);
      if (megaHoverFresh && megaHover && item.contains(megaHover)) { megaHoverFresh = false; setKbd(megaHover); }
      else if (first.length) setKbd(first[0]);
      return;
    }
    if (k === 'Escape') { clearKbd(); closeAll(); return; }
    if (k === 'Enter') {
      if (!kbdLink) return;
      e.preventDefault(); e.stopPropagation();
      window.location.href = kbdLink.href;
      return;
    }
    if (!arrow) return;
    var list = megaLinks(currentOpen);
    if (!list.length) return;
    /* stopPropagation as well as preventDefault: the collection grid listens for
       the same keys on document and would walk the product listing at the same
       time. */
    e.preventDefault(); e.stopPropagation();
    suppressMegaHover(true);
    /* pick up from the hovered link, then step from there — same as the grid */
    if (megaHoverFresh && megaHover && currentOpen.contains(megaHover) && list.indexOf(megaHover) >= 0) {
      megaHoverFresh = false;
      if (kbdLink && kbdLink !== megaHover) kbdLink.classList.remove('is-kbd');
      kbdLink = megaHover;
    }
    if (!kbdLink || list.indexOf(kbdLink) < 0) { setKbd(list[0]); return; }
    var dir = k === 'ArrowUp' ? 'up' : k === 'ArrowDown' ? 'down' : k === 'ArrowLeft' ? 'left' : 'right';
    var nx = nearestLink(list, kbdLink, dir);
    if (nx) setKbd(nx);
  }, true);

  items.forEach(function (item) {
    var trigger = item.querySelector('.de-headerY__nav-link');
    var mega = item.querySelector('.de-headerY__mega');
    if (!trigger || !mega) return;

    function scheduleOpen() {
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      // If another item is already open, switch instantly. Otherwise small delay.
      var delay = currentOpen ? 0 : 80;
      openTimer = setTimeout(function () { openItem(item); }, delay);
    }
    function scheduleClose() {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () { closeItem(item); }, 220);
    }

    item.addEventListener('mouseenter', scheduleOpen);
    item.addEventListener('mouseleave', scheduleClose);
    item.addEventListener('focusin', function () {
      clearTimeout(closeTimer);
      openItem(item);
    });
    item.addEventListener('focusout', function (e) {
      // delay close in case focus moves to a child
      setTimeout(function () {
        if (!item.contains(document.activeElement)) closeItem(item);
      }, 0);
    });

    // Click trigger toggles (mobile-friendly + keyboard)
    trigger.addEventListener('click', function (e) {
      // Allow normal navigation only on small screens; toggle on desktop
      if (window.innerWidth >= 980) {
        e.preventDefault();
        if (item.classList.contains('is-open')) closeItem(item);
        else { clearTimeout(closeTimer); clearTimeout(openTimer); openItem(item); }
      }
    });

    // Keep open while hovering inside mega
    mega.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
    });
  });

  // Click outside closes
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.de-headerY__nav-item--has-menu')) {
      closeAll();
    }
  });
  // Esc closes
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && currentOpen) {
      closeAll();
      var trigger = currentOpen && currentOpen.querySelector('.de-headerY__nav-link');
      if (trigger) trigger.focus();
    }
  });
})();

/* =====================================================================
   20a. ANIMATED STAT COUNTERS — count up from 0 to the displayed value
   when the stat enters the viewport. Targets .de-statX__value and
   any element with data-de-counter. Respects prefers-reduced-motion.
   ===================================================================== */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  function init() {
    var targets = document.querySelectorAll('.de-statX__value:not([data-de-counter]):not([data-target])');
    if (!targets.length) return;
    targets.forEach(function (el) {
      var raw = el.textContent.trim();
      var m = raw.match(/^([^\d]*)([\d,]+(?:\.\d+)?)([^\d]*)$/);
      if (!m) return;
      var prefix = m[1] || '';
      var numStr = m[2].replace(/,/g, '');
      var suffix = m[3] || '';
      var target = parseFloat(numStr);
      if (!isFinite(target) || target <= 0) return;
      el.dataset.deCounterTarget = String(target);
      el.dataset.deCounterPrefix = prefix;
      el.dataset.deCounterSuffix = suffix;
      el.textContent = prefix + '0' + suffix;
    });
    function format(n) {
      n = Math.round(n);
      if (n >= 1000) {
        var s = String(n);
        var parts = [];
        for (var i = s.length; i > 0; i -= 3) parts.unshift(s.substr(Math.max(0, i - 3), Math.min(3, i)));
        return parts.join(',');
      }
      return String(n);
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        if (el.dataset.deCounterDone === '1') return;
        el.dataset.deCounterDone = '1';
        var target = parseFloat(el.dataset.deCounterTarget);
        var prefix = el.dataset.deCounterPrefix || '';
        var suffix = el.dataset.deCounterSuffix || '';
        var startTs = null;
        var dur = Math.min(1800, Math.max(900, target / 20));
        function tick(ts) {
          if (!startTs) startTs = ts;
          var t = Math.min(1, (ts - startTs) / dur);
          var eased = 1 - Math.pow(1 - t, 3);
          var v = target * eased;
          el.textContent = prefix + format(v) + suffix;
          if (t < 1) requestAnimationFrame(tick);
          else el.textContent = prefix + format(target) + suffix;
        }
        requestAnimationFrame(tick);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.3 });
    targets.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* =====================================================================
   21b. ARTICLE SHARE — copy-link button (uses Clipboard API)
   ===================================================================== */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-de-copy-link]');
    if (!btn) return;
    e.preventDefault();
    var url = btn.getAttribute('data-de-copy-link');
    if (!url) return;
    var done = function () {
      var orig = btn.getAttribute('aria-label') || 'Copy link';
      btn.classList.add('is-copied');
      btn.setAttribute('aria-label', 'Link copied');
      if (typeof window.deToast === 'function') window.deToast('Link copied to clipboard', { variant: 'success', duration: 1800 });
      setTimeout(function () {
        btn.classList.remove('is-copied');
        btn.setAttribute('aria-label', orig);
      }, 2000);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done).catch(done);
    } else {
      var ta = document.createElement('textarea');
      ta.value = url; ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); } catch (e2) {}
      document.body.removeChild(ta);
      done();
    }
  });
})();

/* =====================================================================
   22a. STICKY BUY BAR — on a PDP, when the user scrolls past the main
   buy area, slide up a bar with phone + price + Buy now / Add. Hides
   when the checkout area returns to view.
   Phones get the bottom-pinned glass card (CSS block 103b); >=641px gets
   a centred glass rail that also carries the product's state and tier
   chips (block 103c). Class name kept as .de-mobile-buy-bar so no CSS,
   selector or test that already targets it has to change.
   ===================================================================== */
(function () {
  function init() {
    if (!/^\/products\//.test(window.location.pathname)) return;
    // The bar now ships on desktop too (block 103c styles it as a centred
    // glass rail carrying the state + tier chips), so this width gate is gone.
    // Visibility is CSS's job at every size; JS just builds the element once.
    if (document.querySelector('.de-mobile-buy-bar')) return;
    var buyArea = document.querySelector('.de-pdp__cta-row, [data-de-pdp-buy-area]');
    var phoneEl = document.querySelector('.de-pdp__title h1, h1');
    var priceEl = document.querySelector('.de-pdp__price, [data-product-price]');
    var addBtn = document.querySelector('.de-pdp__add[data-de-add]');
    var buyHref = document.querySelector('.de-pdp__buy[href*="/cart/"]');
    if (!buyArea || !phoneEl || !addBtn) return;

    var bar = document.createElement('div');
    bar.className = 'de-mobile-buy-bar';
    bar.setAttribute('aria-label', 'Quick buy');
    var titleParts = phoneEl.innerText.trim().split('·').map(function(s){ return s.trim(); });
    var phone = titleParts[0] || '';
    // Display the number as (xxx) xxx-xxxx in the buy bar. This formats the bar's
    // OWN COPY of the string only — the <h1> it was read from keeps xxx-xxx-xxxx,
    // which is the form that matches the product handle, <title> and canonical.
    var phoneDigits = phone.replace(/\D+/g, '');
    if (phoneDigits.length === 10) {
      phone = '(' + phoneDigits.slice(0, 3) + ') ' + phoneDigits.slice(3, 6) + '-' + phoneDigits.slice(6);
    }
    var state = titleParts[1] || '';
    var tag = titleParts[2] || '';
    // Fallback — pull state + tag from .de-pdp__chip pills when title is phone-only
    if (!state || !tag) {
      var chips = document.querySelectorAll('.de-pdp__chip');
      var chipTexts = Array.from(chips).map(function(c){ return c.innerText.trim(); });
      // Filter out "One of one" or similar non-location chips
      var locChip = chipTexts.find(function(t){ return /^[A-Z][a-z]+( [A-Z][a-z]+)*$/.test(t) && t !== 'One-of-one' && t !== 'One of one'; });
      var tagChip = chipTexts.find(function(t){ return /^\d+/.test(t) || /AABB|ABAB|ABBA|Ascending|Triple|Quad|Sequence|Repeat/i.test(t); });
      if (!state && locChip) state = locChip;
      if (!tag && tagChip) tag = tagChip;
    }
    var price = priceEl ? priceEl.innerText.trim().split('\n')[0] : '';
    function esc(s){ return (s || '').replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
    var metaLine = '';
    if (state && tag) metaLine = esc(state) + ' &middot; ' + esc(tag);
    else if (state) metaLine = esc(state);
    else if (tag) metaLine = esc(tag);
    bar.innerHTML =
      '<div class="de-mobile-buy-bar__info">' +
        '<span class="de-mobile-buy-bar__phone">' + esc(phone) + '</span>' +
        (metaLine ? '<span class="de-mobile-buy-bar__meta">' + metaLine + '</span>' : '') +
        (price ? '<span class="de-mobile-buy-bar__price">' + esc(price) + '</span>' : '') +
      '</div>' +
      '<div class="de-mobile-buy-bar__actions">' +
        '<button type="button" class="de-mobile-buy-bar__add" data-de-add="' + addBtn.getAttribute('data-de-add') + '" aria-label="Add to cart">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 8.4h14v10.4a2.2 2.2 0 0 1-2.2 2.2H7.2A2.2 2.2 0 0 1 5 18.8V8.4Z"/><path d="M8.9 8.4V6.3a3.1 3.1 0 0 1 6.2 0v2.1"/></svg>' +
          // Desktop shows the label; phones keep the icon-only circle (block 103b)
          // and rely on the aria-label above, so the accessible name is identical
          // either way and never doubles up.
          '<span class="de-mobile-buy-bar__add-label">Add to cart</span>' +
        '</button>' +
        (buyHref ? '<a class="de-mobile-buy-bar__buy" href="' + buyHref.getAttribute('href') + '">Buy now</a>' : '') +
      '</div>';
    // Desktop bar carries the product's OWN chips — the state chip (icon + name)
    // and the tier-coloured pattern chip — cloned straight from the PDP. Every
    // chip selector in de-polish.css is unscoped, so a clone keeps the full
    // treatment including the tier colour ladder, with nothing hardcoded here:
    // an Exclusive product's chip arrives Exclusive-coloured on its own.
    // Anchors are flattened to spans so a chip can never pull someone out of
    // the buy flow, and the clones are aria-hidden because the same text is
    // already announced in the PDP body above.
    var chipWrap = document.createElement('div');
    chipWrap.className = 'de-mobile-buy-bar__chips';
    chipWrap.setAttribute('aria-hidden', 'true');
    ['.de-pdp__chip--loc', '.de-pdp__chip--pat'].forEach(function (sel) {
      var src = document.querySelector(sel);
      if (!src) return;
      var chip = document.createElement('span');
      chip.className = src.className;
      chip.innerHTML = src.innerHTML;
      chipWrap.appendChild(chip);
    });
    if (chipWrap.children.length) {
      bar.querySelector('.de-mobile-buy-bar__info').appendChild(chipWrap);
    }

    document.body.appendChild(bar);

    // ---- reserve the bar's footprint at the end of the document ----
    // The bar is position:fixed, so it sits ON TOP of whatever the page ends
    // with - which is the footer's last row: the copyright line and the
    // payment icons. Hiding the bar near the footer would remove the buy
    // action exactly where intent is highest, so instead the footer grows by
    // the bar's height and the bar floats over that new empty strip. Nothing
    // in the footer moves, is covered, or is removed.
    //
    // Measured live rather than hardcoded: the bar is a different height on
    // phone vs the >=641px centred rail, and its offset from the bottom is
    // 10px or 16px PLUS env(safe-area-inset-bottom), which only the browser
    // knows. offsetHeight is used because it ignores the translateY the bar
    // parks at while hidden; getComputedStyle().bottom gives the resolved gap
    // including the safe-area inset.
    document.documentElement.classList.add('de-has-buybar');
    function measureBar() {
      var gap = parseFloat(getComputedStyle(bar).bottom) || 0;
      document.documentElement.style.setProperty(
        '--de-buybar-clear', Math.ceil(bar.offsetHeight + gap) + 'px');
    }
    measureBar();
    // Re-measure on anything that can change the bar's height: the 641px
    // breakpoint swap, orientation, and late webfont swap-in.
    var raf = 0;
    window.addEventListener('resize', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; measureBar(); });
    });
    window.addEventListener('load', measureBar);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measureBar);

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) bar.classList.remove('is-visible');
        else bar.classList.add('is-visible');
      });
    // rootMargin shrinks the detection zone from the TOP: at -10% the buy area
    // had to scroll almost entirely away (its bottom within ~59px of the top)
    // before the bar appeared, so there was a long stretch with no reachable CTA.
    // Per-breakpoint because the same bar serves both (the class name is legacy):
    // 30% on phones, 10% on desktop. The complaint was mobile-only, so desktop is
    // back on its original 10% - 33 and 36 were both tried there and read as early,
    // firing while the real buttons were still fully on screen.
    // Read once at setup; a resize across the breakpoint keeps the initial value,
    // which is fine - nobody resizes mid-scroll, and both values behave sanely.
    }, { rootMargin: '-' + (window.matchMedia('(min-width: 750px)').matches ? 10 : 30) +
                     '% 0px 0px 0px', threshold: 0 });
    io.observe(buyArea);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* =====================================================================
   22b. RECENTLY VIEWED NUMBERS — record current PDP into localStorage
   ('deRecent', LIFO, max 12). Render as an inline strip on PDP at the
   bottom and on the homepage if the host element exists.
   ===================================================================== */
(function () {
  var KEY = 'deRecent';
  var MAX = 12;
  function readList() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function writeList(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
  }
  function recordCurrent() {
    var meta = document.querySelector('meta[property="og:url"]');
    var url = (meta && meta.content) || window.location.href;
    var path = url.replace(/^https?:\/\/[^\/]+/, '').split('?')[0];
    if (!/^\/products\//.test(path)) return;
    var titleEl = document.querySelector('.de-pdp__title h1, h1.de-pdp__title, h1');
    var phoneEl = document.querySelector('.de-pdp__phone-number, .de-pdp__title h1, h1');
    var priceEl = document.querySelector('.de-pdp__price, [data-price]');
    // The <h1> is the bare number, so the strip used to have nothing to show
    // under it. State and pattern come off the two chips beside the title -
    // NOT off og:title, which is the SEO title on most PDPs ("201-676-9666
    // New Jersey Vanity Number · Triple 6s | Digit Exclusive") and only
    // happens to be "number · State · Pattern" on the ones without one.
    // Stored in the product-title shape the renderer already splits on, so
    // this adds no new field and old entries keep working untouched.
    var locEl = document.querySelector('.de-pdp__chip--loc');
    var patEl = document.querySelector('.de-pdp__chip--pat');
    var title = (titleEl && titleEl.innerText.trim()) || '';
    var loc = locEl ? locEl.innerText.trim() : '';
    var pat = patEl ? patEl.innerText.trim() : '';
    if (title && title.indexOf(' · ') === -1 && loc) {
      title = title + ' · ' + loc + (pat ? ' · ' + pat : '');
    }
    // Tier is tag-based and never derivable from the number or the price, so it
    // has to be read where the theme already resolved it: the pattern chip
    // carries de-pdp__chip--tier-<tier>. Stored as its own field because the
    // title's third segment is the PATTERN ("AABB"), not the tier.
    var tier = '';
    if (patEl) {
      var m = String(patEl.className || '').match(/de-pdp__chip--tier-([a-z]+)/);
      if (m) tier = m[1];
    }
    var entry = {
      url: path,
      title: title,
      tier: tier,
      price: (priceEl && priceEl.innerText.trim()) || '',
      ts: Date.now()
    };
    var list = readList().filter(function (x) { return x.url !== path; });
    list.unshift(entry);
    writeList(list);
  }
  function renderInto(host) {
    var list = readList();
    var path = window.location.pathname.split('?')[0];
    // drop the current page AND any malformed entries (old schema / corrupted
    // storage would otherwise render literal 'undefined' cards)
    list = list.filter(function (x) { return x && x.url && x.title && x.url !== path; });
    if (list.length === 0) return;
    // Cards show (xxx) xxx-xxxx; the dashed form is for PDP headings and URLs.
    // The stored title comes off the PDP <h1>, which is dashed, so re-format on
    // the way out. Anything that is not exactly 10 digits is left alone.
    function fmtRecentPhone(s) {
      var d = String(s || '').replace(/\D/g, '');
      return d.length === 10 ? '(' + d.slice(0, 3) + ') ' + d.slice(3, 6) + '-' + d.slice(6) : s;
    }
    // State and tier read as CHIPS, the same two facts the PDP puts beside the
    // title. Escaped on the way in: the state comes from a product title, which
    // is store data rather than anything a visitor controls, but it is being
    // concatenated into innerHTML so it gets escaped regardless.
    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    // The chips wear the PDP's OWN classes rather than a lookalike set. The PDP
    // chip is not a flat pill: it is a layered background (a pale vertical fill on
    // padding-box, a gradient rim on border-box) plus an inset white top highlight
    // and a soft drop shadow, and each tier re-colours all three. Re-implementing
    // that here is how the first attempt ended up looking wrong, and it would drift
    // the next time the PDP chips are touched. Borrowing the classes means the two
    // can only ever be identical; the block in de-polish.css scales them down and
    // changes nothing else. Pin path is the PDP's, copied verbatim.
    var PIN = '<svg viewBox="0 0 24 24" fill="currentColor" stroke="none" aria-hidden="true">' +
      '<path fill-rule="evenodd" clip-rule="evenodd" d="M11.41 0.21L12.55 0.21L12.59 0.28L12.97 0.28L13.84 0.45L15.36 1.08L16.4 1.77L17.48 2.84L18.24 4.02L18.83 5.62L19.01 6.83L18.94 8.05L18.66 9.09L18.1 10.47L16.86 12.87L14.67 16.3L13.42 18.07L12.87 18.59L12.49 18.76L11.83 18.83L11.38 18.73L10.99 18.52L10.3 17.72L8.32 14.84L6.31 11.41L5.27 8.98L5.03 8.05L4.96 6.8L5.13 5.65L5.51 4.47L6.07 3.43L6.76 2.53L7.98 1.46L9.09 0.83L10.13 0.45L11.41 0.24Z M11.79 4.2L12.66 4.27L13.42 4.58L13.87 4.89L14.5 5.65L14.84 6.55L14.88 7.25L14.81 7.84L14.53 8.5L14.25 8.91L13.77 9.4L13.04 9.82L12.59 9.95L11.9 10.02L11.34 9.95L10.44 9.57L9.71 8.91L9.43 8.5L9.16 7.84L9.09 6.94L9.16 6.38L9.47 5.65L9.78 5.2L10.37 4.68L11.06 4.34L11.76 4.23Z M6.35 14.81L6.52 14.88L7.63 16.58L7.63 16.68L5.9 16.99L3.92 17.62L2.81 18.17L2.43 18.45L2.05 18.9L2.08 19.21L2.6 19.73L3.68 20.32L4.58 20.67L6.03 21.09L8.46 21.5L10.65 21.68L13.32 21.68L15.5 21.5L17.1 21.26L18.97 20.81L20.29 20.32L21.54 19.6L21.88 19.21L21.92 18.9L21.36 18.31L20.05 17.62L18.73 17.17L16.34 16.68L17.48 14.84L18 14.88L19.14 15.16L20.81 15.71L22.13 16.37L23.1 17.1L23.65 17.79L23.97 18.66L23.93 19.6L23.62 20.32L23.41 20.6L22.75 21.26L22.27 21.61L20.29 22.54L18.35 23.1L16.92 23.38L15.02 23.62L13.25 23.69L13.21 23.76L10.75 23.76L10.72 23.69L8.95 23.62L6.1 23.2L3.68 22.54L1.77 21.64L0.97 21.05L0.52 20.57L0.03 19.6L0 18.59L0.14 18.14L0.45 17.58L0.83 17.13L2.01 16.27L2.91 15.82L4.34 15.29L6.31 14.84Z"></path></svg>';
    var items = list.slice(0, 6).map(function (x) {
      var titleParts = (x.title || '').split(' · ');
      var phone = fmtRecentPhone(titleParts[0] || x.title);
      var state = (titleParts[1] || '').trim();
      var tier = String(x.tier || '').toLowerCase();
      if (!/^(base|special|premium|exclusive)$/.test(tier)) tier = '';
      // The title's third segment is the PATTERN on a base number ("666", "AABB")
      // but the TIER on a tiered one ("202-202-1500 · washington dc · exclusive").
      // Only the pattern belongs in a chip — printing the tier there is what made
      // every card read "Base", which is not a type at all.
      var pat = (titleParts[2] || '').trim();
      if (/^(base|special|premium|exclusive)$/i.test(pat)) pat = '';
      // Special / Premium / Exclusive announce themselves the way the tier
      // collection pages do: a tracked-out uppercase line above the number, in
      // the tier's colour. Base gets none, exactly as it gets no badge there.
      var tagline = (tier && tier !== 'base')
        ? '<span class="de-recent__tier de-recent__tier--' + tier + '">' +
          esc(tier.charAt(0).toUpperCase() + tier.slice(1)) + '</span>'
        : '';
      var chips = '';
      if (state) chips += '<span class="de-pdp__chip de-pdp__chip--loc de-rchip" title="' + esc(state) + '">' +
                          PIN + '<span class="de-chiptxt">' + esc(state) + '</span></span>';
      if (pat) chips += '<span class="de-pdp__chip de-pdp__chip--pat de-pdp__chip--tier-' +
                        (tier || 'base') + ' de-rchip">' + esc(pat) + '</span>';
      return '<a class="de-recent__item" href="' + x.url + '">' + tagline +
             '<span class="de-recent__phone">' + phone + '</span>' +
             (chips ? '<span class="de-recent__chips">' + chips + '</span>' : '') +
             (x.price ? '<span class="de-recent__price">' + esc(x.price) + '</span>' : '') +
             '</a>';
    }).join('');
    host.innerHTML =
      '<div class="de-recent__head">' +
        (document.body.classList.contains('template-index') ? 'Pick up where you left off' : 'You might also like') +
      '</div>' +
      '<div class="de-recent__list">' + items + '</div>';
    host.removeAttribute('hidden');
    backfillMeta(host, list.slice(0, 6));
  }
  // Entries recorded before the chips were captured hold a bare number, so they
  // have no state/pattern line while newer ones do — a visibly ragged strip.
  // Repair them once from /products/<handle>.js (1.4KB, whose .title is already
  // "number · State · Pattern"), on idle, then re-render. Every entry is tried
  // AT MOST once: the attempt is flagged whether it succeeds or fails, so a
  // number that genuinely has no state can never put this in a fetch loop.
  // Nothing here is allowed to affect first paint — the strip is already on
  // screen before this runs, and any failure just leaves it as it was.
  function backfillMeta(host, shown) {
    if (host.dataset.deHealed || !window.fetch) return;   // one repair pass per page
    // metaTried is VERSIONED, not a boolean. Entries repaired by the first pass
    // carry `true` and have a title but no tier, because tier was not collected
    // then; they need exactly one more fetch. Bumping the stamp to 2 gives them
    // that and no more — an entry at 2 is never fetched again, whatever is still
    // missing, so a number that legitimately has no tier cannot loop.
    var stale = shown.filter(function (x) {
      return x && x.url && x.metaTried !== 2 &&
             (String(x.title || '').indexOf(' · ') === -1 || !x.tier);
    });
    if (!stale.length) return;
    host.dataset.deHealed = '1';
    var run = function () {
      var done = 0;
      stale.forEach(function (entry) {
        fetch(entry.url + '.js', { credentials: 'same-origin' })
          .then(function (r) {
            // 404 = the number sold and came off the site. The card was still
            // linking there, so drop it rather than send anyone to a dead page.
            if (r.status === 404) return { gone: true };
            return r.ok ? r.json() : null;
          })
          .then(function (p) {
            // A network blip returns null: leave the entry completely alone so
            // it is retried on the next page, rather than flagged or deleted.
            if (!p) return;
            var list = readList(), out = [];
            for (var i = 0; i < list.length; i++) {
              if (list[i].url !== entry.url) { out.push(list[i]); continue; }
              if (p.gone) continue;                    // drop it
              list[i].metaTried = 2;
              if (p.title && p.title.indexOf(' · ') > -1) list[i].title = p.title;
              // tags carry the tier, e.g. ['AABB','Base','California']
              if (!list[i].tier && p.tags && p.tags.length) {
                for (var t = 0; t < p.tags.length; t++) {
                  var tag = String(p.tags[t]).toLowerCase();
                  if (/^(base|special|premium|exclusive)$/.test(tag)) { list[i].tier = tag; break; }
                }
              }
              out.push(list[i]);
            }
            writeList(out);
          })
          .catch(function () {})
          .then(function () { if (++done === stale.length && host.isConnected) renderInto(host); });
      });
    };
    if (window.requestIdleCallback) requestIdleCallback(run, { timeout: 2500 });
    else setTimeout(run, 400);
  }
  function init() {
    if (/^\/products\//.test(window.location.pathname)) {
      recordCurrent();
      var pdpHost = document.querySelector('[data-de-recent]');
      // If the theme didn't include a slot, inject one above the FAQ section
      if (!pdpHost) {
        var faqSec = document.querySelector('.de-faqX, [class*="faq"]');
        if (faqSec && faqSec.parentNode) {
          pdpHost = document.createElement('section');
          pdpHost.className = 'de-recent';
          pdpHost.setAttribute('data-de-recent', '');
          pdpHost.setAttribute('aria-label', 'Recently viewed numbers');
          pdpHost.hidden = true;
          faqSec.parentNode.insertBefore(pdpHost, faqSec);
        }
      }
      if (pdpHost) renderInto(pdpHost);
    } else {
      var homeHost = document.querySelector('[data-de-recent]');
      if (homeHost) renderInto(homeHost);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* =====================================================================
   23c. Sticky header offset — measures the rendered .de-headerY height
   and writes it to --de-header-h so .de-filter-bar parks right below
   the header at every viewport (no more z-index overlap glitches).
   Re-measures on resize and after announcement-bar toggles.
   ===================================================================== */
(function () {
  function setHeaderHeight() {
    var header = document.querySelector('.de-headerY, header.de-header, .de-header');
    if (!header) return;
    var h = Math.ceil(header.getBoundingClientRect().height);
    document.documentElement.style.setProperty('--de-header-h', h + 'px');
  }
  function init() {
    setHeaderHeight();
    // Re-measure on resize (orientation change, font-load shifts, announcement bar toggle)
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(setHeaderHeight, 80);
    });
    // Re-measure once fonts have settled
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(setHeaderHeight).catch(function(){});
    }
    // Re-measure when announcement bar might toggle visibility
    setTimeout(setHeaderHeight, 200);
    setTimeout(setHeaderHeight, 1200);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* =====================================================================
   23b. RETIRED - mobile filter-bar collapse.

   This used to inject a "Filters" toggle on <=640px and hide the filter
   controls behind it. The panel is now permanently open (see the comment in
   sections/de-collection.liquid), so the toggle is gone from the markup.

   The block is retired rather than merely dormant because its guard was
   `if (bar.querySelector('.de-filter-bar__mobile-toggle')) return;` - it
   bailed ONLY because the section rendered a toggle. Deleting that toggle
   from the markup would have flipped this code live again: it would have
   built a fresh button and set data-mobile-collapsed="true" on the panel,
   restoring the exact behaviour the removal was meant to end.
   ===================================================================== */

/* =====================================================================
   23a. Mobile footer accordion — collapse Shop/Browse/Learn/Help
   into expandable sections so the footer takes ~100px instead of ~700px.
   ===================================================================== */
(function () {
  function init() {
    if (window.innerWidth > 640) return;
    var cols = document.querySelectorAll('footer .de-footerX__col, footer .de-footerY__col');
    if (!cols.length) return;
    cols.forEach(function (col) {
      var title = col.querySelector('.de-footerX__col-title, .de-footerY__col-title');
      if (!title) return;
      title.setAttribute('role', 'button');
      title.setAttribute('aria-expanded', 'false');
      title.addEventListener('click', function () {
        var open = col.classList.toggle('is-open');
        title.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* =====================================================================
   23. VIEW TOGGLES (collection grid) — Grid / List + adaptive stepper.
   In grid mode the stepper controls columns per row (2-10).
   In list mode the stepper controls rows-per-screen (4-12), which
   maps to row min-height for taller / denser list rows.
   Persists deView, deCols, deRows separately via localStorage.
   ===================================================================== */
(function () {
  var COL_MIN = 2,  COL_MAX = 10, COL_DEFAULT = 4;
  // All four sizes divide the server page size (200 = LCM(25,50,100,200)), so a
  // client page never straddles two server chunks — each shows exactly its N products.
  var LIST_PAGE_SIZES = [25, 50, 100, 200];
  var LIST_PAGE_DEFAULT = 50;

  function init() {
    var grid = document.querySelector('[data-de-product-grid]');
    // de-search-view-bar-2026-09-09 — the search page carries the same View
    // column but NOT the filters, so its bar is tagged [data-de-view-bar]
    // instead. Matching only [data-de-filter-bar] here is what made the search
    // page inherit whatever view was last saved with no way to change it.
    // Deliberately a different attribute: the filter module (section 14) keys
    // off [data-de-filter-bar] and would try to wire state/area/sort selects
    // that do not exist on search.
    var bar = document.querySelector('[data-de-filter-bar], [data-de-view-bar]');
    if (!grid || !bar) return;
    // The View column is now server-rendered (de-view-server-2026-08-28), so
    // '.de-view-toggles' exists on the FIRST pass and this guard would abort
    // init() entirely, leaving every control dead. Guard on a real init flag.
    if (bar.__deViewInit) return;
    bar.__deViewInit = true;

    var SVG = {
      grid: '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="1.5" y="1.5" width="5.5" height="5.5" rx="1"/><rect x="9" y="1.5" width="5.5" height="5.5" rx="1"/><rect x="1.5" y="9" width="5.5" height="5.5" rx="1"/><rect x="9" y="9" width="5.5" height="5.5" rx="1"/></svg>',
      list: '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6"><line x1="2" y1="4" x2="14" y2="4"/><line x1="2" y1="8" x2="14" y2="8"/><line x1="2" y1="12" x2="14" y2="12"/></svg>',
      minus: '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="4" y1="8" x2="12" y2="8"/></svg>',
      plus: '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="4" y1="8" x2="12" y2="8"/><line x1="8" y1="4" x2="8" y2="12"/></svg>'
    };

    var inner = bar.querySelector('.de-filter-bar__inner') || bar;
    var resetBtn = inner.querySelector('[data-de-filter-reset]');

    var modes = [
      { id: 'comfortable', label: 'Grid view' },
      { id: 'list', label: 'List view' }
    ];
    var actionsCol, actionsLabel, actions, stepper, btnMinus, label, btnPlus, tag, pagesize, psTag, psSelect, wrap;
    var __srv = inner.querySelector('.de-filter--actions[data-de-server-view]');
    if (__srv) {
      // ADOPT the server-rendered column. Building it here is what caused the bar
      // to re-flow ~200ms after paint on every collection load.
      actionsCol = __srv;
      // init() later does actionsLabel.textContent = 'View'. Leaving it undefined
      // threw there and aborted the rest of init() BEFORE any listener was
      // attached, which is why the adopted stepper and toggles were inert.
      actionsLabel = __srv.querySelector('.de-filter__label');
      actions   = __srv.querySelector('.de-filter-bar__actions');
      stepper   = __srv.querySelector('.de-cols-stepper');
      tag       = __srv.querySelector('.de-cols-stepper__tag');
      btnMinus  = __srv.querySelector('.de-cols-stepper__btn--minus');
      label     = __srv.querySelector('.de-cols-stepper__value');
      btnPlus   = __srv.querySelector('.de-cols-stepper__btn--plus');
      pagesize  = __srv.querySelector('.de-list-pagesize');
      psTag     = __srv.querySelector('.de-list-pagesize__tag');
      psSelect  = __srv.querySelector('.de-list-pagesize__select');
      wrap      = __srv.querySelector('.de-view-toggles');
      if (resetBtn && resetBtn.parentElement !== actions) {
        resetBtn.classList.add('de-filter__reset--inline');
        actions.appendChild(resetBtn);
      }
    } else {
    // Labeled column wrapper ("View") so the right-side group reads as
    // its own filter, matching the other labeled columns to the left.
    var actionsCol = document.createElement('div');
    actionsCol.className = 'de-filter de-filter--actions';
    var actionsLabel = document.createElement('span');
    actionsLabel.className = 'de-filter__label';
    actionsLabel.textContent = 'View';
    actionsCol.appendChild(actionsLabel);
    var actions = document.createElement('div');
    actions.className = 'de-filter-bar__actions';
    actionsCol.appendChild(actions);

    // Column stepper
    var stepper = document.createElement('div');
    stepper.className = 'de-cols-stepper';
    stepper.setAttribute('role', 'group');
    stepper.setAttribute('aria-label', 'Columns per row');
    var btnMinus = document.createElement('button');
    btnMinus.type = 'button';
    btnMinus.className = 'de-cols-stepper__btn de-cols-stepper__btn--minus';
    btnMinus.setAttribute('aria-label', 'Fewer columns');
    btnMinus.innerHTML = SVG.minus;
    var label = document.createElement('span');
    label.className = 'de-cols-stepper__value';
    label.setAttribute('aria-live', 'polite');
    var btnPlus = document.createElement('button');
    btnPlus.type = 'button';
    btnPlus.className = 'de-cols-stepper__btn de-cols-stepper__btn--plus';
    btnPlus.setAttribute('aria-label', 'More columns');
    btnPlus.innerHTML = SVG.plus;
    var tag = document.createElement('span');
    tag.className = 'de-cols-stepper__tag';
    tag.textContent = 'Cols';
    stepper.appendChild(tag);
    stepper.appendChild(btnMinus);
    stepper.appendChild(label);
    stepper.appendChild(btnPlus);
    btnMinus.setAttribute('aria-label', 'Fewer');
    btnPlus.setAttribute('aria-label', 'More');
    actions.appendChild(stepper);

    // List page-size dropdown (replaces stepper in list view)
    var pagesize = document.createElement('div');
    pagesize.className = 'de-list-pagesize';
    pagesize.setAttribute('role', 'group');
    pagesize.setAttribute('aria-label', 'Products per page');
    var psTag = document.createElement('span');
    psTag.className = 'de-list-pagesize__tag';
    psTag.textContent = 'Show';
    var psSelect = document.createElement('select');
    psSelect.className = 'de-list-pagesize__select';
    psSelect.setAttribute('aria-label', 'Products per page');
    LIST_PAGE_SIZES.forEach(function (n) {
      var opt = document.createElement('option');
      opt.value = String(n);
      opt.textContent = String(n);
      psSelect.appendChild(opt);
    });
    pagesize.appendChild(psTag);
    pagesize.appendChild(psSelect);
    actions.appendChild(pagesize);

    // View toggles (grid / list only — density is now via stepper)
    var wrap = document.createElement('div');
    wrap.className = 'de-view-toggles';
    wrap.setAttribute('role', 'tablist');
    wrap.setAttribute('aria-label', 'View mode');
    var modes = [
      { id: 'comfortable', label: 'Grid view' },
      { id: 'list', label: 'List view' }
    ];
    modes.forEach(function (m) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'de-view-toggles__btn';
      btn.setAttribute('data-de-view-btn', m.id);
      btn.setAttribute('aria-label', m.label);
      btn.setAttribute('title', m.label);
      btn.innerHTML = m.id === 'list' ? SVG.list : SVG.grid;
      wrap.appendChild(btn);
    });
    actions.appendChild(wrap);

    // Move existing reset button into actions wrapper
    if (resetBtn) {
      resetBtn.classList.add('de-filter__reset--inline');
      actions.appendChild(resetBtn);
    }

    inner.appendChild(actionsCol);
    }

    // State
    var view = null;
    try { view = localStorage.getItem('deView'); } catch (e) {}
    if (!view || !modes.some(function (m) { return m.id === view; })) view = 'comfortable';

    var cols = COL_DEFAULT;
    try {
      var rawC = localStorage.getItem('deCols');
      var nC = parseInt(rawC, 10);
      if (nC >= COL_MIN && nC <= COL_MAX) cols = nC;
    } catch (e) {}

    var listLimit = LIST_PAGE_DEFAULT;
    try {
      var rawL = localStorage.getItem('deListLimit');
      var nL = parseInt(rawL, 10);
      if (LIST_PAGE_SIZES.indexOf(nL) !== -1) listLimit = nL;
    } catch (e) {}
    psSelect.value = String(listLimit);

    var listPage = 1;
    // When a filter is active the paginator switches to a purely CLIENT-side mode
    // that pages the matching (non-[hidden]) cards — filteredPage tracks that page.
    var filteredPage = 1;
    /* de-grid-scan-cache-2026-09-19 — one cached walk instead of a :scope query.

       A CPU profile of a "9999" search put 71.6% of all time (18.6s of 26.0s) in
       querySelectorAll. The callers are here: getMatchingCards() and
       applyListLimit() both re-evaluate ':scope > .de-card--number' against a grid
       holding 1,000+ cards, and they run on every de:applied — which fires once per
       batch of results arriving. Walking children and testing classList is much
       cheaper, and the list only changes when the child count changes. */
    var _gcCache = null, _gcCount = -1;
    function gridCards() {
      var n = grid.childElementCount;
      if (_gcCache && _gcCount === n) return _gcCache;
      var out = [], kids = grid.children;
      for (var i = 0; i < kids.length; i++) {
        var k = kids[i];
        if (k.classList && k.classList.contains('de-card--number')) out.push(k);
      }
      _gcCache = out; _gcCount = n;
      return out;
    }

    /* de-card-shell-2026-09-20 — an off-page card keeps its attributes and gives
       up its contents.

       Owner: "way too fucking laggy when i am scrolling… really big delay when
       im on another higher page within paginator."

       Profiled on /search?q=8 at page 6: 2,860 cards in the grid, 70,121 DOM
       nodes, 59 of them on screen. Of the scroll time, 771ms of querySelectorAll
       and 538ms of scroll-position reads belonged to Microsoft Clarity, which
       re-walks the whole document on every scroll; de-polish's own share was 6ms.
       Frames averaged 142ms and the worst was 2,450ms. Our code was not doing the
       work — but we were handing it a document 270,000 nodes deep at the far end
       of the pager, and that is ours to fix.

       A card is 24 nodes and 3.4KB of markup, and while it is paged out it is
       display:none — nobody can see it. So it gives up its children and keeps its
       attributes, which is all the filtering, sorting and paging ever read
       (data-digits, data-price-cents, data-state, data-area). 24 nodes become 1.
       The markup is parked on the element itself, so it is restored instantly and
       is garbage-collected with the card if the grid ever drops it.

       Deliberately NOT a windowing rewrite: the pager's index maths over
       `matching` is the most delicate code here and it is untouched — the same
       cards stay in the same order in the same places, they are simply hollow
       while off screen. */
    function deShell(el, off) {
      try {
        if (off) {
          if (el.__deInner === undefined && el.firstElementChild) {
            el.__deInner = el.innerHTML;
            el.textContent = '';
            el.setAttribute('data-de-shell', '1');
          }
        } else if (el.__deInner !== undefined) {
          el.innerHTML = el.__deInner;
          el.__deInner = undefined;
          el.removeAttribute('data-de-shell');
          /* The stored markup is what the server sent, so the (XXX) XXX-XXXX pass
             has to run again or a restored card shows a dashed number. */
          if (window.deFormatPhones) window.deFormatPhones(el);
        }
      } catch (e) {}
    }

    /* The card inserter lives in the search module and needs this the instant a
       card lands — see de-shell-on-insert. */
    window.__deShell = deShell;

    function getMatchingCards() {
      var all = gridCards(), out = [];
      for (var i = 0; i < all.length; i++) if (!all[i].hasAttribute('hidden')) out.push(all[i]);
      return out;
    }

    function applyStepper() {
      // Stepper is always cols-only now (list view uses dropdown instead)
      grid.setAttribute('data-de-cols', String(cols));
      tag.textContent = 'Cols';
      label.textContent = String(cols);
      btnMinus.disabled = cols <= COL_MIN;
      btnPlus.disabled = cols >= COL_MAX;
    }

    // Page size means ROWS when the grid is showing (mobile only): a row is one
    // full line of cards, so a page holds rows x however many columns are actually
    // rendered. Columns come from the resolved grid template, which is right on
    // every breakpoint - the desktop cols stepper does not apply on phones.
    function gridColumnCount() {
      try {
        var tpl = getComputedStyle(grid).gridTemplateColumns || '';
        var n = tpl.split(' ').filter(function (s) { return s && s !== 'none'; }).length;
        return n > 0 ? n : 1;
      } catch (e) { return 1; }
    }
    // Under 340px (an SE 1st-gen) there is not enough width for the window AND a
    // last-page button, so that one control is dropped rather than wrapping the row.
    // "Previous" is 26px wider than "Prev" - the difference between the full
    // desktop set fitting a 360px phone and not. "Next" is already short enough.
    function dePrevLabel() { return deNarrowPager() ? 'Prev' : 'Previous'; }
    function deTinyPager() {
      try { return window.matchMedia('(max-width: 340px)').matches; } catch (e) { return false; }
    }
    function deNarrowPager() {
      try { return window.matchMedia('(max-width: 640px)').matches; } catch (e) { return false; }
    }
    function gridPagingOn() {
      if (view === 'list') return false;
      /* de-grid-paging-2026-09-15 — page the grid when a filter is on, at ANY width.

         Owner, on /collections/all-numbers?sort_by=price-descending at 7 columns:
         "that shit is genuinely so fucking laggy … there are too many listings
         within one page, i think that is a problem and that is what is causing
         so much fucking lag". Read off that exact tab:

             2,595 listings laid out · 63,942 DOM nodes · 71,337px = 68 screens

         A filter has no server pages to lean on, so every match was appended and
         laid out at once. The filtering itself is cheap (one attribute pass over
         2,600 cards measured 9.5ms) — the cost is laying out and painting tens of
         thousands of nodes on every scroll.

         This paginator ALREADY handles the filtered case correctly; it was just
         gated to phones. Measured on the same page and column count, same
         mechanism, only the gate changed:

             now            959 laid out · 29 screens · 74/171 frames dropped
             50 rows/page   350 laid out · 12 screens · 29/175 frames dropped
             25 rows/page   175 laid out ·  7 screens · 14/175 frames dropped

         Deliberately only while filtered: unfiltered browsing still uses the
         SERVER paginator, which is untouched. */
      if (grid.getAttribute('data-de-filtered') === '1') return true;
      try { return window.matchMedia('(max-width: 640px)').matches; } catch (e) { return false; }
    }
    function perPage() {
      if (view === 'list') return listLimit;
      /* de-grid-200-2026-09-15 — GRID pages by a FIXED 200, never listLimit x columns.

         Owner: "for grid view it should just be 200 products per page, filtered or
         not filtered, no matter the col setting as well ... the custom rows for grid
         view will genuinely crash the site and make it slow as shit, and we cannot
         risk that because we will lose potential customers".

         He is right about the arithmetic. listLimit is a ROW count, so the page size
         scaled with the column stepper and the Show control together:

             Show  50 rows x  2 cols =   100 cards
             Show  50 rows x  7 cols =   350 cards
             Show  50 rows x 10 cols =   500 cards
             Show 200 rows x 10 cols = 2,000 cards on ONE page

         200 is not an arbitrary number: it is exactly what the server paginates
         every collection by (data-de-server-page-size="200" on all of them), so a
         filtered grid page now holds the same amount as an unfiltered one and the
         column stepper only changes the LAYOUT, never how much is rendered.

         List view is untouched — there the Show control means rows of one card
         each, so rows and cards are the same thing. */
      return parseInt(grid.getAttribute('data-de-server-page-size'), 10) || 200;
    }
    function applyListLimit() {
      var cards = gridCards();
      var filtered = grid.getAttribute('data-de-filtered') === '1';
      if (view !== 'list' && !gridPagingOn()) {
        /* de-browse-leak-2026-09-16 — clearing a filter must not leave the cards it
           fetched on the page.

           Owner: "it did load 995 listings in one page ... I was adjusting price
           sliders for All numbers then I readjusted it by dragging each to upmost
           left and right, so basically the default, without clicking reset."

           Reproduced exactly. The deep scan appends cards while a band is active;
           this branch then removed the paginator class from EVERY card, so on
           clearing the band all of them were revealed at once:

               with a band      200 shown of 800 in DOM
               after clearing   800 shown — 600 of them deep-scan appends
               pager row        "1-800 of 16308", still offering 82 pages of 200

           Both statements were individually true and together nonsense: browse mode
           pages in 200-card server pages, so a page holding 800 means page 2 skips
           600 numbers. The other branch of this function already states the rule —
           browse only the ORIGINAL server-page cards — it just was not applied
           here. Appends stay hidden until a filter asks for them again. */
        for (var j = 0; j < cards.length; j++) {
          if (cards[j].hasAttribute('data-de-appended')) {
            cards[j].classList.add('de-card--hidden-by-paginator');
            deShell(cards[j], true);
          } else {
            cards[j].classList.remove('de-card--hidden-by-paginator');
            deShell(cards[j], false);
          }
        }
        grid.removeAttribute('data-de-list-limit');
        grid.removeAttribute('data-de-list-page');
        renderListPaginator();
        return;
      }
      if (filtered) {
        // A real filter is active → paginate the MATCHING cards (the filter's
        // [hidden] marks the rest) purely client-side, in whatever order the filter
        // module last sorted them. Server pages are meaningless over this subset.
        var GEOa = filteredGeometry();
        var matching = GEOa.matching;
        /* de-keep-page-intent-2026-09-17 — clamp for DISPLAY, never overwrite the
           page the buyer asked for. Exactly the rule the browse pager already
           follows a few lines up, and for the same reason.

           With a digit search the matching set arrives over time, so "go to page
           40" is normal while only 16 pages are loaded. Rewriting filteredPage to
           16 threw the request away, and the extra numbers landing a second later
           could not put it back: asking for page 40 of "6" left you on page 16 and
           nothing you did got you further. Keeping the intent means the re-render
           that follows the fetch lands where you asked. */
        var fp = GEOa.showPage;
        var mstart = (fp - 1) * GEOa.per, mend = mstart + GEOa.per;
        for (var mi = 0; mi < matching.length; mi++) {
          var onPage = (mi >= mstart && mi < mend);
          if (onPage) { matching[mi].classList.remove('de-card--hidden-by-paginator'); deShell(matching[mi], false); }
          else { matching[mi].classList.add('de-card--hidden-by-paginator'); deShell(matching[mi], true); }
        }
        /* Cards the FILTER removed are off screen just as surely as paged-out
           ones, and on a narrowed search they are the majority. */
        for (var hi = 0; hi < cards.length; hi++) {
          if (cards[hi].hasAttribute('hidden')) deShell(cards[hi], true);
        }
        grid.setAttribute('data-de-list-limit', String(GEOa.per));
        grid.setAttribute('data-de-list-page', String(fp));
        renderListPaginator();
        /* de-page-detail-2026-09-20 — hand the page over, do not leave it to be
           read back off an attribute later.

           The count row derived its range from `data-de-list-page`, which is only
           as fresh as the last pass that happened to run — so the row could sit a
           dozen pages behind the pager it was describing ("Showing 1,001-1,200"
           above "3401-3600 of 11231"). The page is known exactly here, at the
           instant the cards are sliced; sending it removes the staleness rather
           than narrowing the window in which it can happen. */
        try {
          document.dispatchEvent(new CustomEvent('de:paged',
            { detail: { page: fp, per: GEOa.per, total: GEOa.total } }));
        } catch (e) {}
        return;
      }
      // Browse only the ORIGINAL server-page cards. Cards the deep-scan appended
      // during a past filter session are pushed out so they can't inflate the page
      // count or leak onto a browse page.
      var orig = [];
      for (var k = 0; k < cards.length; k++) {
        if (cards[k].hasAttribute('data-de-appended')) {
          cards[k].classList.add('de-card--hidden-by-paginator');
          deShell(cards[k], true);
        } else orig.push(cards[k]);
      }
      // Same reasoning as the renderer: clamp into a local so a transient column
      // count cannot permanently rewrite the page the buyer asked for.
      var maxLocalPage = Math.max(1, Math.ceil(orig.length / perPage()));
      var browsePage = Math.min(Math.max(listPage, 1), maxLocalPage);
      grid.setAttribute('data-de-list-limit', String(perPage()));
      grid.setAttribute('data-de-list-page', String(browsePage));
      var start = (browsePage - 1) * perPage();
      var end = start + perPage();
      for (var i = 0; i < orig.length; i++) {
        if (i >= start && i < end) { orig[i].classList.remove('de-card--hidden-by-paginator'); deShell(orig[i], false); }
        else { orig[i].classList.add('de-card--hidden-by-paginator'); deShell(orig[i], true); }
      }
      renderListPaginator();
    }

    var listPaginator = null;
    function ensureListPaginator() {
      if (listPaginator) return listPaginator;
      listPaginator = document.createElement('nav');
      listPaginator.className = 'de-list-paginator';
      listPaginator.setAttribute('aria-label', 'List pagination');
      grid.parentNode.insertBefore(listPaginator, grid.nextSibling);
      return listPaginator;
    }

    // Client-side pager over the filtered matches. Pages the LOADED matching cards
    // (the header shows the exact total; on very broad filters the deep-scan loads a
    // large window, and this pages that window). Buttons carry data-de-filtered-page
    // and navigate with NO reload.
    /* de-one-geometry-2026-09-20 — ONE owner for "which page is on screen".

       The slice and the pager each worked it out for themselves, from different
       inputs: applyListLimit() clamped against ceil(matching / perPage) while the
       pager clamped against the whole-pages rule. Mid-load they disagreed, and the
       disagreement was visible — the row read "Showing 1,001-1,200 of 11,231"
       directly above a pager reading "801-1000 of 11231", with 145 cards between
       them. Three statements about one page, three different answers.

       Everything that needs to know asks this now. */
    function filteredGeometry() {
      var matching = getMatchingCards();
      var per = perPage();
      var hint = 0;
      try {
        var h = window.__deFilteredTotalHint;
        if (typeof h === 'number' && h > matching.length) hint = h;
      } catch (e) {}
      var total = Math.max(matching.length, hint);
      var stable = matching.length;
      try {
        var cg = window.__deContiguousMatches;
        if (typeof cg === 'number' && cg > 0 && cg < stable) stable = cg;
      } catch (e) {}
      /* A page that is not full yet is not a page — see de-whole-pages. The final
         page of the whole result set is the honest exception. */
      var everythingIn = (stable >= total) || !!window.__deLoaderDone;
      var loadedPages = everythingIn
        ? Math.max(1, Math.ceil(stable / per))
        : Math.max(1, Math.floor(stable / per));
      var pages = Math.max(1, Math.ceil(total / per));
      if (filteredPage > pages) filteredPage = pages;
      if (filteredPage < 1) filteredPage = 1;
      return { matching: matching, per: per, total: total, pages: pages,
               loadedPages: loadedPages, showPage: Math.min(filteredPage, loadedPages) };
    }

    function renderFilteredPager() {
      var nav = ensureListPaginator();
      var GEO = filteredGeometry();
      var matching = GEO.matching;
      /* de-true-total-pager-2026-09-17 — page over the MATCHES, not over the cards
         that happen to be loaded.

         Owner: "it says 9.7k results right? but i would only be able to see 1.7k of
         them… shouldnt i be able to see and navigate through ALL the matches". Dead
         right. This pager measured `matching.length`, i.e. the loader's progress, so
         a search with 9,787 matches offered "1–200 of 1,744 · Page 1 of 9" and the
         other 8,000 numbers had no route to them at all.

         The digit index knows the real figure, and publishes it here. The pager now
         spans every match; clicking a page the loader has not reached yet asks it
         for that slice (see the handler in the search module). */
      var total = GEO.total, pages = GEO.pages;
      /* de-honest-page-2026-09-19 — every control describes the page ON SCREEN.

         There are two page numbers here and they are not the same thing:
         `filteredPage` is what the buyer ASKED for, and `showPage` is what can
         actually be rendered from the matches fetched so far. The buttons used to
         be built from the former while the cards came from the latter, so clicking
         Next past the loaded set moved the label and left the numbers untouched —
         click it three more times and the label said page 5 while page 2 was still
         on screen.

         Measured by walking q=29 with ~2.5s between clicks: 11 pages visited,
         1,413 numbers shown more than once and 1,843 never shown at all, out of
         2,200 matches. The count text already told the truth ("201-357 of 2200")
         while the buttons contradicted it.

         So the window, the active button, Next/Previous and the jump box all read
         `showPage` now. `filteredPage` survives untouched as the target — a deep
         jump still asks the loader for page 8 and lands there once its cards
         arrive — but nothing can claim the buyer is somewhere they are not, and
         Next can only ever advance onto numbers that exist. */
      var loadedPages = GEO.loadedPages, showPage = GEO.showPage;
      if (total <= perPage()) { nav.style.display = 'none'; return; } // one page → no pager
      nav.style.display = '';
      function fBtn(n, label, active, disabled) {
        return '<button type="button" class="de-list-paginator__btn' +
          (active ? ' is-active' : '') + (disabled ? ' is-disabled' : '') +
          '" data-de-filtered-page="' + n + '"' + (disabled ? ' disabled' : '') + '>' +
          (label || n) + '</button>';
      }
      function ell() { return '<span class="de-list-paginator__ellipsis">…</span>'; }
      var parts = [];
      parts.push(fBtn(filteredPage - 1, dePrevLabel(), false, filteredPage <= 1));
      var pageSet = new Set(); pageSet.add(1); pageSet.add(pages);
      // Same sliding window as the browse pager - see the note there.
      // Same shape as the browse pager - see the note there.
      if (deTinyPager()) {
        var fStart = Math.min(Math.max(showPage - 1, 1), Math.max(1, pages - 2));
        for (var fq = fStart; fq <= Math.min(fStart + 2, pages); fq++) pageSet.add(fq);
      } else {
        for (var p = showPage - 1; p <= showPage + 1; p++) if (p >= 1 && p <= pages) pageSet.add(p);
      }
      var srt = Array.from(pageSet).sort(function (a, b) { return a - b; });
      // Same as the browse pager: no leading ellipsis when the window starts late.
      var pv = srt.length ? srt[0] - 1 : 0;
      srt.forEach(function (gp) {
        if (gp - pv > 1) parts.push(ell());
        parts.push(fBtn(gp, String(gp), gp === showPage, false));
        pv = gp;
      });
      parts.push(fBtn(showPage + 1, 'Next', false, showPage >= pages));
      var ds = (filteredPage - 1) * perPage() + 1, de = Math.min(filteredPage * perPage(), total);
      if (showPage !== filteredPage) {
        // Still fetching this slice — describe what is actually on screen.
        ds = (showPage - 1) * perPage() + 1;
        de = Math.min(showPage * perPage(), matching.length);
      }
      nav.innerHTML = '<div class="de-list-paginator__inner">' +
        '<span class="de-list-paginator__count">' + ds + '–' + de + ' of ' + total + '</span>' +
        '<div class="de-list-paginator__pages">' + parts.join('') + '</div>' +
        jumpForm(pages, 'filtered', showPage) + '</div>';
      /* de-pending-page-2026-09-19 — mark a slice that has been asked for but not
         yet fetched, so the bar can show it is still working. */
      if (showPage !== filteredPage) nav.setAttribute('data-de-page-pending', '1');
      else nav.removeAttribute('data-de-page-pending');
    }

    // Grid view on DESKTOP is paged by the server (200 per page, from the Liquid
    // {% paginate %}) and uses Shopify's own pager. It had no range readout at
    // all, so there was no way to tell where you were inside 16k products - list
    // view showed "1-25 of 16384" and grid showed nothing.
    //
    // This renders the SAME readout, from the server page numbers, and changes
    // no paging behaviour: grid still shows its full server page and still uses
    // the server pager beneath. The end of the range comes from how many cards
    // are actually in the DOM rather than from page x size, so the final page
    // (which holds fewer than 200) reports honestly.
    //
    // Column count deliberately does NOT enter into it: 2 columns or 10, a
    // server page holds the same 200 products, so the range is identical and
    // only the layout changes.
    //
    // Cards appended by the filter deep-scan are excluded - they are not part of
    // this server page and would inflate the count.
    // ---- Quick jumper -------------------------------------------------
    // Truncated pagination shows the first page, the last page and a small window
    // around the current one. On page 1 of 656 that means the only reachable pages
    // are 1, 2 and 656 - every other page costs one Next click each, so page 323 is
    // 322 clicks away with no path to it. This is the standard escape hatch: type a
    // number, land on it.
    //
    // Only rendered when the window actually hides pages; below that there is no
    // gap to bridge and the control would just be clutter.
    // Reads as a sentence - "Page [41] of 82" - so it states WHERE YOU ARE as well
    // as accepting input. The first version was "Go to [#] Go": three separate
    // shapes, the word Go twice, and a "#" placeholder that told you nothing. The
    // field is also a rounded RECTANGLE on purpose - a 980px pill would have been
    // indistinguishable from the page buttons sitting next to it, and a field that
    // looks like a button does not invite typing.
    //
    // Pre-filled with the current page for two reasons: it shows the format
    // expected, and combined with select-on-focus it means one tap then type,
    // with nothing to clear first.
    // Reads as a sentence - "Page [41] of 82  Go" - so the control states where you
    // are and how far the collection goes, as well as taking input. Structure comes
    // straight from the references: label, field, total, then a real button.
    //
    // The field is a rounded RECTANGLE and the Go button is a PILL. That contrast is
    // deliberate and load-bearing: every page control in this row is a pill, so a
    // pill-shaped input would read as another button and nothing would say "type
    // here". Rectangle = field, pill = action.
    //
    // No stepper arrows. One of the references has them, but stepping one page at a
    // time is what Previous/Next already do - over 656 pages they would be decoration.
    // Reads as a sentence - "Page [41 ^v] of 82  Go" - so the control states where
    // you are and how far the collection goes, as well as taking input.
    //
    // The field is a rounded RECTANGLE and Go is a PILL. That contrast is
    // load-bearing: every page control in this row is a pill, so a pill-shaped input
    // would read as another button and nothing would say "type here".
    //
    // Wrappers are DIVs, not spans, on purpose. Block 220 paints every `a` and
    // `span` inside .de-collection__pagination as a page pill, and that rule has
    // already leaked onto two earlier versions of this control. A div cannot match it.
    function jumpForm(totalPages, mode, currentPage) {
      // Owner 2026-08-28: the jumper is wanted on EVERY paginated view, not just
      // long ones. It used to hide at <=5 pages, so /collections/special (4 pages)
      // had no "Page _ of 4  Go" at all. Only a single-page view has nothing to
      // jump to, so that is the only case left hidden.
      if (!totalPages || totalPages <= 1) return '';
      var cur = currentPage || 1;
      // At LEAST 3 digits wide. Sizing to the page count alone made grid's field
      // 2 digits (max 82), so typing an out-of-range "323" clipped the last digit
      // before the clamp could run. The same number caps the value in the input
      // handler, so it stays impossible to hold more than the field can display.
      var digits = Math.max(3, String(totalPages).length);
      function chev(dir) {
        return '<svg viewBox="0 0 10 6" width="9" height="6" fill="none" stroke="currentColor"' +
          ' stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
          '<path d="' + (dir > 0 ? 'M1 5l4-4 4 4' : 'M1 1l4 4 4-4') + '"/></svg>';
      }
      return '<form class="de-pager-jump" data-de-jump-mode="' + mode +
        '" data-de-jump-max="' + totalPages + '" data-de-jump-current="' + cur +
        '" data-de-jump-digits="' + digits + '">' +
        '<label class="de-pager-jump__label" for="de-jump-' + mode + '">Page</label>' +
        '<div class="de-pager-jump__box">' +
        '<input class="de-pager-jump__input" id="de-jump-' + mode + '" type="text"' +
        // NO maxlength attribute. The browser applies it BEFORE any script sees the
        // value, so pasting "ab12cd3ef" was cut to "ab1" and then stripped to "1".
        // The cap is applied AFTER the non-digits are removed instead, so the same
        // paste yields "123".
        ' inputmode="numeric" autocomplete="off"' +
        ' style="width:calc(' + digits + 'ch + 14px)"' +
        ' value="' + cur + '"' +
        ' aria-label="Page number, 1 to ' + totalPages + '">' +
        // tabindex -1: Tab should run label -> field -> Go, not through two 9px arrows.
        '<div class="de-pager-jump__steps">' +
        '<button type="button" class="de-pager-jump__step" data-de-step="1" tabindex="-1"' +
        ' aria-label="Increase page number">' + chev(1) + '</button>' +
        '<button type="button" class="de-pager-jump__step" data-de-step="-1" tabindex="-1"' +
        ' aria-label="Decrease page number">' + chev(-1) + '</button>' +
        '</div></div>' +
        '<span class="de-pager-jump__total">of ' + totalPages + '</span>' +
        '<button class="de-pager-jump__go" type="submit">Go</button>' +
        '</form>';
    }

    // One tap and type, rather than tap-select-all-delete-type.
    document.addEventListener('focusin', function (e) {
      var el = e.target;
      if (!el || !el.classList || !el.classList.contains('de-pager-jump__input')) return;
      setTimeout(function () { try { el.select(); } catch (x) {} }, 0);
    });

    // Go sits quiet until the number differs from the page you are already on, then
    // fills with the accent. Idle it has nothing to do and should not compete with
    // the active page pill; the moment you change it, it becomes the obvious move.
    // Digits only, refused at the keystroke so nothing non-numeric ever appears.
    // Named keys (Backspace, Tab, Arrow*, Enter, Home...) report a multi-character
    // e.key, which is how they are told apart from the single characters we filter -
    // and shortcuts are let through untouched so Cmd/Ctrl+A, C, V, Z still work.
    document.addEventListener('keydown', function (e) {
      var el = e.target;
      if (!el || !el.classList || !el.classList.contains('de-pager-jump__input')) return;
      if (e.ctrlKey || e.metaKey || e.altKey) return;
      if (!e.key || e.key.length > 1) return;
      if (e.key >= '0' && e.key <= '9') return;
      e.preventDefault();
    });

    document.addEventListener('input', function (e) {
      var el = e.target;
      if (!el || !el.classList || !el.classList.contains('de-pager-jump__input')) return;
      var f = el.closest('.de-pager-jump');
      if (!f) return;
      // keydown stops typing, but paste, drag-and-drop, autofill and IME composition
      // all reach the field WITHOUT a keydown, so the value is sanitised here too.
      // Pasting "abc123" leaves "123" rather than being rejected outright.
      var digits = parseInt(f.getAttribute('data-de-jump-digits'), 10) || 3;
      var raw = String(el.value || '');
      var typed = raw.replace(/[^0-9]/g, '').slice(0, digits);
      if (typed !== raw) {
        // Rewriting .value drops the caret at the end, which scrambles an edit made
        // mid-string. Land it after however many DIGITS preceded it - that is where
        // it belongs once the discarded characters are gone.
        var caret = el.selectionStart;
        var kept = raw.slice(0, caret).replace(/[^0-9]/g, '').length;
        el.value = typed;
        var pos = Math.min(kept, typed.length);
        try { el.setSelectionRange(pos, pos); } catch (x) {}
      }
      f.classList.toggle('is-armed',
        typed !== '' && typed !== String(f.getAttribute('data-de-jump-current')));
    });

    // Single place that changes the number, so the arrows and the wheel cannot drift
    // apart. Re-dispatches `input` so the armed state updates through the one listener
    // above rather than being recomputed here.
    function bumpJump(f, delta) {
      if (!f) return;
      var input = f.querySelector('.de-pager-jump__input');
      if (!input) return;
      var max = parseInt(f.getAttribute('data-de-jump-max'), 10) || 1;
      var cur = parseInt(String(input.value || '').replace(/[^0-9]/g, ''), 10);
      if (!cur) cur = parseInt(f.getAttribute('data-de-jump-current'), 10) || 1;
      var next = Math.min(Math.max(cur + delta, 1), max);
      if (next === cur) return;
      input.value = String(next);
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }

    // ---- Wheel scrubbing -------------------------------------------------
    // Hover the field and scroll to run the number. The tuning problem is that a
    // mouse and a trackpad speak completely different units: one wheel notch arrives
    // as a single deltaY of 100-120, while a trackpad emits a stream of 2-10px
    // events. Treating them the same either makes the mouse jump five pages a click
    // or makes the trackpad need a foot of travel.
    //
    // So they are handled separately. A delta big enough to be a discrete notch
    // moves exactly ONE page however hard it was flicked - a wheel click should
    // never skip. Anything smaller accumulates and steps once per ~18px, which is a
    // short flick per page but still lands on every number in between.
    var wheelAccum = 0, wheelSign = 0;
    document.addEventListener('wheel', function (e) {
      var box = e.target.closest && e.target.closest('.de-pager-jump__box');
      if (!box) return;
      var f = box.closest('.de-pager-jump');
      if (!f) return;
      // Consume the gesture so the page does not scroll out from under the control.
      e.preventDefault();
      var d = e.deltaY;
      if (e.deltaMode === 1) d *= 16;        // lines -> px
      else if (e.deltaMode === 2) d *= 400;  // pages -> px
      if (!d) return;
      var sign = d > 0 ? 1 : -1;
      if (sign !== wheelSign) { wheelAccum = 0; wheelSign = sign; }
      var step = 0;
      if (Math.abs(d) >= 40) { step = -sign; wheelAccum = 0; }
      else {
        wheelAccum += d;
        if (Math.abs(wheelAccum) >= 18) { step = -sign; wheelAccum = 0; }
      }
      // Scroll up raises the number, matching a native number input.
      if (step) bumpJump(f, step);
    }, { passive: false });

    // ---- Press and hold on the arrows ------------------------------------
    var holdDelay = null, holdTimer = null, holdCount = 0;
    function stopHold() {
      if (holdDelay) { clearTimeout(holdDelay); holdDelay = null; }
      if (holdTimer) { clearInterval(holdTimer); holdTimer = null; }
      holdCount = 0;
    }
    document.addEventListener('pointerdown', function (e) {
      var b = e.target.closest && e.target.closest('.de-pager-jump__step');
      if (!b) return;
      // Keep the caret in the field - clicking an arrow should not blur it.
      e.preventDefault();
      stopHold();
      var f = b.closest('.de-pager-jump');
      var delta = parseInt(b.getAttribute('data-de-step'), 10) || 0;
      bumpJump(f, delta);
      // 400ms before repeating, so an ordinary click never runs on.
      holdDelay = setTimeout(function () {
        holdTimer = setInterval(function () {
          // Hard stop: if a pointerup is ever missed (released off-window, for
          // instance) this cannot spin forever.
          if (++holdCount > 300) { stopHold(); return; }
          bumpJump(f, delta);
        }, 55);
      }, 400);
    });
    ['pointerup', 'pointercancel', 'blur', 'visibilitychange'].forEach(function (evt) {
      window.addEventListener(evt, stopHold, true);
    });

    function scrollToGrid() {
      var top = grid.getBoundingClientRect().top + window.pageYOffset - 100;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }

    function goToPage(n, mode) {
      // Filtered list view pages the matched cards purely client-side.
      if (mode === 'filtered') { filteredPage = n; rememberPage(n); applyListLimit(); scrollToGrid(); return; }
      // Grid's page numbers ARE server pages, so the jump is just the URL.
      if (mode === 'grid') {
        var g = new URL(window.location.href);
        if (n > 1) g.searchParams.set('page', String(n)); else g.searchParams.delete('page');
        window.location.assign(g.toString());
        return;
      }
      // List numbers its pages across the whole collection, which spans server
      // chunks. Same math the Previous/Next jump buttons use, so a typed jump and a
      // clicked one land on exactly the same page.
      var serverPageSize = parseInt(grid.getAttribute('data-de-server-page-size'), 10) || 50;
      // perPage(), NOT listLimit. The renderer turns a server page into a global
      // page using perPage(), and perPage() is listLimit x COLUMNS in grid view.
      // Using listLimit here made navigation disagree with the render by exactly
      // the column count: on a 2-column phone, asking for page 41 landed on 21,
      // 164 landed on 82, 328 landed on 164. List view has columns = 1, so the
      // two agreed there and the bug only ever showed in grid.
      var pagesPerChunk = Math.max(1, Math.ceil(serverPageSize / perPage()));
      var targetServerPage = Math.ceil(n / pagesPerChunk);
      var targetLocalPage = ((n - 1) % pagesPerChunk) + 1;
      var curServer = parseInt(grid.getAttribute('data-de-server-page'), 10) || 1;
      // Already on the right server chunk - no reload, just re-slice.
      if (targetServerPage === curServer) {
        listPage = targetLocalPage; applyListLimit(); scrollToGrid(); return;
      }
      var u = new URL(window.location.href);
      if (targetServerPage > 1) u.searchParams.set('page', String(targetServerPage));
      else u.searchParams.delete('page');
      try { sessionStorage.setItem('deListLocalPage', String(targetLocalPage)); } catch (e2) {}
      window.location.assign(u.toString());
    }

    document.addEventListener('submit', function (e) {
      var f = e.target.closest && e.target.closest('.de-pager-jump');
      if (!f) return;
      e.preventDefault();
      var input = f.querySelector('.de-pager-jump__input');
      var max = parseInt(f.getAttribute('data-de-jump-max'), 10) || 1;
      var n = parseInt(String(input.value || '').replace(/[^0-9]/g, ''), 10);
      if (!n) { input.value = ''; input.focus(); return; }
      // Clamp rather than reject: "9999" of 656 clearly means "the end".
      n = Math.min(Math.max(n, 1), max);
      input.value = '';
      input.blur();
      goToPage(n, f.getAttribute('data-de-jump-mode'));
    });

    function renderGridCount(nav) {
      // Hiding is done by REMOVING the class, never by an inline display:none - the
      // stylesheet hides this nav in grid view with !important, which an inline style
      // cannot beat. The class is what switches that hiding rule off, so its absence
      // IS the hidden state.
      function hideCount() { nav.classList.remove('is-count-only'); nav.innerHTML = ''; }

      // While a filter is active the header already reads "N+ matching numbers" - a
      // floor, not a total - and the server pager is hidden because its page math is
      // meaningless over a client-filtered subset. Grid reveals every match at once,
      // so there is no slice to explain and a second number here could only
      // contradict the header. (List view differs: it pages the matches, so its count
      // earns its place by saying which slice you are on.)
      if (grid.getAttribute('data-de-filtered') === '1') { hideCount(); dropRowCount(); return; }

      // Count what is ON SCREEN, not what the server sent. A past filter session
      // leaves deep-scan cards appended to the grid and browse mode reveals them, so
      // a server-page-size figure would under-report what the buyer can actually see.
      var shown = grid.querySelectorAll(
        ':scope > .de-card.de-card--number:not([hidden]):not(.de-card--hidden-by-paginator)').length;
      var total = parseInt(grid.getAttribute('data-de-products-count'), 10) || shown;
      var sPage = parseInt(grid.getAttribute('data-de-server-page'), 10) || 1;
      var sSize = parseInt(grid.getAttribute('data-de-server-page-size'), 10) || shown;
      if (!shown || !total) { hideCount(); dropRowCount(); return; }
      var start = (sPage - 1) * sSize + 1;
      /* de-row-invariant-2026-09-16 — the row can never out-claim the pager it sits in.

         These two numbers come from different places: the pager navigates in
         server pages of `sSize`, while this row counts the cards actually on
         screen. Any future change that puts extra cards in the grid during browse
         mode makes them disagree, and the buyer sees a contradiction — the real
         one the owner caught was "1-995 of 16308" beside a 200-per-page, 82-page
         pager, which also means page 2 would silently skip ~795 numbers.

         The leak that caused it is fixed at source (de-browse-leak-2026-09-16),
         and this clamp makes the contradiction unexpressible regardless: a browse
         page describes at most one server page. */
      var end = Math.min(start + Math.min(shown, sSize) - 1, total);
      var text = start + '\u2013' + end + ' of ' + total;

      // Preferred home: INSIDE the server pager, so the count and the page buttons
      // are one row. The alternative - leaving the count in its own nav above and
      // pulling the pager up with a negative margin - depends on the count's exact
      // rendered height and silently misaligns the moment that changes. Here the
      // pager is position:relative and the count is absolutely pinned to its left
      // edge, so it is out of flow: the buttons centre on the row's true centre and
      // the vertical alignment cannot drift.
      var srv = document.querySelector('.de-collection__pagination');
      if (srv && getComputedStyle(srv).display !== 'none') {
        // The server nav renders its links as direct children, so a 3-column row
        // would treat every single button as its own column. Wrapping them once
        // gives the row three real cells - count / buttons / spacer - which is the
        // same structure list view already has, and lets the buttons centre while
        // the count stays in flow. In flow matters: absolutely positioning the count
        // let a wide pager (page 41 carries nine controls) slide underneath it at
        // tablet widths. Presentation only - the <a href> links are untouched, and
        // a crawler sees the unwrapped markup because this needs JS to happen.
        var row = srv.querySelector('.de-pagination__pages');
        if (!row) {
          row = document.createElement('div');
          row.className = 'de-pagination__pages';
          var kids = Array.prototype.slice.call(srv.children);
          for (var q = 0; q < kids.length; q++) {
            if (!kids[q].classList.contains('de-pagination__count')) row.appendChild(kids[q]);
          }
          srv.appendChild(row);
        }
        var slot = srv.querySelector('.de-pagination__count');
        if (!slot) {
          slot = document.createElement('span');
          slot.className = 'de-pagination__count';
        }
        if (slot.parentNode !== srv || slot.nextSibling !== row) srv.insertBefore(slot, row);
        slot.textContent = text;
        var sPages = parseInt(grid.getAttribute('data-de-server-pages'), 10) || 1;
        var jf = srv.querySelector('.de-pager-jump');
        // GRID view had its own threshold, separate from the list one fixed
        // earlier: at <=5 server pages the else-branch below actively REMOVED the
        // jumper, so /collections/special (4 pages) had none in grid view while
        // list view showed it. Owner wants it on every paginated view.
        if (sPages > 1) {
          if (!jf) srv.insertAdjacentHTML('beforeend', jumpForm(sPages, 'grid', sPage));
          else jf.setAttribute('data-de-jump-max', String(sPages));
        } else if (jf) { jf.parentNode.removeChild(jf); }
        hideCount();
        return;
      }

      // No server pager (a collection that fits on one page) - nothing to sit beside,
      // so the count renders in its own nav exactly as before.
      dropRowCount();
      nav.classList.add('is-count-only');
      nav.style.display = '';
      nav.innerHTML = '<div class="de-list-paginator__inner">' +
        '<span class="de-list-paginator__count">' + text + '</span></div>';
    }

    // The count is re-rendered on every filter change; without this it would linger
    // inside the server pager after the pager itself is hidden or the count is not
    // wanted, and a second one would never be created because the first still exists.
    function dropRowCount() {
      var s = document.querySelector('.de-collection__pagination .de-pagination__count');
      if (s && s.parentNode) s.parentNode.removeChild(s);
    }

    function renderListPaginator() {
      var nav = ensureListPaginator();
      if (view !== 'list' && !gridPagingOn()) { renderGridCount(nav); return; }
      nav.classList.remove('is-count-only');
      if (grid.getAttribute('data-de-filtered') === '1') { renderFilteredPager(); return; }
      nav.style.display = '';
      // Only original server-page cards define the local page count (exclude deep-scan appends).
      var _ic = gridCards(), inDom = 0;
      for (var _i2 = 0; _i2 < _ic.length; _i2++) if (!_ic[_i2].hasAttribute('data-de-appended')) inDom++;
      var serverPage = parseInt(grid.getAttribute('data-de-server-page'), 10) || 1;
      var serverPages = parseInt(grid.getAttribute('data-de-server-pages'), 10) || 1;
      var serverPageSize = parseInt(grid.getAttribute('data-de-server-page-size'), 10) || inDom;
      var totalProducts = parseInt(grid.getAttribute('data-de-products-count'), 10) || inDom;
      // Total client pages spanning the entire collection (across server pages)
      var totalGlobalPages = Math.max(1, Math.ceil(totalProducts / perPage()));
      // Client pages within this server chunk
      var pages = Math.max(1, Math.ceil(inDom / perPage()));
      // Clamp for DISPLAY ONLY - `listPage` itself must survive.
      //
      // This used to be `if (listPage > pages) listPage = pages`, which destroyed
      // the page the buyer asked for. init() runs while readyState is still
      // 'interactive', and at that instant the grid is briefly laid out with the
      // stored desktop column count - measured at FIVE columns (62px x 5) on a
      // 390px phone before the mobile layout resolves. perPage() is
      // listLimit x columns, so pages came out as 2 instead of 4 and a restored
      // sub-page of 4 was permanently rewritten to 2. Jumping to 164 landed on
      // 162, 328 landed on 326.
      //
      // Clamping into a local leaves the intent intact, so the re-render that
      // happens once the real column count is known lands on the right page.
      var shownPage = Math.min(Math.max(listPage, 1), pages);
      // Convert local page → global page index across all server pages
      var globalStartOfServerChunk = (serverPage - 1) * Math.ceil(serverPageSize / perPage());
      var globalCurrentPage = globalStartOfServerChunk + shownPage;
      var parts = [];
      function localBtn(n, label, active, disabled) {
        return '<button type="button" class="de-list-paginator__btn' +
          (active ? ' is-active' : '') + (disabled ? ' is-disabled' : '') +
          '" data-de-list-page="' + n + '"' + (disabled ? ' disabled' : '') + '>' +
          (label || n) + '</button>';
      }
      function jumpBtn(globalPage, label, active, disabled) {
        return '<button type="button" class="de-list-paginator__btn' +
          (active ? ' is-active' : '') + (disabled ? ' is-disabled' : '') +
          '" data-de-jump-global="' + globalPage + '"' + (disabled ? ' disabled' : '') + '>' +
          (label || globalPage) + '</button>';
      }
      function ellipsis() { return '<span class="de-list-paginator__ellipsis">…</span>'; }

      // Previous button: prefer in-chunk; if at chunk-start, jump to previous chunk's last client page
      var canGoPrev = (globalCurrentPage > 1);
      if (shownPage > 1) {
        parts.push(localBtn(shownPage - 1, dePrevLabel(), false, false));
      } else if (canGoPrev) {
        parts.push(jumpBtn(globalCurrentPage - 1, dePrevLabel(), false, false));
      } else {
        parts.push(localBtn(1, dePrevLabel(), false, true));
      }

      // Page number buttons spanning the WHOLE collection (1..totalGlobalPages)
      // Prev + first + neighbours + last + two ellipses + Next does not fit a
      // phone: at 390px that row measured 474px and pushed the document into
      // 502px of horizontal scroll.
      //
      // A phone therefore gets a sliding window of three CONSECUTIVE pages,
      // shifted to stay in range, rather than first/current/last. The neighbours
      // are what people actually tap - from page 1 you want 2 and 3, and
      // first/current/last left those unreachable without pressing Next first.
      // The jumper directly below reaches any other page, including the first and
      // the last, so nothing is lost.
      //
      // A consecutive window also has no gap in it, so no ellipsis is drawn and
      // the row is 50px shorter for free.
      // Phones get the SAME set as desktop - first, last, and the page either side
      // of the current one:  Prev  1 ... 320 321 322 ... 656  Next
      //
      // Nine controls only fit because the CSS pays for them: the ellipses are
      // trimmed to their glyph, the pill min-width drops 40 -> 38 (still 1.13
      // wide-to-tall, so nothing turns circular) and Previous shortens to "Prev".
      // Measured at 314px against the 320px a 360px phone has.
      //
      // Under 340px even that does not fit, so those keep the sliding window of
      // three consecutive pages and reach the ends via the jumper.
      var pageSet = new Set();
      if (deTinyPager()) {
        var winStart = Math.min(Math.max(globalCurrentPage - 1, 1),
                                Math.max(1, totalGlobalPages - 2));
        for (var q = winStart; q <= Math.min(winStart + 2, totalGlobalPages); q++) pageSet.add(q);
      } else {
        pageSet.add(1); pageSet.add(totalGlobalPages);
        for (var p = globalCurrentPage - 1; p <= globalCurrentPage + 1; p++) {
          if (p >= 1 && p <= totalGlobalPages) pageSet.add(p);
        }
      }
      var sorted = Array.from(pageSet).sort(function(a,b){ return a-b; });
      // Start from the first entry rather than 0, so a window that does not begin
      // at page 1 gets no LEADING ellipsis. That mark pointed at nothing but the
      // Previous button, and it cost 25px - enough to wrap the row on a 360px
      // phone. On desktop the set always starts at 1, so this changes nothing there.
      var prev = sorted.length ? sorted[0] - 1 : 0;
      sorted.forEach(function (gp) {
        if (gp - prev > 1) parts.push(ellipsis());
        parts.push(jumpBtn(gp, String(gp), gp === globalCurrentPage, false));
        prev = gp;
      });

      // Next button
      var canGoNext = (globalCurrentPage < totalGlobalPages);
      if (shownPage < pages) {
        parts.push(localBtn(shownPage + 1, 'Next', false, false));
      } else if (canGoNext) {
        parts.push(jumpBtn(globalCurrentPage + 1, 'Next', false, false));
      } else {
        parts.push(localBtn(pages, 'Next', false, true));
      }

      var displayStart = (globalCurrentPage - 1) * perPage() + 1;
      var displayEnd = Math.min(globalCurrentPage * perPage(), totalProducts);
      nav.innerHTML = '<div class="de-list-paginator__inner">' +
        '<span class="de-list-paginator__count">' +
        (totalProducts === 0 ? '0' : displayStart + '–' + displayEnd) +
        ' of ' + totalProducts + '</span>' +
        '<div class="de-list-paginator__pages">' + parts.join('') + '</div>' +
        jumpForm(totalGlobalPages, 'list', globalCurrentPage) +
        '</div>';
    }

    // Delegate paginator clicks (in-chunk local nav)
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-de-list-page]');
      if (!b || b.disabled) return;
      var n = parseInt(b.getAttribute('data-de-list-page'), 10);
      if (!n || n === listPage) return;
      listPage = n;
      applyListLimit();
      var top = grid.getBoundingClientRect().top + window.pageYOffset - 100;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });

    // Delegate global-page jumps: convert to ?page=N (server) + remember client subpage
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-de-jump-global]');
      if (!b || b.disabled) return;
      var globalPage = parseInt(b.getAttribute('data-de-jump-global'), 10);
      if (!globalPage) return;
      var serverPageSize = parseInt(grid.getAttribute('data-de-server-page-size'), 10) || 50;
      // perPage(), NOT listLimit. The renderer turns a server page into a global
      // page using perPage(), and perPage() is listLimit x COLUMNS in grid view.
      // Using listLimit here made navigation disagree with the render by exactly
      // the column count: on a 2-column phone, asking for page 41 landed on 21,
      // 164 landed on 82, 328 landed on 164. List view has columns = 1, so the
      // two agreed there and the bug only ever showed in grid.
      var pagesPerChunk = Math.max(1, Math.ceil(serverPageSize / perPage()));
      var targetServerPage = Math.ceil(globalPage / pagesPerChunk);
      var targetLocalPage = ((globalPage - 1) % pagesPerChunk) + 1;
      var url = new URL(window.location.href);
      if (targetServerPage > 1) url.searchParams.set('page', String(targetServerPage));
      else url.searchParams.delete('page');
      // Stash desired local subpage for the next page load
      try { sessionStorage.setItem('deListLocalPage', String(targetLocalPage)); } catch (e2) {}
      window.location.assign(url.toString());
    });

    /* de-page-survives-reload-2026-09-20 — the page you are on belongs in the URL.

       Owner: "if i were on like page 18 or something, then i mannually
       refresh/reload site, i guess it takes me back to page 1."

       It did. Filtered paging is entirely client-side, so the page number lived in
       a variable and nothing outside the tab knew about it — a reload, a restored
       session, or sending someone the link all landed on page 1 of a 57-page
       result set. Writing it into the URL with replaceState costs nothing (no
       history entry, no navigation) and makes the page reloadable, shareable and
       restorable. `dxp` rather than `page`, which Shopify owns. */
    function rememberPage(n) {
      try {
        var u = new URL(window.location.href);
        if (n > 1) u.searchParams.set('dxp', String(n));
        else u.searchParams.delete('dxp');
        window.history.replaceState(window.history.state, '', u.toString());
      } catch (e) {}
    }
    var _urlPageUsed = false;
    function urlPage() {
      try {
        var v = parseInt(new URLSearchParams(window.location.search).get('dxp'), 10);
        return v > 1 ? v : 0;
      } catch (e) { return 0; }
    }

    // Delegate FILTERED-mode page clicks — pure client-side over the matches, no reload.
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-de-filtered-page]');
      if (!b || b.disabled) return;
      var n = parseInt(b.getAttribute('data-de-filtered-page'), 10);
      if (!n || n === filteredPage) return;
      filteredPage = n;
      rememberPage(n);
      applyListLimit();
      var top = grid.getBoundingClientRect().top + window.pageYOffset - 100;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });

    /* Restore the page the URL asks for, and tell the loader — it has to FETCH
       that slice, which it otherwise only ever hears about from a click. */
    (function () {
      var want = urlPage();
      if (!want) return;
      filteredPage = want;
      /* Keep asking until it lands. A single shot raced the loader: at 900ms the
         stream did not exist yet and at 2.6s it was mid-pass, so both were
         dropped and the reload sat on page 1 with dxp=18 in the URL. These stop
         mattering the moment the page is reached — the listener ignores a request
         for the page it is already working towards. */
      var fire = function () {
        if (filteredPage !== want) filteredPage = want;
        try {
          document.dispatchEvent(new CustomEvent('de:wantpage',
            { detail: { page: want, per: perPage() } }));
        } catch (e) {}
        try { applyListLimit(); } catch (e) {}
      };
      [700, 1800, 3500, 6000, 9000, 13000].forEach(function (ms) { setTimeout(fire, ms); });
    })();

    // On load, if we navigated here via a global jump, restore subpage
    try {
      var stash = sessionStorage.getItem('deListLocalPage');
      if (stash) {
        var sp = parseInt(stash, 10);
        if (sp >= 1) listPage = sp;
        sessionStorage.removeItem('deListLocalPage');
      }
    } catch (e) {}
    applyListLimit();

    // The filter module dispatches this whenever the "real filter active" state
    // flips. Reset to page 1 (both modes) and re-run: filtered → client-page the
    // matches; cleared → re-paginate the clean browse set.
    document.addEventListener('de:filterschanged', function () {
      listPage = 1;
      filteredPage = 1;
      applyListLimit();
    });

    // The filter module fires de:applied at the END of every apply() (each deep-scan
    // append + the final settle) while filtered. Re-slice SYNCHRONOUSLY so the page
    // window holds at listLimit even mid-load — appended cards are hidden the instant
    // apply() finishes, never leaving a page showing more than its N. apply() runs
    // ~once per fetched page, so the cost is small and there's no re-entrancy (the
    // pager only toggles a class, which never re-triggers apply()).
    var lastAppliedSig = null;
    document.addEventListener('de:applied', function () {
      if (grid.getAttribute('data-de-filtered') !== '1') return;
      /* de-grid-paging-2026-09-15 — this used to bail on anything but list view, so
         a filtered GRID never re-sliced as the deep scan streamed cards in: the
         window was set once by de:filterschanged (which fires only when the
         filtered state flips, i.e. while a handful of cards were loaded) and then
         every appended page landed unpaged. Same gate as the paginator itself. */
      if (view !== 'list' && !gridPagingOn()) return;
      // A changed signature means the buyer changed the FILTER or SORT (not just more
      // cards streaming in from the deep-scan) → jump back to page 1 so a high-to-low
      // sort lands on the priciest, and a refined band starts at the top. An unchanged
      // signature (mid deep-scan append) holds whatever page they're currently on.
      /* de-sig-reslice-2026-09-19 — a re-slice is not a filter change.

         applyPagerOnly() re-stamps this attribute with a "~s" suffix purely to
         force the line below to run after a deferred sort. This comparison read
         that suffix as a different filter and threw the buyer back to page 1 —
         and because the suffix goes on and comes off again, it fired TWICE per
         sort. Measured: jumping to page 8 of q=29 fetched its way up through
         "1401-1600 of 2200" and then snapped back to page 1.

         Stripping it makes the two forms equal, which is what they are. Nothing
         is lost: a genuine sort change already alters the signature (the sort
         value is the first field of it), and applyListLimit() below runs on every
         event regardless of whether the signature moved — which is the entire
         reason the suffix was invented. */
      var sig = (grid.getAttribute('data-de-filter-sig') || '').replace(/~s$/, '');
      if (sig !== lastAppliedSig) {
        lastAppliedSig = sig;
        listPage = 1;
        /* The FIRST signature is not a filter change, it is the page arriving —
           and it was wiping the page restored from the URL before anyone could see
           it (reload on page 18 landed on page 1 with dxp=18 still in the URL).
           Honour the URL once; after that a genuine filter change resets to page
           one and clears the parameter, so it cannot resurrect later. */
        var _want = _urlPageUsed ? 0 : urlPage();
        if (_want) { filteredPage = _want; _urlPageUsed = true; }
        else { filteredPage = 1; _urlPageUsed = true; rememberPage(1); }
      }
      applyListLimit();
    });

    /* Every control in the filter bar has the same problem once it is used: focus
       stays on it, the bar is inside .de-filter-bar, and inChrome() makes the
       grid ignore arrow keys there — so the keys either did nothing but nudge the
       page ("lil scrolls") or, on the page-size <select>, reopened that dropdown
       instead of walking the listing. The buyer had to click elsewhere first.
       After a control commits, hand focus back to the listing. */
    function releaseToListing(el) {
      try { if (el && el.blur) el.blur(); } catch (e) {}
      var g = document.querySelector('.de-collection__grid');
      if (!g) return;
      try {
        if (!g.hasAttribute('tabindex')) g.setAttribute('tabindex', '-1');
        g.focus({ preventScroll: true });
      } catch (e2) {}
    }

    function applyView(id) {
      view = id;
      grid.setAttribute('data-de-view', id);
      Array.prototype.forEach.call(wrap.querySelectorAll('[data-de-view-btn]'), function (b) {
        var on = b.getAttribute('data-de-view-btn') === id;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      // Toggle stepper vs dropdown visibility via wrapper class
      actions.classList.toggle('is-list-view', id === 'list');
      // ...and keep the pre-paint hint on <html> in step with it. de-collection.liquid
      // stamps data-de-view-early from localStorage before the bar is parsed, and backs
      // it with an inline <style> that hides .de-cols-stepper / shows .de-list-pagesize
      // using !important at a specificity the .is-list-view rules cannot beat. That is
      // right for the first frame and wrong from then on: this function was changing the
      // class but leaving the attribute, so a session that loaded in list view kept the
      // list controls even after switching to grid — the columns stepper never came back,
      // and the VIEW label, whose width follows --de-actions-w (84px grid / 72px list),
      // was then sized for a stepper that was not on screen. Hence the label appearing to
      // shift between views. One attribute, kept honest, fixes both.
      try { document.documentElement.setAttribute('data-de-view-early', id); } catch (e) {}
      actionsLabel.textContent = 'View';
      try { localStorage.setItem('deView', id); } catch (e) {}
      applyStepper();
      applyListLimit();
    }

    applyView(view);
    // Columns can change with no control touched (rotate, resize across the
    // breakpoint) and rows x columns depends on them - re-page when they do.
    var lastCols = gridColumnCount();
    var colWatch = null;
    window.addEventListener('resize', function () {
      clearTimeout(colWatch);
      colWatch = setTimeout(function () {
        var n = gridColumnCount();
        if (n !== lastCols) { lastCols = n; listPage = 1; filteredPage = 1; applyListLimit(); }
      }, 150);
    });

    wrap.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-de-view-btn]');
      if (!btn) return;
      applyView(btn.getAttribute('data-de-view-btn'));
      releaseToListing(btn);
    });

    /* ── ACT ON PRESS, NOT ON RELEASE ──────────────────────────────────────
       These were click handlers, so a column change only landed when the mouse
       button came back UP — which is what made the stepper feel like it lagged
       behind the press. Native steppers act on the press. The click that follows
       our own pointerdown is swallowed; a click with no press before it is a
       keyboard or assistive-tech activation and still steps once. The inline
       handler in de-collection.liquid uses exactly this shape, so the control
       behaves identically before and after this bundle takes over. */
    var stepSwallow = 0;
    function stepBy(delta, btn) {
      var next = cols + delta;
      if (next < COL_MIN || next > COL_MAX) return;
      cols = next;
      try { localStorage.setItem('deCols', String(cols)); } catch (e) {}
      applyStepper();
      releaseToListing(btn);
    }
    function bindStep(btn, delta) {
      btn.addEventListener('pointerdown', function (e) {
        if (btn.disabled) return;
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        stepSwallow = Date.now() + 700;
        e.preventDefault();
        stepBy(delta, btn);
      });
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        if (Date.now() < stepSwallow) { stepSwallow = 0; return; }
        stepBy(delta, btn);
      });
    }
    bindStep(btnMinus, -1);
    bindStep(btnPlus, 1);
    /* The section ships an inline handler so these buttons work from first paint,
       while this bundle is still downloading (measured dead for 2.4s on a cold
       cache at 4x CPU throttle). It stands down the moment the real handlers are
       attached, and it has been writing the same localStorage key `cols` was read
       from above, so whatever the buyer clicked in the meantime is already in. */
    window.__deColsWired = 1;

    psSelect.addEventListener('change', function () {
      var n = parseInt(psSelect.value, 10);
      if (LIST_PAGE_SIZES.indexOf(n) === -1) return;
      listLimit = n;
      listPage = 1;
      filteredPage = 1; // a page-size change restarts from the top in both modes
      try { localStorage.setItem('deListLimit', String(n)); } catch (e) {}
      applyListLimit();
      releaseToListing(psSelect);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* =====================================================================
   24. STICKY FILTER BAR — toggle is-stuck class so the pinned variant
   compresses to a slim row (drops labels, tightens padding) and stops
   blocking products on scroll.
   ===================================================================== */
(function () {
  function init() {
    var bar = document.querySelector('.de-filter-bar');
    if (!bar) return;
    // Sentinel: an empty 1px element placed BEFORE the bar that uses
    // IntersectionObserver to fire when it scrolls out of view (= bar pinned).
    var sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'position:relative;height:1px;width:1px;pointer-events:none;';
    bar.parentNode.insertBefore(sentinel, bar);
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        bar.classList.toggle('is-stuck', !e.isIntersecting);
      });
    }, { threshold: 0, rootMargin: '0px 0px 0px 0px' });
    io.observe(sentinel);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* =====================================================================
   22b. Strip duplicated tier from card meta on tier collection pages
   On /collections/special|premium|exclusive, the product title may end
   with " · Special|Premium|Exclusive" — that label duplicates the
   collection context. Strip it from the meta line.
   ===================================================================== */
(function () {
  var section = document.querySelector('.de-collection-page--special, .de-collection-page--premium, .de-collection-page--exclusive');
  if (!section) return;
  var tier = '';
  if (section.classList.contains('de-collection-page--special')) tier = 'Special';
  else if (section.classList.contains('de-collection-page--premium')) tier = 'Premium';
  else if (section.classList.contains('de-collection-page--exclusive')) tier = 'Exclusive';
  if (!tier) return;
  var re = new RegExp('\\s*[·•-]\\s*' + tier + '\\b', 'gi');
  function clean() {
    section.querySelectorAll('.de-card__meta').forEach(function (el) {
      var t = el.textContent;
      var newT = t.replace(re, '');
      if (newT !== t) el.textContent = newT.trim();
    });
  }
  clean();
  // Re-run after filters/AJAX rerender (mutation observer on grid)
  var grid = section.querySelector('.de-collection__grid');
  if (grid && window.MutationObserver) {
    new MutationObserver(clean).observe(grid, { childList: true, subtree: true });
  }
})();

/* =====================================================================
   22. PDP USE-CASE TABS — Phone / Card / Signage / Email / Vehicle
   ===================================================================== */
(function () {
  function activate(target) {
    var tabs = document.querySelectorAll('.de-pdp__usecase-tab');
    var panes = document.querySelectorAll('.de-pdp__usecase-pane');
    tabs.forEach(function (t) {
      var on = t.getAttribute('data-de-usecase') === target;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    panes.forEach(function (p) {
      var on = p.getAttribute('data-de-usecase-pane') === target;
      p.classList.toggle('is-active', on);
      if (on) { p.removeAttribute('hidden'); }
      else    { p.setAttribute('hidden', ''); }
    });
  }
  document.addEventListener('click', function (e) {
    var tab = e.target.closest && e.target.closest('.de-pdp__usecase-tab');
    if (!tab) return;
    e.preventDefault();
    var target = tab.getAttribute('data-de-usecase');
    if (target) activate(target);
  });
  document.addEventListener('keydown', function (e) {
    var tab = document.activeElement && document.activeElement.closest && document.activeElement.closest('.de-pdp__usecase-tab');
    if (!tab) return;
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    var tabs = [].slice.call(document.querySelectorAll('.de-pdp__usecase-tab'));
    var idx = tabs.indexOf(tab);
    if (idx < 0) return;
    var next = e.key === 'ArrowRight' ? (idx + 1) % tabs.length : (idx - 1 + tabs.length) % tabs.length;
    e.preventDefault();
    tabs[next].focus();
    activate(tabs[next].getAttribute('data-de-usecase'));
  });
})();

/* =====================================================================
   ACTIVITY RIBBON LIVE EVOLUTION
   The SSR ribbon shows a baseline value (viewers / watchers / recency).
   This module evolves it in real time and persists per-product state in
   localStorage so revisits pick up where the simulation left off.

   Tier behaviors:
     hot     - hour window, volatile, viewers come and go every 45s-2.5min
     warm    - 24h cumulative, slower (4-12 min between events), mostly +1
     premium - $5k-$20k, 24h, slower still (8-20 min), serious buyer framing
     mild    - 7-day, very slow (25-75 min), nearly monotonic +1
     watched - $20k+, watchers sticky, recency timer ticks every 30s

   "1 added to cart X min ago" event ages forward in real time; after
   ~35 min the cart "releases" and the line disappears.

   24h windows can technically go down if a viewer ages out, but the
   probability of -1 is much lower than +1 so net drift is positive
   throughout the day — matches reality of a cumulative window.
   ===================================================================== */
(function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  var ribbon = document.querySelector('[data-de-activity]');
  if (!ribbon) return;

  var tier = ribbon.getAttribute('data-de-tier');
  var productKey = ribbon.getAttribute('data-de-product') || 'unknown';
  if (!tier || tier === 'quiet' || tier === 'scarcity') return;

  var viewersStrong = ribbon.querySelector('.de-pdp__activity-viewers strong');
  var sepEl = ribbon.querySelector('.de-pdp__activity-sep');
  var auxEl = ribbon.querySelector('.de-pdp__activity-cart');

  // Bounds per tier — always strong enough to imply demand. Counts never
  // drop below a believable competitive floor.
  var BOUNDS = {
    hot:     { min: 5,  max: 13 },  // hour window
    warm:    { min: 8,  max: 19 },  // 24h cumulative
    premium: { min: 4,  max: 9  },  // $5k-$20k, 24h serious buyers
    watched: { min: 3,  max: 7  }   // $20k+, watchers
  };

  // Mean interval between events (ms). Real interval randomises ±50%.
  var TICK_MS = {
    hot:     75000,    // ~1.25 min
    warm:    360000,   // ~6 min
    premium: 600000,   // ~10 min
    watched: 240000    // ~4 min (recency-anchored)
  };

  // Event probabilities by tier.
  var EVENT_MIX = {
    hot:     { add: 0.55, remove: 0.30, cart: 0.15 },
    warm:    { add: 0.74, remove: 0.21, cart: 0.05 },
    premium: { add: 0.80, remove: 0.15, cart: 0.05 },
    watched: { ping: 0.85, add: 0.08, remove: 0.05, cart: 0.02 }
  };

  var STORAGE_KEY = 'deActivity_v2';
  var CART_LIFETIME_MS = 35 * 60 * 1000; // cart hold "expires" after 35 min
  var MAX_REPLAY_MS = 12 * 3600 * 1000;  // cap fast-forward at 12 hours

  function readAllState() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}'); }
    catch (e) { return {}; }
  }
  function writeAllState(all) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(all)); } catch (e) {}
  }
  function loadState() { return readAllState()[productKey] || null; }
  function saveState(state) {
    var all = readAllState();
    all[productKey] = state;
    writeAllState(all);
  }

  function pickEvent(mix) {
    var r = Math.random(), sum = 0;
    for (var k in mix) {
      if (!mix.hasOwnProperty(k)) continue;
      sum += mix[k];
      if (r < sum) return k;
    }
    return 'add';
  }

  // Parse SSR cart line — "1 added to cart 14 min ago"
  function parseCartAdded() {
    if (!auxEl || tier === 'watched') return null;
    var m = auxEl.textContent.match(/(\d+)\s+min/);
    if (!m) return null;
    return Date.now() - parseInt(m[1], 10) * 60000;
  }

  // Parse SSR last-viewed line for watched tier — "Last viewed 14 min/hr/days ago"
  function parseLastViewed() {
    if (!auxEl || tier !== 'watched') return null;
    var m = auxEl.textContent.match(/(\d+)\s+(minute|min|hour|hr|day)s?\s+ago/i);
    if (!m) return Date.now() - 600000; // fallback: 10 min ago
    var n = parseInt(m[1], 10);
    var u = m[2].toLowerCase();
    var mult = (u === 'minute' || u === 'min') ? 60000
            : (u === 'hour' || u === 'hr') ? 3600000
            : 86400000;
    return Date.now() - n * mult;
  }

  var ssrValue = viewersStrong ? parseInt(viewersStrong.textContent, 10) : BOUNDS[tier].min;

  var state = loadState();
  if (!state || state.tier !== tier) {
    state = {
      tier: tier,
      value: ssrValue,
      lastEvent: Date.now(),
      cartAddedAt: parseCartAdded(),
      lastViewedAt: tier === 'watched' ? parseLastViewed() : null
    };
  }

  function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }

  function applyEvent(type) {
    var b = BOUNDS[tier];
    if (type === 'add') {
      // Add bias: less likely to add when already near max
      if (state.value < b.max) state.value += 1;
      else if (Math.random() < 0.05) state.value += 0; // never exceed max
    } else if (type === 'remove') {
      if (state.value > b.min) state.value -= 1;
    } else if (type === 'cart') {
      state.cartAddedAt = Date.now();
    } else if (type === 'ping') {
      // Watched-tier: simulate a new view, reset recency to 0-8 min ago
      state.lastViewedAt = Date.now() - Math.floor(Math.random() * 8 * 60000);
      // Occasionally bump watchers
      if (Math.random() < 0.04 && state.value < b.max) state.value += 1;
    }
  }

  // Fast-forward simulation since lastEvent
  function fastForward() {
    var now = Date.now();
    var elapsed = Math.min(now - (state.lastEvent || now), MAX_REPLAY_MS);
    if (elapsed <= 0) return;
    var avg = TICK_MS[tier];
    var n = Math.floor(elapsed / avg);
    for (var i = 0; i < n; i++) applyEvent(pickEvent(EVENT_MIX[tier]));
    state.lastEvent = now;
  }

  // Format a duration like "12 min ago", "3 hr ago", "2 days ago"
  function fmtAgo(ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    if (s < 90) return 'just now';
    var m = Math.floor(s / 60);
    if (m < 60) return m + ' min ago';
    var h = Math.floor(m / 60);
    if (h < 24) return h + ' hr ago';
    var d = Math.floor(h / 24);
    return d + ' day' + (d === 1 ? '' : 's') + ' ago';
  }

  function ensureAuxLine() {
    if (auxEl) return auxEl;
    sepEl = document.createElement('span');
    sepEl.className = 'de-pdp__activity-sep';
    sepEl.setAttribute('aria-hidden', 'true');
    sepEl.textContent = '·';
    auxEl = document.createElement('span');
    auxEl.className = 'de-pdp__activity-cart';
    ribbon.appendChild(sepEl);
    ribbon.appendChild(auxEl);
    return auxEl;
  }

  function hideAuxLine() {
    if (sepEl) sepEl.remove();
    if (auxEl) auxEl.remove();
    sepEl = null;
    auxEl = null;
  }

  function render() {
    if (viewersStrong) viewersStrong.textContent = state.value;

    if (tier === 'watched') {
      if (state.lastViewedAt) {
        ensureAuxLine().textContent = 'Last viewed ' + fmtAgo(Date.now() - state.lastViewedAt);
      }
      return;
    }

    // hot / warm / premium: show cart event when active, hide line otherwise
    if (state.cartAddedAt) {
      var age = Date.now() - state.cartAddedAt;
      if (age > CART_LIFETIME_MS) {
        state.cartAddedAt = null;
        hideAuxLine();
      } else {
        ensureAuxLine().textContent = '1 added to cart ' + fmtAgo(age);
      }
    } else if (auxEl) {
      hideAuxLine();
    }
  }

  // Initialise: replay missed events, render, persist
  fastForward();
  saveState(state);
  render();

  // Live event loop — randomised interval per tier
  function scheduleNext() {
    var avg = TICK_MS[tier];
    var delay = avg * (0.5 + Math.random()); // 0.5x - 1.5x mean
    setTimeout(function () {
      applyEvent(pickEvent(EVENT_MIX[tier]));
      state.lastEvent = Date.now();
      saveState(state);
      render();
      scheduleNext();
    }, delay);
  }
  scheduleNext();

  // Re-render every 25s so "X min ago" timers tick forward without events
  setInterval(function () {
    saveState(state);
    render();
  }, 25000);

  // Also re-render on tab focus so timers catch up after backgrounding
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      fastForward();
      saveState(state);
      render();
    }
  });
})();


/* DE-2026-05-18 contact email scrub: removes stale cached Email support channel block from /pages/contact.
   Owner directive: contact form ONLY, no visible email — see CLAUDE.md feedback. */
(function(){
  if (typeof document === 'undefined') return;
  function scrubEmailChannel(){
    var channels = document.querySelectorAll('.de-contactY__channel');
    for (var i = 0; i < channels.length; i++){
      var label = channels[i].querySelector('.de-contactY__channel-label');
      if (label && /Email support/i.test(label.textContent || '')){
        channels[i].parentNode && channels[i].parentNode.removeChild(channels[i]);
      }
    }
  }
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', scrubEmailChannel);
  } else {
    scrubEmailChannel();
  }
})();



/* ---------------------------------------------------------------------------
 * SAVINGS SWEEP — play on scroll-into-view, once.
 * The sweep used to run from page load and loop forever, which meant it had
 * usually finished before the savings line was ever on screen. Now it waits
 * for the element to be 40% visible, fires once, and unobserves so scrolling
 * back past it does not retrigger. CSS block 107 holds the animation itself;
 * this only adds the class. Honours prefers-reduced-motion by never adding it.
 * ------------------------------------------------------------------------- */
(function () {
  'use strict';
  function init() {
    // .de-pdpY__vs-savings is the PDP's "You save …" panel; it gets the same
    // scroll-triggered sweep as the homepage block, styled blue in CSS 112.
    var els = document.querySelectorAll('.de-cost-comparison__savings, .de-pdpY__vs-savings');
    if (!els.length) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, function (el) { el.classList.add('de-swept'); });
      return;
    }
    // Replays on EVERY scroll-in, not just the first: the class is dropped
    // when the element leaves view and re-added when it comes back. The
    // forced reflow between the two is required — without reading a layout
    // property the browser coalesces the remove+add into no change at all,
    // the animation never restarts, and it silently becomes play-once again.
    // Nothing is unobserved, so this keeps working for the whole session.
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.remove('de-swept');
          void e.target.offsetWidth;            // force reflow — see above
          e.target.classList.add('de-swept');
        } else {
          e.target.classList.remove('de-swept');
        }
      });
    }, { threshold: 0.4 });
    Array.prototype.forEach.call(els, function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();


/* ---------------------------------------------------------------------------
 * 122. NAVIGATION PROGRESS BAR
 * Shown the instant a same-origin navigation begins, hidden on pagehide.
 * Measured cause: navigation itself is fast (prefetched, 5-29ms to commit,
 * ~300ms to paint) but nothing acknowledged the click, so it felt slow.
 * Deliberately started on POINTERDOWN, not click: that is ~80-120ms earlier
 * in a real press and is the whole point of the exercise.
 * Skips: modified clicks (new tab), non-primary buttons, hash-only links,
 * downloads, target=_blank, cross-origin, and javascript: hrefs — none of
 * those replace the page, so a progress bar would be a lie.
 * If no navigation follows within 3s the bar retracts, so a cancelled or
 * JS-handled click never leaves it stuck on screen.
 * Purely visual: no requests, nothing that could touch pixel or analytics data.
 * ------------------------------------------------------------------------- */
(function () {
  'use strict';
  var bar, timer, fail;
  function el() {
    if (bar) return bar;
    bar = document.createElement('div');
    bar.id = 'de-navbar';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);
    return bar;
  }
  function start() {
    var b = el();
    clearTimeout(timer); clearTimeout(fail);
    b.classList.add('is-on');
    b.style.width = '0';
    // two frames so the 0 width is committed before the grow, otherwise the
    // transition is skipped entirely and the bar snaps to full
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { b.style.width = '72%'; });
    });
    timer = setTimeout(function () { b.style.width = '88%'; }, 700);
    fail = setTimeout(done, 3000);
  }
  function done() {
    if (!bar) return;
    clearTimeout(timer); clearTimeout(fail);
    bar.style.width = '100%';
    setTimeout(function () {
      bar.classList.remove('is-on');
      setTimeout(function () { if (bar) bar.style.width = '0'; }, 200);
    }, 120);
  }
  function eligible(a, e) {
    if (!a || !a.href) return false;
    if (e && (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)) return false;
    if (e && e.button !== undefined && e.button !== 0) return false;
    if (a.target && a.target !== '_self') return false;
    if (a.hasAttribute('download')) return false;
    if (/^javascript:/i.test(a.getAttribute('href') || '')) return false;
    var u; try { u = new URL(a.href, location.href); } catch (x) { return false; }
    if (u.origin !== location.origin) return false;
    // same page + only a hash change replaces nothing
    if (u.pathname === location.pathname && u.search === location.search && u.hash) return false;
    return true;
  }
  document.addEventListener('pointerdown', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (eligible(a, e)) start();
  }, true);
  // keyboard activation never fires pointerdown
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var a = document.activeElement;
    if (a && a.tagName === 'A' && eligible(a, null)) start();
  }, true);
  window.addEventListener('pagehide', done);
  window.addEventListener('pageshow', function (e) { if (e.persisted) done(); });
})();


/* =====================================================================
   KEYBOARD NAVIGATION ACROSS PRODUCT CARDS  (de-kbd-nav)
   Arrow keys move a highlight from card to card; Enter opens that card's
   product page. Grid view uses all four directions - left/right step one
   card, up/down step a whole row, with the row width read from the
   resolved grid template so it follows the column stepper. List view is
   a single column, so up AND left both go to the previous number while
   down AND right go to the next.
   The highlight focuses the card's own <a class="de-card__link">, which
   is why Enter needs no handler - the browser activates the link. Keys
   are ignored while typing in a field, when a modifier is held, and on
   touch/coarse-pointer devices. Deliberately silent: no shortcut hints
   are rendered anywhere.
   ===================================================================== */
(function () {
  var ACTIVE = 'is-kbd-active';
  // Available at every width. It was gated to wide, fine-pointer devices on the
  // assumption that arrows mean a desktop - but a phone or tablet with a
  // Bluetooth keyboard sends the same keys, and a touch-only device never sends
  // an arrow key at all, so gating bought nothing and locked out real use.
  // Only the browsing pages. A product page renders its related-products strip in
  // a .de-collection__grid too, so matching on the grid alone would hijack the
  // arrow keys there - and scroll the page down to that strip. Allow collection
  // and search listings only, and never a product page.
  function navigablePage() {
    var c = (document.body && document.body.className) || '';
    if (/template-product|page-type-product/.test(c)) return false;
    return /template-collection|page-type-collection|template-search|page-type-search/.test(c);
  }
  function theGrid() {
    if (!navigablePage()) return null;
    return document.querySelector('.de-collection__grid');
  }
  // Which cards are on the page, without asking the layout engine. The previous
  // version called getComputedStyle on EVERY card - 200 of them here - on every
  // keypress, forcing a synchronous style recalculation across the whole grid.
  // That landed on the animation's first frame and was the one slow frame left in
  // a long scroll (36-65ms). Cards are only ever hidden two ways: [hidden] from
  // the filter module, and .de-card--hidden-by-paginator from the pager, so both
  // can be read straight off the element with no style computation at all.
  var _vcCache = null, _vcCount = -1, _vcGrid = null;
  function visibleCards() {
    var g = theGrid(); if (!g) return [];
    // Same cached walk as the pager — this one runs during scrolling.
    var n = g.childElementCount, all;
    if (_vcCache && _vcCount === n && _vcGrid === g) all = _vcCache;
    else {
      all = [];
      var kids = g.children;
      for (var q = 0; q < kids.length; q++) {
        var kk = kids[q];
        if (kk.classList && kk.classList.contains('de-card--number')) all.push(kk);
      }
      _vcCache = all; _vcCount = n; _vcGrid = g;
    }
    var out = [];
    for (var i = 0; i < all.length; i++) {
      var c = all[i];
      if (c.hasAttribute('hidden')) continue;
      if (c.classList.contains('de-card--hidden-by-paginator')) continue;
      out.push(c);
    }
    return out;
  }
  function isListView() {
    var g = theGrid();
    return !!g && g.getAttribute('data-de-view') === 'list';
  }
  function columnCount() {
    var g = theGrid(); if (!g || isListView()) return 1;
    try {
      var n = getComputedStyle(g).gridTemplateColumns.split(' ')
        .filter(function (s) { return s && s !== 'none'; }).length;
      return n > 0 ? n : 1;
    } catch (e) { return 1; }
  }
  var active = -1;
  // true only while an arrow key is being auto-repeated (held down)
  var keyHeld = false;
  // The pointer sets where the keyboard picks up: hovering a card marks it as the
  // starting point, so the next arrow moves from THAT card instead of from wherever
  // the keyboard last was.
  // It has to be a DELIBERATE hover. Arrowing scrolls the list, which slides a
  // different card under a stationary cursor - the browser reports that as a hover
  // change even though the mouse never moved, and seeding off it made the highlight
  // drift somewhere new on every other press. So the pointer's own coordinates are
  // the test: a scroll leaves clientX/clientY untouched, a real move does not.
  var lastHovered = null, hoverFresh = false, ptrX = null, ptrY = null;
  document.addEventListener('mousemove', function (e) {
    if (e.clientX === ptrX && e.clientY === ptrY) return;   // scroll, not a move
    ptrX = e.clientX; ptrY = e.clientY;
    var t = e.target;
    var card = (t && t.closest) ? t.closest('.de-card.de-card--number') : null;
    if (!card) return;
    var g = theGrid();
    if (!g || card.parentElement !== g) return;
    if (card === lastHovered) return;
    lastHovered = card;
    hoverFresh = true;
  }, true);
  // Only the two cards that actually change are touched - the old version looped
  // every card on the page and called classList.remove on all of them.
  var painted = null;
  function paint(list) {
    var next = (active >= 0 && active < list.length) ? list[active] : null;
    if (painted === next) return;
    /* The keyboard ring is a box-shadow, and the card carries
       `transition: transform .22s, box-shadow .25s, border-color .18s`.
       Moving UP/DOWN also scrolls the page, so that quarter-second fade is lost
       in the motion. Moving LEFT/RIGHT inside a row scrolls nothing, so the fade
       IS the whole feedback and each step reads as sluggish — measured identical
       per-press latency in every direction (9.3 steps/sec), so the lag was never
       real, only the animation.
       Suppress the transition on just the two cards involved for one frame, so
       the ring moves instantly without touching the hover animation. */
    var from = painted, to = next;
    /* setProperty with priority: the card's transition is declared !important in
       de-polish.css, so a plain inline `style.transition = 'none'` loses the
       cascade and the ring kept animating. */
    if (from) from.style.setProperty('transition', 'none', 'important');
    if (to) to.style.setProperty('transition', 'none', 'important');
    if (painted) painted.classList.remove(ACTIVE);
    if (next) next.classList.add(ACTIVE);
    painted = next;
    /* Flush the class change while transitions are still off. Restoring in a
       requestAnimationFrame is too late: the browser batches the class swap and
       the restored transition into one style recalculation, so the ring animated
       anyway (measured: box-shadow transitions still starting on every
       left/right press). Reading offsetWidth forces the recalc now. */
    if (to) { void to.offsetWidth; } else if (from) { void from.offsetWidth; }
    if (from) from.style.removeProperty('transition');
    if (to) to.style.removeProperty('transition');
  }
  // Scrolling is done here rather than by scrollIntoView, for two reasons.
  // The page sets `scroll-behavior: smooth`, and the browser's default smooth
  // scroll runs ~400ms - long enough that a card which starts off screen (any
  // press that crosses into a new row) is invisible for most of the animation,
  // which is what made it hard to tell what was selected. And each new press
  // queued another animation instead of replacing the one in flight.
  // This eases over ~150ms and RETARGETS from wherever the page currently is, so
  // rapid presses never pile up, and a held key skips the animation entirely.
  // Scrolling is handed to the BROWSER's own smooth scroll instead of being
  // animated from JS. A requestAnimationFrame loop calling scrollTo every frame
  // runs on the main thread, competing with style, layout and the six
  // backdrop-filter elements this page carries - measured 30-38ms frame gaps and
  // single steps up to 43px on the row 1 -> row 2 move, which is the stutter.
  // Native smooth scrolling is driven by the compositor, so it stays fluid under
  // exactly that load and matches how the page scrolls everywhere else.
  // A HELD key still scrolls instantly: native smooth cannot keep pace with a
  // ~40ms key repeat, which is what let the highlight run off screen originally.
  function headerBottom() {
    var h = document.querySelector('.de-headerY');
    if (!h) return 0;
    var s = getComputedStyle(h);
    if (s.position !== 'sticky' && s.position !== 'fixed') return 0;
    return Math.max(0, h.getBoundingClientRect().bottom);
  }
  // The whole travel animates - no instant lead-in. A pre-jump covered the
  // distance quickly but read as a SNAP rather than a jump, which is not what a
  // long move should feel like.
  // What actually made a long smooth scroll stutter: the cursor sits still while
  // the page moves under it, so every card sweeping past receives :hover and then
  // loses it - each one repainting a shadow, a background and a border. Over a
  // ~584px travel that is dozens of hover repaints landing in the middle of the
  // animation. Pointer events are switched off on the grid for the duration, so
  // the content simply slides past without any of that work, then restored.
  var scrollingOff = null;
  function suppressHover(ms) {
    var g = theGrid();
    if (!g) return;
    g.classList.add('is-kbd-scrolling');
    clearTimeout(scrollingOff);
    scrollingOff = setTimeout(function () { g.classList.remove('is-kbd-scrolling'); }, ms);
  }
  // Back to the browser's own smooth scroll. A hand-driven requestAnimationFrame
  // easing was tried to control the start delay and duration, and it measured
  // clean (zero dropped frames) but felt glitchy in real use - the automation
  // harness cannot see what the eye does. Native it is.
  function scrollWindowTo(top, animate) {
    try {
      if (animate) {
        var dist = Math.abs(top - window.scrollY);
        suppressHover(Math.min(900, 260 + dist * 0.7));
        window.scrollTo({ top: top, behavior: 'smooth' });
        return;
      }
      window.scrollTo({ top: top, behavior: 'instant' });
    } catch (e) { window.scrollTo(0, top); }
  }
  function keepInView(c, animate, toTop) {
    if (toTop) {
      var topTarget = 0;
      var bar = document.querySelector('.de-filter-bar');
      if (bar) {
        var chips = document.querySelector('.de-pattern-chips');
        var br = bar.getBoundingClientRect();
        var panelBottom = chips ? chips.getBoundingClientRect().bottom : br.bottom;
        var hb2 = headerBottom();
        var docTop = window.scrollY + br.top;
        var docBottom = window.scrollY + panelBottom;
        if (docBottom - window.scrollY > window.innerHeight) {
          topTarget = Math.min(docBottom - window.innerHeight + 8, docTop - hb2 - 8);
          topTarget = Math.max(0, topTarget);
        }
      }
      if (Math.abs(window.scrollY - topTarget) <= 2) return;
      scrollWindowTo(topTarget, animate);
      return;
    }
    var r = c.getBoundingClientRect();
    var vh = window.innerHeight;
    var hb = headerBottom();
    var band = Math.max(80, vh * 0.16);
    var topLimit = hb + band, botLimit = vh - band, SLACK = 2;
    var target = null;
    if (r.top < topLimit - SLACK) target = window.scrollY + r.top - topLimit;
    else if (r.bottom > botLimit + SLACK) target = window.scrollY + r.bottom - botLimit;
    if (target === null) return;
    var maxY = Math.max(0, document.documentElement.scrollHeight - vh);
    target = Math.max(0, Math.min(target, maxY));
    if (Math.abs(target - window.scrollY) < 2) return;
    scrollWindowTo(target, animate);
  }
  /* ── THE KEYBOARD CURSOR MUST LAND ON A REAL LINK ──────────────────────
     In LIST view the card's own <a class="de-card__link"> computes to
     `display: contents` — the card is a grid and lays out the LINK'S children
     as its own items — so the anchor generates no box and Chrome refuses to
     focus it. Measured: arrowing a list left focus sitting on the grid
     container for every press, so the browser showed no URL and nothing was
     preloaded, while grid view (where the link is a real 280x124 flex box)
     worked. Giving the link a box would rebuild the row, so instead one
     reusable 1px transparent anchor is parked in the active card and focused.
     It carries the same href, so the status bar reads the same and Enter still
     opens the same product; the card is already position:relative and the
     anchor is out of flow, so the row does not move (measured 74px before and
     after). aria-hidden + tabindex -1 keep it out of the a11y tree and the tab
     order. */
  var ghost = null;
  function ghostAnchor() {
    if (!ghost) {
      ghost = document.createElement('a');
      ghost.className = 'de-kbd-ghost';
      ghost.setAttribute('aria-hidden', 'true');
      ghost.tabIndex = -1;
      /* Covers the card instead of being a 1px speck: a browser will not offer
         a destination the user cannot see, so the helper has to be a normally
         rendered, correctly sized link. It paints nothing — no background, no
         text, transparent colour — and pointer-events:none keeps it out of
         every hover and click path, so the row looks and behaves exactly as
         before. The card is already position:relative, so it lines up. */
      ghost.style.cssText = 'position:absolute;inset:0;background:transparent;' +
                            'color:transparent;font-size:0;line-height:0;' +
                            'pointer-events:none;overflow:hidden;text-decoration:none';
    }
    return ghost;
  }
  function focusActive(list) {
    var c = list[active]; if (!c) return;
    var link = c.querySelector('.de-card__link');
    if (link) {
      try { link.focus({ preventScroll: true }); } catch (e) { link.focus(); }
      var href = link.getAttribute('href');
      if (document.activeElement !== link && href) {
        var g = ghostAnchor();
        g.setAttribute('href', href);
        if (g.parentNode !== c) c.appendChild(g);
        try { g.focus({ preventScroll: true }); } catch (e2) {}
      }
      /* Silent background load for the keyboard cursor, exactly how the
         dropdown rows do it: PREFETCH only, never prerender, so a card the
         buyer arrows past but never opens executes no page JS and fires no
         pixel or ad events. A card that is opened fires exactly one, as it
         always did. */
      try { if (href && window.__dxPreloadFn) window.__dxPreloadFn(href); } catch (e3) {}
    }
    // top row (a single item in list view) -> reveal the whole filter system
    var atTopRow = isListView() ? (active === 0) : (active < columnCount());
    keepInView(c, !keyHeld, atTopRow);
  }
  function typing(el) {
    if (!el) return false;
    var t = el.tagName;
    return t === 'INPUT' || t === 'SELECT' || t === 'TEXTAREA' || el.isContentEditable === true;
  }
  // Arrow keys belong to the product listing, not to the chrome around it. Focus
  // can land on a view toggle, Reset, a tier chip or a pager button - none of
  // which are form fields, so the `typing` check above does not catch them - and
  // the keys would have driven the cards instead of the control. Anything inside
  // the filter bar, the chips or the pager is off limits, and we return BEFORE
  // preventDefault so those controls keep their own native arrow behaviour (a
  // select changes option, the price slider moves).
  function inChrome(el) {
    if (!el || !el.closest) return false;
    /* .dx-pop / .dx-wrap are the custom dropdown's panel and mount. The panel is
       appended to <body> (it has to escape the bar's overflow), so it is NOT
       inside .de-filter-bar and was not matched here. While focus sat in the
       panel's search <input> the typing() guard above caught it, but once arrow
       keys began moving real focus onto the option rows (<a>, not an input),
       neither guard fired and the grid's card navigation ran at the same time as
       the dropdown's — arrowing through states also walked the product listing. */
    return !!el.closest('.de-filter-bar, .de-pattern-chips, .de-list-paginator, .dx-pop, .dx-wrap');
  }
  document.addEventListener('keydown', function (e) {
    if (e.metaKey || e.ctrlKey || e.altKey) return;
    var k = e.key;
    var isEnter = (k === 'Enter');
    if (!isEnter && k !== 'ArrowLeft' && k !== 'ArrowRight' && k !== 'ArrowUp' && k !== 'ArrowDown' && k !== 'Escape') return;
    if (typing(document.activeElement)) return;
    if (inChrome(document.activeElement) || inChrome(e.target)) return;
    if (!navigablePage()) return;
    keyHeld = !!e.repeat;
    var list = visibleCards(); if (!list.length) return;
    if (active >= list.length) active = -1;
    // Enter opens the highlighted card. Done explicitly rather than leaning on the
    // focused anchor's default action: focus does not stick here (activeElement
    // stays on BODY), so there is no link for the browser to activate.
    if (isEnter) {
      if (active < 0) return;
      var card = list[active];
      var a = card && card.querySelector('.de-card__link');
      var href = a && a.getAttribute('href');
      if (!href) return;
      e.preventDefault();
      window.location.href = href;
      return;
    }
    if (k === 'Escape') { active = -1; paint(list); hoverFresh = false; return; }
    e.preventDefault();
    // pick up from the last hovered card, when the pointer has moved to a new one
    if (hoverFresh && lastHovered) {
      var hi = list.indexOf(lastHovered);
      hoverFresh = false;
      if (hi >= 0) active = hi;
    }
    if (active < 0) {
      // start at whatever card is nearest the top of the viewport
      var best = 0, bestD = Infinity;
      for (var i = 0; i < list.length; i++) {
        var d = Math.abs(list[i].getBoundingClientRect().top - 100);
        if (d < bestD) { bestD = d; best = i; }
      }
      active = best;
      paint(list); focusActive(list); return;
    }
    /* The highlighted card may be far off screen — the buyer arrowed to a card,
       then scrolled somewhere else entirely (easy in list view at 200 rows).
       Stepping from it would yank the page back to wherever the cursor was left,
       which reads as the screen jumping for no reason. If it is no longer
       visible, restart from the card nearest the top of the viewport, exactly as
       a fresh press does. */
    if (list[active]) {
      var ar = list[active].getBoundingClientRect();
      if (ar.bottom < 0 || ar.top > window.innerHeight) {
        var rb = 0, rbD = Infinity;
        for (var ri = 0; ri < list.length; ri++) {
          var rd = Math.abs(list[ri].getBoundingClientRect().top - 100);
          if (rd < rbD) { rbD = rd; rb = ri; }
        }
        active = rb;
        paint(list); focusActive(list); return;
      }
    }
    var step;
    if (isListView()) {
      step = (k === 'ArrowUp' || k === 'ArrowLeft') ? -1 : 1;
    } else if (k === 'ArrowLeft') { step = -1; }
    else if (k === 'ArrowRight') { step = 1; }
    else { step = (k === 'ArrowUp' ? -columnCount() : columnCount()); }
    var next = active + step;
    if (next < 0 || next >= list.length) {
      // no row above/below, or past either end - stay put
      paint(list); focusActive(list); return;
    }
    active = next;
    paint(list); focusActive(list);
  });
  document.addEventListener('keyup', function (e) {
    if (e.key && e.key.indexOf('Arrow') === 0) keyHeld = false;
  }, true);
  // Claim keyboard focus for the listing on arrival, so the first arrow press
  // works without clicking the page first. Needed because the theme-preview URL
  // injects a full-viewport iframe (#PBarNextFrame) that holds focus - measured
  // document.hasFocus() === false on a fresh load - so arrows went to the preview
  // bar instead of the page. Only claims focus when nothing meaningful has it,
  // and with preventScroll so the page does not jump.
  function claimFocus() {
    if (!navigablePage()) return;
    var g = theGrid();
    if (!g) return;
    var a = document.activeElement;
    if (a && a !== document.body && a !== document.documentElement && a.tagName !== 'IFRAME') return;
    try {
      if (!g.hasAttribute('tabindex')) g.setAttribute('tabindex', '-1');
      g.focus({ preventScroll: true });
    } catch (e) {}
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(claimFocus, 60); });
  } else {
    setTimeout(claimFocus, 60);
  }
  window.addEventListener('load', function () { setTimeout(claimFocus, 60); });
  // clicking anywhere hands control back to the mouse
  document.addEventListener('mousedown', function () {
    if (active < 0) return;
    var list = visibleCards(); active = -1; paint(list);
  });
})();

/* =====================================================================
   15b. SEARCH RESULTS — FILTER BAR  (de-search-filters-2026-09-09)

   The collection's filter module (block 14) cannot be pointed at /search:
   picking a state there navigates to /collections/<state> and its sort
   re-fetches window.location.pathname with no `q`, so both would throw away
   the query the buyer just typed. On a search page the same controls have to
   REFINE the result set instead. Hence a separate module, keyed on
   [data-de-search-filter-bar] so block 14 never sees this bar.

   Division of labour:
     • Sort   — server side. /search?q=…&sort_by=… is honoured by Shopify
                (verified live: price-ascending returns $250 first,
                price-descending $32,000), so sorting covers ALL results,
                not just the page in the DOM.
     • State / area code / price — client side over the rendered cards, over
                the WHOLE result set: the deep scan below pulls every server
                page in at idle before the buyer touches anything.

   It drives the SAME contract the list paginator already reads, so paging
   over a filtered set works with no changes there:
     hidden attribute on non-matching cards
     data-de-filtered="1" on the grid while any filter is active
     data-de-filter-sig so a real change resets to page 1
     de:filterschanged when the filtered state flips, de:applied on each pass
   ===================================================================== */
(function () {
  function init() {
    var grid = document.querySelector('[data-de-product-grid]');
    var bar = document.querySelector('[data-de-search-filter-bar]');
    if (!grid || !bar || bar.__deSearchInit) return;
    bar.__deSearchInit = true;

    var stateSel = bar.querySelector('[data-de-filter="state"]');
    var areaSel = bar.querySelector('[data-de-filter="area"]');
    var sortSel = bar.querySelector('[data-de-filter="sort"]');
    var pMin = bar.querySelector('[data-de-price-min]');
    var pMax = bar.querySelector('[data-de-price-max]');
    var pMinL = bar.querySelector('[data-de-price-min-label]');
    var pMaxL = bar.querySelector('[data-de-price-max-label]');
    var pFill = bar.querySelector('[data-de-price-fill]');
    var resetBtn = bar.querySelector('[data-de-search-reset]');
    var countEl = document.querySelector('[data-de-search-count]');
    var AREA_CITY = window.DE_AREA_CITY || {};

    var params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
    var QUERY = params.get('q') || '';
    /* A partial phone query ("626-1") cannot be searched by Shopify directly —
       see block 15c. The form sends the searchable token as q and the full
       digit string here; every card must contain it as a substring. It is a
       permanent narrowing of this result set, not a control the buyer can
       clear, so it is applied on top of the filters rather than beside them. */
    var SUBDIGITS = (params.get('de_digits') || '').replace(/\D/g, '');
    /* de-search-qdigits-2026-09-14 — a digit search must actually contain the digits.
       Shopify returned three results for "500" that carry no 500 anywhere — not in
       the number, not in the tags:
           707-890-6888 · California    917-336-3789 · New York    989-989-8866 · Michigan
       (its matcher reaches into fields the buyer never sees). For a SINGLE-token
       digit query the rule is unambiguous: Shopify prefix-matches one title token,
       so a genuine hit always contains those digits contiguously, and anything that
       does not is noise. Deliberately limited to single-token queries — with
       separators ("212-9666") the tokens can match non-adjacent parts of the number
       and a contiguity test would throw away real results. */
    var QDIGITS = (function () {
      var q = (params.get('q') || '').trim();
      if (/^[0-9]+$/.test(q)) return q;
      /* de-search-qdigits-punct-2026-09-16 — a 5+ digit entry is rewritten into a
         searchable token before it reaches this page ("64665" -> q=646-65), and the
         bare digits-only test threw those away: no digit filter, no contains stream,
         and the page read "6 results for 646-65" when nine numbers hold 64665. The
         punctuation is ours, not the buyer's — strip it and treat it as what they
         typed. */
      if (/^[0-9][0-9\s().-]*$/.test(q)) return q.replace(/\D/g, '');
      return '';
    })();
    function prettyDigits(d) {
      if (!d) return '';
      if (d.length <= 3) return d;
      if (d.length <= 6) return d.slice(0, 3) + '-' + d.slice(3);
      return d.slice(0, 3) + '-' + d.slice(3, 6) + '-' + d.slice(6, 10);
    }
    var LABEL = SUBDIGITS ? prettyDigits(SUBDIGITS) : QUERY;
    var SKEY = 'deSearchFilters:' + QUERY;
    var TOTAL = parseInt(grid.getAttribute('data-de-products-count'), 10) || 0;
    var SERVER_PAGES = parseInt(grid.getAttribute('data-de-server-pages'), 10) || 1;
    var CUR_PAGE = parseInt(grid.getAttribute('data-de-server-page'), 10) || 1;

    /* de-cards-cache-2026-09-19 — a CPU profile of a "9999" load put **73% of all
       time in querySelectorAll** (19.0s of 26.0s sampled). This function is the
       reason: apply(), buildOptions(), sortVisible() and the pager each call it,
       apply() runs once per arriving batch, and ':scope > …' is re-evaluated
       against a grid holding well over a thousand cards every single time.

       Walking grid.children and testing classList is far cheaper than a :scope
       selector, and the result is cached until the child count changes — which is
       the only way cards enter or leave. */
    var _cardsCache = null, _cardsCount = -1;
    function cards() {
      var n = grid.childElementCount;
      if (_cardsCache && _cardsCount === n) return _cardsCache;
      var out = [], kids = grid.children;
      for (var i = 0; i < kids.length; i++) {
        var k = kids[i];
        if (k.classList && k.classList.contains('de-card--number')) out.push(k);
      }
      _cardsCache = out; _cardsCount = n;
      return out;
    }
    function cents(c) {
      if (c.__deC === undefined) c.__deC = parseInt(c.getAttribute('data-price-cents'), 10) || 0;
      return c.__deC;
    }

    /* ---------- price scale ----------------------------------------
       Endpoints track the live result set, never hardcoded — the same
       rule the collection slider follows. A log scale because the range
       is $250–$130,000: on a linear track every number under $2,000
       (the great majority of the catalogue) would sit inside the first
       2% of the rail and be unpickable. */
    var loC = 0, hiC = 0;
    function pctToCents(p) {
      if (!(hiC > loC) || loC <= 0) return loC;
      var t = Math.min(100, Math.max(0, p)) / 100;
      return Math.round(Math.exp(Math.log(loC) + t * (Math.log(hiC) - Math.log(loC))));
    }
    function centsToPct(v) {
      if (!(hiC > loC) || loC <= 0) return 0;
      var t = (Math.log(v) - Math.log(loC)) / (Math.log(hiC) - Math.log(loC));
      return Math.max(0, Math.min(100, Math.round(t * 100)));
    }
    /* de-search-price-scale-2026-09-14
       Moving the endpoints is only safe if the buyer's selection moves with
       them. The two thumbs hold PERCENTAGES of the current scale, so a scale
       that shifts underneath them silently re-prices what they chose — a
       $400 ceiling on a $250-$2,175 track becomes a $1,200 ceiling the moment
       the track narrows. So: read the selection out in CENTS against the old
       scale, move the scale, put it back as percentages of the new one. A thumb
       that was sitting at (or past) an end stays at that end, i.e. stays "open"
       rather than becoming a real constraint. */
    function setRange(lo, hi) {
      if (!isFinite(lo) || lo <= 0 || !(hi > 0) || hi < lo) return;
      if (lo === loC && hi === hiC) return;
      var full = priceIsFullRange();
      var selLo = full ? null : pctToCents(Math.min(+pMin.value, +pMax.value));
      var selHi = full ? null : pctToCents(Math.max(+pMin.value, +pMax.value));
      loC = lo; hiC = hi;
      sizePills();
      if (pMin && pMax) {
        if (selLo === null) { pMin.value = 0; pMax.value = 100; }
        else {
          pMin.value = selLo <= loC ? 0 : centsToPct(selLo);
          pMax.value = selHi >= hiC ? 100 : centsToPct(selHi);
        }
      }
    }
    function recomputeRange() {
      /* While a band is applied the cards on screen are a SUBSET by construction,
         so measuring them would shrink the track to the band and strand the buyer
         inside it — the exact fault above. The remembered full range stands. */
      if (deSNativeOn()) {
        var keep = deSRangeLoad();
        if (keep) { if (keep.lo < loC || !loC) loC = keep.lo; if (keep.hi > hiC) hiC = keep.hi; }
        return;
      }
      var all = cards(), lo = Infinity, hi = 0;
      for (var i = 0; i < all.length; i++) {
        var v = cents(all[i]);
        if (!v) continue;
        if (v < lo) lo = v;
        if (v > hi) hi = v;
      }
      if (isFinite(lo) && hi > 0) { setRange(lo, hi); deSRangeSave(loC, hiC); }
    }
    /* de-search-price-scale-2026-09-14 — the endpoints must describe what the
       buyer is ACTUALLY looking at, not the result set they started from.
       Reported: "the price slider ranges are inaccurate, which happens almost
       all the time". Measured live and checked against the catalogue rather
       than assumed:

           search "626"                352 numbers, truly $250-$2,175   slider $250-$2.2k   right
           search "626" + area 678       2 numbers, truly   $300-$300   slider $250-$2.2k   WRONG
           search "888" + Texas          9 numbers, truly   $300-$750   slider  $250-$14k   WRONG

       Both results cost $300 and the track still offered $250-$2,200, so ~97%
       of the rail pointed at nothing and any drag returned "no matches".

       Bounds come from the cards matching every filter EXCEPT price. That
       exclusion is what stops the old trapping bug: narrowing to $300-$400 can
       never shrink the track to $300-$400 and strand the buyer inside it,
       because the price selection is not an input to its own scale. Clearing a
       filter widens it straight back. */
    function rescaleToFiltered() {
      if (!pMin || !pMax) return;
      /* de-search-range-2026-09-16 — never re-scale to a SERVER-filtered page.

         This function exists to size the track to what the buyer is looking at,
         which is right when the narrowing is a client-side facet. It is wrong when
         Shopify applied a price band: the cards are then a price-bounded subset by
         construction, so measuring them moves the track's floor up to the band and
         the range below it becomes unreachable. Measured with min $680 applied to
         a search whose true floor is $250 — dragging the thumb fully left gave
         $680, not $250, so $250-$680 could not be selected again at all. */
      if (deSNativeOn()) {
        var keep = deSRangeLoad();
        if (keep) { if (keep.lo < loC || !loC) loC = keep.lo; if (keep.hi > hiC) hiC = keep.hi; paintPrice(); }
        return;
      }
      var wantState = stateSel ? stateSel.value : '';
      var wantArea = areaSel ? areaSel.value : '';
      var all = cards(), lo = Infinity, hi = 0;
      for (var i = 0; i < all.length; i++) {
        var c = all[i];
        if (SUBDIGITS && (c.getAttribute('data-digits') || '').indexOf(SUBDIGITS) < 0) continue;
        if (QDIGITS && (c.getAttribute('data-digits') || '').indexOf(QDIGITS) < 0) continue;
        if (wantState && cardState(c) !== wantState) continue;
        if (wantArea && (c.getAttribute('data-area') || '').trim() !== wantArea) continue;
        var v = cents(c);
        if (!v) continue;
        if (v < lo) lo = v;
        if (v > hi) hi = v;
      }
      /* An intersection that matches nothing ("Texas" + area 212) keeps the
         scale it had — collapsing it would leave nothing to widen back out. */
      if (!isFinite(lo) || !(hi > 0)) return;
      setRange(lo, hi);
      paintPrice();
    }
    function money(c) {
      var d = c / 100;
      if (d >= 1000) {
        var k = d / 1000;
        return '$' + (k >= 10 ? Math.round(k) : Math.round(k * 10) / 10) + 'k';
      }
      return '$' + Math.round(d);
    }
    /* de-rail-stable-2026-09-14 — pin the readout pills to the widest value this
       page can actually show, so the rail cannot be pushed sideways mid-drag.
       Sizing every pill to the catalogue-wide worst case ("$131.5k") would cost
       a short rail ~20px of travel, so it is measured per page: build every
       label the current scale can produce, measure the longest one once, and
       publish it as --de-pill-w. Re-run whenever the scale moves. */
    function sizePills() {
      if (!pMinL || !pMaxL) return;
      var widest = '', best = 0, i, s;
      for (i = 0; i <= 100; i++) { s = money(pctToCents(i)); if (s.length > best) { best = s.length; widest = s; } }
      var cs2 = window.getComputedStyle(pMinL);
      var probe = document.createElement('span');
      probe.textContent = widest;
      probe.style.cssText = 'position:absolute;left:-9999px;top:0;visibility:hidden;white-space:nowrap;' +
        'font:' + cs2.font + ';font-size:' + cs2.fontSize + ';font-weight:' + cs2.fontWeight +
        ';font-family:' + cs2.fontFamily + ';letter-spacing:' + cs2.letterSpacing + ';';
      document.body.appendChild(probe);
      var tW = probe.getBoundingClientRect().width;
      probe.parentNode.removeChild(probe);
      var w = Math.ceil(tW + (parseFloat(cs2.paddingLeft) || 0) + (parseFloat(cs2.paddingRight) || 0) +
                        (parseFloat(cs2.borderLeftWidth) || 0) + (parseFloat(cs2.borderRightWidth) || 0));
      if (w > 0) (bar.querySelector('[data-de-price-slider]') || bar).style.setProperty('--de-pill-w', w + 'px');
    }
    /* ═══ de-search-native-price-2026-09-16 ══════════════════════════════════
       Hand the band to Shopify on the search page too.

       Verified against the live index before wiring it: /search honours
       filter.v.price.gte/lte, a partition test (below X + at-or-above X) comes out
       exact, and — because the filter is applied BEFORE the result cap — it reaches
       results the plain search cannot: q=888 above $1,000 returns 666 where the
       unfiltered search stops at 1,000 of 1,260.

       This replaces client-side price filtering here, which had two visible faults
       found by stress-testing this page:
         • sorting LOST the band — q=9999 high-to-low came back with $14,000 cards
           in a band capped far below that, because the sort is a navigation and the
           band lived only in this module's slider;
         • the SERVER pager and the client pager were both on screen, disagreeing,
           since the server pager is only hidden once everything is loaded.
       A band in the URL survives the sort by construction, and the server pager
       becomes the correct one because the server really did the filtering. */
    var deSNat = (function () {
      try {
        var p2 = new URLSearchParams(window.location.search);
        var g2 = p2.get('filter.v.price.gte'), l2 = p2.get('filter.v.price.lte');
        if (g2 === null && l2 === null) return null;
        return { min: g2 === null ? null : parseFloat(g2), max: l2 === null ? null : parseFloat(l2) };
      } catch (e) { return null; }
    })();
    function deSNativeOn() { return !!deSNat; }
    /* de-search-range-2026-09-16 — the track must always span the WHOLE result set.

       Owner: "I search up 6, the min is $250, I drag min and set it to $750, but I
       cannot drag it back to $250."

       Exactly right, and it is this: after the band is applied the page contains
       only in-band cards, so recomputeRange() — which measures the cards on screen —
       rescaled the track to $680–$4.4k. Every thumb position except hard-zero then
       means ">= $680", and the $250–$680 span is simply gone from the control. The
       band had eaten the scale it was drawn on.

       So the unfiltered range is remembered per query the moment we are on a page
       that HAS no band (the only time it can be measured honestly), and restored
       whenever a band is active. Session-scoped and keyed by the query, so a
       different search measures its own range. */
    var deSRangeKey = 'deSearchRange:' + (function () {
      try { return new URLSearchParams(window.location.search).get('q') || ''; } catch (e) { return ''; }
    })();
    function deSRangeSave(loCents, hiCents) {
      if (deSNativeOn()) return;                       // a filtered page cannot measure it
      try { sessionStorage.setItem(deSRangeKey, JSON.stringify({ lo: loCents, hi: hiCents })); } catch (e) {}
    }
    function deSRangeLoad() {
      try {
        var raw = sessionStorage.getItem(deSRangeKey);
        if (!raw) return null;
        var v = JSON.parse(raw);
        return (v && v.lo > 0 && v.hi >= v.lo) ? v : null;
      } catch (e) { return null; }
    }
    function deSNativeGo(minC, maxC) {
      var u = new URL(window.location.href);
      u.searchParams.delete('filter.v.price.gte');
      u.searchParams.delete('filter.v.price.lte');
      if (minC !== null && minC !== undefined) u.searchParams.set('filter.v.price.gte', String(Math.round(minC / 100)));
      if (maxC !== null && maxC !== undefined) u.searchParams.set('filter.v.price.lte', String(Math.round(maxC / 100)));
      u.searchParams.delete('page');
      var next = u.toString();
      if (next === window.location.href) return;
      window.location.href = next;
    }
    function priceIsFullRange() {
      return (!pMin || +pMin.value <= 0) && (!pMax || +pMax.value >= 100);
    }
    function paintPrice() {
      if (!pMin || !pMax) return;
      var a = +pMin.value, b = +pMax.value;
      if (a > b) { var t = a; a = b; b = t; }
      if (pMinL) pMinL.textContent = money(pctToCents(a));
      if (pMaxL) pMaxL.textContent = money(pctToCents(b));
      /* de-pill-guard-2026-09-16 — the reservation must never be out-grown.
         sizePills() measures the widest label from the range KNOWN AT THE TIME, but
         the range moves (the deep scan widens it, a band re-seeds it), so a later
         value can be wider than what was reserved and the track shifts again —
         measured at 4.8-6.9px on search, about one character. After painting, if a
         label's own content is wider than the box reserved for it, raise the
         reservation. Self-correcting, settles in one step, only ever grows. */
      try {
        var _host = bar.querySelector('[data-de-price-slider]') || bar;
        var _cur = parseFloat(_host.style.getPropertyValue('--de-pill-w') || '0') || 0;
        var _need = Math.ceil(Math.max(pMinL ? pMinL.scrollWidth : 0, pMaxL ? pMaxL.scrollWidth : 0));
        if (_need > _cur) _host.style.setProperty('--de-pill-w', _need + 'px');
      } catch (e) {}
      if (pFill) {
        /* de-rail-instant-2026-09-14 — left + RIGHT, never left + width.
           Only `left` carried a CSS transition, so an eased left edge dragged
           the un-eased right edge along with it: measured with a real drag of
           the LEFT handle alone, the bar's right end swung to 358px on a 344px
           track before settling back. Binding each edge to its own handle makes
           dragging one physically unable to move the other. */
        pFill.style.left = a + '%';
        pFill.style.right = (100 - b) + '%';
        pFill.style.width = '';
      }
    }

    /* ---------- option lists ---------------------------------------
       Built from every loaded card. Because the deep scan runs at idle on
       load, "every loaded card" is the whole result set within a second or
       two of arriving — the lists no longer depend on which server page
       you happen to be standing on.

       Area codes are grouped by state and labelled "code — City", codes
       ascending inside each group: the exact format the collection bar and
       the homepage finder use, off the same window.DE_AREA_CITY map. */
    function buildOptions() {
      var all = cards(), st = {}, ar = {}, areaToState = {};
      for (var i = 0; i < all.length; i++) {
        var s = cardState(all[i]);
        var a = (all[i].getAttribute('data-area') || '').trim();
        if (s) st[s] = (st[s] || 0) + 1;
        if (a) {
          ar[a] = (ar[a] || 0) + 1;
          if (s && !areaToState[a]) areaToState[a] = s;
        }
      }
      /* Prefer the whole-catalogue answer when the index can give one — the counts
         beside each option then mean "numbers matching your search in this state",
         not "…among the ones downloaded so far". */
      var _f = indexFacets();
      if (_f) {
        st = _f.states; ar = _f.areas;
        areaToState = DE_META.areaToState;
      }
      if (stateSel) {
        var keep = stateSel.value;
        var html = '<option value="">All states</option>';
        Object.keys(st).sort().forEach(function (k) {
          html += '<option value="' + k.replace(/"/g, '&quot;') + '">' +
                  k.replace(/</g, '&lt;') + ' (' + st[k] + ')</option>';
        });
        stateSel.innerHTML = html;
        stateSel.value = keep;
        if (stateSel.value !== keep) stateSel.value = '';
      }
      if (areaSel) {
        var keepA = areaSel.value;
        Array.prototype.slice.call(areaSel.querySelectorAll('optgroup')).forEach(function (g) { g.remove(); });
        while (areaSel.options.length > 1) areaSel.remove(1);
        var byState = {};
        Object.keys(ar).forEach(function (a) {
          var s2 = areaToState[a] || '';
          (byState[s2] = byState[s2] || []).push(a);
        });
        function addOpt(parent, a, s2) {
          var opt = document.createElement('option');
          opt.value = a;
          var city = AREA_CITY[a];
          opt.textContent = (city ? (a + ' — ' + city) : a) + ' (' + ar[a] + ')';
          opt.setAttribute('data-state', s2 || '');
          parent.appendChild(opt);
        }
        Object.keys(byState).filter(function (s2) { return s2; }).sort().forEach(function (s2) {
          var og = document.createElement('optgroup');
          og.label = s2;
          byState[s2].sort(function (x, y) { return parseInt(x, 10) - parseInt(y, 10); })
            .forEach(function (a) { addOpt(og, a, s2); });
          areaSel.appendChild(og);
        });
        (byState[''] || []).sort(function (x, y) { return parseInt(x, 10) - parseInt(y, 10); })
          .forEach(function (a) { addOpt(areaSel, a, ''); });
        areaSel.value = keepA;
        if (areaSel.value !== keepA) areaSel.value = '';
        refilterAreasByState(stateSel ? stateSel.value : '');
      }
    }

    /* Choosing a state collapses the area list to that state's codes —
       same behaviour as the collection bar. */
    function refilterAreasByState(stateName) {
      if (!areaSel) return;
      Array.prototype.forEach.call(areaSel.querySelectorAll('option'), function (o) {
        if (!o.value) return;
        var s = o.getAttribute('data-state') || '';
        o.hidden = !(!stateName || s === stateName);
      });
      Array.prototype.forEach.call(areaSel.querySelectorAll('optgroup'), function (g) {
        g.hidden = !!stateName && g.label !== stateName;
      });
      if (areaSel.value) {
        var sel = areaSel.querySelector('option[value="' + areaSel.value + '"]');
        if (sel && sel.hidden) areaSel.value = '';
      }
    }

    /* ---------- apply --------------------------------------------- */
    function filterSig() {
      /* de-sig-stable-2026-09-19 — describe the BUYER's choice, not the widget's.

         This used to be the slider's raw percentages. Those are relative to the
         price range of the cards currently LOADED, and that range moves as results
         stream in — rescaleToFiltered() then rewrites the percentages to keep the
         same band on screen. So the signature changed while nothing the buyer had
         chosen changed, and the list paginator reads a changed signature as "they
         refined the filter, go back to page 1".

         Measured: jumping to page 8 of q=29 fetched its way up through
         "1401-1600 of 2200" and then snapped back to page 1 the instant the last
         batch landed. The buyer asked for page 8 and was dumped on page 1.

         Comparing the band in whole dollars instead makes a pure rescale a no-op,
         which is exactly what it is — and rounding absorbs the cent-level jitter
         that moving the scale introduces. */
      var band;
      if (priceIsFullRange()) band = 'full';
      else {
        var a = pMin ? +pMin.value : 0, b = pMax ? +pMax.value : 100;
        if (a > b) { var t = a; a = b; b = t; }
        band = Math.round(pctToCents(a) / 100) + '-' + Math.round(pctToCents(b) / 100);
      }
      return [stateSel ? stateSel.value : '', areaSel ? areaSel.value : '', band].join('|');
    }
    function anyFilterActive() {
      // SUBDIGITS counts: the paginator pages the MATCHING cards only while
      // data-de-filtered is set, so without this a refined page would still
      // page the server's whole result set and show blanks.
      return !!(SUBDIGITS || QDIGITS || stateQ() || (stateSel && stateSel.value) ||
                (areaSel && areaSel.value) ||
                (!priceIsFullRange() && !deSNativeOn()));
    }
    function apply() {
      /* Before anything reads the thumbs: the scale they are percentages OF may
         be describing a set the buyer has already narrowed away. */
      rescaleToFiltered();
      var all = cards();
      var wantState = stateSel ? stateSel.value : '';
      var wantArea = areaSel ? areaSel.value : '';
      var a = pMin ? +pMin.value : 0, b = pMax ? +pMax.value : 100;
      if (a > b) { var t = a; a = b; b = t; }
      var full = priceIsFullRange();
      var lo = full ? -Infinity : pctToCents(a);
      var hi = full ? Infinity : pctToCents(b);
      var shown = 0;
      var _ctx = { wantState: wantState, wantArea: wantArea, stateQuery: stateQ(),
                   full: full, lo: lo, hi: hi };
      for (var i = 0; i < all.length; i++) {
        var c = all[i], ok = cardPasses(c, _ctx);
        if (ok) { c.removeAttribute('hidden'); shown++; }
        else c.setAttribute('hidden', '');
      }
      var active = anyFilterActive();
      /* de-sort-before-pager-2026-09-16 — ORDER FIRST, then page.

         The paginator lives in another module and re-pages on de:applied /
         de:filterschanged, which were fired here BEFORE sortVisible() ran. So it
         chose its 200 from the pre-sort DOM and the reorder then shuffled cards
         it had already hidden. Measured on "888": 2,121 matching numbers loaded,
         the best-ranked ones (888 filling a whole group) all sat on page 2+, and
         page 1 was 198 numbers with 888 adrift mid-group. The grid looked sorted —
         every visible card was in order — it was just the wrong 200 cards. */
      /* de-sort-at-settle-2026-09-19 — reorder once things stop arriving.

         sortVisible() re-appends EVERY shown card to put it in rank order (up to
         1,800 DOM moves) and apply() runs on every batch that lands. Profiling a
         scroll during load blamed **447ms of appendChild on sortVisible** — the
         single largest JS cost, and the reason scrolling stuttered while results
         filled in. Cards are fetched in rank order and arrive paged-out, so the
         deferred sort changes nothing visible; it just stops happening under the
         user's finger. */
      if (!_flushQueued && !_scrolling && !(CST && CST.busy)) sortVisible();
      else if (!_sortPending) {
        /* Re-defer rather than fire on the first gap between wheel ticks. The
           earlier version ran the moment _scrolling happened to be clear, which
           during streaming meant re-appending ~1,800 cards mid-scroll — 333ms of
           appendChild, straight back into the frame budget. */
        _sortPending = true;
        (function waitIdle(tries) {
          setTimeout(function () {
            if (_scrolling || _flushQueued || (CST && CST.busy)) {
              if (tries > 0) return waitIdle(tries - 1);
              _sortPending = false; return;
            }
            _sortPending = false;
            sortVisible(); applyPagerOnly();
          }, 400);
        })(12);
      }
      /* de-hint-scope-2026-09-17 — the true-match hint describes the DIGITS ONLY.

         The paginator uses it to offer pages the loader has not reached yet, which
         is right for a bare digit search. The moment another control narrows the
         set — a state, an area code, a price band — that figure stops describing
         what is on the page: narrowing "6" to California would still have offered
         49 pages of 9,787 while a few hundred numbers matched. So the hint only
         stands while the digits are the only filter; otherwise the pager goes back
         to counting what it can actually see. */
      var narrowedBeyondDigits = !!((stateSel && stateSel.value) || (areaSel && areaSel.value) ||
                                    (!priceIsFullRange() && !deSNativeOn()) || deSNat);
      FACET_TOTAL = facetTotal();
      try {
        /* The pager can span the faceted set too, now that its size is known
           exactly — narrowing to a state no longer strands the rest behind a
           pager that only counts what was downloaded. */
        var _facetOnly = !!allowedAreas() &&
            !((!priceIsFullRange() && !deSNativeOn()) || deSNat);
        /* de-hint-knows-the-band-2026-09-20 — the pager may span a PRICE-narrowed
           set too, now that the price index exists.

           The rule below was written when the index held digits and nothing else,
           so any price narrowing forced the pager back to counting the cards it
           had actually downloaded. Dragging the slider on /search?q=8 to $250-$841
           left a pager reading "1-200 of 885" beside a row reading
           "Showing 1-200 of 8,970" — both from the same page, and 8,085 matches
           with no route to them.

           indexTotal() answers query + state + area + band exactly and instantly,
           so when it can answer, it IS the hint. The older reasoning stays as the
           fallback for the cases it cannot judge (a word query, an index still
           loading). */
        var _it = indexTotal();
        var newHint = (_it != null) ? _it
                    : (FACET_TOTAL != null && _facetOnly) ? FACET_TOTAL
                    : (CONTAINS_TOTAL != null && !narrowedBeyondDigits) ? CONTAINS_TOTAL : 0;
        if (window.__deFilteredTotalHint !== newHint) {
          window.__deFilteredTotalHint = newHint;
          /* The paginator lives in another module and, in desktop grid view, skips
             its de:applied re-render. So when the figure it pages by changes, say so
             in the one event it always acts on — otherwise picking a state left the
             old row on screen ("1–200 of 9,787 · 49 pages") over sixteen results. */
          document.dispatchEvent(new CustomEvent('de:filterschanged'));
        }
      } catch (e) {}
      var was = grid.getAttribute('data-de-filtered') === '1';
      if (active !== was) {
        if (active) grid.setAttribute('data-de-filtered', '1');
        else grid.removeAttribute('data-de-filtered');
        try { document.dispatchEvent(new CustomEvent('de:filterschanged')); } catch (e) {}
      }
      grid.setAttribute('data-de-filter-sig', (sortSel ? sortSel.value : 'default') + '~' + filterSig());
      if (active) { try { document.dispatchEvent(new CustomEvent('de:applied')); } catch (e) {} }
      paintCount(active ? shown : 0, active);
      paintHeading(shown);
      paintEmpty(shown === 0 && (active || !!SUBDIGITS));
      paintPager(shown);
      save();
    }

    /* de-search-phonesort-2026-09-14 — "Phone: ascending/descending" did nothing here.
       The sort is handed to Shopify as title-ascending / title-descending, which it
       honours on a collection but IGNORES on /search. Verified against the live
       index, first four results for q=500:

           relevance          5205001688  4755003000  5855006666  5205009666
           title-ascending    5205001688  4755003000  5855006666  5205009666   <- identical
           title-descending   5205001688  4755003000  5855006666  5205009666   <- identical
           price-ascending    5205001688  7185003878  8605001688  8085005599   <- honoured

       So both phone options were dead controls. Price stays server-side (it works,
       and it covers every result, not just the ones loaded). Phone is ordered here
       instead, over the deep-scanned set. The monotonic pre-check keeps repeat
       apply() passes free — only a genuinely out-of-order grid is touched. */
    function sortVisible() {
      var mode = sortSel ? sortSel.value : 'default';
      var isPrice = (mode === 'price-asc' || mode === 'price-desc');
      /* Price ordering is Shopify's job and it does it over every result, not just
         the loaded ones — so leave it alone on a plain search. But a contains
         stream mixes in numbers the server never ranked, and they arrive in title
         order: "9999" under Price: low to high put $14,000 fourteenth, ahead of
         $1,450. Once streamed cards are present the order has to be settled here. */
      var mixed = isPrice && !!grid.querySelector('[data-de-contains]');
      /* Relevance ("default") has to be ordered here too. Shopify ranked only the
         handful of rows it could find; every number the contains stream brought in
         is unranked, so without this the grid is catalogue order and a buyer who
         typed "6" is shown 929-565-5577 first. */
      /* Not conditional on streamed cards. Shopify's own ordering for a digit query
         is no better than catalogue order: "73" returned 550 rows with 95 numbers
         in the 73x area code among them, and led with 206-737-3388 — a 73 buried
         mid-number — because nothing had ranked them. If the buyer typed digits and
         the index is up, this decides the order. */
      var rel = (mode === 'default') && CQ() && window.__deDigitIndex &&
                !!window.__deDigitIndex.peek();   // digits only: a state listing has no rank
      if (!mixed && !rel && mode !== 'phone-asc' && mode !== 'phone-desc') return;
      var shown = cards().filter(function (c) { return !c.hasAttribute('hidden'); });
      if (shown.length < 2) return;
      if (rel) {
        // Includes cards the paginator has paged out — they are candidates for
        // page 1 once ranked, which is the entire point.

        var idxR = window.__deDigitIndex, qR = CQ();
        // Score ONCE per card and reuse for both the ordered-check and the sort;
        // the comparator was recomputing it on every comparison.
        var sc = new Array(shown.length);
        for (var r0 = 0; r0 < shown.length; r0++) sc[r0] = idxR.score(cardDigits(shown[r0]), qR);
        var okR = true;
        for (var r1 = 1; r1 < shown.length; r1++) if (sc[r1 - 1] > sc[r1]) { okR = false; break; }
        if (okR) return;
        var keyed = shown.map(function (c, n) { return { c: c, s: sc[n], n: n }; });
        keyed.sort(function (a, b) { return a.s !== b.s ? a.s - b.s : a.n - b.n; });
        var fragR = document.createDocumentFragment();
        for (var r2 = 0; r2 < keyed.length; r2++) fragR.appendChild(keyed[r2].c);
        grid.appendChild(fragR);
        return;
      }
      if (mixed) {
        var ascP = (mode === 'price-asc');
        var okP = true;
        for (var q1 = 1; q1 < shown.length; q1++) {
          if (ascP ? cents(shown[q1 - 1]) > cents(shown[q1]) : cents(shown[q1 - 1]) < cents(shown[q1])) { okP = false; break; }
        }
        if (okP) return;
        shown.sort(function (a, b) { return ascP ? cents(a) - cents(b) : cents(b) - cents(a); });
        var fragP = document.createDocumentFragment();
        for (var q2 = 0; q2 < shown.length; q2++) fragP.appendChild(shown[q2]);
        grid.appendChild(fragP);
        return;
      }
      var asc = mode === 'phone-asc';
      var dig = function (c) { return c.getAttribute('data-digits') || ''; };
      var ordered = true;
      for (var i = 1; i < shown.length; i++) {
        if (asc ? dig(shown[i - 1]) > dig(shown[i]) : dig(shown[i - 1]) < dig(shown[i])) { ordered = false; break; }
      }
      if (ordered) return;
      shown.sort(function (a, b) {
        var x = dig(a), y = dig(b);
        return x === y ? 0 : (x < y ? -1 : 1) * (asc ? 1 : -1);
      });
      var frag = document.createDocumentFragment();
      for (var j = 0; j < shown.length; j++) frag.appendChild(shown[j]);
      grid.appendChild(frag);
    }

    /* Filters can intersect to nothing — "Texas" + area code "212" is a
       legitimate thing to pick and returns zero. Without this the grid just
       empties and the page looks broken. Built here rather than in the
       section markup so there is nothing to render when it is not needed. */
    var emptyEl = null;
    function paintEmpty(show) {
      if (!show) { if (emptyEl) emptyEl.hidden = true; return; }
      if (!emptyEl) {
        emptyEl = document.createElement('div');
        emptyEl.className = 'de-searchX__nofilter';
        emptyEl.setAttribute('role', 'status');
        emptyEl.style.cssText = 'padding:34px 18px;text-align:center;';
        emptyEl.innerHTML =
          '<div style="font-weight:700;font-size:1.05rem;margin-bottom:6px;">No numbers match these filters</div>' +
          '<div style="opacity:.7;font-size:.95rem;margin-bottom:14px;">Try a wider price range, or clear one of the filters.</div>';
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'de-filter__reset de-filter__reset--inline';
        b.textContent = 'Clear filters';
        b.addEventListener('click', function () {
          var r = bar.querySelector('[data-de-search-reset]');
          if (r) r.click();
        });
        emptyEl.appendChild(b);
        grid.parentNode.insertBefore(emptyEl, grid.nextSibling);
      }
      emptyEl.hidden = false;
    }

    /* de-one-total-2026-09-19 — the headline and the row are ONE number.

       Owner: "the match count should sync up with whatever filter combinations are
       made… I noticed that when I used the price slider, for a split second the
       match count actually did sync up, before returning to 453 matches."

       Exactly the bug: paintCount() had been taught about the facet total while
       paintHeading() still quoted CONTAINS_TOTAL, so the big number — the one you
       actually read — stayed at the unfiltered figure. Both now come from here.

       Price is the one filter the index cannot answer: it knows every number's
       digits, not its price. So while a band is active the count is whatever we can
       currently see, and it says so with a "+" until the whole match set is loaded
       and the figure becomes exact. */
    /* de-instant-total-2026-09-19 — the whole result set, counted from the
       catalogue instead of from whatever has been fetched so far.

       Every filter the page offers is answerable without a single product card:
       the query and both dropdowns reduce to the digits themselves, and the band
       reduces to the price index. One pass over 16,298 strings (~3ms) settles
       any combination of them. Returns null — and the caller keeps its old
       behaviour — when it cannot answer honestly: no digit or state query to
       anchor on, an index still loading, or a price snapshot that has drifted too
       far from the live catalogue to quote.

       Deliberately mirrors cardPasses() field for field. If one of them gains a
       filter the other must too, or the headline and the grid will disagree. */
    var _itKey = null, _itVal = null;
    function indexTotal() {
      var P = queryPredicate();
      if (!P || !DE_META || !window.__deDigitIndex) return null;
      var all = window.__deDigitIndex.peek();
      if (!all || !all.length) return null;
      var x = filterCtx();
      /* A band Shopify applied itself wins: under native filtering the thumbs are
         not rescaled, so the slider's own lo/hi describe nothing. */
      var band = null;
      if (deSNat) {
        band = [deSNat.min !== null && !isNaN(deSNat.min) ? Math.round(deSNat.min * 100) : -Infinity,
                deSNat.max !== null && !isNaN(deSNat.max) ? Math.round(deSNat.max * 100) : Infinity];
      } else if (!x.full) {
        band = [x.lo, x.hi];
      }
      var pa = null;
      if (band) {
        if (!window.__dePriceIndex) return null;
        pa = window.__dePriceIndex.align(all);
        if (!pa) return null;
      }
      var key = P.kind + ':' + P.q + '|' + x.wantState + '|' + x.wantArea + '|' +
                x.stateQuery + '|' + (band ? band[0] + '~' + band[1] : 'x') + '|' +
                all.length + '|' + (QDIGITS || '') + '|' + (SUBDIGITS || '');
      if (_itKey === key) return _itVal;
      var n = 0, unknown = 0, a2s = DE_META.areaToState;
      for (var i = 0; i < all.length; i++) {
        var d = all[i];
        if (P.kind === 'digits') {
          /* Both can be set at once — "626-1" arrives as a rewritten token — and
             the grid demands both, so the count must as well. */
          if (QDIGITS && d.indexOf(QDIGITS) < 0) continue;
          if (SUBDIGITS && d.indexOf(SUBDIGITS) < 0) continue;
          if (!QDIGITS && !SUBDIGITS && !P.keep(d)) continue;
        } else if (!P.keep(d)) continue;
        var a = d.slice(0, 3);
        if (x.wantArea && a !== x.wantArea) continue;
        var st = a2s[a];
        if (x.stateQuery && st !== x.stateQuery) continue;
        if (x.wantState && st !== x.wantState) continue;
        if (band) {
          var v = pa[i];
          if (v < 0) { unknown++; continue; }
          if (v < band[0] || v > band[1]) continue;
        }
        n++;
      }
      /* The same tolerance the stream uses for index drift. A handful of numbers
         sold since the snapshot cannot move a count anybody would notice; a
         snapshot that has properly fallen behind must not be quoted at all. */
      if (unknown > 50) { _itKey = key; _itVal = null; return null; }
      _itKey = key; _itVal = n;
      return n;
    }

    /* de-instant-total-2026-09-19 — the headline is computed, never accumulated.

       Owner: "i want it to feel instant and seamless, instead of waiting for the
       count to go up". With a price band in play the number used to be whatever
       had been FETCHED, because prices only existed on rendered cards — so it
       climbed for ~20s wearing a "+" until the stream finished. Now fetching
       fills the grid and nothing else; it stopped being what the count is made
       of, and the answer is whole from the first frame. */
    /* de-no-downgrade-2026-09-19 — never replace a known answer with a guess.

       The inline script in de-search.liquid works the total out before this
       bundle has even been requested, and for the first moments afterwards it
       knows MORE than the bundle does: DE_META is still in flight, so
       indexTotal() cannot answer and the old floor logic took over. Measured on
       q=29 with a band: "1,450 matches" at 88ms, "0+ matches" at 133ms, "1,450"
       again at 1.5s — the page correcting itself back to where it started, which
       is exactly the flicker the whole change exists to remove.

       The seed is only good while the page still asks the question it was
       computed for: no dropdown narrowing, and the same band. Touch either and it
       is discarded rather than trusted. */
    function seedTotal() {
      var s = window.__deInstantCount;
      if (!s || !s.ok || s.n == null) return null;
      if (stateSel && stateSel.value) return null;
      if (areaSel && areaSel.value) return null;
      /* Under a native band the thumbs are inert, so the URL is still the band.
         Otherwise the seed assumed no band at all and the slider must be idle. */
      if (!deSNat && !priceIsFullRange()) return null;
      return s.n;
    }

    function headlineTotal(shown) {
      var exact = indexTotal();
      if (exact != null) return { n: exact, floor: false, exact: true };
      var seeded = seedTotal();
      if (seeded != null) return { n: seeded, floor: false, exact: true };
      var priceNarrow = (!priceIsFullRange() && !deSNativeOn()) || !!deSNat;
      var base = (FACET_TOTAL != null) ? FACET_TOTAL
               : (CONTAINS_TOTAL != null) ? CONTAINS_TOTAL : TOTAL;
      if (!priceNarrow) return { n: base, floor: false, exact: true };
      var everything = !!(CST && CST.done) || (CST && CST.want &&
                        CST.cursor >= CST.want.length);
      return { n: shown, floor: !everything, exact: !!everything };
    }

    var _lastShown = 0, _lastActive = false, _pageGeo = null;
    document.addEventListener('de:paged', function (e) {
      if (e && e.detail && e.detail.page > 0) _pageGeo = e.detail;
      try { paintCount(_lastShown, _lastActive); } catch (err) {}
    });
    function paintCount(shown, active) {
      if (!countEl) return;
      _lastShown = shown; _lastActive = active;
      var tail = ' result' + (shown === 1 ? '' : 's') + (LABEL ? ' for “' + LABEL + '”' : '');
      // With a substring refinement the server's total is meaningless to the
      // buyer — they asked for "626-1", not for all 365 numbers in area 626.
      if (SUBDIGITS && CONTAINS_TOTAL == null && indexTotal() == null && seedTotal() == null) {
        countEl.textContent = shown.toLocaleString() + tail; return;
      }
      var ht = headlineTotal(shown);
      var TOT = ht.n, plus = ht.floor ? '+' : '';
      var t2 = ' result' + (TOT === 1 ? '' : 's') + (LABEL ? ' for “' + LABEL + '”' : '');
      /* de-row-says-the-page-2026-09-20 — say where the buyer IS, not how far the
         loader has got.

         Owner, on "1,058 of 11,231 results for “8”": "where does that 1,058 come
         from so confused, what…". Fair — 1,058 was how many cards had been fetched
         at that instant. It is loader progress. It is not a fact about his search,
         it changes while he reads it, and it means nothing next to the 11,231 in
         the heading directly above.

         What is worth saying at the top of a result set is which slice of it he is
         looking at — the same thing the pager says at the bottom, and the same two
         numbers the heading uses. */
      var lp = _pageGeo ? _pageGeo.page : 0;
      var ll = _pageGeo ? _pageGeo.per : 0;
      if (lp > 0 && ll > 0 && TOT > ll) {
        var a = (lp - 1) * ll + 1;
        var b = Math.min(lp * ll, TOT);
        if (b >= a) {
          countEl.textContent = 'Showing ' + a.toLocaleString() + '\u2013' + b.toLocaleString() +
            ' of ' + TOT.toLocaleString() + plus +
            (LABEL ? ' for \u201C' + LABEL + '\u201D' : '');
          return;
        }
      }
      countEl.textContent = (TOT === 0 && !plus)
        ? ('No results for \u201C' + LABEL + '\u201D')
        : (TOT.toLocaleString() + plus + t2);
    }
    /* The <h1> and the box still show the token the server was given. Correct
       both to what was actually typed. */
    function paintHeading(shown) {
      /* de-search-heading-2026-09-16 — the <h1> quoted Shopify's tally while the row
         beneath it quoted ours: "171 matches for “6”" directly above "390 of 9,789
         results for “6”". Two totals for one query on one screen. The index figure
         is the true one, so the heading uses it. */
      if (CONTAINS_TOTAL != null) {
        var ht2 = headlineTotal(shown);
        var nH = ht2.n, plusH = ht2.floor ? '+' : '';
        var hC = document.querySelector('.de-searchX__title');
        /* de-zero-reads-as-none-2026-09-22 — "0 matches for “626-123”" is a
           number where a sentence belongs. The parse-time script already writes
           "No matches for …" and then this overwrote it, so which wording a buyer
           saw depended on which ran last. Say it once, the same way, and swap the
           subhead for the one that actually helps from here. */
        if (hC) hC.textContent = (nH === 0 && !plusH)
          ? ('No matches for “' + LABEL + '”')
          : (nH.toLocaleString() + plusH + ' match' +
             (nH === 1 && !plusH ? '' : 'es') + ' for “' + LABEL + '”');
        if (nH === 0 && !plusH) {
          try {
            var sub0 = document.querySelector('.de-searchX__subhead');
            if (sub0) sub0.textContent =
              'Try an area code (415), state (Texas), or digit pattern (8888).';
          } catch (e0) {}
        }
        try { document.title = 'Search: ' + nH + ' results found for "' + LABEL + '"'; } catch (e) {}
        if (!SUBDIGITS) return;
      }
      if (!SUBDIGITS) return;
      var h = document.querySelector('.de-searchX__title');
      if (h && CONTAINS_TOTAL == null) h.textContent = (shown === 0)
        ? ('No matches for “' + LABEL + '”')
        : (shown.toLocaleString() + ' match' + (shown === 1 ? '' : 'es') + ' for “' + LABEL + '”');
      var box = document.querySelector('.de-searchX__input');
      if (box && box.value === QUERY) box.value = LABEL;
      try { document.title = 'Search: ' + shown + ' results found for "' + LABEL + '"'; } catch (e) {}
    }

    /* ---------- the pager row --------------------------------------
       de-search-pager-truth-2026-09-09

       Two things were wrong in GRID view, both because the server pager
       describes a world that no longer exists once every result has been
       pulled into the page:

         • Unfiltered it read "1-1000 of 1000 ... Page _ of 5". All 1,000 are
           already on screen, so pages 2-5 lead nowhere new.
         • Filtered to California it still offered those same 5 pages — that
           is the math for the UNFILTERED 1,000 — while showing 217 cards and
           no count at all, because the view module deliberately hides its
           readout whenever a filter is on (server-page maths is meaningless
           over a filtered subset).

       So: once the page genuinely holds every result, the server pager goes
       away and a truthful count takes its place. The guard is
       cards().length >= TOTAL, not a "scan finished" flag — if the scan half
       failed, the pager stays so nothing is stranded out of reach.

       List view is untouched: its client paginator already pages the matching
       set and prints its own honest "1-25 of 217".
    */
    var countRow = null;
    function ensureCountRow() {
      if (countRow && countRow.isConnected) return countRow;
      countRow = document.createElement('div');
      // Deliberately NOT .de-collection__pagination: the view module adopts
      // the first element with that class and injected its "Page _ of 5 Go"
      // jumper straight into this row — the very server-page number this is
      // here to replace.
      countRow.className = 'de-search-countrow';
      countRow.setAttribute('data-de-search-countrow', '');
      countRow.setAttribute('role', 'status');
      var s = document.createElement('span');
      s.className = 'de-search-countrow__text';
      countRow.appendChild(s);
      grid.parentNode.insertBefore(countRow, grid.nextSibling);
      return countRow;
    }
    function paintPager(shown) {
      var srv = document.querySelector('.de-collection__pagination');
      /* ONE pager, always. Which one depends on who is actually narrowing:

           client-side narrowing (a digit query, a state or area pick) -> the client
             pager owns it; the server pager describes a different, wider set and
             was the second contradictory row in the screenshot ("1-200 of 535,
             page 1 of 3" beside "1 2 3 ... 82").
           otherwise (plain results, or a native price band the SERVER applied) ->
             the server pager is the accurate one and the client pager stands down.

         List view is exempt: there the client pager always owns the page, which is
         what the Show 25/50/100/200 control means. */
      var clientNarrow = !!(SUBDIGITS || QDIGITS || stateQ() ||
                            (stateSel && stateSel.value) || (areaSel && areaSel.value));
      var isListView = grid.getAttribute('data-de-view') === 'list';
      /* de-loaded-is-not-shown-2026-09-20 — "everything is loaded" used to hide the
         server pager too, on the reasoning that if the client holds every result
         there is nothing left to page to. That stopped being true the moment scan
         appends started arriving OFF-PAGE: /search?q=gold loads all 1,000 results
         but browse mode shows only its 200, so hiding the pager left the other 800
         with no route to them at all — no client pager either, because nothing is
         narrowing. In browse mode the server pager is always the accurate one. */
      if (srv) srv.style.display = (clientNarrow || isListView) ? 'none' : '';
      var lp2 = document.querySelector('.de-list-paginator');
      /* Inline display is not enough here: a stylesheet rule carries !important, so
         `style.display = 'none'` computed back to `block` and the row stayed on
         screen. Set the priority explicitly, and remove the property (rather than
         assigning '') when showing it again, or the important sticks. */
      if (lp2 && !isListView) {
        if (clientNarrow) lp2.style.removeProperty('display');
        else lp2.style.setProperty('display', 'none', 'important');
      }
      /* de-pager-truth-2026-09-17 — the client pager must never describe a wider set
         than the one on screen.

         It sizes itself from the digit-match hint, which is right for a bare digit
         search. Narrow that search with a state and the hint is cleared, but the
         pager kept its previous row: "1–200 of 1,573 · Page 1 of 8" above sixteen
         Alabama numbers. Its own re-render does not reliably run in desktop grid
         view, and rather than reach into that module, the page that owns this view
         states the truth: when everything that matches now fits on one page, there
         is nothing to page through. */
      if (lp2 && clientNarrow && !isListView) {
        var limitAttr = parseInt(grid.getAttribute('data-de-list-limit'), 10) || 0;
        if (limitAttr > 0) {
          var matchNow = grid.querySelectorAll(':scope > .de-card.de-card--number:not([hidden])').length;
          var hintNow = 0;
          try { hintNow = window.__deFilteredTotalHint || 0; } catch (e) {}
          if (Math.max(matchNow, hintNow) <= limitAttr) {
            lp2.style.setProperty('display', 'none', 'important');
          }
        }
      }

      var isList = grid.getAttribute('data-de-view') === 'list';
      // Under 640px the view module paginates the GRID too (50 at a time), so
      // its paginator owns the readout there just as it does in list view.
      // Without this the row claimed "1-1,000 of 1,000" on a phone while 50
      // cards were on screen, directly contradicting the pager beside it —
      // caught by testing at 390px, not by reasoning about it.
      var mobilePaging = false;
      try { mobilePaging = window.matchMedia('(max-width: 640px)').matches; } catch (e) {}
      var row = ensureCountRow();
      // In list view the client paginator carries its own count; a second one
      // here would be a contradiction waiting to happen.
      /* de-one-countrow-2026-09-17 — clientNarrow belongs in this list for exactly
         the same reason. Whenever the CLIENT pager owns paging (any digit query
         does), it prints its own "1–200 of 543" — and this row printed "1–543 of
         543" directly beneath it. Owner's screenshot of q=4 caught both: "1–12 of
         12" above "1–69 of 69". One row, one owner: if the client pager is paging,
         this one stays out of the way. */
      if (isList || mobilePaging || clientNarrow || !everythingLoaded) { row.style.display = 'none'; return; }
      row.style.display = '';
      var n = (typeof shown === 'number' && anyFilterActive())
        ? shown
        : cards().length;
      row.firstChild.textContent = '1\u2013' + n.toLocaleString() + ' of ' + n.toLocaleString();
    }


    /* ---------- contains-stream (de-search-contains-2026-09-16) -------
       Shopify cannot answer a digit fragment. It tokenises "201-205-9999" into
       201 / 205 / 9999 and prefix-matches whole tokens, so digits sitting across
       a group boundary or mid-group are invisible to it. Measured live:

           "37"  2 products returned, NEITHER containing 37     (774 do)
           "27"  1 genuine match on the page                    (990 do)
           "29"  0 returned                                     (2,202 do)
           "124" 0 returned                                     (9 do)

       A buyer typing digits is asking one question — "which numbers have these
       digits in them" — and the store knows the answer for every one of them.
       So rather than send them somewhere else, bring the missing numbers here.

       window.__deDigitIndex holds every number we sell, sorted. Titles ARE the
       dashed digits, so sort_by=title-ascending puts entry i on server page
       floor(i / pageSize) + 1 — verified against the live site. That turns "find
       the 9 numbers containing 124" from an 82-page sweep into at most 9 page
       fetches, and the total is exact instead of a floor.

       Strictly additive and self-checking: Shopify's own results stay where they
       are, every fetched page is verified to contain the number the index
       predicted, and any failure (no index, stale index, fetch error) leaves the
       page exactly as it was. */
    var CONTAINS_TOTAL = null;          // exact count from the index, when known
    var containsRan = false;
    /* de-search-full-facets-2026-09-19 — area/state facets computed from the INDEX.

       The dropdowns here were built from `cards()` — the numbers already fetched —
       so they described the loader's progress rather than the result set. Search
       "6" and pick Alabama and you got nothing: Alabama numbers do contain a 6,
       they just rank low and had not arrived. The area code IS the first three
       digits of every number, so the index can answer both facets exactly:
       area directly, state through the 344-code map the collection page uses. */
    var DE_META = null;
    (function () {
      try {
        if (!window.deInventoryMetaUrl) return;
        fetch(window.deInventoryMetaUrl, { cache: 'force-cache' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; })
          .then(function (m) {
            if (!m || !m.area_codes) return;
            DE_META = { areaToState: {}, stateAreas: {} };
            m.area_codes.forEach(function (a) {
              if (!a.state) return;
              DE_META.areaToState[a.code] = a.state;
              (DE_META.stateAreas[a.state] = DE_META.stateAreas[a.state] || []).push(a.code);
            });
            /* A state query cannot be recognised without this map, and the
               parse-time count runs long before any fetch could deliver it —
               so keep a copy where that script can reach it synchronously. */
            try {
              localStorage.setItem('de_dx_meta_v1', JSON.stringify(DE_META.stateAreas));
            } catch (e) {}
            try { buildOptions(); } catch (e) {}
            /* A STATE query cannot even be recognised until this map exists, and
               deContainsStream() has already run and bowed out by now. Give it the
               second chance it needs, or "California" keeps showing Shopify's
               1,000-result cap instead of its true 2,592. */
            try { deContainsStream(); } catch (e) {}
          });
      } catch (e) {}
    })();

    /* The price index decides whether a banded count can be exact, and it arrives
       after first paint — so repaint when it lands or the headline keeps the floor
       it opened with. A band already in the URL is needed immediately; otherwise
       the buyer has to reach the slider first, so idle is soon enough. */
    (function () {
      try {
        var PI = window.__dePriceIndex;
        if (!PI) return;
        var go = function () {
          PI.ready().then(function (ok) {
            if (!ok) return;
            _itKey = null;
            try { apply(); } catch (e) {}
          });
        };
        if (deSNat) go();
        else if (window.requestIdleCallback) requestIdleCallback(go, { timeout: 3000 });
        else setTimeout(go, 900);
        /* A revalidated index is a different answer to the same question. */
        document.addEventListener('de:index-refreshed', function () {
          _itKey = null;
          try { apply(); } catch (e) {}
        });
      } catch (e) {}
    })();

    /* Facet counts over EVERY match, not the loaded subset. Returns null when the
       index or the area map is not ready, and the caller falls back to counting
       cards exactly as before. */
    /* Which area codes the current state/area selection permits — null means no
       narrowing. Used to steer the LOADER, so picking a state fetches that
       state's matches instead of filtering the ones already on screen. */
    function allowedAreas() {
      var a = areaSel && areaSel.value ? String(areaSel.value) : '';
      var s = stateSel && stateSel.value ? String(stateSel.value) : '';
      if (a) { var o1 = {}; o1[a] = 1; return o1; }
      if (s && DE_META && DE_META.stateAreas[s]) {
        var o2 = {};
        DE_META.stateAreas[s].forEach(function (c) { o2[c] = 1; });
        return o2;
      }
      return null;
    }

    /* How many numbers match the query AND the current state/area. The label used
       to keep quoting the unfaceted total — "6" narrowed to Texas read "130 of
       9,785" when the honest answer is "130 of 437" — and the pager had no idea
       the other 307 existed. */
    var FACET_TOTAL = null, _ftCache = {};
    function facetTotal() {
      var P = queryPredicate();
      if (!P || !window.__deDigitIndex) return null;
      var all = window.__deDigitIndex.peek();
      if (!all) return null;
      var AA = allowedAreas();
      if (!AA) return CONTAINS_TOTAL;
      /* Memoised: this scans all 16,304 index entries, and apply() runs on every
         batch that lands. Uncached it was re-counting the whole catalogue dozens of
         times per page load for an answer that only changes when the facet does. */
      var key = P.kind + ':' + P.q + '|' + Object.keys(AA).sort().join(',');
      if (_ftCache[key] != null) return _ftCache[key];
      var n = 0;
      for (var i = 0; i < all.length; i++) {
        var d = all[i];
        if (!P.keep(d)) continue;
        if (!AA[d.slice(0, 3)]) continue;
        n++;
      }
      _ftCache[key] = n;
      return n;
    }

    /* de-state-by-areacode-2026-09-19 — the area code decides the state.

       15 active products carry a state tag that contradicts their own area code:
       816-789-9999 is tagged Texas though 816 is Missouri; 208 tagged Ohio (Idaho);
       626 tagged Arizona (California); 904 tagged Texas (Florida). Filtering by the
       tag while COUNTING by the area map made the two disagree — the page read
       "34 of 33 results" for 9999 + Texas.

       The area code is the authority (NANPA), so both sides use it when the map is
       loaded: the counts stay exact and those 15 numbers file under the state they
       actually belong to. Falls back to the card's own tag if the map is absent.
       Product tags are NOT modified here — that data still wants fixing at source. */
    function cardState(c) {
      var a = cardArea(c);
      if (DE_META && a && DE_META.areaToState[a]) return DE_META.areaToState[a];
      if (c.__deSt === undefined) c.__deSt = (c.getAttribute('data-state') || '').trim();
      return c.__deSt;
    }
    /* Attribute reads are cached on the node. apply() runs once per arriving batch
       and walks EVERY card, so on a query that loads 1,300+ of them the same
       getAttribute calls were being repeated hundreds of thousands of times. */
    function cardDigits(c) {
      if (c.__deDg === undefined) c.__deDg = c.getAttribute('data-digits') || '';
      return c.__deDg;
    }
    function cardArea(c) {
      if (c.__deAr === undefined) c.__deAr = (c.getAttribute('data-area') || '').trim();
      return c.__deAr;
    }

    var _facetCache = null, _facetKey = null;
    function indexFacets() {
      var P = queryPredicate();
      if (!P || !DE_META || !window.__deDigitIndex) return null;
      var all = window.__deDigitIndex.peek();
      if (!all) return null;
      // One pass per query, not per repaint — buildOptions() runs on every batch.
      var key = P.kind + ':' + P.q + '|' + all.length;
      if (_facetKey === key && _facetCache) return _facetCache;
      var st = {}, ar = {};
      for (var i = 0; i < all.length; i++) {
        var d = all[i];
        if (!P.keep(d)) continue;
        var a = d.slice(0, 3);
        ar[a] = (ar[a] || 0) + 1;
        var s = DE_META.areaToState[a];
        if (s) st[s] = (st[s] || 0) + 1;
      }
      _facetKey = key; _facetCache = { states: st, areas: ar };
      return _facetCache;
    }
    /* The digits the buyer actually typed, whether they arrived bare or as a
       rewritten token ("64665" -> q=646-65). */
    function CQ() { return QDIGITS || SUBDIGITS || ''; }

    /* de-state-query-2026-09-19 — searching a STATE hits Shopify's 1,000 cap.

       Owner: "it makes no sense for only 1000 matches when the search is
       California because we have more than 2k california numbers". Exactly right —
       California is 2,592 and New York is 5,255, but Shopify's search returns at
       most 1,000 results for any query, so the page could never show more.

       A state is just its set of area codes, and the area code is the first three
       digits of every number — so the index can answer this the same way it answers
       a digit fragment: exactly, across the whole catalogue. */
    function stateQ() {
      if (!DE_META || QDIGITS || SUBDIGITS) return '';
      var q = (QUERY || '').trim().toLowerCase();
      if (!q) return '';
      for (var st in DE_META.stateAreas) {
        if (st.toLowerCase() === q) return st;
      }
      return '';
    }
    /* What this page is looking for: a digit fragment, a state, or neither. */
    function queryPredicate() {
      var d = CQ();
      if (d) return { kind: 'digits', q: d, keep: function (dg) { return dg.indexOf(d) !== -1; } };
      var st = stateQ();
      if (st) {
        var ok = {};
        DE_META.stateAreas[st].forEach(function (c) { ok[c] = 1; });
        return { kind: 'state', q: st, keep: function (dg) { return !!ok[dg.slice(0, 3)]; } };
      }
      return null;
    }
    var ALL_PATH = '/collections/all-numbers';

    /* One attempt is not enough. These pages are ~1.3MB each and six go out at a
       time, so on a busy browser or a slow connection an abort is ordinary — and an
       aborted page used to be lost for good, because it had already been marked as
       fetched. That is what produced a search sitting at "0 of 2,201 results": not a
       wrong answer, just requests that never came back and were never retried. */
    function deContainsFetch(pg, attempt) {
      attempt = attempt || 1;
      var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 15000) : null;
      /* Section Rendering API once page 1 has told us the section's id. Identical
         cards, identical grid attributes, 769KB instead of 1.31MB — a 41% cut on
         every page after the first, which matters because these fetches are the
         entire cost of the feature. Measured on page 21: 211 cards either way,
         same first number. */
      var sid = (CST && CST.sid) ? '&section_id=' + encodeURIComponent(CST.sid) : '';
      return fetch(ALL_PATH + '?sort_by=title-ascending&page=' + pg + sid,
                   { headers: { 'X-Requested-With': 'XMLHttpRequest' },
                     signal: ctrl ? ctrl.signal : undefined })
        // 304 is a SUCCESS — the browser is revalidating its cache, not refusing us.
        .then(function (r) { return (r.ok || r.status === 304) ? r.text() : ''; })
        .catch(function () { return ''; })
        .then(function (t) {
          if (timer) clearTimeout(timer);
          if (t) { fetchFails = 0; return t; }   // any success clears the streak
          fetchFails++;
          /* CONSECUTIVE refusals mean the store is pushing back; isolated ones are
             just the internet. The first cut latched after four failures counted
             across the whole page-load and never unlatched, so a couple of stray
             aborts early on permanently disabled the loader and the buyer got
             "0 of 862 results" on a query that works perfectly. */
          if (fetchFails >= 6) { throttled = true; return ''; }
          if (attempt < 2) return deContainsFetch(pg, attempt + 1);
          return t;
        });
    }

    /* State kept between passes so the loader can be RESUMED.

       Owner: "i want to be able to see all possible results, u get what i mean???
       where it makes sense". The first cut stopped dead at 200 matches, so "6"
       loaded 106 of 9,789 and there was no way to reach the rest — the pager could
       only page what had been fetched. The index knows every match AND which server
       page each one sits on, so there is no reason any of them should be
       unreachable: keep the ranked list and the cursor, and fetch the next block
       whenever the buyer pages towards the end of what is loaded.

       Ranked order matters for cost as well as quality. Matches that share an area
       code sit together in title order, so "6" pulls 200 of them from a page or
       two; scattered ones like "9999" cost a fetch each. Paying that only when
       somebody actually pages that far is the difference between a fast search and
       downloading the catalogue. */
    var CST = null;

    function deContainsStream() {
      var PRED = queryPredicate();
      if (containsRan || !PRED) return;
      if (PRED.kind === 'digits' && PRED.q.length > 9) return;
      var CQv = PRED.q;
      var idx = window.__deDigitIndex;
      if (!idx || !idx.ready) return;
      containsRan = true;
      idx.ready().then(function (all) {
        if (!all || !all.length) return;                     // no index — leave the page alone
        var exact;
        if (PRED.kind === 'digits') exact = idx.count(CQv);
        else {
          exact = 0;
          for (var _e = 0; _e < all.length; _e++) if (PRED.keep(all[_e])) exact++;
        }
        if (exact == null) return;
        CONTAINS_TOTAL = exact;
        // Tell the paginator how many matches really exist, so it can offer a route
        // to all of them rather than only to the ones already fetched.
        try { window.__deFilteredTotalHint = exact; } catch (e) {}
        /* Repaint the moment the total is known, not when the cards finish landing.
           The count is an index lookup — instant — while fetching the numbers takes
           seconds, and every early return below skipped the repaint entirely.
           Measured: "7" sat on Shopify's "29 results" while 8,689 numbers contain a
           7, and "64665" read 6 against a true 9. */
        try { apply(); } catch (e) {}
        var have = {}, cs = cards();
        for (var i = 0; i < cs.length; i++) have[cs[i].getAttribute('data-digits') || ''] = 1;
        var want;
        if (PRED.kind === 'digits') want = idx.matches(CQv) || [];
        else {
          // Already in title order, which is the natural order for a state listing.
          want = [];
          for (var _w = 0; _w < all.length; _w++) if (PRED.keep(all[_w])) want.push({ d: all[_w], i: _w, s: 0 });
        }
        if (!want.length) return;

        /* de-scaffold-cache-2026-09-19 — remember the collection's shape.

           Page 1 is fetched WITHOUT section_id (the id is what we are there to
           learn), so it costs 1.31MB versus 769KB for every later page — and it sat
           on the critical path of EVERY search. The three facts it yields (section
           id, server page size, catalogue size) do not change between searches, so
           cache them for the session: the first search pays, the rest start
           fetching real result pages immediately. */
        var _sc = null;
        try { _sc = JSON.parse(sessionStorage.getItem('de_dx_scaffold') || 'null'); } catch (e) {}
        if (_sc && _sc.sid && _sc.size > 0 && Math.abs((_sc.declared || 0) - all.length) <= 50) {
          var sec2 = document.querySelector('[id^="shopify-section-template--"]');
          CST = { q: CQv, keep: PRED.keep, kind: PRED.kind, want: want, cursor: 0,
                  size: _sc.size, have: have, fetched: {}, busy: false, done: false,
                  sid: _sc.sid, rank: deRankMap(want), stash: {}, shown: deCloneMap(have), skip: {}, matPtr: 0, contig: 0, aaSig: '' };
          CST_DRIFT = Math.abs((_sc.declared || 0) - all.length);
          return deContainsMore(260);
        }
        return deContainsFetch(1).then(function (html1) {
          if (!html1) {
            /* Page 1 establishes the page size, so without it nothing can start.
               Worth one more try — but ONLY one. Re-entering on every failure is
               what turned a throttled response into 123 requests and an empty
               page; past that, leave Shopify's own results standing. */
            if (!window.__deC1Retry && !throttled) {
              window.__deC1Retry = 1;
              containsRan = false;
              setTimeout(deContainsStream, 3000);
            }
            return;
          }
          var doc1 = new DOMParser().parseFromString(html1, 'text/html');
          var g1 = doc1.querySelector('[data-de-product-grid]');
          if (!g1) return;
          var size = parseInt(g1.getAttribute('data-de-server-page-size'), 10) ||
                     g1.querySelectorAll(':scope > .de-card.de-card--number').length;
          if (!(size > 0)) return;
          /* The index must roughly describe THIS collection for the page maths to
             hold — but demanding an EXACT match was a hair trigger. One sale, and
             the sitemap (16,304) disagreed with the collection (16,303) by a single
             product, so this returned and the whole rescue silently switched off:
             "6" fell back to Shopify's 171 results with the heading still promising
             9,785. Numbers sell all day; the index is a cache. Tolerate small drift
             and let the per-page harvest absorb it — every card is checked for the
             digits anyway, so a shifted prediction costs a fetch, not correctness. */
          var declared = parseInt(g1.getAttribute('data-de-products-count'), 10) || 0;
          var drift = declared ? Math.abs(declared - all.length) : 0;
          if (declared && drift > 50) return;
          CST_DRIFT = drift;

          var sec = doc1.querySelector('[id^="shopify-section-template--"]');
          var sidVal = sec ? sec.id.replace('shopify-section-', '') : null;
          CST = { q: CQv, keep: PRED.keep, kind: PRED.kind, want: want, cursor: 0,
                  size: size, have: have, fetched: { 1: true }, busy: false,
                  done: false, sid: sidVal, rank: deRankMap(want), stash: {}, shown: deCloneMap(have), skip: {}, matPtr: 0, contig: 0, aaSig: '' };
          try {
            if (sidVal) sessionStorage.setItem('de_dx_scaffold',
              JSON.stringify({ sid: sidVal, size: size, declared: declared }));
          } catch (e) {}
          deContainsHarvest([html1]);
          // Enough for a full first page plus a little headroom. More arrives when
          // the buyer actually pages, which is the only time it is worth fetching.
          return deContainsMore(260);
        });
      }).catch(function () { /* never let the rescue break the page */ });
    }

    /* Pull `n` more ranked matches in, fetching only the server pages that hold
       them. Safe to call repeatedly; it picks up where it left off.

       Works in SMALL CHUNKS and paints after each one. The first cut collected every
       page the next 400 ranked matches touched and appended nothing until all of
       them had been fetched — fine when the matches cluster, ruinous when they do
       not. Owner's screenshot of "67": 1,573 matches, 23 cards on screen, the state
       and area dropdowns still reading LOADING, because the browser was working
       through hundreds of queued page fetches before the first append.

       Chunking fixes both halves. Cards appear within a second, and the loop stops
       as soon as it has what it was asked for — a page of "67" arrives in roughly
       twelve fetches because ~9.6% of the catalogue contains those digits and every
       fetched page is harvested in full, not just for the match that selected it. */
    /* BUDGETS. These are deliberately small, and the reason is worth stating.

       A trace of /search?q=29 caught 123 requests to /collections/all-numbers on a
       single page load, after which Shopify simply stopped serving them — the fetch
       came back not-ok with a 9KB error body, every page in flight resolved empty,
       and the buyer got "0 of 2,201 results". The load caused the emptiness.

       Two things were wrong: the per-call ceiling was far too high, and a failed
       page-1 fetch re-entered the whole stream every 2.5s, so throttling produced
       more requests, which produced more throttling. A page of results needs about
       a dozen fetches; anything beyond that is the loader working against itself
       and against the store. */
    var CST_DRIFT = 0;            // sitemap-vs-collection skew, absorbed below
    var CHUNK_PAGES = 8;          // pages per round trip
    var CHUNK_CONC = 4;           // in flight at once
    var CALL_PAGE_CAP = 24;       // pages one call may spend
    var PAGE_BUDGET = 60;         // pages this page-load may spend on its own
    var pagesSpent = 0, fetchFails = 0, throttled = false;

    /* Bounded concurrency. Six 1.3MB pages at once is what tipped the storefront
       into refusing them; four keeps the same wall-clock without the cliff. */
    function deContainsAll(pages, onPage, stop) {
      /* onPage fires as each page lands. Waiting for the whole chunk before showing
         anything put the first card at ~2.1s when the document itself was ready at
         0.8s — the buyer stared at Shopify's handful of results while eight 769KB
         pages finished in parallel. Now the first page to return paints. */
      var out = new Array(pages.length), at = 0;
      function worker() {
        if (at >= pages.length) return Promise.resolve();
        /* Stop pulling the rest of the chunk once the ask is met. A dense query
           yields ~120 matches per page, so fetching a full 8-page chunk inserted
           ~960 cards to satisfy a request for 260 — a lot of DOM (and jank) for
           results nobody had asked to see. */
        if (stop && stop()) return Promise.resolve();
        var mine = at++;
        return deContainsFetch(pages[mine]).then(function (h) {
          out[mine] = h;
          if (onPage) { try { onPage(h, pages[mine]); } catch (e) {} }
          return worker();
        });
      }
      var lanes = [];
      for (var i = 0; i < Math.min(CHUNK_CONC, pages.length); i++) lanes.push(worker());
      return Promise.all(lanes).then(function () { return out; });
    }

    function deContainsMore(n) {
      if (!CST || CST.done) return Promise.resolve();
      /* A request that arrives mid-flight used to be DROPPED. That was survivable
         while deepScan pre-loaded a thousand server cards to filter against, but
         once that was removed the facet fetch became the only source — and picking
         a state during the initial load left the buyer on 8 results of 437, or 0
         of 1,491. Remember the ask and honour it when the current pass finishes. */
      if (CST.busy) { CST.rerun = Math.max(CST.rerun || 0, n); return Promise.resolve(); }
      CST.busy = true;
      /* Same flag the deep scan uses, so the bar shows it is still working. Without
         it a broad query looks finished while it is still filling. */
      try { bar.setAttribute('data-de-scanning', '1'); } catch (e) {}
      var need = n, spent = 0;

      function step() {
        /* A jump in flight widens the batch. The buyer is waiting on a specific
           page rather than browsing, so fewer, larger round trips get them there
           sooner — the tail of a broad query is sparse, and eight pages at a time
           was leaving the last few result-pages just out of reach. */
        // A facet cuts how much each page yields — "6" + Texas is 437 matches out
        // of 9,783, roughly 9 per fetched page, so filling a 200-card screen needs
        // ~22 pages. Fetch wider when one is active.
        var chunk = CST.needPage ? 14 : (allowedAreas() ? 14 : CHUNK_PAGES);
        var AA = allowedAreas();
        var pages = [];
        while (CST.cursor < CST.want.length && pages.length < chunk) {
          var m = CST.want[CST.cursor++];
          // Skip matches outside the chosen state/area so the fetch budget is
          // spent on numbers the buyer can actually see.
          if (AA && !AA[m.d.slice(0, 3)]) { CST.skip[m.d] = 1; continue; }
          if (CST.have[m.d]) continue;              // already on the page
          var pg = Math.floor(m.i / CST.size) + 1;
          // With drift, an entry near the top of a page may actually sit on the one
          // before it. Cheap insurance: read the neighbour for boundary cases only.
          if (CST_DRIFT > 0 && (m.i % CST.size) < CST_DRIFT + 2 && pg > 1 && !CST.fetched[pg - 1]) {
            CST.fetched[pg - 1] = true; pages.push(pg - 1);
          }
          if (CST.fetched[pg]) continue;            // a page already read covers it
          CST.fetched[pg] = true;
          pages.push(pg);
        }
        if (!pages.length) {
          if (CST.cursor >= CST.want.length) CST.done = true;
          return Promise.resolve();
        }
        if (throttled) { CST.done = true; return Promise.resolve(); }
        /* Out of budget is not the same as out of numbers. Mark it capped and stop;
           a pager click raises the ceiling and carries on, because that is the buyer
           asking for more rather than the page deciding to fetch it. */
        if (pagesSpent >= PAGE_BUDGET) { CST.capped = true; return Promise.resolve(); }
        spent += pages.length;
        pagesSpent += pages.length;
        return deContainsAll(pages, function (html) {
          if (html) need -= deContainsHarvest([html]);   // paint this page now
        }, function () { return need <= 0 && !CST.needPage; }).then(function (htmls) {
          for (var a = 0; a < htmls.length; a++) {
            // Un-mark a page that did not come back, so a later pass can try again.
            if (!htmls[a]) delete CST.fetched[pages[a]];
          }
          if (need > 0 && !throttled && !CST.capped &&
              spent < (CST.needPage ? 42 : (allowedAreas() ? 48 : CALL_PAGE_CAP)) &&
              pagesSpent < PAGE_BUDGET && CST.cursor < CST.want.length) return step();
        });
      }

      function finish() {
        CST.busy = false;
        try { bar.removeAttribute('data-de-scanning'); } catch (e) {}
        if (CST.rerun) {
          var again = CST.rerun; CST.rerun = 0;
          setTimeout(function () { deContainsMore(again); }, 60);
          return;
        }
        /* Nothing on screen while the index says there are matches means every
           fetch in this pass failed. The pages were un-marked above, so one more
           attempt is worth making before giving the buyer an empty page. */
        if (!CST.done && !CST.retried && !throttled && need > 0 &&
            pagesSpent < PAGE_BUDGET &&
            !grid.querySelector('[data-de-contains]') && CONTAINS_TOTAL > 0) {
          CST.retried = true;
          setTimeout(function () { deContainsMore(n); }, 1800);
          return;
        }
        // Still short of the page the buyer opened? Keep going — bounded, so a
        // jump beyond the end of the matches cannot loop.
        /* 20 continuations, not 8. Reaching page 40 of a 9,787-match query means
           loading ~8,000 matches, which is roughly 67 server pages — more than
           eight passes can cover, so the jump stopped two-thirds of the way there.
           This only ever runs because someone typed a page number. */
        /* de-fill-not-finish-2026-09-19 — fetch to fill the page, never to count.

           This used to be two loops. A price band had its own, which kept fetching
           until EVERY match had been pulled and priced, for one reason: the index
           knew each number's digits but not its price, so the headline could only
           say "385+" until the last page landed. On q=9999 with a band that meant
           700 matches dragged in over ~20s, and the buyer watched the number climb
           the whole way.

           The price index answers that question outright now, so the fetching that
           existed to answer it is pure waste — every page of it was work for the
           network, the layout engine and the mutation observers, spent on a figure
           already known before the first card arrived.

           What remains is the honest reason to fetch: filling the screen. A band
           narrows what each page yields exactly as a facet does, so both use the
           same rule — keep going while the page is short of a full 200, stop the
           moment it is full. */
        /* de-fill-page-one-2026-09-19 — one loop, and it owns filling the screen.

           This used to run only for a facet or a band, on the reasoning that those
           are what make a fetched page yield few cards. The ranked-prefix rule
           makes it true of EVERY query: only matches inside the cursor may be
           shown, and for a query whose best matches are scattered across the
           catalogue the cursor advances a few ranks per fetched page. q=29 settled
           with 361 matches harvested and 93 of the 200 on screen.

           Counting what is actually VISIBLE is the right measure — it already
           accounts for the cursor, the stash and the filters at once — so the same
           condition that fixed the faceted case fixes this one. A brief attempt at
           a second, cursor-based loop beside it is exactly what not to do: two
           continuations returning out of the same finish() fought each other and
           the pager thrashed (q=9999 walked 68 pages of a 4-page result set). */
        if (!CST.needPage && !CST.done && !throttled &&
            (CST.facetTries = (CST.facetTries || 0)) < 40) {
          var _cc = cards(), visNow = 0;
          for (var _v = 0; _v < _cc.length; _v++) if (!_cc[_v].hasAttribute('hidden')) visNow++;
          /* de-cover-page-one-2026-09-19 — a full screen is not a finished page.

             This stopped as soon as 200 cards were visible, and Shopify's own 200
             server-rendered results satisfy that on their own. Their ranks are
             scattered across the whole result set, so the loader would settle with
             the contiguous prefix only 38 deep while page 1 claimed to be the best
             200 matches. It was not — it was whatever happened to sort highest out
             of the 238 cards present. The real top-ranked numbers arrived later,
             inserted above them, and pushed the rest down a page: walking q=888 at
             a leisurely twelve seconds a page still showed 215 numbers twice and
             never showed another 215.

             Page one is finished when the RANKED PREFIX covers it. */
          var _needCover = (CST.contig || 0) < 200;
          if ((visNow < 200 || _needCover) && CST.cursor < CST.want.length &&
              pagesSpent < PAGE_BUDGET + 200) {
            CST.facetTries++;
            PAGE_BUDGET = Math.max(PAGE_BUDGET, pagesSpent + 48);
            setTimeout(function () { deContainsMore(600); }, 80);
            return;
          }
        }
        deMaterialise();
        /* de-unblock-2026-09-19 — a rank that can never arrive must not hold the
           queue shut.

           deMaterialise() stops at the first rank whose card is missing, which is
           what keeps DOM order equal to rank order. But a number that sold since
           the index was built is in `want` and will never appear on any page, and
           without this it would block every better-ranked... every WORSE-ranked
           card behind it for the rest of the visit.

           Here is the one moment it can be told apart: the pass has finished, so
           every page it requested has come back. A rank whose page has been read
           and still has no card is simply gone. Bounded, because each skip can
           expose another. */
        for (var _ub = 0; _ub < 60 && CST.matPtr < CST.want.length; _ub++) {
          var _bw = CST.want[CST.matPtr], _bd = _bw.d;
          if (CST.stash[_bd] || CST.shown[_bd] || CST.skip[_bd]) break;
          var _bpg = Math.floor(_bw.i / CST.size) + 1;
          if (!CST.fetched[_bpg]) break;          // still to be read — keep waiting
          CST.skip[_bd] = 1;
          deMaterialise();
        }
        if (CST.needPage && !CST.done && !throttled && CST.needTries < 20) {
          var have = grid.querySelectorAll(':scope > .de-card--number:not([hidden])').length;
          var want = CST.needPage * CST.needPer;
          if (have < want && have < CONTAINS_TOTAL) {
            CST.needTries++;
            CST.capped = false;
            PAGE_BUDGET = Math.max(PAGE_BUDGET, pagesSpent + 40, 100);
            setTimeout(function () { deContainsMore(want - have + 200); }, 150);
          } else {
            CST.needPage = 0;
          }
        }
      }
      return step().then(finish, finish);
    }

    /* Pull the matching cards straight out of the RAW HTML.

       Parsing was the dominant cost: every fetched page is ~769KB, and
       DOMParser.parseFromString was run on all 25 of them — the long tasks that
       show up as stutter while the results fill in. A page holds 200 cards, each a
       <article class="de-card de-card--number" … data-digits="…">, and articles do
       not nest, so the first </article> after a start closes that card. Slice out
       only the cards whose digits match and parse THOSE — typically 5-30 cards
       instead of 200, so a few tens of KB instead of three quarters of a megabyte. */
    var CARD_RE = /<article[^>]*class="[^"]*de-card--number[^"]*"[^>]*>/g;
    var DIGITS_RE = /data-digits="(\d{10})"/;

    function cardsFromHtml(html, keep, skip) {
      CARD_RE.lastIndex = 0;
      var starts = [], m;
      while ((m = CARD_RE.exec(html))) starts.push(m.index);
      // `out`, not `keep` — the accumulator used to share the predicate's name and
      // shadowed it, so keep(dg) threw and every harvest silently returned nothing.
      var out = [], digits = [];
      for (var i = 0; i < starts.length; i++) {
        var end = (i + 1 < starts.length) ? starts[i + 1] : html.length;
        var chunk = html.slice(starts[i], end);
        var dm = DIGITS_RE.exec(chunk);
        if (!dm) continue;
        var dg = dm[1];
        if (!keep(dg) || skip[dg]) continue;
        var close = chunk.indexOf('</article>');
        out.push(close === -1 ? chunk : chunk.slice(0, close + 10));
        digits.push(dg);
      }
      return { cards: out, digits: digits };
    }

    /* de-incremental-filter-2026-09-19 — judge ONE card, so a batch that has just
       landed does not force a pass over the whole grid.

       Painting each fetched page as it arrives halved time-to-first-card (2.1s ->
       1.0s), but calling apply() per page pushed long tasks up (888: 2,149 ->
       2,763ms) because every pass walks every card. New cards still have to be
       filtered the instant they appear or they would flash through unfiltered — so
       filter just those, and let the debounced full pass fix the counts and pager.
       apply() uses the SAME predicate, so the two can never drift apart. */
    function filterCtx() {
      var a = pMin ? +pMin.value : 0, b = pMax ? +pMax.value : 100;
      if (a > b) { var t = a; a = b; b = t; }
      var full = priceIsFullRange();
      return { wantState: stateSel ? stateSel.value : '',
               wantArea: areaSel ? areaSel.value : '',
               /* A state SEARCH narrows the page as firmly as the state dropdown
                  does. Without this, Shopify's own fuzzy matches stayed on screen
                  beside the exact ones — "Illinois" showed numbers from other
                  states because Shopify had matched them on a tag. */
               stateQuery: stateQ(),
               full: full,
               lo: full ? -Infinity : pctToCents(a),
               hi: full ? Infinity : pctToCents(b) };
    }
    function cardPasses(c, x) {
      if (SUBDIGITS && cardDigits(c).indexOf(SUBDIGITS) < 0) return false;
      if (QDIGITS && cardDigits(c).indexOf(QDIGITS) < 0) return false;
      if (x.stateQuery && cardState(c) !== x.stateQuery) return false;
      if (x.wantState && cardState(c) !== x.wantState) return false;
      if (x.wantArea && cardArea(c) !== x.wantArea) return false;
      if (!x.full && !deSNativeOn()) { var v = cents(c); if (v < x.lo || v > x.hi) return false; }
      /* A streamed card was never seen by Shopify, so the server's band does not
         cover it, and the thumbs cannot judge it either — under native filtering
         recomputeRange() deliberately does not run, so every thumb reads 0.
         Measured: /search?q=888 with gte=1000 rendering a $300 number. */
      if (deSNat && c.hasAttribute('data-de-contains')) {
        var vN = cents(c);
        if (deSNat.min !== null && !isNaN(deSNat.min) && vN < Math.round(deSNat.min * 100)) return false;
        if (deSNat.max !== null && !isNaN(deSNat.max) && vN > Math.round(deSNat.max * 100)) return false;
      }
      return true;
    }

    /* de-yield-while-scrolling-2026-09-19 — do not build the page under the user.

       Measured with synthesized wheel gestures: a SETTLED page scrolls cleanly
       (q=6, 1,811 cards: 2 dropped frames, worst 33ms). Scrolling WHILE results
       stream in was the bad case — 25 dropped, 17 over 50ms, worst frame 945ms.
       The work itself is not the problem; doing it during a scroll is. So insert a
       much smaller slice while the wheel is moving and let the frames through. */
    var _scrolling = 0;
    (function () {
      var t = null;
      function mark() {
        _scrolling = 1;
        clearTimeout(t);
        t = setTimeout(function () { _scrolling = 0; }, 140);
      }
      window.addEventListener('scroll', mark, { passive: true });
      window.addEventListener('wheel', mark, { passive: true });
      window.addEventListener('touchmove', mark, { passive: true });
    })();

    /* de-hold-while-typing-2026-09-22 — nothing is built while a new query is
       being typed.

       Owner: "when im using the search type box, when things are loading, i guess
       what i am typing lags out when undoing or redoing itself".

       Measured: keystroke-to-paint is 13-17ms and no keystroke is ever lost — but
       the load phase runs long tasks (worst 454ms at 6x CPU), and a key pressed
       inside one of those appears only when it ends. Several then land at once,
       which is exactly the "lags out, then undoes/redoes itself" he describes.

       The deeper point is that the work is POINTLESS: someone typing in the search
       box is asking for a different query, so every card still being fetched and
       inserted for the old one is waste competing with their keystrokes. The same
       reasoning as de-yield-while-scrolling — do not build the page under the
       user — and the same mechanism.

       Profiled during load at 4x CPU the main thread splits Clarity 2,733ms /
       ours 390ms, so this cannot make typing perfect on its own. It removes our
       share of it, which is the part that is ours to remove. */
    var _typing = 0;
    (function () {
      var t = null;
      function mark() {
        _typing = 1;
        clearTimeout(t);
        t = setTimeout(function () { _typing = 0; }, 450);
      }
      function wire(el) {
        if (!el || el.__deTypeWired) return;
        el.__deTypeWired = 1;
        el.addEventListener('keydown', mark);
        el.addEventListener('input', mark);
      }
      function wireAll() {
        try {
          var list = document.querySelectorAll(
            '.de-searchX__input, input[name="q"], .dx-search input, .de-pager-jump__input');
          for (var i = 0; i < list.length; i++) wire(list[i]);
        } catch (e) {}
      }
      wireAll();
      /* The dropdown panels and their search boxes are built on first open. */
      document.addEventListener('focusin', function (e) {
        var t2 = e.target;
        if (t2 && t2.tagName === 'INPUT') wire(t2);
      }, true);
      setTimeout(wireAll, 1500);
    })();

    var _pendingNodes = [], _pendingHtml = [], _flushQueued = false, _flushHeld = 0;

    function _flushNodes() {
      /* Insert in small batches across frames. One appendChild of several hundred
         cards was a single long task — measured 2,757ms of them on "888". */
      /* While the wheel is moving, insert nothing — just come back next frame. A
         scroll lasts a few hundred ms; the cards can wait that long, and this is
         the difference between a smooth scroll and a 950ms frame. The counter is a
         starvation guard: someone scrolling continuously still gets results, just
         a few at a time. */
      if ((_scrolling || _typing) && _flushHeld < 45) {
        _flushHeld++;
        requestAnimationFrame(_flushNodes);
        return;
      }
      var BATCH = (_scrolling || _typing) ? 6 : 40, f = document.createDocumentFragment(), i = 0;
      _flushHeld = 0;
      var ctx = filterCtx();
      var paging = !!grid.getAttribute('data-de-list-limit');
      /* de-born-as-a-shell-2026-09-20 — build what we are going to keep, not what
         we are about to throw away.

         A card arriving into a paged grid is hidden the instant it lands and then
         hollowed out, so parsing its full markup created twenty-three child nodes
         that existed only to be destroyed on the same frame. That is parse work,
         allocation, garbage, and — worst of it — twenty-three extra nodes in every
         mutation record that Microsoft Clarity's observer then walks.

         Profiled while scrolling a loading page: 1,857ms of Clarity
         querySelectorAll and 1,579ms of its scroll-position reads (each one
         flushing layout against our pending mutations) against ~610ms for all of
         de-polish. We cannot make Clarity cheaper, but we hand it a twenty-fourth
         of the nodes.

         Only the opening tag is parsed, so the element arrives with every
         attribute the filter, sort and pager read, and the markup waits in
         __deInner exactly as deShell() would have left it. */
      if (_pendingHtml.length) {
        var slice = _pendingHtml.splice(0, BATCH);
        var host = document.createElement('div');
        if (paging) {
          var opens = [], inners = [];
          for (var sh = 0; sh < slice.length; sh++) {
            var h = slice[sh], gt = h.indexOf('>');
            var close = h.lastIndexOf('</');
            if (gt < 0 || close < gt) { opens.push(h); inners.push(null); continue; }
            opens.push(h.slice(0, gt + 1) + h.slice(close));
            inners.push(h.slice(gt + 1, close));
          }
          host.innerHTML = opens.join('');
          var freshS = host.querySelectorAll('.de-card.de-card--number');
          for (var q5 = 0; q5 < freshS.length; q5++) {
            var el = freshS[q5];
            el.setAttribute('data-de-appended', '1');
            el.setAttribute('data-de-contains', '1');
            if (inners[q5] != null) {
              el.__deInner = inners[q5];
              el.setAttribute('data-de-shell', '1');
            }
            _pendingNodes.push(el);
          }
        } else {
          host.innerHTML = slice.join('');
          var fresh = host.querySelectorAll('.de-card.de-card--number');
          for (var q4 = 0; q4 < fresh.length; q4++) {
            fresh[q4].setAttribute('data-de-appended', '1');
            fresh[q4].setAttribute('data-de-contains', '1');
            _pendingNodes.push(fresh[q4]);
          }
        }
      }
      while (i < BATCH && _pendingNodes.length) {
        var nd = _pendingNodes.shift();
        if (cardPasses(nd, ctx)) nd.removeAttribute('hidden');
        else nd.setAttribute('hidden', '');
        /* de-arrivals-are-paged-out-2026-09-19 — a card that has just arrived is NOT
           on the current page until the paginator says so.

           Revealing them on insert and leaving the re-slice to a 350ms debounce
           looked fine until the debounce got STARVED: during a deep-page load the
           next batch always landed first, so the re-slice never ran and the grid
           grew without limit. Owner, on page 9 of "6": 6,071 cards in the DOM with
           4,408 of them visible, against a pager reading "1601-1748 of 9783".
           Arriving hidden means the visible set can never exceed the page size,
           whatever the timing does. */
        if (paging) {
          nd.classList.add('de-card--hidden-by-paginator');
          /* de-shell-on-insert-2026-09-20 — hollow it out NOW, not at the next
             repaint.

             Shelling only inside applyListLimit() left a hole exactly where it
             hurt most: while the buyer scrolls, the flush is held and the settle
             repaint is deferred, so thousands of cards land at full size and stay
             that way for as long as the scroll lasts. Measured with natural wheel
             scrolling at page 18 of q=8 — 8,982 cards, 133,421 nodes, worst frame
             4,032ms, which is precisely the "extremely choppy" the owner reported.
             A card that is inserted already paged-out has never been seen, so
             there is nothing to preserve by waiting. */
          if (window.__deShell) window.__deShell(nd, true);
        }
        f.appendChild(nd); i++;
      }
      if (f.childNodes.length) grid.appendChild(f);
      if (_pendingNodes.length || _pendingHtml.length) { requestAnimationFrame(_flushNodes); return; }
      _flushQueued = false;
      if (window.deFormatPhones) window.deFormatPhones(grid);
      /* The expensive trio (recomputeRange/buildOptions/paintPrice — paintPrice and
         sizePills measured 486ms and 259ms in a profile) settles once the arrivals
         stop, not after every batch. The cards themselves are already filtered. */
      /* Debounced, but with a CEILING — a continuous stream of batches could reset
         this forever, which is how the re-slice came to be starved. */
      if (!_repaintFirst) _repaintFirst = Date.now();
      clearTimeout(_repaintT);
      function _settleRepaint() {
        if (_scrolling || _typing) { _repaintT = setTimeout(_settleRepaint, 160); return; }
        _repaintFirst = 0;
        recomputeRange(); buildOptions(); paintPrice(); apply();
      }
      if (Date.now() - _repaintFirst > 900 && !_scrolling && !_typing) _settleRepaint();
      else _repaintT = setTimeout(_settleRepaint, 350);
    }
    var _repaintT = null, _repaintFirst = 0, _sortPending = false;
    /* Re-slice the pager without redoing the whole filter pass — used after a
       deferred sort so the right 200 cards end up on screen. */
    function applyPagerOnly() {
      try {
        grid.setAttribute('data-de-filter-sig',
          (sortSel ? sortSel.value : 'default') + '~' + filterSig() + '~s');
        document.dispatchEvent(new CustomEvent('de:applied'));
      } catch (e) {}
    }

    /* de-ranked-prefix-2026-09-19 — the grid holds a PREFIX of the ranked list.

       Owner: "you need to actually check if the results are actually accurate or
       not, cuz it is very possible that we miss a lot of results." He was right,
       and this is why.

       Every fetched page is a page of the CATALOGUE, so it carries matches from
       all over the ranked list — a fetch aimed at rank 40 also drags in matches
       ranked 900th and 1,500th. Those were all inserted, then sortVisible() slotted
       them into their proper places, which pushes everything below them down by
       one. Do that while somebody is paging and the page boundaries move under
       them: a number they have already walked past shifts up into a page they have
       already left, and is never seen again.

       Measured by walking q=9999 to the end, waiting for each page: 587 of 700
       numbers seen, 244 shown twice, 113 never shown at all.

       The cure is to keep the grid an honest prefix of the ranked list — ranks
       0..cursor and nothing else. A match the fetch did not ask for yet is kept in
       memory by digits instead of being inserted, and materialises the moment the
       cursor reaches its rank. Nothing is re-fetched, the DOM stays a fraction of
       the size, and DOM order is rank order, so a page always holds exactly the
       numbers it says it does. */
    /* A read-only window onto the loader. Paging bugs here are all about numbers
       that live in closures — the cursor, the stash, what the budget has left —
       and without this every question about them costs a deploy to answer. */
    window.__deLoaderState = function () {
      if (!CST) return null;
      var st = 0; for (var k in CST.stash) st++;
      return { cursor: CST.cursor, want: CST.want.length, matPtr: CST.matPtr,
               stashed: st, have: Object.keys(CST.have).length,
               done: !!CST.done, busy: !!CST.busy, capped: !!CST.capped,
               needPage: CST.needPage || 0, coverTries: CST.coverTries || 0,
               facetTries: CST.facetTries || 0, needTries: CST.needTries || 0,
               pagesSpent: pagesSpent, budget: PAGE_BUDGET, throttled: !!throttled,
               pendingHtml: _pendingHtml.length, pendingNodes: _pendingNodes.length,
               flushQueued: _flushQueued, shownCount: Object.keys(CST.shown).length,
               skipped: Object.keys(CST.skip).length };
    };

    /* de-seed-shown-2026-09-19 — a number already on the page is already shown.

       The strict queue waits at the first rank whose card has not arrived. Shopify
       renders its own results server-side, and those digits are in `skip` when the
       harvest reads a page — correctly, they are already in the grid — so they
       never reach the stash. The queue therefore sat at rank 0 waiting for a card
       that was on screen the whole time: measured on q=626, matPtr stayed at 0 for
       eighteen seconds while 200 cards sat in the DOM and 234 more sat in the
       stash, and the page ended up showing 217 of 453.

       `have` is seeded at construction with exactly those digits, so seeding
       `shown` from it starts the queue where the page really is. */
    function deCloneMap(m) {
      var o = {};
      for (var k in m) o[k] = 1;
      return o;
    }

    function deRankMap(want) {
      var r = {};
      for (var i = 0; i < want.length; i++) r[want[i].d] = i;
      return r;
    }

    /* Everything the cursor has now reached, in rank order, pulled out of the
       stash. The pointer only moves forward, so this stays O(1) amortised. */
    function deMaterialise() {
      if (!CST || !CST.want) return 0;
      /* A change of facet changes which ranks are skippable, so the queue has to
         be re-walked. `shown` makes that idempotent. */
      var AAm = allowedAreas(), aaSig = AAm ? Object.keys(AAm).sort().join(',') : '';
      if (aaSig !== CST.aaSig) { CST.aaSig = aaSig; CST.matPtr = 0; CST.skip = {}; CST.contig = 0; }
      var n = 0;
      /* Strictly in rank order, and it STOPS at the first rank whose card has not
         arrived. Skipping a gap is what let a late-arriving better-ranked card jump
         the queue afterwards; holding the line means DOM order is rank order at
         every instant, so a page always holds exactly what it claims and nothing
         a buyer has already walked past can move. */
      while (CST.matPtr < CST.want.length) {
        var d = CST.want[CST.matPtr].d;
        /* Already on the page — a server-rendered result, or one released
           earlier. It counts towards the contiguous prefix either way. */
        if (CST.shown[d]) { CST.contig++; CST.matPtr++; continue; }
        if (CST.skip[d]) { CST.matPtr++; continue; }
        if (AAm && !AAm[d.slice(0, 3)]) { CST.matPtr++; continue; }
        var html = CST.stash[d];
        if (!html) break;                       // not here yet — wait for it
        _pendingHtml.push(html); delete CST.stash[d];
        CST.shown[d] = 1; CST.contig++; n++; CST.matPtr++;
      }
      /* de-contiguous-pager-2026-09-19 — pages follow the PREFIX, not the pile.

         The pager sized itself on every card in the grid. Most of those are the
         200 Shopify rendered server-side, and their ranks are scattered all over
         the result set — so "two pages are loaded" could be true by headcount
         while ranks 40..400 had not arrived at all. Page 2 rendered from whatever
         happened to sort into that range, the missing ranks landed later and
         pushed it along, and a buyer walking forward saw some numbers twice and
         others not at all: q=888, 3,939 matches, 323 repeated and 323 never shown.

         Ranks 0..matPtr are contiguous by construction, so `contig` is the only
         honest measure of how many pages can be rendered stably. Everything past
         it stays out of the pager until the prefix reaches it. */
      window.__deContiguousMatches = CST.contig || 0;
      /* de-last-page-reachable-2026-09-20 — "the prefix covers everything" cannot
         be spelled `contig === total`.

         The whole-pages rule only allows a part-filled page when it is the LAST
         one, and it judged that by contig reaching the total. A few ranks never
         produce a card — numbers sold since the index was built, which the unblock
         deliberately skips — so contig settles a little short of the total forever
         and the final page stays out of reach: jumping to 57 of 57 on q=8 landed
         on 56 and Next could not finish the job. When the loader is DONE there is
         nothing more coming, and that is the honest end-of-list signal. */
      window.__deLoaderDone = !!(CST.done || CST.cursor >= CST.want.length);
      /* Nothing may be STRANDED in there. The cursor is what releases a held card,
         so once it has stopped moving — the ranked list is exhausted, or the stream
         has finished for any other reason — whatever is left has to come out, in
         rank order, or those numbers become permanently invisible while the count
         still promises them.

         Caught by walking q=626: the prefix rule alone removed every duplicate
         (453 expected, 0 repeats) but left 53 numbers in the stash with no cursor
         left to free them, so the walk ended at 400. */
      if (CST.done || CST.cursor >= CST.want.length) {
        for (var i = CST.matPtr; i < CST.want.length; i++) {
          var d2 = CST.want[i].d, h2 = CST.stash[d2];
          if (h2 && !CST.shown[d2]) {
            _pendingHtml.push(h2); delete CST.stash[d2]; CST.shown[d2] = 1; n++;
          }
        }
        CST.matPtr = CST.want.length;
        CST.contig = Object.keys(CST.shown).length;
        /* Anything the ranked list never mentioned (drift between the index and
           the live catalogue) still belongs on the page. */
        for (var k in CST.stash) {
          if (!CST.shown[k]) { _pendingHtml.push(CST.stash[k]); CST.shown[k] = 1; n++; }
          delete CST.stash[k];
        }
      }
      if (n && !_flushQueued) { _flushQueued = true; requestAnimationFrame(_flushNodes); }
      return n;
    }

    function deContainsHarvest(htmls) {
      if (!CST) return 0;
      /* The set of digits already on the page, built ONCE. This used to be a
         grid.querySelector per candidate — O(n^2) against a grid of thousands. */
      var live = {};
      var lc = cards();
      for (var i = 0; i < lc.length; i++) live[cardDigits(lc[i])] = 1;

      var parts = [], allDigits = [];
      for (var h = 0; h < htmls.length; h++) {
        if (!htmls[h]) continue;
        var skip = {};
        for (var k in live) skip[k] = 1;
        for (var k2 in CST.have) skip[k2] = 1;
        var got = cardsFromHtml(htmls[h], CST.keep, skip);
        if (!got.digits.length) continue;
        for (var d = 0; d < got.digits.length; d++) {
          if (live[got.digits[d]] || CST.have[got.digits[d]]) continue;
          live[got.digits[d]] = 1; CST.have[got.digits[d]] = 1;
        }
        /* Everything lands in the stash; deMaterialise() is the only thing that
           puts a card on the page, and it does so in strict rank order. Inserting
           "already past the cursor" cards directly from here was the last hole:
           the cursor moves the moment a page is REQUESTED, not when it arrives, so
           a card ranked 50th could be harvested while the cursor sat at 205 and be
           appended after two hundred better-ranked ones. sortVisible() then lifted
           it to its proper place and pushed everything below it down — which is
           precisely the boundary shift that was losing numbers from under a buyer
           who was paging. */
        for (var g2 = 0; g2 < got.cards.length; g2++) CST.stash[got.digits[g2]] = got.cards[g2];
        allDigits = allDigits.concat(got.digits);
      }
      var _rel = deMaterialise();
      if (!parts.length) return _rel ? allDigits.length : 0;

      /* Queue the HTML and parse it in the flush, a slice per frame. Parsing a
         whole page of matches in one go was a single synchronous chunk of work —
         "6" matches ~120 cards per page, roughly 430KB of markup — and it showed up
         as a ~500ms frame while the buyer was scrolling. */
      for (var p2 = 0; p2 < parts.length; p2++) _pendingHtml.push(parts[p2]);
      var added = allDigits.length;
      if (!added) return 0;
      if (!_flushQueued) { _flushQueued = true; requestAnimationFrame(_flushNodes); }
      return added;
    }

    /* de-price-order-stream-2026-09-20 — a price sort must see every match, not
       just the ones relevance happened to load.

       Sorting /search?q=8 high-to-low put 838-383-8383 at $32,000 on top. The true
       most expensive number containing an 8 is 989-898-9898 at $140,000, and the
       second is $65,000 — neither was on the page, because the contains stream
       loads in RELEVANCE order and had fetched 1,278 of the 11,229 matches. The
       pager said "1-200 of 11,229" while the order described a tenth of that.

       Shopify will hand over the catalogue already sorted by price, so matches can
       be harvested in true price order by walking those pages from the top: for a
       broad query the first page or two already contains a full screen of them.
       The cards arrive in the right order, sortVisible() keeps them there, and the
       relevance stream carries on underneath for everything else. */
    var PST = null;
    function dePriceDir() {
      var v = sortSel ? sortSel.value : '';
      if (v === 'price-asc') return 'price-ascending';
      if (v === 'price-desc') return 'price-descending';
      return '';
    }
    function dePriceStream(need) {
      var dir = dePriceDir();
      var P = queryPredicate();
      if (!dir || !P) return;
      if (!PST || PST.dir !== dir) {
        var seen = {};
        var have0 = cards();
        for (var i = 0; i < have0.length; i++) seen[cardDigits(have0[i])] = 1;
        PST = { dir: dir, page: 1, seen: seen, matches: 0, busy: false, done: false, tries: 0 };
      }
      if (PST.busy || PST.done) return;
      PST.busy = true;
      try { bar.setAttribute('data-de-scanning', '1'); } catch (e) {}
      var want = need || 260;

      function step() {
        if (PST.matches >= want || PST.page > 90) { PST.busy = false; return Promise.resolve(); }
        var sid = (CST && CST.sid) ? '&section_id=' + encodeURIComponent(CST.sid) : '';
        var url = ALL_PATH + '?sort_by=' + dir + '&page=' + PST.page + sid;
        return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return (r.ok || r.status === 304) ? r.text() : ''; })
          .catch(function () { return ''; })
          .then(function (html) {
            PST.page++;
            if (!html) {
              if (++PST.tries > 4) { PST.done = true; PST.busy = false; return; }
              return step();
            }
            var got = cardsFromHtml(html, P.keep, PST.seen);
            if (!got.digits.length && PST.page > 3 && PST.matches === 0) {
              /* Nothing at all on the first pages means this is not a query the
                 catalogue order can serve; leave it to the relevance stream. */
              if (PST.page > 8) { PST.done = true; PST.busy = false; return; }
            }
            for (var k = 0; k < got.digits.length; k++) {
              PST.seen[got.digits[k]] = 1;
              if (CST && CST.have) CST.have[got.digits[k]] = 1;
              if (CST && CST.shown) CST.shown[got.digits[k]] = 1;
              _pendingHtml.push(got.cards[k]);
              PST.matches++;
            }
            if (got.digits.length && !_flushQueued) {
              _flushQueued = true; requestAnimationFrame(_flushNodes);
            }
            return step();
          });
      }
      return step().then(function () {
        PST.busy = false;
        try { bar.removeAttribute('data-de-scanning'); } catch (e) {}
        try { recomputeRange(); buildOptions(); paintPrice(); apply(); } catch (e) {}
      }, function () { PST.busy = false; });
    }

    /* Paging towards the end of what is loaded is the signal to fetch more. The
       pager lives in another module, so rather than reach into it, watch for a
       click on any pager control and top the buffer up afterwards. */
    document.addEventListener('click', function (e) {
      if (!CST) return;
      var t = e.target;
      if (!t || !t.closest) return;
      if (!t.closest('.de-list-paginator, .de-pagination, [data-de-pager], [data-de-list-paginator]')) return;
      /* Free anything already held before deciding whether a fetch is needed — a
         page whose cards are sitting in the stash costs nothing to show. */
      deMaterialise();
      if (CST.done || CST.busy) return;
      /* Paging is an explicit request for more, so it buys more budget. Without
         this, "29" stopped dead at 252 of 2,201: the automatic ceiling had been
         reached, Next went grey, and the remaining 1,949 numbers were unreachable
         for the rest of the visit. */
      if (CST.capped) { PAGE_BUDGET = pagesSpent + 40; CST.capped = false; }
      /* Ask for enough to COVER the page being opened, not a fixed top-up. Jumping
         straight to page 14 of a 49-page result set has to fetch the matches that
         page is made of, or it lands on an empty grid. */
      /* Two ways to move: the numbered buttons, and the "Page [ ] of N  Go" box.
         Only the buttons were being read, so typing a page number — the natural way
         to reach page 40 of 49 — asked for a generic top-up and crawled forward a
         few pages per press instead of going there. */
      var fb = t.closest('[data-de-filtered-page], [data-de-list-page]');
      var jf = t.closest('.de-pager-jump');
      var ask = 600, pgNo = 0;
      if (fb) {
        pgNo = parseInt(fb.getAttribute('data-de-filtered-page') ||
                        fb.getAttribute('data-de-list-page'), 10) || 1;
      } else if (jf) {
        var jin = jf.querySelector('input');
        pgNo = jin ? (parseInt(jin.value, 10) || 0) : 0;
      }
      if (pgNo > 0 && dePriceDir()) {
        try { dePriceStream((pgNo + 1) * 200); } catch (e) {}
      }
      if (pgNo > 0) {
        var per = 200;
        try {
          var lp = document.querySelector('.de-list-paginator__count');
          var mm = lp && lp.textContent.match(/(\d[\d,]*)\s*[–-]\s*(\d[\d,]*)/);
          if (mm) per = Math.max(1, (+mm[2].replace(/,/g, '')) - (+mm[1].replace(/,/g, '')) + 1);
        } catch (e) {}
        var _lm = cards(), loadedMatches = 0;
        for (var _q2 = 0; _q2 < _lm.length; _q2++) if (!_lm[_q2].hasAttribute('hidden')) loadedMatches++;
        ask = Math.max(600, (pgNo + 1) * per - loadedMatches);
        if (ask > 0 && CST.capped !== false) { CST.capped = false; }
        PAGE_BUDGET = Math.max(PAGE_BUDGET, pagesSpent + Math.min(120, Math.ceil(ask / 8)));
        /* Record the destination. One pass rarely covers a deep jump — a call is
           capped at CALL_PAGE_CAP pages — so finishing has to check whether the
           page the buyer opened is actually reachable yet, and carry on if not.
           Without this, "go to page 20" walked forward a few pages per click and
           never arrived. */
        CST.needPage = pgNo; CST.needPer = per; CST.needTries = 0;
        PAGE_BUDGET = Math.max(PAGE_BUDGET, 100);
      }
      setTimeout(function () { deContainsMore(ask); }, 0);
    }, true);

    /* A page restored from the URL is the same request as a pager click — the
       buyer wants that slice — so it buys the same budget and sets the same
       destination. Fired twice by the paginator, hence the no-op guard. */
    document.addEventListener('de:wantpage', function (e) {
      if (!CST || CST.done) return;
      var pg = e && e.detail ? (parseInt(e.detail.page, 10) || 0) : 0;
      var per = e && e.detail ? (parseInt(e.detail.per, 10) || 200) : 200;
      if (pg < 2) return;
      if (CST.needPage === pg) return;      // already heading there
      var _hw = cards(), haveW = 0;
      for (var _q4 = 0; _q4 < _hw.length; _q4++) if (!_hw[_q4].hasAttribute('hidden')) haveW++;
      /* Record the destination even while a pass is in flight — finish() checks
         needPage and carries on towards it. Bailing out on `busy` threw the
         request away, which is why a reloaded deep page never went anywhere. */
      CST.needPage = pg; CST.needPer = per; CST.needTries = 0; CST.capped = false;
      PAGE_BUDGET = Math.max(PAGE_BUDGET, pagesSpent + 40, 100);
      if (!CST.busy) setTimeout(function () { deContainsMore(Math.max(600, (pg + 1) * per - haveW)); }, 0);
    }, true);

    /* Enter in the "Page [ ] of N" box submits the form rather than clicking Go,
       so the same intent has to be read here too. */
    document.addEventListener('submit', function (e) {
      if (!CST || CST.done || CST.busy) return;
      var f = e.target;
      if (!f || !f.classList || !f.classList.contains('de-pager-jump')) return;
      var inp = f.querySelector('input');
      var pg = inp ? (parseInt(inp.value, 10) || 0) : 0;
      if (!pg) return;
      var perS = 200;
      try {
        var lpS = document.querySelector('.de-list-paginator__count');
        var mS = lpS && lpS.textContent.match(/(\d[\d,]*)\s*[\u2013-]\s*(\d[\d,]*)/);
        if (mS) perS = Math.max(1, (+mS[2].replace(/,/g, '')) - (+mS[1].replace(/,/g, '')) + 1);
      } catch (e2) {}
      var _hs = cards(), haveS = 0;
      for (var _q3 = 0; _q3 < _hs.length; _q3++) if (!_hs[_q3].hasAttribute('hidden')) haveS++;
      CST.needPage = pg; CST.needPer = perS; CST.needTries = 0; CST.capped = false;
      PAGE_BUDGET = Math.max(PAGE_BUDGET, pagesSpent + 40, 100);
      setTimeout(function () { deContainsMore(Math.max(600, (pg + 1) * perS - haveS)); }, 0);
    }, true);


    /* ---------- deep scan ------------------------------------------
       Pulls EVERY server page the query has, skipping the one already in
       the DOM. Two things this gets right that the first cut did not:

         • It scans pages 1..N, not 2..N. On page 2 the old version
           re-fetched page 2 (duplicating it) and never loaded page 1, so
           the dropdowns disagreed depending on which page you stood on.
         • It runs automatically at idle on load, not on first interaction.
           Otherwise the area list only ever offered codes from the 200
           cards that happened to be on your page — a buyer on page 1 of
           "626" saw only "626" and had no way to know the other codes
           existed without paging.

       Appended cards carry data-de-appended, which keeps them out of the
       paginator's server-page maths — the same marker the collection uses. */
    var scanned = false, scanning = false, waiters = [];
    function flush() {
      var w = waiters; waiters = [];
      for (var i = 0; i < w.length; i++) { try { w[i](); } catch (e) {} }
    }
    function deepScan(then) {
      /* de-skip-deepscan-2026-09-19 — redundant once the index is driving.

         deepScan exists to pull EVERY server page of the query so the dropdowns can
         describe the whole result set. For a digit query the index does that far
         better (whole catalogue, not just Shopify's 1,000-result cap), and the
         contains stream is already fetching the ranked matches. All deepScan adds
         is DOM: "888" returns 1,000 results from Shopify, so it inserted a thousand
         cards nobody pages to — and every one of them is work for the layout engine
         and for the third-party scripts watching mutations. */
      if (queryPredicate() && window.__deDigitIndex) {
        /* The index may not have resolved yet — deepScan is kicked at idle, often
           before it lands. Checking peek() alone lost the race and scanned anyway:
           "8888" ended up with 1,012 cards in the DOM of which only 103 came from
           the stream, the other ~900 being server pages nobody pages to. Wait for
           the decision instead of guessing at it. */
        if (window.__deDigitIndex.peek()) {
          scanned = true; if (then) then(); flush(); return;
        }
        if (!scanning) {
          scanning = true;
          if (then) waiters.push(then);
          window.__deDigitIndex.ready().then(function (ok) {
            scanning = false;
            if (ok) { scanned = true; flush(); return; }
            deepScan(null);            // no index — fall back to the real scan
          });
          return;
        }
      }
      if (scanned) { if (then) then(); return; }
      if (then) waiters.push(then);
      if (SERVER_PAGES <= 1) { scanned = true; flush(); return; }
      if (scanning) return;
      scanning = true;
      bar.setAttribute('data-de-scanning', '1');
      var page = 1, added = 0;
      function next() {
        if (page > SERVER_PAGES) {
          scanned = true; scanning = false;
          bar.removeAttribute('data-de-scanning');
          if (added) {
            // Range endpoints follow the loaded set, so pulling the rest of
            // the results moves them. Repaint or the readout keeps quoting
            // the first page's ceiling.
            recomputeRange(); buildOptions(); paintPrice();
          }
          flush();
          apply();
          return;
        }
        if (page === CUR_PAGE) { page++; next(); return; }
        var u = new URLSearchParams(window.location.search);
        u.set('page', String(page));
        fetch(window.location.pathname + '?' + u.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var got = doc.querySelectorAll('[data-de-product-grid] > .de-card.de-card--number');
            for (var i = 0; i < got.length; i++) {
              /* The contains-stream may already have brought this number in from
                 the catalogue — appending the server page blind duplicated four
                 of them under "888" and pushed the shown count past the true
                 total. Whoever gets there first wins; the other skips. */
              var dg0 = got[i].getAttribute('data-digits') || '';
              if (dg0 && grid.querySelector('.de-card--number[data-digits="' + dg0 + '"]')) continue;
              var node = document.importNode(got[i], true);
              node.setAttribute('data-de-appended', '1');
              /* de-scan-appends-stay-off-page-2026-09-20 — a scanned card is NOT
                 part of the page it lands on.

                 The idle scan pulls the remaining server pages so the dropdowns can
                 describe the whole result set. On a word query — where the digit
                 index has nothing to say and no filter is active — nothing ever
                 paged them: /search?q=gold rendered its 200, the scan appended 800
                 more, and all 1,000 stayed visible. 25,196 nodes, a 20,000px page,
                 both pagers hidden while the server pager's own text still read
                 "1-200 of 1000 ... 5 Next", and 32-43 dropped frames on a scroll.

                 The browse rule already exists — browse shows only the original
                 server-page cards — but it is enforced in applyListLimit(), which
                 on this page only runs while a filter is active. The scan is the
                 one thing that can break the rule, so the scan upholds it: append
                 off-page and hollow, exactly as the contains stream does. A filter
                 reveals them through the normal path. */
              if (!anyFilterActive()) {
                node.classList.add('de-card--hidden-by-paginator');
                if (window.__deShell) window.__deShell(node, true);
              }
              grid.appendChild(node);
              added++;
            }
            page++;
            next();
          })
          .catch(function () { page++; next(); });
      }
      next();
    }

    /* ---------- persistence ---------------------------------------- */
    function save() {
      try {
        sessionStorage.setItem(SKEY, JSON.stringify({
          state: stateSel ? stateSel.value : '',
          area: areaSel ? areaSel.value : '',
          min: pMin ? pMin.value : '0',
          max: pMax ? pMax.value : '100'
        }));
      } catch (e) {}
    }
    function restore() {
      var raw = null;
      try { raw = sessionStorage.getItem(SKEY); } catch (e) {}
      if (!raw) return false;
      var s; try { s = JSON.parse(raw); } catch (e) { return false; }
      if (!s) return false;
      var wanted = !!(s.state || s.area || (s.min && +s.min > 0) || (s.max && +s.max < 100));
      if (!wanted) return false;
      if (pMin && s.min != null) pMin.value = s.min;
      if (pMax && s.max != null) pMax.value = s.max;
      deepScan(function () {
        if (stateSel && s.state) { stateSel.value = s.state; refilterAreasByState(s.state); }
        if (areaSel && s.area) areaSel.value = s.area;
        paintPrice();
        apply();
      });
      return true;
    }

    /* ---------- wiring ---------------------------------------------- */
    var SORT_TO_SHOPIFY = {
      'price-asc': 'price-ascending',
      'price-desc': 'price-descending',
      'phone-asc': 'title-ascending',
      'phone-desc': 'title-descending'
    };
    if (sortSel) {
      var urlSort = params.get('sort_by');
      if (urlSort) {
        for (var k in SORT_TO_SHOPIFY) {
          if (SORT_TO_SHOPIFY[k] === urlSort) { sortSel.value = k; break; }
        }
      }
      sortSel.addEventListener('change', function () {
        save();
        var u = new URLSearchParams(window.location.search);
        u.delete('page');
        var mapped = SORT_TO_SHOPIFY[sortSel.value];
        if (mapped) u.set('sort_by', mapped); else u.delete('sort_by');
        window.location.href = window.location.pathname + '?' + u.toString();
      });
    }

    function onFilterChange() {
      deepScan(function () { apply(); });
      /* Re-walk the ranked list under the new facet. Without this, choosing a
         state only re-filtered what was already downloaded — which is exactly
         how "6 + Alabama" managed to show zero results. */
      if (CST && !throttled) {
        CST.cursor = 0; CST.done = false; CST.capped = false;
        CST.needPage = 0; CST.facetTries = 0; CST.rerun = 0;
        setTimeout(function () { deContainsMore(600); }, 0);
      }
    }
    // The view toggle changes which pager is meaningful, so re-evaluate.
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('[data-de-view-btn]')) setTimeout(function () { apply(); }, 60);
    }, true);
    // Crossing the 640px line hands the readout between the two owners.
    var rzT;
    window.addEventListener('resize', function () {
      clearTimeout(rzT);
      rzT = setTimeout(function () { apply(); }, 180);
    }, { passive: true });
    if (stateSel) stateSel.addEventListener('change', function () {
      refilterAreasByState(stateSel.value);
      onFilterChange();
    });
    if (areaSel) areaSel.addEventListener('change', onFilterChange);
    if (pMin) pMin.addEventListener('input', paintPrice);
    if (pMax) pMax.addEventListener('input', paintPrice);
    function onPriceCommit() {
      var a = pMin ? +pMin.value : 0, b = pMax ? +pMax.value : 100;
      if (a > b) { var t = a; a = b; b = t; }
      deSNativeGo(a <= 0 ? null : pctToCents(a), b >= 100 ? null : pctToCents(b));
    }
    if (pMin) pMin.addEventListener('change', onPriceCommit);
    if (pMax) pMax.addEventListener('change', onPriceCommit);
    if (resetBtn) resetBtn.addEventListener('click', function () {
      /* de-search-reset-native-2026-09-16 — when the band was applied by Shopify
         (filter.v.price.* in the URL) the cards outside it were never sent to the
         page, so putting the thumbs back changes nothing: measured "626" resetting
         to 86 results instead of its 453. Take the filter out of the URL and let
         the page come back whole. */
      try {
        var _u = new URL(window.location.href), _drop = [];
        _u.searchParams.forEach(function (v, k) { if (k.indexOf('filter.v.price.') === 0) _drop.push(k); });
        if (_drop.length) {
          for (var _i = 0; _i < _drop.length; _i++) _u.searchParams.delete(_drop[_i]);
          window.location.href = _u.pathname + (_u.search ? _u.search : '');
          return;
        }
      } catch (e) {}
      if (stateSel) stateSel.value = '';
      if (areaSel) areaSel.value = '';
      if (pMin) pMin.value = 0;
      if (pMax) pMax.value = 100;
      refilterAreasByState('');
      paintPrice();
      apply();
    });

    recomputeRange();
    if (deSNat) {
      /* Put the server's band back on the thumbs. recomputeRange() has just scaled
         the track to the cards on screen — which are only the in-band ones — so the
         endpoints are widened to include the band before placing the handles, or a
         band the buyer could never widen back out would be baked in. */
      var lo0 = deSNat.min !== null && !isNaN(deSNat.min) ? deSNat.min * 100 : null;
      var hi0 = deSNat.max !== null && !isNaN(deSNat.max) ? deSNat.max * 100 : null;
      var full = deSRangeLoad();
      if (full) { if (full.lo < loC) loC = full.lo; if (full.hi > hiC) hiC = full.hi; }
      if (lo0 !== null && lo0 < loC) loC = lo0;
      if (hi0 !== null && hi0 > hiC) hiC = hi0;
      if (pMin) pMin.value = lo0 === null ? 0 : centsToPct(lo0);
      if (pMax) pMax.value = hi0 === null ? 100 : centsToPct(hi0);
    }
    sizePills();
    buildOptions();
    paintPrice();
    /* de-search-initapply-2026-09-14 — apply() used to run on load only for a
       SUBDIGITS refinement, so anything else this module owns silently did
       nothing until the buyer touched a control. Two things landed in that gap:
       the QDIGITS sanity filter, and the client-side phone ordering (the server
       ignores title-* on /search). Both are decided by the URL alone, so both
       have to run on arrival. */
    var __needsApply = SUBDIGITS || QDIGITS ||
      (sortSel && (sortSel.value === 'phone-asc' || sortSel.value === 'phone-desc'));
    if (__needsApply) {
      // Narrow immediately, and pull the rest of the pages so the refinement
      // sees every result rather than the first 200.
      apply();
      deepScan(function () { buildOptions(); apply(); });
    } else if (!restore()) {
      paintCount(0, false);
      // Load the rest of the results in the background so the dropdowns
      // describe the whole result set, not just this page.
      var kick = function () { deepScan(null); };
      if (window.requestIdleCallback) window.requestIdleCallback(kick, { timeout: 2500 });
      else setTimeout(kick, 700);
    }
    /* de-search-contains-2026-09-16 — unconditional. It used to be called inside
       two of the three init branches, so a buyer who had used the filter bar
       earlier in the session took the restore() path and got Shopify's answer
       only: "1 of 6 results for 27" with 990 numbers containing 27 sitting
       unfetched. Which numbers contain the digits does not depend on which
       controls happen to be restored. */
    deContainsStream();
    /* A price sort needs its own pass before the page can claim to be ordered. */
    if (dePriceDir()) setTimeout(function () { try { dePriceStream(320); } catch (e) {} }, 350);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* =====================================================================
   15e. SHORT DIGIT SEARCHES — route them, do not dead-end them
        (de-short-digit-2026-09-16)

   Owner: "when I type something like 6, it only having 171 results really makes
   no fucking sense to me at all… there are an infinite amount of digit
   combinations, styles, lengths."

   Right on both counts. Shopify indexes the title's 3- and 4-digit tokens, so a
   one- or two-character query has nothing to prefix-match and the result is
   arbitrary. Measured against the live index and the catalogue:

       ONE digit   every single one returns under 5% of the numbers that contain it
                   "8" -> 62 results, while 11,238 numbers contain an 8
                   "0" -> 3 results, of 8,472
       TWO digits  61 62 63 64 65 67 68 69 -> ZERO results each,
                   while 807 / 1,686 / 1,081 / 893 / 1,019 / 1,574 / 1,645 / 1,173
                   numbers respectively contain them
       THREE digits are fine (626 -> 364 of 453, 212 -> 227 of 246)

   A buyer typing "62" is part-way through an area code, and the store already has
   a curated page for every one of them — plus a repeating-digit collection per
   digit. So answer the question they are actually asking instead of showing a
   dead end: the real area codes that start with those digits, and the repeating
   collection for that digit. Everything here is already in the page
   (window.DE_AREA_CITY, 344 codes), so it renders instantly with no fetch.

   Deliberately additive: the normal results still render underneath. Long digit
   queries and word queries are untouched — they already work. */
(function () {
  try {
    if (!/\/search/.test(window.location.pathname)) return;
    var q;
    try { q = (new URLSearchParams(window.location.search).get('q') || '').trim(); } catch (e) { return; }
    /* Fires for 1-2 digit queries always (Shopify cannot answer those at all), and
       for ANY digit query that came back empty — which is the general safety net:
       whatever the length, a buyer who typed digits and got nothing is offered the
       area codes, the repeating collection, and the substring browse. */
    /* A 5+ digit query is rewritten into a searchable token before it reaches
       here ("95223" -> q=952-23), so a bare /^[0-9]+$/ test threw those away and
       left the buyer on an empty page with no rescue — 95223 matches a real
       number we sell. Accept anything that is only digits and phone punctuation,
       and work with the digits inside it. */
    if (!/^[0-9][0-9\s().-]*$/.test(q)) return;
    q = q.replace(/\D/g, '');
    if (!q) return;
    var g0 = document.querySelector('[data-de-product-grid]');
    /* Count RENDERED cards, not data-de-products-count. Shopify's figure counts every
       object type it matched, and this template renders products only — so a query
       like "37" reported a non-zero count while the grid was empty, and the rescue
       never fired: 0 results shown with 774 numbers containing those digits. What
       the buyer sees is the only honest measure of "no results". */
    var n0 = g0 ? g0.querySelectorAll('[data-de-product]').length : 0;
    var __wide = q.length > 2;
    if (__wide && n0 > 0) return;                      // real results exist; leave the page alone

    /* de-auto-contains-2026-09-16 — a digit search with NO results should still show
       the numbers that contain those digits.

       Shopify matches whole title groups, so a fragment sitting mid-number returns
       nothing however common it is. Swept 161 unpredictable digit queries across
       lengths 1-7: 33 came back empty from Shopify while the catalogue held matches
       — "29" (2,202 exist), "67" (1,574), "016" (113), "124" (9). Offering a chip
       for those is better than a dead end, but the buyer asked a clear question and
       the answer exists, so take them to it.

       Only when the search genuinely returned NOTHING, only for pure digits, and to
       a different path, so this can neither loop nor override a page that had real
       results. location.replace so Back returns to where they came from rather than
       bouncing through the empty page. */
    /* de-contains-net-2026-09-16 — this is now a NET, not the answer.

       The answer is de-search-contains-2026-09-16: the digit index streams the
       missing numbers into THIS page, so the buyer keeps their query, their URL,
       the filter bar and the area-code routes below. Redirecting away from all
       of that was the blunt version of the same fix.

       But the index is an optimisation and is allowed to fail — no sitemap, a
       blocked fetch, sessionStorage off. So give the page a few seconds to fill
       itself, then check what the buyer can actually see: if a pure-digit search
       is STILL showing nothing and numbers containing those digits exist, send
       them to the browse that can show them. A dead end is the one outcome that
       is never acceptable. */
    /* de-no-redirect-2026-09-16 — the net is retired.

       Owner: "id rather it be in a search results page.. for all searches using the
       search thingy". Since de-digit-scaffold-2026-09-16 the search template renders
       the grid and the filter bar for ANY digits-only query, so the contains stream
       always has somewhere to put the numbers and there is no longer a page to be
       rescued from. A digit search now begins and ends on /search. */
    if (false) {
      setTimeout(function () {
        try {
          var g = document.querySelector('[data-de-product-grid]');
          /* No grid at all means Shopify matched nothing, so the search template
             rendered its empty state and there is nothing on this page to fill —
             the in-place stream has no container to append to. That is precisely
             the dead end this net exists for, so go, and go without waiting. */
          if (!g) {
            var d0 = '/collections/all-numbers?de_text=' + encodeURIComponent(q);
            if (window.location.pathname + window.location.search !== d0) window.location.replace(d0);
            return;
          }
          var live = g.querySelectorAll('[data-de-product]');
          var real = 0;
          for (var i = 0; i < live.length; i++) {
            var dg = live[i].getAttribute('data-digits') || '';
            if (dg.indexOf(q) !== -1 && !live[i].hasAttribute('hidden')) real++;
          }
          if (real > 0) return;                       // the page answered — leave it alone
          var dest = '/collections/all-numbers?de_text=' + encodeURIComponent(q);
          if (window.location.pathname + window.location.search !== dest) {
            window.location.replace(dest);
          }
        } catch (e) {}
      }, document.querySelector('[data-de-product-grid]') ? 7000 : 250);
    }

    var REPEAT = { '0': ['zeros', '0s'], '1': ['ones', '1s'], '2': ['twos', '2s'], '3': ['threes', '3s'],
                   '4': ['fours', '4s'], '5': ['fives', '5s'], '6': ['sixes', '6s'], '7': ['sevens', '7s'],
                   '8': ['eights', '8s'], '9': ['nines', '9s'] };

    function build() {
      if (document.querySelector('[data-de-digit-routes]')) return true;
      var grid = document.querySelector('[data-de-product-grid]');
      var anchor = document.querySelector('.de-searchX__empty, .de-collection__empty-results') || grid;
      if (!anchor || !anchor.parentNode) return false;

      var codes = [];
      var map = window.DE_AREA_CITY || {};
      if (q.length <= 3) { for (var c in map) if (c.indexOf(q) === 0) codes.push(c); }
      codes.sort();
      var rep = (q.length === 1) ? REPEAT[q] : (q[0] === q[1] ? REPEAT[q[0]] : null);

      var wrap = document.createElement('div');
      wrap.className = 'de-pattern-chips de-digit-routes';
      wrap.setAttribute('data-de-digit-routes', '1');
      wrap.setAttribute('role', 'group');
      wrap.setAttribute('aria-label', 'Ways to browse ' + q);

      var html = '';
      if (rep) {
        html += '<div class="de-pattern-chips__group">' +
                '<span class="de-pattern-chips__group-label" aria-hidden="true">Repeating</span>' +
                '<a class="de-pattern-chip" href="/collections/' + rep[0] + '">All ' + rep[1] + '</a></div>';
      }
      if (codes.length) {
        html += '<div class="de-pattern-chips__group">' +
                '<span class="de-pattern-chips__group-label" aria-hidden="true">Area code</span>';
        for (var i = 0; i < codes.length && i < 14; i++) {
          var city = map[codes[i]];
          html += '<a class="de-pattern-chip" href="/collections/area-code-' + codes[i] + '">' +
                  codes[i] + (city ? ' — ' + String(city).replace(/[<>&"]/g, '') : '') + '</a>';
        }
        if (codes.length > 14) {
          html += '<span class="de-pattern-chips__group-label" aria-hidden="true">+' + (codes.length - 14) + ' more</span>';
        }
        html += '</div>';
      }
      /* The always-correct answer, whatever the digits: every number containing
         them. The collection bar matches a digit substring and deep-scans for the
         rest, so this is the one route that can never come up empty — it is what
         rescues the fragments that match no area code and no repeating digit. */
      html += '<div class="de-pattern-chips__group">' +
              '<span class="de-pattern-chips__group-label" aria-hidden="true">Contains</span>' +
              '<a class="de-pattern-chip" href="/collections/all-numbers?de_text=' + encodeURIComponent(q) + '">' +
              'Numbers containing ' + q + '</a></div>';
      wrap.innerHTML = html;
      anchor.parentNode.insertBefore(wrap, anchor);
      return true;
    }

    /* DE_AREA_CITY is written by a later script on some templates, so retry briefly
       rather than racing it. */
    /* de-no-digit-chips-2026-09-16 — the panel this used to render is switched off.

       Owner, looking at /search?q=6: "i really dont like how it shows this thing,
       instead of showing product listings, also the 29+ more, i dont like it cuz it
       basically doesnt tell u or show you".

       Both halves are right. It stood 183px tall directly above the grid, so the
       numbers — the thing being sold — started 803px down the page; and "+29 MORE"
       named a quantity without showing or linking to anything. It existed because
       a digit search used to return nothing useful, which is no longer true: the
       index answers the query itself now. The builder is left in place, unused, so
       it can be brought back cheaply if a compact version is ever wanted. */
    if (true) return;
    if (build()) return;
    var tries = 0;
    var t = setInterval(function () { if (build() || ++tries > 40) clearInterval(t); }, 150);
  } catch (e) {}
})();

/* =====================================================================
   15c. SEARCH QUERY NORMALISER  (de-search-normalise-2026-09-09)

   Shopify's product search is TOKEN based. A title reads
   "626-123-4567 · California · AABB", which tokenises to 626 / 123 / 4567 /
   California / AABB — so "626" finds 365 numbers but "626-1" finds ZERO,
   even though 129 numbers really do start 626-1. That is why the collection
   bar used to filter client-side instead of linking to /search, and why
   simply pointing its box at /search would have been a downgrade for every
   partial query.

   This normalises a phone-shaped query into something the search engine can
   actually match, and carries the full digit string along as de_digits so
   the results page can narrow itself back down to what the buyer typed:

     "626-1"        -> /search?q=626&de_digits=6261      (partial: refine)
     "626"          -> /search?q=626                     (whole token)
     "626-123-4567" -> /search?q=626-123-4567            (complete number)
     "California"   -> /search?q=California              (not phone-shaped)

   Bound to every search form on the site — the collection filter bar, the
   search page's own box — so all of them behave the same way.
   ===================================================================== */
(function () {
  function digitsOf(s) { return (s || '').replace(/\D/g, ''); }

  function normalise(raw) {
    var v = (raw || '').trim();
    if (!v) return null;
    // Anything with letters is a state / pattern / word query — pass through.
    if (!/^[\d\s().+\-]+$/.test(v)) return { q: v };
    var d = digitsOf(v);
    if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1);
    if (d.length >= 10) return { q: v };            // complete number: search it as typed
    /* de-four-digit-2026-09-16 — a FOUR digit run is a real token too.

       Titles read "626-619-0000", so the index holds 3-digit groups AND the 4-digit
       last group. Truncating every 4-digit query to its first three searched the
       wrong thing and then filtered the remains client-side, which came back empty
       on the exact queries buyers are most likely to type:

           "9999" -> q=999&de_digits=9999 -> 0 shown   (700 numbers contain 9999)
           "0000" -> q=000&de_digits=0000 -> 0 shown   (239 contain 0000)

       Searched whole, both land on real results. Five or more digits still spans
       two groups, so those keep the search-a-token-then-refine path. */
    if (d.length <= 4) return { q: d };             // an area code or a 4-digit group is a real token
    return { q: d.slice(0, 3), digits: d };         // partial: search the area code, refine client-side
  }

  function bind(form) {
    if (!form || form.__deNormBound) return;
    form.__deNormBound = true;
    form.addEventListener('submit', function (e) {
      var input = form.querySelector('input[name="q"]');
      if (!input) return;
      var n = normalise(input.value);
      if (!n) { e.preventDefault(); return; }
      if (!n.digits) { input.value = n.q; return; }  // let the browser submit normally
      e.preventDefault();
      var u = new URLSearchParams();
      u.set('type', 'product');
      u.set('q', n.q);
      u.set('de_digits', n.digits);
      window.location.href = (form.getAttribute('action') || '/search') + '?' + u.toString();
    });
  }

  /* The collection bar's Search is a plain <label> + <input>, not a form —
     it has to stay a label to keep the bar's styling (as a <form> it sat 6px
     below every other control). So bind the input directly: Enter runs the
     same normalisation and goes to /search. */
  function bindInput(input) {
    if (!input || input.__deNormBound) return;
    input.__deNormBound = true;
    input.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.keyCode !== 13) return;
      e.preventDefault();
      var n = normalise(input.value);
      if (!n) return;
      var u = new URLSearchParams();
      u.set('type', 'product');
      u.set('q', n.q);
      if (n.digits) u.set('de_digits', n.digits);
      window.location.href = '/search?' + u.toString();
    });
  }

  function init() {
    var forms = document.querySelectorAll('form[action*="/search"]');
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].querySelector('input[name="q"]')) bind(forms[i]);
    }
    var inputs = document.querySelectorAll('[data-de-collection-search]');
    for (var j = 0; j < inputs.length; j++) bindInput(inputs[j]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
